import React, { createElement } from 'react';
import PropTypes from 'prop-types';
import { Controller, useWatch, useFormContext, useForm, FormProvider } from 'react-hook-form';
export { Controller } from 'react-hook-form';
import { Level, Dropdown, Icon, Card, useModal, Button, Modal, Input, Columns, Heading, Select, Notification, Textarea, Checkbox } from '@selfdetermine/react-elements';
import { useMutation, useLazyQuery, useDebounce, useQuery } from '@selfdetermine/react-hooks';
import { Toasts } from '@selfdetermine/react-toasts';
import { gql } from '@selfdetermine/graphql';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/**
 * Generic form input for creating other custom inputs for selecting an associated model.
 */

var AssociationInput = function AssociationInput(_ref) {
  var name = _ref.name,
      label = _ref.label,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? false : _ref$multiple,
      defaultValue = _ref.defaultValue,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      children = _ref.children,
      disabled = _ref.disabled,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      renderSelectionItem = _ref.renderSelectionItem,
      renderSelectedItem = _ref.renderSelectedItem,
      placeholderMessage = _ref.placeholderMessage,
      Placeholder = _ref.placeholderComponent,
      requiredProp = _ref.required;
  return /*#__PURE__*/React.createElement(Controller, {
    name: name,
    defaultValue: defaultValue,
    render: function render(_ref2) {
      var onChange = _ref2.onChange,
          value = _ref2.value;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "mb-2"
      }, /*#__PURE__*/React.createElement(Level, {
        mobile: true
      }, /*#__PURE__*/React.createElement(Level.Left, null, /*#__PURE__*/React.createElement(Level.Item, {
        title: requiredProp ? "Field is required" : null
      }, /*#__PURE__*/React.createElement("p", {
        className: "label"
      }, label), requiredProp ? /*#__PURE__*/React.createElement("span", {
        className: "has-text-danger ml-1",
        style: {
          alignSelf: "flex-start"
        }
      }, "*") : null), !!(!disabled && (multiple || !Object.keys(value || {}).length)) && /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement(Dropdown, {
        onClose: onBlur,
        onOpen: onFocus
      }, /*#__PURE__*/React.createElement(Dropdown.Trigger, {
        removeIndicator: true,
        size: "small"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "plus"
      }), /*#__PURE__*/React.createElement("span", null, "Add")), /*#__PURE__*/React.createElement(Dropdown.Content, null, !!children && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dropdown.Item, null, children), /*#__PURE__*/React.createElement(Dropdown.Divider, null)), (options === null || options === void 0 ? void 0 : options.length) ? options.map(function (option, optionIndex) {
        return /*#__PURE__*/React.createElement(Dropdown.Item, {
          key: (option === null || option === void 0 ? void 0 : option.id) || optionIndex,
          as: "a",
          role: "button",
          tabIndex: "0",
          onClick: function onClick() {
            return onChange(multiple ? [].concat(_toConsumableArray(value || []), [option]) : option);
          }
        }, renderSelectionItem(option));
      }) : /*#__PURE__*/React.createElement(React.Fragment, null, !!Placeholder && /*#__PURE__*/React.createElement(Placeholder, {
        className: "mx-6 pt-4"
      }), !!placeholderMessage && /*#__PURE__*/React.createElement("p", {
        className: "has-text-grey has-text-centered"
      }, placeholderMessage)))))))), /*#__PURE__*/React.createElement("div", {
        className: "mb-6"
      }, (Array.isArray(value) ? value : [value]).filter(Boolean).map(function (selectedItem, selectedItemIndex) {
        return /*#__PURE__*/React.createElement(Card, {
          key: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) || selectedItemIndex
        }, /*#__PURE__*/React.createElement(Card.Header, {
          title: renderSelectedItem(selectedItem)
        }, !disabled && /*#__PURE__*/React.createElement(Card.HeaderAction, {
          "aria-label": "Remove",
          title: "Remove",
          onClick: function onClick(e) {
            e.stopPropagation();
            onChange(multiple ? value.filter(function (current) {
              return current !== selectedItem;
            }) : null);
          }
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "close"
        }))));
      })));
    }
  });
};
AssociationInput.propTypes = {
  /** Display label for the input */
  label: PropTypes.string.isRequired,

  /** Form input name */
  name: PropTypes.string.isRequired,

  /** Value required */
  required: PropTypes.bool,

  /** Default input value */
  defaultValue: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),

  /** Multiple people may be selected */
  multiple: PropTypes.bool,

  /** Prevents the user from selecting a value.has-text-justified-desktop-only */
  disabled: PropTypes.bool,

  /** Invoked after the input is "blurred" */
  onBlur: PropTypes.func,

  /** Invoked after the input gains "focus" */
  onFocus: PropTypes.func,

  /** Extra content inside the opened input. Usually for explanations or search features */
  children: PropTypes.node,

  /** Available options to select from */
  options: PropTypes.arrayOf(PropTypes.shape({})),

  /** Function that tells how to render a single option that may be selected from the list of options */
  renderSelectionItem: PropTypes.func,

  /** Function that tells how to render a selected option */
  renderSelectedItem: PropTypes.func,

  /** Message to display when there are no options displayed */
  placeholderMessage: PropTypes.string,

  /** Placeholder image component to render when there are no options displayed */
  placeholderComponent: PropTypes.node
};

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      query Counsels {\n        viewer {\n          counsels {\n            id\n            name\n          }\n        }\n      }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    mutation($counsel: NewCounselInput) {\n      counsel: addCounsel(counsel: $counsel) {\n        name\n        id\n      }\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var useCreate = function useCreate() {
  var _useMutation = useMutation(gql(_templateObject())),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      mutate = _useMutation2[0],
      meta = _useMutation2[1];

  var create = function create(counsel) {
    return mutate({
      variables: {
        counsel: counsel
      }
    });
  };

  return [create, meta];
};
/**
 * React hook that retrieves a list of available counsels.
 * @param {object} [options={}] - Additional query options
 * @returns {[function, object]} Tuple with function that performs the query and object containing meta data
 */

var useCounsels = function useCounsels() {
  var _meta$data, _meta$data$viewer;

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    fetchPolicy: "cache-and-network"
  };

  var _useLazyQuery = useLazyQuery(gql(_templateObject2()), options),
      _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
      query = _useLazyQuery2[0],
      meta = _useLazyQuery2[1];

  var getCounsels = function getCounsels() {
    var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var requestOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return query(_objectSpread2({
      variables: form
    }, requestOptions));
  }; // Cleaned data for easier consumption


  var data = {
    counsels: (meta === null || meta === void 0 ? void 0 : (_meta$data = meta.data) === null || _meta$data === void 0 ? void 0 : (_meta$data$viewer = _meta$data.viewer) === null || _meta$data$viewer === void 0 ? void 0 : _meta$data$viewer.counsels) || []
  };
  return [getCounsels, _objectSpread2(_objectSpread2({}, meta), {}, {
    data: data
  })];
};
/**
 * Custom form input for allowing users to select one or more counsels. Connects automatically
 * to a parent `Form` component.
 */


var CounselInput = function CounselInput(_ref) {
  var name = _ref.name,
      label = _ref.label,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? false : _ref$multiple,
      defaultValue = _ref.defaultValue,
      props = _objectWithoutProperties(_ref, ["name", "label", "multiple", "defaultValue"]);

  var _useCounsels = useCounsels(),
      _useCounsels2 = _slicedToArray(_useCounsels, 2),
      getCounsels = _useCounsels2[0],
      _useCounsels2$ = _useCounsels2[1],
      data = _useCounsels2$.data,
      refetch = _useCounsels2$.refetch;

  var _useCreate = useCreate(),
      _useCreate2 = _slicedToArray(_useCreate, 2),
      create = _useCreate2[0],
      createMeta = _useCreate2[1];

  var createModal = useModal();

  var createCounsel = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(form) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return create(form);

            case 3:
              createModal.close();
              refetch();
              Toasts.success("New counsel created");
              _context.next = 10;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));

    return function createCounsel(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(AssociationInput, _extends({}, props, {
    name: name,
    label: label,
    multiple: multiple,
    options: data.counsels,
    defaultValue: defaultValue,
    onFocus: function onFocus() {
      getCounsels();
    },
    renderSelectionItem: function renderSelectionItem(counsel) {
      return /*#__PURE__*/React.createElement("p", {
        className: "has-text-weight-semibold"
      }, counsel.name);
    },
    renderSelectedItem: function renderSelectedItem(counsel) {
      return counsel.name;
    }
  }), /*#__PURE__*/React.createElement(Level, null, /*#__PURE__*/React.createElement(Level.Left, null, /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement("span", {
    className: "is-size-5"
  }, "Counsels"))), /*#__PURE__*/React.createElement(Level.Right, null, /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement(Button, _extends({
    type: "button",
    color: "success",
    size: "small"
  }, createModal.triggerProps), /*#__PURE__*/React.createElement(Icon, {
    name: "plus"
  }), " ", /*#__PURE__*/React.createElement("span", null, "Add")), /*#__PURE__*/React.createElement(Modal, _extends({}, createModal.modalProps, {
    title: "New Counsel"
  }), /*#__PURE__*/React.createElement(Modal.Content, null, createModal.active && /*#__PURE__*/React.createElement(Form, {
    onSubmit: createCounsel,
    error: createMeta.error,
    loading: createMeta.loading
  }, /*#__PURE__*/React.createElement(Form.Input, {
    name: "name",
    label: "Name",
    type: "text",
    required: true
  }), /*#__PURE__*/React.createElement(Level, {
    mobile: true
  }, /*#__PURE__*/React.createElement(Level.Right, null, /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement(Form.SubmitButton, {
    color: "success"
  }, "Create Counsel")))))))))));
};
CounselInput.propTypes = {
  /** Display label for the input */
  label: PropTypes.string.isRequired,

  /** Form input name */
  name: PropTypes.string.isRequired,

  /** Default input value */
  defaultValue: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),

  /** Multiple counsels may be selected */
  multiple: PropTypes.bool
};

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

var _ref = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("linearGradient", {
  id: "PersonInput_svg__a",
  x1: 514.28,
  y1: 794.6,
  x2: 514.28,
  y2: 39.29,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/createElement("linearGradient", {
  id: "PersonInput_svg__b",
  x1: 352.46,
  y1: 508.8,
  x2: 352.46,
  y2: 387.8,
  xlinkHref: "#PersonInput_svg__a"
}), /*#__PURE__*/createElement("linearGradient", {
  id: "PersonInput_svg__c",
  x1: 301.02,
  y1: 688.3,
  x2: 403.5,
  y2: 688.3,
  xlinkHref: "#PersonInput_svg__a"
}), /*#__PURE__*/createElement("linearGradient", {
  id: "PersonInput_svg__d",
  x1: 1051.17,
  y1: 868,
  x2: 1051.17,
  y2: 325,
  gradientTransform: "matrix(-1 0 0 1 1753.99 0)",
  xlinkHref: "#PersonInput_svg__a"
}), /*#__PURE__*/createElement("linearGradient", {
  id: "PersonInput_svg__e",
  x1: 478.51,
  y1: 568.15,
  x2: 478.51,
  y2: 54.57,
  xlinkHref: "#PersonInput_svg__a"
}), /*#__PURE__*/createElement("linearGradient", {
  id: "PersonInput_svg__f",
  x1: -2402.29,
  y1: 267.8,
  x2: -2402.29,
  y2: 147,
  gradientTransform: "matrix(-1 0 0 1 -2054.74 0)",
  xlinkHref: "#PersonInput_svg__a"
}));

var _ref2 = /*#__PURE__*/createElement("path", {
  d: "M1047 458.22c-39.15 53.72-26.23 130.4-3.6 191.49 7.58 20.45 16.19 42.08 12.26 64.33-4.8 27.2-27.36 47.58-50.81 58.68-42.75 20.23-93.25 17-131.49-8.49-33-22-56.23-58.56-89.87-79.51-56.3-35.05-129.39-19.39-192.05 7.37-44.33 18.93-92.89 43.31-136.09 25.83-30.4-12.3-50.87-43.61-61.64-77.08-5.2-16.16-8.84-33.7-19.2-46.35-6.16-7.52-14.3-12.76-22.67-17.14-76.39-40-174.65-15-248.71-59.63-50-30.14-81.12-88.63-94.05-150.12S-.65 241.2 4.5 177.4c3.66-45.34 9.45-93.79 36.71-129.42C70.04 10.31 118.36-4.66 161.57 1.24s81.95 29.9 115.84 58.55c42.39 35.74 81.39 80.61 134.11 94.18 35.91 9.24 74.06 2.7 111.39-.19 62.4-4.82 124.58.73 186.38 7 59.16 6 118.73 12.7 174.76 32.37 39.65 13.92 71.08 40.23 108.41 58.21 24.33 11.72 51.1 14.44 74 29.58 28.26 18.65 53.8 51.69 45.51 91.34-7.83 37.69-44.17 57.43-64.97 85.94z",
  fill: "#28629b",
  opacity: 0.1
});

var _ref3 = /*#__PURE__*/createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/createElement("path", {
  d: "M854.99 703.24s3.3-97.76 56.19-153c22.2-23.18 36.78-52.62 40.64-84.48a249.26 249.26 0 001.24-45.57",
  fill: "none",
  stroke: "#535461",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/createElement("path", {
  d: "M986.19 385.2c-3.62 10.92-33.88 36-33.88 36s-9.27-38.21-5.65-49.12a20.824 20.824 0 0139.53 13.11zM998.8 456.5c-9 7.2-48 11.82-48 11.82s13-37.11 22-44.3a20.82 20.82 0 1126 32.48zM963.12 559.34c-11.38 1.68-47.41-14-47.41-14s29.94-25.48 41.32-27.16a20.824 20.824 0 116.09 41.2zM918.59 631.08c-10.93 3.58-49.1-5.82-49.1-5.82s25.21-30.17 36.14-33.75a20.825 20.825 0 0113 39.57zM908.59 456.67c5.31 10.2 39.21 30.17 39.21 30.17s3.08-39.19-2.23-49.4a20.82 20.82 0 10-36.94 19.22zM857.58 541.22c8.12 8.15 46.4 17.07 46.4 17.07s-8.79-38.32-16.9-46.47a20.82 20.82 0 10-29.5 29.39zM819.28 630.21c6.62 9.4 42.85 24.67 42.85 24.67s-2.18-39.25-8.81-48.66a20.82 20.82 0 10-34 24z",
  fill: "#28629b"
}), /*#__PURE__*/createElement("path", {
  d: "M866.61 662.78s-30-43.64-24.74-84.7a80.24 80.24 0 00-9.48-49.86 135 135 0 00-14.12-20.24",
  fill: "none",
  stroke: "#535461",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/createElement("path", {
  d: "M821.44 482.08c1.93 5.92-3.17 26.58-3.17 26.58s-16.33-13.66-18.26-19.57a11.272 11.272 0 0121.43-7zM849.87 509.07c-1.59 6-17.11 20.59-17.11 20.59s-6.28-20.34-4.69-26.36a11.275 11.275 0 0121.8 5.77zM867.41 565.33c-4.41 4.39-25.16 9.14-25.16 9.14s4.84-20.73 9.26-25.12a11.278 11.278 0 1115.9 16zM871.1 610.9c-3.61 5.07-23.3 13.24-23.3 13.24s1.27-21.25 4.88-26.32a11.274 11.274 0 1118.38 13.06zM810.64 538.14c5.59 2.74 26.76.54 26.76.54s-11.27-18.06-16.86-20.79a11.27 11.27 0 00-9.9 20.25zM815.63 591.39c6.16.94 25.7-7.49 25.7-7.49s-16.16-13.86-22.31-14.76a11.273 11.273 0 00-3.39 22.29zM827.57 642.46c5.91 2 26.6-3 26.6-3s-13.58-16.39-19.49-18.36a11.275 11.275 0 10-7.11 21.4z",
  fill: "#28629b"
}), /*#__PURE__*/createElement("path", {
  d: "M821.44 482.08c1.93 5.92-3.17 26.58-3.17 26.58s-16.33-13.66-18.26-19.57a11.272 11.272 0 0121.43-7zM849.87 509.07c-1.59 6-17.11 20.59-17.11 20.59s-6.28-20.34-4.69-26.36a11.275 11.275 0 0121.8 5.77zM867.41 565.33c-4.41 4.39-25.16 9.14-25.16 9.14s4.84-20.73 9.26-25.12a11.278 11.278 0 1115.9 16zM871.1 610.9c-3.61 5.07-23.3 13.24-23.3 13.24s1.27-21.25 4.88-26.32a11.274 11.274 0 1118.38 13.06zM810.64 538.14c5.59 2.74 26.76.54 26.76.54s-11.27-18.06-16.86-20.79a11.27 11.27 0 00-9.9 20.25zM815.63 591.39c6.16.94 25.7-7.49 25.7-7.49s-16.16-13.86-22.31-14.76a11.273 11.273 0 00-3.39 22.29zM827.57 642.46c5.91 2 26.6-3 26.6-3s-13.58-16.39-19.49-18.36a11.275 11.275 0 10-7.11 21.4z",
  fill: "#fff",
  opacity: 0.5
}), /*#__PURE__*/createElement("path", {
  fill: "#474059",
  d: "M811.1 781.11h85.33l21.34-130.13h-128l21.33 130.13z"
}), /*#__PURE__*/createElement("path", {
  opacity: 0.1,
  d: "M806.1 650.98l19.93 121.6h71.8l-1.4 8.53H811.1l-21.33-130.13h16.33z"
}));

var _ref4 = /*#__PURE__*/createElement("path", {
  fill: "url(#PersonInput_svg__a)",
  d: "M201.28 39.29h626v755.3h-626z"
});

var _ref5 = /*#__PURE__*/createElement("path", {
  fill: "#fff",
  d: "M209.28 48.95h610v736h-610z"
});

var _ref6 = /*#__PURE__*/createElement("path", {
  fill: "#c0bccf",
  d: "M446.28 131.95h246v12h-246zM446.28 169.95h246v12h-246z"
});

var _ref7 = /*#__PURE__*/createElement("path", {
  fill: "#28629b",
  d: "M505.28 207.95h128v12h-128z"
});

var _ref8 = /*#__PURE__*/createElement("path", {
  fill: "#c0bccf",
  opacity: 0.5,
  d: "M446.28 372.95h246v12h-246zM446.28 410.95h246v12h-246z"
});

var _ref9 = /*#__PURE__*/createElement("path", {
  fill: "#28629b",
  opacity: 0.5,
  d: "M505.28 448.95h128v12h-128z"
});

var _ref10 = /*#__PURE__*/createElement("path", {
  fill: "#c0bccf",
  opacity: 0.5,
  d: "M446.28 613.95h246v12h-246zM446.28 651.95h246v12h-246z"
});

var _ref11 = /*#__PURE__*/createElement("path", {
  fill: "#28629b",
  opacity: 0.5,
  d: "M505.28 689.95h128v12h-128z"
});

var _ref12 = /*#__PURE__*/createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/createElement("path", {
  d: "M378.28 416.94a67.68 67.68 0 01-16.37 44.25c-.52.61-1.06 1.21-1.61 1.8q-.41.46-.84.9a66.72 66.72 0 01-7.26 6.59l-.18.13a66.46 66.46 0 01-12.9 7.92 67 67 0 01-7.24 2.9l-.91.29c-.56.19-1.14.36-1.71.52l-.23.07a68.33 68.33 0 01-37.55 0h-.1c-1-.29-2-.59-2.92-.92l-.85-.3a65.94 65.94 0 01-9.4-4.16l-.19-.1a68.26 68.26 0 01-13.32-9.43l-.33-.31a63.54 63.54 0 01-5.81-6c-.24-.27-.47-.55-.7-.83-.44-.52-.86-1.06-1.28-1.6a68 68 0 11121.7-41.72z",
  fill: "#c0bccf"
}), /*#__PURE__*/createElement("path", {
  d: "M402.87 463.74l-5.16-2.32a20.47 20.47 0 00.1-2.36 18.53 18.53 0 000-2c-.51-5.26-3.86-9.84-6.23-14.65a41.61 41.61 0 01-4.07-14c-.63-6 0-12.22-2.2-17.86-1.79-4.55-5.33-8.35-9.12-11.71a46.29 46.29 0 00-14.65-9.29c-5.54-2-11.91-2.51-17.45-.47-5 1.84-8.85 5.51-12.57 9.08a42.25 42.25 0 00-7.1 8.08c-2.27 3.72-3.24 8-4 12.22a186.94 186.94 0 00-2.46 20.42c-.39 5.71-1 12.19-5.88 15.69-2.38 1.71-5.73 2.67-6.82 5.26a5.38 5.38 0 00-.36 2.45 9 9 0 00.15 2.07c.07.4.15.79.25 1.19a87.72 87.72 0 00-3.52 10.68c-.73 2.7-1.4 5.35-2 7.92h2.48l9.32.22h.13l10 .23h.05l9.32.22h.23l2.69.19h.88l37.27.86h.2l2.48.06h.87l7.46.17 11 .25h.08l8.28.2h2.58l-.44-8.68c1.82-13.29-1.79-14.12-1.79-14.12zM361 462.68c0 7.36-7.88 16.37-7.88 16.37l-7.93-10.8.29-.42 7.64 10.4s7.88-9 7.88-16.37a8.65 8.65 0 01.63-1.08l.18.56a10.61 10.61 0 00-.81 1.34zm12.12 28.88c0-.37 0-.75-.07-1.12s-.06-.7-.11-1.06-.09-.71-.14-1.07-.12-.71-.19-1.07-.14-.71-.22-1.07c0-.12-.05-.23-.08-.36-.11-.47-.23-.94-.36-1.41s-.21-.76-.33-1.13c0-.17-.1-.34-.16-.5s-.17-.54-.26-.81l-.18-.52c-.08-.23-.16-.47-.25-.7-.15-.42-.31-.83-.47-1.25s-.33-.83-.5-1.24c-.34-.84-.71-1.67-1.08-2.51-1.45-3.24-3.08-6.43-4.58-9.59a51 51 0 01-2.14-5.08l-.19.25a10.61 10.61 0 00-.81 1.35c0 7.36-7.88 16.37-7.88 16.37l-7.93-10.8-6.94 10c-1 .5-2 2.2-2.78 4.62-.22.65-.43 1.37-.63 2.12-.14.51-.27 1-.39 1.57-.07.27-.13.54-.19.82l-.18.85v.13c-.12.58-.24 1.18-.35 1.79s-.24 1.31-.35 2q-.12.65-.21 1.29c-.14.83-.26 1.67-.38 2.51-.07.49-.14 1-.2 1.45l-.24 1.86c.51 1.53 1.08 3 1.67 4.54a7.14 7.14 0 01.65 2.57 72.88 72.88 0 0037.55 0 .34.34 0 010-.09 10.44 10.44 0 01-.24-2.55 65.89 65.89 0 011-7.16 24.47 24.47 0 00.19-3.52v-.42c-.03-.38-.04-.72-.05-1.05zm0 0c0-.37 0-.75-.07-1.12s-.06-.7-.11-1.06-.09-.71-.14-1.07-.12-.71-.19-1.07-.14-.71-.22-1.07c0-.12-.05-.23-.08-.36-.11-.47-.23-.94-.36-1.41s-.21-.76-.33-1.13c0-.17-.1-.34-.16-.5s-.17-.54-.26-.81l-.18-.52c-.08-.23-.16-.47-.25-.7-.15-.42-.31-.83-.47-1.25s-.33-.83-.5-1.24c-.34-.84-.71-1.67-1.08-2.51-1.45-3.24-3.08-6.43-4.58-9.59a51 51 0 01-2.14-5.08l-.19.25a10.61 10.61 0 00-.81 1.35c0 7.36-7.88 16.37-7.88 16.37l-7.93-10.8-6.94 10c-1 .5-2 2.2-2.78 4.62-.22.65-.43 1.37-.63 2.12-.14.51-.27 1-.39 1.57-.07.27-.13.54-.19.82l-.18.85v.13c-.12.58-.24 1.18-.35 1.79s-.24 1.31-.35 2q-.12.65-.21 1.29c-.14.83-.26 1.67-.38 2.51-.07.49-.14 1-.2 1.45l-.24 1.86c.51 1.53 1.08 3 1.67 4.54a7.14 7.14 0 01.65 2.57 72.88 72.88 0 0037.55 0 .34.34 0 010-.09 10.44 10.44 0 01-.24-2.55 65.89 65.89 0 011-7.16 24.47 24.47 0 00.19-3.52v-.42c-.03-.38-.04-.72-.05-1.05zm0 0c0-.37 0-.75-.07-1.12s-.06-.7-.11-1.06-.09-.71-.14-1.07-.12-.71-.19-1.07-.14-.71-.22-1.07c0-.12-.05-.23-.08-.36-.11-.47-.23-.94-.36-1.41s-.21-.76-.33-1.13c0-.17-.1-.34-.16-.5s-.17-.54-.26-.81l-.18-.52c-.08-.23-.16-.47-.25-.7-.15-.42-.31-.83-.47-1.25s-.33-.83-.5-1.24c-.34-.84-.71-1.67-1.08-2.51-1.45-3.24-3.08-6.43-4.58-9.59a51 51 0 01-2.14-5.08l-.19.25a10.61 10.61 0 00-.81 1.35c0 7.36-7.88 16.37-7.88 16.37l-7.93-10.8-6.94 10c-1 .5-2 2.2-2.78 4.62-.22.65-.43 1.37-.63 2.12-.14.51-.27 1-.39 1.57-.07.27-.13.54-.19.82l-.18.85v.13c-.12.58-.24 1.18-.35 1.79s-.24 1.31-.35 2q-.12.65-.21 1.29c-.14.83-.26 1.67-.38 2.51-.07.49-.14 1-.2 1.45l-.24 1.86c.51 1.53 1.08 3 1.67 4.54a7.14 7.14 0 01.65 2.57 72.88 72.88 0 0037.55 0 .34.34 0 010-.09 10.44 10.44 0 01-.24-2.55 65.89 65.89 0 011-7.16 24.47 24.47 0 00.19-3.52v-.42c-.03-.38-.04-.72-.05-1.05zm0 0c0-.37 0-.75-.07-1.12s-.06-.7-.11-1.06-.09-.71-.14-1.07-.12-.71-.19-1.07-.14-.71-.22-1.07c0-.12-.05-.23-.08-.36-.11-.47-.23-.94-.36-1.41s-.21-.76-.33-1.13c0-.17-.1-.34-.16-.5s-.17-.54-.26-.81l-.18-.52c-.08-.23-.16-.47-.25-.7-.15-.42-.31-.83-.47-1.25s-.33-.83-.5-1.24c-.34-.84-.71-1.67-1.08-2.51-1.45-3.24-3.08-6.43-4.58-9.59a51 51 0 01-2.14-5.08l-.19.25a10.61 10.61 0 00-.81 1.35c0 7.36-7.88 16.37-7.88 16.37l-7.93-10.8-6.94 10c-1 .5-2 2.2-2.78 4.62-.22.65-.43 1.37-.63 2.12-.14.51-.27 1-.39 1.57-.07.27-.13.54-.19.82l-.18.85v.13c-.12.58-.24 1.18-.35 1.79s-.24 1.31-.35 2q-.12.65-.21 1.29c-.14.83-.26 1.67-.38 2.51-.07.49-.14 1-.2 1.45l-.24 1.86c.51 1.53 1.08 3 1.67 4.54a7.14 7.14 0 01.65 2.57 72.88 72.88 0 0037.55 0 .34.34 0 010-.09 10.44 10.44 0 01-.24-2.55 65.89 65.89 0 011-7.16 24.47 24.47 0 00.19-3.52v-.42c-.03-.38-.04-.72-.05-1.05z",
  transform: "translate(-43.2 -23.86)",
  fill: "url(#PersonInput_svg__b)"
}), /*#__PURE__*/createElement("path", {
  fill: "#493545",
  d: "M284.28 397.95h46v31h-46z"
}), /*#__PURE__*/createElement("path", {
  d: "M337.92 432.14l-19.25 27.12-20.12-1.75s-26.25 1.74-8.75-18.37c8.41-9.67 11.16-17.73 11.75-23.48.64-6.22-1.25-9.76-1.25-9.76l21.87-2.62a16.32 16.32 0 00-.36 9.13c2.74 11.36 16.11 19.73 16.11 19.73z",
  fill: "#c77485"
}), /*#__PURE__*/createElement("path", {
  d: "M321.8 412.38a21.86 21.86 0 01-20.26 3.26c.64-6.22-1.25-9.76-1.25-9.76l21.87-2.62a16.32 16.32 0 00-.36 9.12z",
  opacity: 0.1
}), /*#__PURE__*/createElement("circle", {
  cx: 308.61,
  cy: 394.07,
  r: 21.87,
  fill: "#c77485"
}), /*#__PURE__*/createElement("path", {
  d: "M337.12 433.26l-.51-2-.44-1.76-.65-2.6-.12-.48-.1-.4s.52-1.57-2.91-1.06l-.64.11c-.54.11-1.17.26-1.89.46l-.65.2-.86.27a18.75 18.75 0 00-7.26 4.38 16.35 16.35 0 00-2.43 2.94c-.07.1-.12.19-.18.27a9.44 9.44 0 00-.63 1.16c0 7.88-7.88 17.5-7.88 17.5l-7.69-11.11-.15-.22-1.83-2.66-.65-.86-.22-.3-4-5.37-1-1.34-.33-.45-.49-.65-1.15-1.53-4.5 2.63-6 3.5-3.5 22.75v.63l.11 1.88.73 12.36v.17l-1.28 5.12.19.1a65.94 65.94 0 009.4 4.16l.85.3c1 .33 1.94.63 2.92.92a3.54 3.54 0 01.08.45v-.43a68.33 68.33 0 0037.55 0l.23-.07c.57-.16 1.15-.33 1.71-.52l.91-.29a67 67 0 007.24-2.9l.84-17.9.6-12.91v-.74z",
  opacity: 0.1
}), /*#__PURE__*/createElement("path", {
  d: "M329.92 466.51c0-.4 0-.8-.07-1.2s-.06-.75-.11-1.13-.09-.76-.14-1.14-.12-.76-.19-1.14-.14-.76-.22-1.14c0-.13-.05-.25-.08-.38-.11-.5-.23-1-.36-1.51s-.21-.81-.33-1.21c0-.18-.1-.36-.16-.53s-.17-.58-.26-.87l-.18-.56c-.08-.25-.16-.5-.25-.75-.15-.45-.31-.89-.47-1.34s-.33-.89-.5-1.33c-.34-.9-.71-1.79-1.08-2.68-1.45-3.46-3.08-6.87-4.58-10.25a56.67 56.67 0 01-2.14-5.43l-.19.27a11.55 11.55 0 00-.81 1.44c0 7.87-7.88 17.5-7.88 17.5l-7.93-11.55-6.94 10.67c-1 .53-2 2.35-2.78 4.94-.22.7-.43 1.46-.63 2.27-.14.54-.27 1.11-.39 1.68-.07.29-.13.58-.19.88l-.18.91v.14c-.12.62-.24 1.26-.35 1.91s-.24 1.4-.35 2.11q-.12.69-.21 1.38c-.14.89-.26 1.79-.38 2.68-.07.52-.14 1-.2 1.55l-.24 2a95.43 95.43 0 001.67 4.85 8.06 8.06 0 01.65 2.75 68.33 68.33 0 0037.55 0 .38.38 0 010-.1 11.91 11.91 0 01-.24-2.73 75 75 0 011-7.65 28 28 0 00.19-3.76v-.45c-.03-.38-.04-.74-.05-1.1zm0 0c0-.4 0-.8-.07-1.2s-.06-.75-.11-1.13-.09-.76-.14-1.14-.12-.76-.19-1.14-.14-.76-.22-1.14c0-.13-.05-.25-.08-.38-.11-.5-.23-1-.36-1.51s-.21-.81-.33-1.21c0-.18-.1-.36-.16-.53s-.17-.58-.26-.87l-.18-.56c-.08-.25-.16-.5-.25-.75-.15-.45-.31-.89-.47-1.34s-.33-.89-.5-1.33c-.34-.9-.71-1.79-1.08-2.68-1.45-3.46-3.08-6.87-4.58-10.25a56.67 56.67 0 01-2.14-5.43l-.19.27a11.55 11.55 0 00-.81 1.44c0 7.87-7.88 17.5-7.88 17.5l-7.93-11.55-6.94 10.67c-1 .53-2 2.35-2.78 4.94-.22.7-.43 1.46-.63 2.27-.14.54-.27 1.11-.39 1.68-.07.29-.13.58-.19.88l-.18.91v.14c-.12.62-.24 1.26-.35 1.91s-.24 1.4-.35 2.11q-.12.69-.21 1.38c-.14.89-.26 1.79-.38 2.68-.07.52-.14 1-.2 1.55l-.24 2a95.43 95.43 0 001.67 4.85 8.06 8.06 0 01.65 2.75 68.33 68.33 0 0037.55 0 .38.38 0 010-.1 11.91 11.91 0 01-.24-2.73 75 75 0 011-7.65 28 28 0 00.19-3.76v-.45c-.03-.38-.04-.74-.05-1.1zm0 0c0-.4 0-.8-.07-1.2s-.06-.75-.11-1.13-.09-.76-.14-1.14-.12-.76-.19-1.14-.14-.76-.22-1.14c0-.13-.05-.25-.08-.38-.11-.5-.23-1-.36-1.51s-.21-.81-.33-1.21c0-.18-.1-.36-.16-.53s-.17-.58-.26-.87l-.18-.56c-.08-.25-.16-.5-.25-.75-.15-.45-.31-.89-.47-1.34s-.33-.89-.5-1.33c-.34-.9-.71-1.79-1.08-2.68-1.45-3.46-3.08-6.87-4.58-10.25a56.67 56.67 0 01-2.14-5.43l-.19.27a11.55 11.55 0 00-.81 1.44c0 7.87-7.88 17.5-7.88 17.5l-7.93-11.55-6.94 10.67c-1 .53-2 2.35-2.78 4.94-.22.7-.43 1.46-.63 2.27-.14.54-.27 1.11-.39 1.68-.07.29-.13.58-.19.88l-.18.91v.14c-.12.62-.24 1.26-.35 1.91s-.24 1.4-.35 2.11q-.12.69-.21 1.38c-.14.89-.26 1.79-.38 2.68-.07.52-.14 1-.2 1.55l-.24 2a95.43 95.43 0 001.67 4.85 8.06 8.06 0 01.65 2.75 68.33 68.33 0 0037.55 0 .38.38 0 010-.1 11.91 11.91 0 01-.24-2.73 75 75 0 011-7.65 28 28 0 00.19-3.76v-.45c-.03-.38-.04-.74-.05-1.1zm10.6-18.77l-3.57-14.25-.61-2.44-.17-.67-.87-3.48a.66.66 0 000-.09.8.8 0 00-.07-.45c-.13-.26-.46-.53-1.23-.6a6.22 6.22 0 00-.88 0 15.23 15.23 0 00-2.57.48c-.41.11-.85.23-1.32.38l-.86.27h-.08a19.08 19.08 0 00-6.3 3.5 17 17 0 00-3.2 3.54l-.19.27a11.55 11.55 0 00-.81 1.44c0 7.87-7.88 17.5-7.88 17.5l-7.93-11.55-.45-.65-.08-.11-1.15-1.69-.87-1.16-.23-.3-4.1-5.47-1.3-1.77v-.06l-.45-.61-.86-1.14-3 1.75-7.5 4.37-3.46 22.51v.24l.1 1.64.74 12.53v.71l-1.13 4.51a65.94 65.94 0 009.4 4.16l.85.3c1 .33 1.94.63 2.92.92a3.54 3.54 0 01.08.45v-.43a68.33 68.33 0 0037.55 0l.23-.07c.57-.16 1.15-.33 1.71-.52l.91-.29a67 67 0 007.24-2.9l.83-17.88.6-12.77zm-49.18 34.53a3.54 3.54 0 01.08.45v-.43zm38.58-15.76c0-.4 0-.8-.07-1.2s-.06-.75-.11-1.13-.09-.76-.14-1.14-.12-.76-.19-1.14-.14-.76-.22-1.14c0-.13-.05-.25-.08-.38-.11-.5-.23-1-.36-1.51s-.21-.81-.33-1.21c0-.18-.1-.36-.16-.53s-.17-.58-.26-.87l-.18-.56c-.08-.25-.16-.5-.25-.75-.15-.45-.31-.89-.47-1.34s-.33-.89-.5-1.33c-.34-.9-.71-1.79-1.08-2.68-1.45-3.46-3.08-6.87-4.58-10.25a56.67 56.67 0 01-2.14-5.43l-.19.27a11.55 11.55 0 00-.81 1.44c0 7.87-7.88 17.5-7.88 17.5l-7.93-11.55-6.94 10.67c-1 .53-2 2.35-2.78 4.94-.22.7-.43 1.46-.63 2.27-.14.54-.27 1.11-.39 1.68-.07.29-.13.58-.19.88l-.18.91v.14c-.12.62-.24 1.26-.35 1.91s-.24 1.4-.35 2.11q-.12.69-.21 1.38c-.14.89-.26 1.79-.38 2.68-.07.52-.14 1-.2 1.55l-.24 2a95.43 95.43 0 001.67 4.85 8.06 8.06 0 01.65 2.75 68.33 68.33 0 0037.55 0 .38.38 0 010-.1 11.91 11.91 0 01-.24-2.73 75 75 0 011-7.65 28 28 0 00.19-3.76v-.45c-.03-.38-.04-.74-.05-1.1zm0 0c0-.4 0-.8-.07-1.2s-.06-.75-.11-1.13-.09-.76-.14-1.14-.12-.76-.19-1.14-.14-.76-.22-1.14c0-.13-.05-.25-.08-.38-.11-.5-.23-1-.36-1.51s-.21-.81-.33-1.21c0-.18-.1-.36-.16-.53s-.17-.58-.26-.87l-.18-.56c-.08-.25-.16-.5-.25-.75-.15-.45-.31-.89-.47-1.34s-.33-.89-.5-1.33c-.34-.9-.71-1.79-1.08-2.68-1.45-3.46-3.08-6.87-4.58-10.25a56.67 56.67 0 01-2.14-5.43l-.19.27a11.55 11.55 0 00-.81 1.44c0 7.87-7.88 17.5-7.88 17.5l-7.93-11.55-6.94 10.67c-1 .53-2 2.35-2.78 4.94-.22.7-.43 1.46-.63 2.27-.14.54-.27 1.11-.39 1.68-.07.29-.13.58-.19.88l-.18.91v.14c-.12.62-.24 1.26-.35 1.91s-.24 1.4-.35 2.11q-.12.69-.21 1.38c-.14.89-.26 1.79-.38 2.68-.07.52-.14 1-.2 1.55l-.24 2a95.43 95.43 0 001.67 4.85 8.06 8.06 0 01.65 2.75 68.33 68.33 0 0037.55 0 .38.38 0 010-.1 11.91 11.91 0 01-.24-2.73 75 75 0 011-7.65 28 28 0 00.19-3.76v-.45c-.03-.38-.04-.74-.05-1.1zm0 0c0-.4 0-.8-.07-1.2s-.06-.75-.11-1.13-.09-.76-.14-1.14-.12-.76-.19-1.14-.14-.76-.22-1.14c0-.13-.05-.25-.08-.38-.11-.5-.23-1-.36-1.51s-.21-.81-.33-1.21c0-.18-.1-.36-.16-.53s-.17-.58-.26-.87l-.18-.56c-.08-.25-.16-.5-.25-.75-.15-.45-.31-.89-.47-1.34s-.33-.89-.5-1.33c-.34-.9-.71-1.79-1.08-2.68-1.45-3.46-3.08-6.87-4.58-10.25a56.67 56.67 0 01-2.14-5.43l-.19.27a11.55 11.55 0 00-.81 1.44c0 7.87-7.88 17.5-7.88 17.5l-7.93-11.55-6.94 10.67c-1 .53-2 2.35-2.78 4.94-.22.7-.43 1.46-.63 2.27-.14.54-.27 1.11-.39 1.68-.07.29-.13.58-.19.88l-.18.91v.14c-.12.62-.24 1.26-.35 1.91s-.24 1.4-.35 2.11q-.12.69-.21 1.38c-.14.89-.26 1.79-.38 2.68-.07.52-.14 1-.2 1.55l-.24 2a95.43 95.43 0 001.67 4.85 8.06 8.06 0 01.65 2.75 68.33 68.33 0 0037.55 0 .38.38 0 010-.1 11.91 11.91 0 01-.24-2.73 75 75 0 011-7.65 28 28 0 00.19-3.76v-.45c-.03-.38-.04-.74-.05-1.1zm0 0c0-.4 0-.8-.07-1.2s-.06-.75-.11-1.13-.09-.76-.14-1.14-.12-.76-.19-1.14-.14-.76-.22-1.14c0-.13-.05-.25-.08-.38-.11-.5-.23-1-.36-1.51s-.21-.81-.33-1.21c0-.18-.1-.36-.16-.53s-.17-.58-.26-.87l-.18-.56c-.08-.25-.16-.5-.25-.75-.15-.45-.31-.89-.47-1.34s-.33-.89-.5-1.33c-.34-.9-.71-1.79-1.08-2.68-1.45-3.46-3.08-6.87-4.58-10.25a56.67 56.67 0 01-2.14-5.43l-.19.27a11.55 11.55 0 00-.81 1.44c0 7.87-7.88 17.5-7.88 17.5l-7.93-11.55-6.94 10.67c-1 .53-2 2.35-2.78 4.94-.22.7-.43 1.46-.63 2.27-.14.54-.27 1.11-.39 1.68-.07.29-.13.58-.19.88l-.18.91v.14c-.12.62-.24 1.26-.35 1.91s-.24 1.4-.35 2.11q-.12.69-.21 1.38c-.14.89-.26 1.79-.38 2.68-.07.52-.14 1-.2 1.55l-.24 2a95.43 95.43 0 001.67 4.85 8.06 8.06 0 01.65 2.75 68.33 68.33 0 0037.55 0 .38.38 0 010-.1 11.91 11.91 0 01-.24-2.73 75 75 0 011-7.65 28 28 0 00.19-3.76v-.45c-.03-.38-.04-.74-.05-1.1zm0 0c0-.4 0-.8-.07-1.2s-.06-.75-.11-1.13-.09-.76-.14-1.14-.12-.76-.19-1.14-.14-.76-.22-1.14c0-.13-.05-.25-.08-.38-.11-.5-.23-1-.36-1.51s-.21-.81-.33-1.21c0-.18-.1-.36-.16-.53s-.17-.58-.26-.87l-.18-.56c-.08-.25-.16-.5-.25-.75-.15-.45-.31-.89-.47-1.34s-.33-.89-.5-1.33c-.34-.9-.71-1.79-1.08-2.68-1.45-3.46-3.08-6.87-4.58-10.25a56.67 56.67 0 01-2.14-5.43l-.19.27a11.55 11.55 0 00-.81 1.44c0 7.87-7.88 17.5-7.88 17.5l-7.93-11.55-6.94 10.67c-1 .53-2 2.35-2.78 4.94-.22.7-.43 1.46-.63 2.27-.14.54-.27 1.11-.39 1.68-.07.29-.13.58-.19.88l-.18.91v.14c-.12.62-.24 1.26-.35 1.91s-.24 1.4-.35 2.11q-.12.69-.21 1.38c-.14.89-.26 1.79-.38 2.68-.07.52-.14 1-.2 1.55l-.24 2a95.43 95.43 0 001.67 4.85 8.06 8.06 0 01.65 2.75 68.33 68.33 0 0037.55 0 .38.38 0 010-.1 11.91 11.91 0 01-.24-2.73 75 75 0 011-7.65 28 28 0 00.19-3.76v-.45c-.03-.38-.04-.74-.05-1.1zm0 0c0-.4 0-.8-.07-1.2s-.06-.75-.11-1.13-.09-.76-.14-1.14-.12-.76-.19-1.14-.14-.76-.22-1.14c0-.13-.05-.25-.08-.38-.11-.5-.23-1-.36-1.51s-.21-.81-.33-1.21c0-.18-.1-.36-.16-.53s-.17-.58-.26-.87l-.18-.56c-.08-.25-.16-.5-.25-.75-.15-.45-.31-.89-.47-1.34s-.33-.89-.5-1.33c-.34-.9-.71-1.79-1.08-2.68-1.45-3.46-3.08-6.87-4.58-10.25a56.67 56.67 0 01-2.14-5.43l-.19.27a11.55 11.55 0 00-.81 1.44c0 7.87-7.88 17.5-7.88 17.5l-7.93-11.55-6.94 10.67c-1 .53-2 2.35-2.78 4.94-.22.7-.43 1.46-.63 2.27-.14.54-.27 1.11-.39 1.68-.07.29-.13.58-.19.88l-.18.91v.14c-.12.62-.24 1.26-.35 1.91s-.24 1.4-.35 2.11q-.12.69-.21 1.38c-.14.89-.26 1.79-.38 2.68-.07.52-.14 1-.2 1.55l-.24 2a95.43 95.43 0 001.67 4.85 8.06 8.06 0 01.65 2.75 68.33 68.33 0 0037.55 0 .38.38 0 010-.1 11.91 11.91 0 01-.24-2.73 75 75 0 011-7.65 28 28 0 00.19-3.76v-.45c-.03-.38-.04-.74-.05-1.1zm0 0c0-.4 0-.8-.07-1.2s-.06-.75-.11-1.13-.09-.76-.14-1.14-.12-.76-.19-1.14-.14-.76-.22-1.14c0-.13-.05-.25-.08-.38-.11-.5-.23-1-.36-1.51s-.21-.81-.33-1.21c0-.18-.1-.36-.16-.53s-.17-.58-.26-.87l-.18-.56c-.08-.25-.16-.5-.25-.75-.15-.45-.31-.89-.47-1.34s-.33-.89-.5-1.33c-.34-.9-.71-1.79-1.08-2.68-1.45-3.46-3.08-6.87-4.58-10.25a56.67 56.67 0 01-2.14-5.43l-.19.27a11.55 11.55 0 00-.81 1.44c0 7.87-7.88 17.5-7.88 17.5l-7.93-11.55-6.94 10.67c-1 .53-2 2.35-2.78 4.94-.22.7-.43 1.46-.63 2.27-.14.54-.27 1.11-.39 1.68-.07.29-.13.58-.19.88l-.18.91v.14c-.12.62-.24 1.26-.35 1.91s-.24 1.4-.35 2.11q-.12.69-.21 1.38c-.14.89-.26 1.79-.38 2.68-.07.52-.14 1-.2 1.55l-.24 2a95.43 95.43 0 001.67 4.85 8.06 8.06 0 01.65 2.75 68.33 68.33 0 0037.55 0 .38.38 0 010-.1 11.91 11.91 0 01-.24-2.73 75 75 0 011-7.65 28 28 0 00.19-3.76v-.45c-.03-.38-.04-.74-.05-1.1zm0 0c0-.4 0-.8-.07-1.2s-.06-.75-.11-1.13-.09-.76-.14-1.14-.12-.76-.19-1.14-.14-.76-.22-1.14c0-.13-.05-.25-.08-.38-.11-.5-.23-1-.36-1.51s-.21-.81-.33-1.21c0-.18-.1-.36-.16-.53s-.17-.58-.26-.87l-.18-.56c-.08-.25-.16-.5-.25-.75-.15-.45-.31-.89-.47-1.34s-.33-.89-.5-1.33c-.34-.9-.71-1.79-1.08-2.68-1.45-3.46-3.08-6.87-4.58-10.25a56.67 56.67 0 01-2.14-5.43l-.19.27a11.55 11.55 0 00-.81 1.44c0 7.87-7.88 17.5-7.88 17.5l-7.93-11.55-6.94 10.67c-1 .53-2 2.35-2.78 4.94-.22.7-.43 1.46-.63 2.27-.14.54-.27 1.11-.39 1.68-.07.29-.13.58-.19.88l-.18.91v.14c-.12.62-.24 1.26-.35 1.91s-.24 1.4-.35 2.11q-.12.69-.21 1.38c-.14.89-.26 1.79-.38 2.68-.07.52-.14 1-.2 1.55l-.24 2a95.43 95.43 0 001.67 4.85 8.06 8.06 0 01.65 2.75 68.33 68.33 0 0037.55 0 .38.38 0 010-.1 11.91 11.91 0 01-.24-2.73 75 75 0 011-7.65 28 28 0 00.19-3.76v-.45c-.03-.38-.04-.74-.05-1.1z",
  fill: "#fff"
}), /*#__PURE__*/createElement("path", {
  d: "M302.13 440.91l-.67-.09a24.36 24.36 0 01-3-.6l-.37-.1c-2.44-.69-5.11-1.93-5.71-4.11a3.89 3.89 0 01.06-2.13 18.26 18.26 0 011.36-3.44v-.06a4.77 4.77 0 01.25-.45 10 10 0 013.61-3.93l-1.2.19-10.16 1.65-15.75 2.54s-2.8-.56-6.61 9.94c0 .13-.09.25-.13.39-.92 2.57-1.89 5.78-2.89 9.79-.69 2.78-1.32 5.51-1.9 8.16-.17.8-.34 1.59-.5 2.37a63.54 63.54 0 005.81 6l.33.31a68.26 68.26 0 0013.32 9.43l.19.1a65.94 65.94 0 009.4 4.16l.85.3c.18-1.85.38-3.9.62-6 0-.21 0-.42.08-.63l.24-2c.06-.51.13-1 .2-1.55.12-.89.24-1.79.38-2.68q.09-.69.21-1.38a116.063 116.063 0 01.7-4.02v-.14l.18-.91c.06-.3.12-.59.19-.88.12-.57.25-1.14.39-1.68.2-.81.41-1.57.63-2.27.8-2.59 1.73-4.41 2.78-4.94l6.94-10.67.29-.45.13-.2z",
  opacity: 0.1
}), /*#__PURE__*/createElement("path", {
  d: "M301.54 440.93l-7.37 11.32c-1 .51-1.94 2.28-2.73 4.79-.23.74-.46 1.55-.68 2.4a119.57 119.57 0 00-2.26 13.09c0 .2 0 .4-.08.6-.34 2.78-.62 5.51-.85 7.92a65.94 65.94 0 01-9.4-4.16l-.19-.1a68.26 68.26 0 01-13.32-9.43l-.33-.31a63.54 63.54 0 01-5.81-6c-.24-.27-.47-.55-.7-.83.11-.52.22-1 .34-1.56.57-2.65 1.2-5.37 1.89-8.14a98.53 98.53 0 013.4-11.2 3.06 3.06 0 01.13-.32c3.54-9.11 6.09-8.6 6.09-8.6l16.63-2.68 10.5-1.7-.33.19a10.65 10.65 0 00-2.89 3.08l-.29.49c-.12.19-.23.4-.35.61a17.72 17.72 0 00-1.38 3.5 3.68 3.68 0 00.24 2.86c1 1.94 3.84 3 6.17 3.58l.39.1a25.09 25.09 0 003.18.5z",
  fill: "#444176"
}), /*#__PURE__*/createElement("path", {
  d: "M359.33 461.14l-.41-8.88c1.75-14-1.75-14.87-1.75-14.87l-4.16-2h-.11l-16.73-8.11-.65-.32-.2-.09-2.18-1.06-1.38-.67-2.58-1.25-.87-.42V426.94c0 1 .09 2.17.17 3.53.18 3.42.51 8 1.1 13.4.33 3.13.75 6.55 1.27 10.22.31 2.17.53 4.33.67 6.44a113.33 113.33 0 01-.66 21.3l.91-.29a67 67 0 007.24-2.9 66.46 66.46 0 0012.9-7.92l.18-.13a66.72 66.72 0 007.26-6.59z",
  opacity: 0.1
}), /*#__PURE__*/createElement("path", {
  d: "M360.21 461.14l-.41-8.9c1.75-14-1.75-14.87-1.75-14.87l-5-2.42h-.1l-16.78-8.14-.77-.37-.15-.07-1.23-.6-1.63-.79-3.22-1.56v3.18c0 1 .09 2.31.18 3.8.17 3.19.47 7.37 1 12.34.36 3.41.81 7.2 1.4 11.28q.46 3.27.66 6.47a113.18 113.18 0 01-.62 21 67 67 0 007.24-2.9 66.46 66.46 0 0012.9-7.92l.18-.13a66.72 66.72 0 007.26-6.59q.44-.44.84-.9z",
  fill: "#444176"
}), /*#__PURE__*/createElement("path", {
  d: "M289.5 370.08c-1 1.38-.92 3.28-1.37 5-1.07 3.91-5.31 6.36-6.28 10.3-.57 2.3.09 4.74-.3 7.08-.71 4.31-4.65 7.23-6.85 11a14.84 14.84 0 00-.91 12.9 20.68 20.68 0 011.27 3.26 11.91 11.91 0 01-.31 5c-.75 3.56-1.52 7.48.2 10.69 1.45 2.71 4.46 4.3 7.49 4.8a29.11 29.11 0 009.17-.42c3.31-.51 6.7-1.1 9.58-2.8l-10.83-26.14c-1.09-2.64-2.21-5.37-2.2-8.23a18.09 18.09 0 011.35-6.14 53.2 53.2 0 019-15.55c1.57 1.82 1.45 4.59 2.76 6.61a10.43 10.43 0 004.46 3.33 147.75 147.75 0 0015.79 6.6 2.07 2.07 0 011.54 3.08l-4.08 16.84c-.9 3.71-1.69 8 .62 11s7.52 4.42 7.55 8.29a13.25 13.25 0 000 1.84c.27 1.81 2.42 2.68 4.25 2.77a12.67 12.67 0 0012.71-10.37c1-6.62-3.38-12.72-5.21-19.17-3.08-10.85 1-23.58-5.05-33.11-4.9-7.73-13.83-9.83-22.31-10.79-5.95-.7-17.85-3.2-22.04 2.33z",
  opacity: 0.1
}), /*#__PURE__*/createElement("path", {
  d: "M289.5 369.08c-1 1.38-.92 3.28-1.37 5-1.07 3.91-5.31 6.36-6.28 10.3-.57 2.3.09 4.74-.3 7.08-.71 4.31-4.65 7.23-6.85 11a14.84 14.84 0 00-.91 12.9 20.68 20.68 0 011.27 3.26 11.91 11.91 0 01-.31 5c-.75 3.56-1.52 7.48.2 10.69 1.45 2.71 4.46 4.3 7.49 4.8a29.11 29.11 0 009.17-.42c3.31-.51 6.7-1.1 9.58-2.8l-10.83-26.14c-1.09-2.64-2.21-5.37-2.2-8.23a18.09 18.09 0 011.35-6.14 53.2 53.2 0 019-15.55c1.57 1.82 1.45 4.59 2.76 6.61a10.43 10.43 0 004.46 3.33 147.75 147.75 0 0015.79 6.6 2.07 2.07 0 011.54 3.08l-4.08 16.84c-.9 3.71-1.69 8 .62 11s7.52 4.42 7.55 8.29a13.25 13.25 0 000 1.84c.27 1.81 2.42 2.68 4.25 2.77a12.67 12.67 0 0012.71-10.37c1-6.62-3.38-12.72-5.21-19.17-3.08-10.85 1-23.58-5.05-33.11-4.9-7.73-13.83-9.83-22.31-10.79-5.95-.7-17.85-3.2-22.04 2.33z",
  fill: "#493545"
}));

var _ref13 = /*#__PURE__*/createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/createElement("path", {
  d: "M378.28 657.94a67.68 67.68 0 01-16.37 44.25c-.52.61-1.06 1.21-1.61 1.8q-.41.46-.84.9a66.72 66.72 0 01-7.26 6.59l-.18.13a66.46 66.46 0 01-12.9 7.92 67 67 0 01-7.24 2.9l-.91.29c-.56.19-1.14.36-1.71.52l-.23.07a68.33 68.33 0 01-37.55 0h-.1c-1-.29-2-.59-2.92-.92l-.85-.3a65.94 65.94 0 01-9.4-4.16l-.19-.1a68.26 68.26 0 01-13.32-9.43l-.33-.31a63.54 63.54 0 01-5.81-6c-.24-.27-.47-.55-.7-.83-.44-.52-.86-1.06-1.28-1.6a68 68 0 11121.7-41.72z",
  fill: "#c0bccf"
}), /*#__PURE__*/createElement("path", {
  d: "M403.41 725.62l-.41-9c1.75-14.23-1.75-15.12-1.75-15.12l-5-2.46-.1-.05-16.78-8.27-.77-.38-.1-.41s.33-1-1.33-1.17a6.09 6.09 0 01-.42-2.55c.17-1.92 1.62-3.43 2.75-5a20.54 20.54 0 003.29-14.57 34.27 34.27 0 00-5.58-14.08l-.32-.47a16.94 16.94 0 00.59-4.42c0-11.51-11.64-20.84-26-20.84-13 0-23.83 7.69-25.71 17.72a9.11 9.11 0 00-.79 1.24c-2.64 4.94 1.44 8.63 1.57 13.56.09 3.4-2.19 6.31-4 9.19s-3.15 6.71-1.29 9.55c.61.94 1.53 1.65 2.08 2.63 1.93 3.41-1.28 7.32-2.45 11.06a10.58 10.58 0 00-.32 1.33l-7.72 1.26s-2.55-.52-6.09 8.74a3.14 3.14 0 00-.13.33 101.39 101.39 0 00-3.4 11.39c-.69 2.82-1.32 5.58-1.89 8.27-.12.53-.23 1.06-.34 1.59.23.28.46.57.7.84a64.13 64.13 0 005.81 6.12l.33.32a68.28 68.28 0 0013.32 9.59l.19.1a65.4 65.4 0 009.4 4.23l.85.3c1 .34 1.94.64 2.92.94a3.65 3.65 0 01.08.46v-.44a67.26 67.26 0 0037.55 0l.23-.07c.57-.16 1.15-.34 1.71-.53l.91-.29a66.41 66.41 0 007.24-2.95 66.28 66.28 0 0012.9-8.05l.18-.13a67.13 67.13 0 007.26-6.7q.44-.44.84-.91z",
  transform: "translate(-43.2 -23.86)",
  fill: "url(#PersonInput_svg__c)"
}), /*#__PURE__*/createElement("path", {
  d: "M283.35 636.93c.09 3.35-2.19 6.21-4 9s-3.15 6.6-1.29 9.39c.61.92 1.53 1.63 2.08 2.59 1.93 3.35-1.28 7.2-2.45 10.88-1.35 4.25.22 9 3.06 12.45s6.76 5.78 10.72 7.83a95.67 95.67 0 0026.52 9.44c4.84.89 10 1.29 14.54-.65a15.46 15.46 0 008.73-17c-1.15-5.26-5-9.49-7-14.46a6.77 6.77 0 01-.66-3.13c.17-1.89 1.62-3.37 2.75-4.9a20 20 0 003.24-14.23 33.4 33.4 0 00-5.58-13.86 15.18 15.18 0 00-4-4.4c-2.18-1.47-4.88-1.89-7.48-2.26-10.86-1.52-22.11-3.18-33.06-3.74-3.46-.18-6 .5-7.71 3.74-2.61 4.83 1.46 8.46 1.59 13.31z",
  fill: "#444176"
}), /*#__PURE__*/createElement("path", {
  d: "M339.28 670.94l-20.61 29.31-20.12-1.75s-.66 7-8.75-18.37c-4.52-14.19 4.67-9.26 6.48-13.19s5-7.4 5.27-10.3c.64-6.22-1.25-9.76-1.25-9.76l21.87-2.62a16.32 16.32 0 00-.36 9.13c2.74 11.38 17.47 17.55 17.47 17.55z",
  fill: "#c77485"
}), /*#__PURE__*/createElement("ellipse", {
  cx: 308.28,
  cy: 625.45,
  rx: 26,
  ry: 20.5,
  fill: "#444176"
}), /*#__PURE__*/createElement("path", {
  d: "M321.8 653.38a21.86 21.86 0 01-20.26 3.26c.64-6.22-1.25-9.76-1.25-9.76l21.87-2.62a16.32 16.32 0 00-.36 9.12z",
  opacity: 0.1
}), /*#__PURE__*/createElement("circle", {
  cx: 308.61,
  cy: 635.07,
  r: 21.87,
  fill: "#c77485"
}), /*#__PURE__*/createElement("path", {
  d: "M337.12 674.26l-.51-2-.44-1.76-.65-2.6-.12-.48-.1-.4s.52-1.57-2.91-1.06l-.64.11c-.54.11-1.17.26-1.89.46l-.65.2-.86.27a18.75 18.75 0 00-7.26 4.38 16.35 16.35 0 00-2.43 2.94c-.07.1-.12.19-.18.27a9.44 9.44 0 00-.63 1.16c0 7.88-7.88 17.5-7.88 17.5l-7.69-11.11-.15-.22-1.83-2.66-.65-.86-.22-.3-4-5.37-1-1.34-.33-.45-.49-.65-1.15-1.53-4.5 2.63-6 3.5-3.5 22.75v.63l.11 1.88.73 12.36v.17l-1.28 5.12.19.1a65.94 65.94 0 009.4 4.16l.85.3c1 .33 1.94.63 2.92.92a3.54 3.54 0 01.08.45v-.43a68.33 68.33 0 0037.55 0l.23-.07c.57-.16 1.15-.33 1.71-.52l.91-.29a67 67 0 007.24-2.9l.84-17.9.6-12.91v-.74z",
  opacity: 0.1
}), /*#__PURE__*/createElement("path", {
  d: "M329.92 707.51c0-.4 0-.8-.07-1.2s-.06-.75-.11-1.13-.09-.76-.14-1.14-.12-.76-.19-1.14-.14-.76-.22-1.14c0-.13-.05-.25-.08-.38-.11-.5-.23-1-.36-1.51s-.21-.81-.33-1.21c0-.18-.1-.36-.16-.53s-.17-.58-.26-.87l-.18-.56c-.08-.25-.16-.5-.25-.75-.15-.45-.31-.89-.47-1.34s-.33-.89-.5-1.33c-.34-.9-.71-1.79-1.08-2.68-1.45-3.46-3.08-6.87-4.58-10.25a56.67 56.67 0 01-2.14-5.43l-.19.27a11.55 11.55 0 00-.81 1.44c0 7.87-7.88 17.5-7.88 17.5l-7.93-11.55-6.94 10.67c-1 .53-2 2.35-2.78 4.94-.22.7-.43 1.46-.63 2.27-.14.54-.27 1.11-.39 1.68-.07.29-.13.58-.19.88l-.18.91v.14c-.12.62-.24 1.26-.35 1.91s-.24 1.4-.35 2.11q-.12.69-.21 1.38c-.14.89-.26 1.79-.38 2.68-.07.52-.14 1-.2 1.55l-.24 2a95.43 95.43 0 001.67 4.85 8.06 8.06 0 01.65 2.75 68.33 68.33 0 0037.55 0 .38.38 0 010-.1 11.91 11.91 0 01-.24-2.73 75 75 0 011-7.65 28 28 0 00.19-3.76v-.45c-.03-.38-.04-.74-.05-1.1zm0 0c0-.4 0-.8-.07-1.2s-.06-.75-.11-1.13-.09-.76-.14-1.14-.12-.76-.19-1.14-.14-.76-.22-1.14c0-.13-.05-.25-.08-.38-.11-.5-.23-1-.36-1.51s-.21-.81-.33-1.21c0-.18-.1-.36-.16-.53s-.17-.58-.26-.87l-.18-.56c-.08-.25-.16-.5-.25-.75-.15-.45-.31-.89-.47-1.34s-.33-.89-.5-1.33c-.34-.9-.71-1.79-1.08-2.68-1.45-3.46-3.08-6.87-4.58-10.25a56.67 56.67 0 01-2.14-5.43l-.19.27a11.55 11.55 0 00-.81 1.44c0 7.87-7.88 17.5-7.88 17.5l-7.93-11.55-6.94 10.67c-1 .53-2 2.35-2.78 4.94-.22.7-.43 1.46-.63 2.27-.14.54-.27 1.11-.39 1.68-.07.29-.13.58-.19.88l-.18.91v.14c-.12.62-.24 1.26-.35 1.91s-.24 1.4-.35 2.11q-.12.69-.21 1.38c-.14.89-.26 1.79-.38 2.68-.07.52-.14 1-.2 1.55l-.24 2a95.43 95.43 0 001.67 4.85 8.06 8.06 0 01.65 2.75 68.33 68.33 0 0037.55 0 .38.38 0 010-.1 11.91 11.91 0 01-.24-2.73 75 75 0 011-7.65 28 28 0 00.19-3.76v-.45c-.03-.38-.04-.74-.05-1.1zm0 0c0-.4 0-.8-.07-1.2s-.06-.75-.11-1.13-.09-.76-.14-1.14-.12-.76-.19-1.14-.14-.76-.22-1.14c0-.13-.05-.25-.08-.38-.11-.5-.23-1-.36-1.51s-.21-.81-.33-1.21c0-.18-.1-.36-.16-.53s-.17-.58-.26-.87l-.18-.56c-.08-.25-.16-.5-.25-.75-.15-.45-.31-.89-.47-1.34s-.33-.89-.5-1.33c-.34-.9-.71-1.79-1.08-2.68-1.45-3.46-3.08-6.87-4.58-10.25a56.67 56.67 0 01-2.14-5.43l-.19.27a11.55 11.55 0 00-.81 1.44c0 7.87-7.88 17.5-7.88 17.5l-7.93-11.55-6.94 10.67c-1 .53-2 2.35-2.78 4.94-.22.7-.43 1.46-.63 2.27-.14.54-.27 1.11-.39 1.68-.07.29-.13.58-.19.88l-.18.91v.14c-.12.62-.24 1.26-.35 1.91s-.24 1.4-.35 2.11q-.12.69-.21 1.38c-.14.89-.26 1.79-.38 2.68-.07.52-.14 1-.2 1.55l-.24 2a95.43 95.43 0 001.67 4.85 8.06 8.06 0 01.65 2.75 68.33 68.33 0 0037.55 0 .38.38 0 010-.1 11.91 11.91 0 01-.24-2.73 75 75 0 011-7.65 28 28 0 00.19-3.76v-.45c-.03-.38-.04-.74-.05-1.1zm10.6-18.77l-3.57-14.25-.61-2.44-.17-.67-.87-3.48a.66.66 0 000-.09.8.8 0 00-.07-.45c-.13-.26-.46-.53-1.23-.6a6.22 6.22 0 00-.88 0 15.23 15.23 0 00-2.57.48c-.41.11-.85.23-1.32.38l-.86.27h-.08a19.08 19.08 0 00-6.3 3.5 17 17 0 00-3.2 3.54l-.19.27a11.55 11.55 0 00-.81 1.44c0 7.87-7.88 17.5-7.88 17.5l-7.93-11.55-.45-.65-.08-.11-1.15-1.69-.87-1.16-.23-.3-4.1-5.47-1.3-1.77v-.06l-.45-.61-.86-1.14-3 1.75-7.5 4.37-3.46 22.51v.24l.1 1.64.74 12.53v.71l-1.13 4.51a65.94 65.94 0 009.4 4.16l.85.3c1 .33 1.94.63 2.92.92a3.54 3.54 0 01.08.45v-.43a68.33 68.33 0 0037.55 0l.23-.07c.57-.16 1.15-.33 1.71-.52l.91-.29a67 67 0 007.24-2.9l.83-17.88.6-12.77zm-49.18 34.53a3.54 3.54 0 01.08.45v-.43zm38.58-15.76c0-.4 0-.8-.07-1.2s-.06-.75-.11-1.13-.09-.76-.14-1.14-.12-.76-.19-1.14-.14-.76-.22-1.14c0-.13-.05-.25-.08-.38-.11-.5-.23-1-.36-1.51s-.21-.81-.33-1.21c0-.18-.1-.36-.16-.53s-.17-.58-.26-.87l-.18-.56c-.08-.25-.16-.5-.25-.75-.15-.45-.31-.89-.47-1.34s-.33-.89-.5-1.33c-.34-.9-.71-1.79-1.08-2.68-1.45-3.46-3.08-6.87-4.58-10.25a56.67 56.67 0 01-2.14-5.43l-.19.27a11.55 11.55 0 00-.81 1.44c0 7.87-7.88 17.5-7.88 17.5l-7.93-11.55-6.94 10.67c-1 .53-2 2.35-2.78 4.94-.22.7-.43 1.46-.63 2.27-.14.54-.27 1.11-.39 1.68-.07.29-.13.58-.19.88l-.18.91v.14c-.12.62-.24 1.26-.35 1.91s-.24 1.4-.35 2.11q-.12.69-.21 1.38c-.14.89-.26 1.79-.38 2.68-.07.52-.14 1-.2 1.55l-.24 2a95.43 95.43 0 001.67 4.85 8.06 8.06 0 01.65 2.75 68.33 68.33 0 0037.55 0 .38.38 0 010-.1 11.91 11.91 0 01-.24-2.73 75 75 0 011-7.65 28 28 0 00.19-3.76v-.45c-.03-.38-.04-.74-.05-1.1zm0 0c0-.4 0-.8-.07-1.2s-.06-.75-.11-1.13-.09-.76-.14-1.14-.12-.76-.19-1.14-.14-.76-.22-1.14c0-.13-.05-.25-.08-.38-.11-.5-.23-1-.36-1.51s-.21-.81-.33-1.21c0-.18-.1-.36-.16-.53s-.17-.58-.26-.87l-.18-.56c-.08-.25-.16-.5-.25-.75-.15-.45-.31-.89-.47-1.34s-.33-.89-.5-1.33c-.34-.9-.71-1.79-1.08-2.68-1.45-3.46-3.08-6.87-4.58-10.25a56.67 56.67 0 01-2.14-5.43l-.19.27a11.55 11.55 0 00-.81 1.44c0 7.87-7.88 17.5-7.88 17.5l-7.93-11.55-6.94 10.67c-1 .53-2 2.35-2.78 4.94-.22.7-.43 1.46-.63 2.27-.14.54-.27 1.11-.39 1.68-.07.29-.13.58-.19.88l-.18.91v.14c-.12.62-.24 1.26-.35 1.91s-.24 1.4-.35 2.11q-.12.69-.21 1.38c-.14.89-.26 1.79-.38 2.68-.07.52-.14 1-.2 1.55l-.24 2a95.43 95.43 0 001.67 4.85 8.06 8.06 0 01.65 2.75 68.33 68.33 0 0037.55 0 .38.38 0 010-.1 11.91 11.91 0 01-.24-2.73 75 75 0 011-7.65 28 28 0 00.19-3.76v-.45c-.03-.38-.04-.74-.05-1.1zm0 0c0-.4 0-.8-.07-1.2s-.06-.75-.11-1.13-.09-.76-.14-1.14-.12-.76-.19-1.14-.14-.76-.22-1.14c0-.13-.05-.25-.08-.38-.11-.5-.23-1-.36-1.51s-.21-.81-.33-1.21c0-.18-.1-.36-.16-.53s-.17-.58-.26-.87l-.18-.56c-.08-.25-.16-.5-.25-.75-.15-.45-.31-.89-.47-1.34s-.33-.89-.5-1.33c-.34-.9-.71-1.79-1.08-2.68-1.45-3.46-3.08-6.87-4.58-10.25a56.67 56.67 0 01-2.14-5.43l-.19.27a11.55 11.55 0 00-.81 1.44c0 7.87-7.88 17.5-7.88 17.5l-7.93-11.55-6.94 10.67c-1 .53-2 2.35-2.78 4.94-.22.7-.43 1.46-.63 2.27-.14.54-.27 1.11-.39 1.68-.07.29-.13.58-.19.88l-.18.91v.14c-.12.62-.24 1.26-.35 1.91s-.24 1.4-.35 2.11q-.12.69-.21 1.38c-.14.89-.26 1.79-.38 2.68-.07.52-.14 1-.2 1.55l-.24 2a95.43 95.43 0 001.67 4.85 8.06 8.06 0 01.65 2.75 68.33 68.33 0 0037.55 0 .38.38 0 010-.1 11.91 11.91 0 01-.24-2.73 75 75 0 011-7.65 28 28 0 00.19-3.76v-.45c-.03-.38-.04-.74-.05-1.1zm0 0c0-.4 0-.8-.07-1.2s-.06-.75-.11-1.13-.09-.76-.14-1.14-.12-.76-.19-1.14-.14-.76-.22-1.14c0-.13-.05-.25-.08-.38-.11-.5-.23-1-.36-1.51s-.21-.81-.33-1.21c0-.18-.1-.36-.16-.53s-.17-.58-.26-.87l-.18-.56c-.08-.25-.16-.5-.25-.75-.15-.45-.31-.89-.47-1.34s-.33-.89-.5-1.33c-.34-.9-.71-1.79-1.08-2.68-1.45-3.46-3.08-6.87-4.58-10.25a56.67 56.67 0 01-2.14-5.43l-.19.27a11.55 11.55 0 00-.81 1.44c0 7.87-7.88 17.5-7.88 17.5l-7.93-11.55-6.94 10.67c-1 .53-2 2.35-2.78 4.94-.22.7-.43 1.46-.63 2.27-.14.54-.27 1.11-.39 1.68-.07.29-.13.58-.19.88l-.18.91v.14c-.12.62-.24 1.26-.35 1.91s-.24 1.4-.35 2.11q-.12.69-.21 1.38c-.14.89-.26 1.79-.38 2.68-.07.52-.14 1-.2 1.55l-.24 2a95.43 95.43 0 001.67 4.85 8.06 8.06 0 01.65 2.75 68.33 68.33 0 0037.55 0 .38.38 0 010-.1 11.91 11.91 0 01-.24-2.73 75 75 0 011-7.65 28 28 0 00.19-3.76v-.45c-.03-.38-.04-.74-.05-1.1zm0 0c0-.4 0-.8-.07-1.2s-.06-.75-.11-1.13-.09-.76-.14-1.14-.12-.76-.19-1.14-.14-.76-.22-1.14c0-.13-.05-.25-.08-.38-.11-.5-.23-1-.36-1.51s-.21-.81-.33-1.21c0-.18-.1-.36-.16-.53s-.17-.58-.26-.87l-.18-.56c-.08-.25-.16-.5-.25-.75-.15-.45-.31-.89-.47-1.34s-.33-.89-.5-1.33c-.34-.9-.71-1.79-1.08-2.68-1.45-3.46-3.08-6.87-4.58-10.25a56.67 56.67 0 01-2.14-5.43l-.19.27a11.55 11.55 0 00-.81 1.44c0 7.87-7.88 17.5-7.88 17.5l-7.93-11.55-6.94 10.67c-1 .53-2 2.35-2.78 4.94-.22.7-.43 1.46-.63 2.27-.14.54-.27 1.11-.39 1.68-.07.29-.13.58-.19.88l-.18.91v.14c-.12.62-.24 1.26-.35 1.91s-.24 1.4-.35 2.11q-.12.69-.21 1.38c-.14.89-.26 1.79-.38 2.68-.07.52-.14 1-.2 1.55l-.24 2a95.43 95.43 0 001.67 4.85 8.06 8.06 0 01.65 2.75 68.33 68.33 0 0037.55 0 .38.38 0 010-.1 11.91 11.91 0 01-.24-2.73 75 75 0 011-7.65 28 28 0 00.19-3.76v-.45c-.03-.38-.04-.74-.05-1.1zm0 0c0-.4 0-.8-.07-1.2s-.06-.75-.11-1.13-.09-.76-.14-1.14-.12-.76-.19-1.14-.14-.76-.22-1.14c0-.13-.05-.25-.08-.38-.11-.5-.23-1-.36-1.51s-.21-.81-.33-1.21c0-.18-.1-.36-.16-.53s-.17-.58-.26-.87l-.18-.56c-.08-.25-.16-.5-.25-.75-.15-.45-.31-.89-.47-1.34s-.33-.89-.5-1.33c-.34-.9-.71-1.79-1.08-2.68-1.45-3.46-3.08-6.87-4.58-10.25a56.67 56.67 0 01-2.14-5.43l-.19.27a11.55 11.55 0 00-.81 1.44c0 7.87-7.88 17.5-7.88 17.5l-7.93-11.55-6.94 10.67c-1 .53-2 2.35-2.78 4.94-.22.7-.43 1.46-.63 2.27-.14.54-.27 1.11-.39 1.68-.07.29-.13.58-.19.88l-.18.91v.14c-.12.62-.24 1.26-.35 1.91s-.24 1.4-.35 2.11q-.12.69-.21 1.38c-.14.89-.26 1.79-.38 2.68-.07.52-.14 1-.2 1.55l-.24 2a95.43 95.43 0 001.67 4.85 8.06 8.06 0 01.65 2.75 68.33 68.33 0 0037.55 0 .38.38 0 010-.1 11.91 11.91 0 01-.24-2.73 75 75 0 011-7.65 28 28 0 00.19-3.76v-.45c-.03-.38-.04-.74-.05-1.1zm0 0c0-.4 0-.8-.07-1.2s-.06-.75-.11-1.13-.09-.76-.14-1.14-.12-.76-.19-1.14-.14-.76-.22-1.14c0-.13-.05-.25-.08-.38-.11-.5-.23-1-.36-1.51s-.21-.81-.33-1.21c0-.18-.1-.36-.16-.53s-.17-.58-.26-.87l-.18-.56c-.08-.25-.16-.5-.25-.75-.15-.45-.31-.89-.47-1.34s-.33-.89-.5-1.33c-.34-.9-.71-1.79-1.08-2.68-1.45-3.46-3.08-6.87-4.58-10.25a56.67 56.67 0 01-2.14-5.43l-.19.27a11.55 11.55 0 00-.81 1.44c0 7.87-7.88 17.5-7.88 17.5l-7.93-11.55-6.94 10.67c-1 .53-2 2.35-2.78 4.94-.22.7-.43 1.46-.63 2.27-.14.54-.27 1.11-.39 1.68-.07.29-.13.58-.19.88l-.18.91v.14c-.12.62-.24 1.26-.35 1.91s-.24 1.4-.35 2.11q-.12.69-.21 1.38c-.14.89-.26 1.79-.38 2.68-.07.52-.14 1-.2 1.55l-.24 2a95.43 95.43 0 001.67 4.85 8.06 8.06 0 01.65 2.75 68.33 68.33 0 0037.55 0 .38.38 0 010-.1 11.91 11.91 0 01-.24-2.73 75 75 0 011-7.65 28 28 0 00.19-3.76v-.45c-.03-.38-.04-.74-.05-1.1zm0 0c0-.4 0-.8-.07-1.2s-.06-.75-.11-1.13-.09-.76-.14-1.14-.12-.76-.19-1.14-.14-.76-.22-1.14c0-.13-.05-.25-.08-.38-.11-.5-.23-1-.36-1.51s-.21-.81-.33-1.21c0-.18-.1-.36-.16-.53s-.17-.58-.26-.87l-.18-.56c-.08-.25-.16-.5-.25-.75-.15-.45-.31-.89-.47-1.34s-.33-.89-.5-1.33c-.34-.9-.71-1.79-1.08-2.68-1.45-3.46-3.08-6.87-4.58-10.25a56.67 56.67 0 01-2.14-5.43l-.19.27a11.55 11.55 0 00-.81 1.44c0 7.87-7.88 17.5-7.88 17.5l-7.93-11.55-6.94 10.67c-1 .53-2 2.35-2.78 4.94-.22.7-.43 1.46-.63 2.27-.14.54-.27 1.11-.39 1.68-.07.29-.13.58-.19.88l-.18.91v.14c-.12.62-.24 1.26-.35 1.91s-.24 1.4-.35 2.11q-.12.69-.21 1.38c-.14.89-.26 1.79-.38 2.68-.07.52-.14 1-.2 1.55l-.24 2a95.43 95.43 0 001.67 4.85 8.06 8.06 0 01.65 2.75 68.33 68.33 0 0037.55 0 .38.38 0 010-.1 11.91 11.91 0 01-.24-2.73 75 75 0 011-7.65 28 28 0 00.19-3.76v-.45c-.03-.38-.04-.74-.05-1.1z",
  fill: "#444176"
}), /*#__PURE__*/createElement("path", {
  d: "M302.13 681.91l-.67-.09a24.36 24.36 0 01-3-.6l-.37-.1c-2.44-.69-5.11-1.93-5.71-4.11a3.89 3.89 0 01.06-2.13 18.26 18.26 0 011.36-3.44v-.06a4.77 4.77 0 01.25-.45 10 10 0 013.61-3.93l-1.2.19-10.16 1.65-15.75 2.54s-2.8-.56-6.61 9.94c0 .13-.09.25-.13.39-.92 2.57-1.89 5.78-2.89 9.79-.69 2.78-1.32 5.51-1.9 8.16-.17.8-.34 1.59-.5 2.37a63.54 63.54 0 005.81 6l.33.31a68.26 68.26 0 0013.32 9.43l.19.1a65.94 65.94 0 009.4 4.16l.85.3c.18-1.85.38-3.9.62-6 0-.21 0-.42.08-.63l.24-2c.06-.51.13-1 .2-1.55.12-.89.24-1.79.38-2.68q.09-.69.21-1.38a116.063 116.063 0 01.7-4.02v-.14l.18-.91c.06-.3.12-.59.19-.88.12-.57.25-1.14.39-1.68.2-.81.41-1.57.63-2.27.8-2.59 1.73-4.41 2.78-4.94l6.94-10.67.29-.45.13-.2z",
  opacity: 0.1
}), /*#__PURE__*/createElement("path", {
  d: "M301.54 681.93l-7.37 11.32c-1 .51-1.94 2.28-2.73 4.79-.23.74-.46 1.55-.68 2.4a119.57 119.57 0 00-2.26 13.09c0 .2 0 .4-.08.6-.34 2.78-.62 5.51-.85 7.92a65.94 65.94 0 01-9.4-4.16l-.19-.1a68.26 68.26 0 01-13.32-9.43l-.33-.31a63.54 63.54 0 01-5.81-6c-.24-.27-.47-.55-.7-.83.11-.52.22-1 .34-1.56.57-2.65 1.2-5.37 1.89-8.14a98.53 98.53 0 013.4-11.2 3.06 3.06 0 01.13-.32c3.54-9.11 6.09-8.6 6.09-8.6l16.63-2.68 10.5-1.7-.33.19a10.65 10.65 0 00-2.89 3.08l-.29.49c-.12.19-.23.4-.35.61a17.72 17.72 0 00-1.38 3.5 3.68 3.68 0 00.24 2.86c1 1.94 3.84 3 6.17 3.58l.39.1a25.09 25.09 0 003.18.5z",
  fill: "#f1d2d7"
}), /*#__PURE__*/createElement("path", {
  d: "M359.33 702.14l-.41-8.88c1.75-14-1.75-14.87-1.75-14.87l-4.16-2h-.11l-16.73-8.11-.65-.32-.2-.09-2.18-1.06-1.38-.67-2.58-1.25-.87-.42V667.94c0 1 .09 2.17.17 3.53.18 3.42.51 8 1.1 13.4.33 3.13.75 6.55 1.27 10.22.31 2.17.53 4.33.67 6.44a113.33 113.33 0 01-.66 21.3l.91-.29a67 67 0 007.24-2.9 66.46 66.46 0 0012.9-7.92l.18-.13a66.72 66.72 0 007.26-6.59z",
  opacity: 0.1
}), /*#__PURE__*/createElement("path", {
  d: "M360.21 702.14l-.41-8.9c1.75-14-1.75-14.87-1.75-14.87l-5-2.42h-.1l-16.78-8.14-.77-.37-.15-.07-1.23-.6-1.63-.79-3.22-1.56v3.18c0 1 .09 2.31.18 3.8.17 3.19.47 7.37 1 12.34.36 3.41.81 7.2 1.4 11.28q.46 3.27.66 6.47a113.18 113.18 0 01-.62 21 67 67 0 007.24-2.9 66.46 66.46 0 0012.9-7.92l.18-.13a66.72 66.72 0 007.26-6.59q.44-.44.84-.9z",
  fill: "#f1d2d7"
}), /*#__PURE__*/createElement("path", {
  d: "M303.8 628.67c3.12-.53 6.26-1.67 9.36-1 2.6.54 4.77 2.27 7.15 3.47a18.51 18.51 0 007.38 1.95 4.34 4.34 0 002.71-.53c1.24-.86 1.42-2.62 1.21-4.12-.6-4.26-3.26-7.92-6-11.24a22 22 0 00-3.76-3.81c-3.59-2.65-8.34-3.1-12.79-2.9-5.08.23-10.24 1.21-14.65 3.76-3 1.72-9.88 7.14-7.49 11.06 2.51 4.1 12.95 4.03 16.88 3.36z",
  opacity: 0.1
}), /*#__PURE__*/createElement("path", {
  d: "M303.8 627.67c3.12-.53 6.26-1.67 9.36-1 2.6.54 4.77 2.27 7.15 3.47a18.51 18.51 0 007.38 1.95 4.34 4.34 0 002.71-.53c1.24-.86 1.42-2.62 1.21-4.12-.6-4.26-3.26-7.92-6-11.24a22 22 0 00-3.76-3.81c-3.59-2.65-8.34-3.1-12.79-2.9-5.08.23-10.24 1.21-14.65 3.76-3 1.72-9.88 7.14-7.49 11.06 2.51 4.1 12.95 4.03 16.88 3.36z",
  fill: "#444176"
}));

var _ref14 = /*#__PURE__*/createElement("path", {
  d: "M621.61 602.56h.15c.22 6.7 1.17 12.76 3 14.44 4.36 4 22.44-4 21.2-8.84-.25-1-.67-2.64-1.2-4.71 4.88-.61 9.05-2 10.71-4.86l3.14 9.68.22.69h.24c2.07 19.62 6.76 60.36 10.51 65.82 5 7.23 10.75 38.56 10.75 38.56l10.75 64.27s4.14 37 6.62 41a4.65 4.65 0 002.72 1.41c-1.45 4.34-3.53 9.41-6 12.24-5 5.62-11.58 16.87-17.37 16.07s-7.44 11.25 3.31 12.85c5.95.89 15.44-.19 22.73-1.33 0 3.22 2.24 6.92 7.87 7.76 10.75 1.61 33.08-3.21 33.08-3.21s19-8 19.85-13.66c.6-4.1-2.31-20.56-3.93-29.19 3-4.81-.2-46.32-.2-46.32l-5.79-79.53s3.31-44.18 0-52.22c-2.07-5-2.84-28-3.13-44.45l4 .26a7.38 7.38 0 00.62-.87l1 .07s5-5.62.83-14.46c-3.07-6.57-2.49-36.23-2-51l.59-7a2 2 0 00.49-.76 73.35 73.35 0 0022.33-6.76 22.66 22.66 0 005.86-3.56c4.14-4 1.65-28.12-6.62-64.27s-15.71-32.94-15.71-32.94-19.85-1.61-28.95-13.66-15.21-11.89-15.21-11.89a68.39 68.39 0 01-.5-4.46c0-.52-.08-1-.11-1.52a26.44 26.44 0 006.88-10.43c1.86-1 4.15-1.33 5.93-2.59a7.06 7.06 0 001.23-1.14 10.11 10.11 0 003.19-6.29 25.72 25.72 0 00-.37-7.89c-.63-3.84-1.56-7.77-3.8-10.79s-5.59-4.84-8.82-6.53q-13.12-6.89-26.31-13.64a14.52 14.52 0 00-5.63-2c-3.52-.2-6.68 2.21-9.52 4.5a40.62 40.62 0 00-3.25 2.85 18.25 18.25 0 00-2.39 2.57c-3.32 4.45-4.73 12.83-3.27 18.39.46 1.76 1.45 2.27 2.67 2.25a25.78 25.78 0 00-2.75 11.6 26.3 26.3 0 0012.21 22.09c0 .56 0 1.11.05 1.64a58.69 58.69 0 01-.2 6.15s-22 11.89-24.47 17.51-11.58 9.64-11.58 9.64-17.37 8.84-17.37 40.17l-9.1 44.18-1.65 84.35s1.14-1 3-2.42c-.06.56-.11 1.14-.16 1.73a95.23 95.23 0 00-.25 9.69zm111.1 218.31c-.34 1.29-.84 3-1.47 5-.28-1.66-.56-3.3-.84-4.86a38.8 38.8 0 012.31-.14z",
  transform: "translate(-43.2 -23.86)",
  fill: "url(#PersonInput_svg__d)"
});

var _ref15 = /*#__PURE__*/createElement("path", {
  d: "M659.47 786.65s-3.19 14.34-8 19.91-11.11 16.73-16.67 15.93-7.17 11.15 3.19 12.74 31.81-3.18 31.81-3.18 18.32-8 19.11-13.54-4.78-34.25-4.78-34.25z",
  fill: "#53526b"
});

var _ref16 = /*#__PURE__*/createElement("path", {
  d: "M659.47 786.65s-3.19 14.34-8 19.91-11.11 16.73-16.67 15.93-7.17 11.15 3.19 12.74 31.81-3.18 31.81-3.18 18.32-8 19.11-13.54-4.78-34.25-4.78-34.25z",
  opacity: 0.05
});

var _ref17 = /*#__PURE__*/createElement("path", {
  d: "M688.94 793.02s-3.19 14.34-8 19.91-11.14 16.73-16.69 15.93-7.17 11.15 3.19 12.74 31.86-3.19 31.86-3.19 18.32-8 19.11-13.54-4.78-34.25-4.78-34.25z",
  fill: "#53526b"
});

var _ref18 = /*#__PURE__*/createElement("path", {
  d: "M616.46 574.81s6.37 68.49 11.15 75.66 10.35 38.23 10.35 38.23l10.35 63.71s4 36.64 6.37 40.62 31.93 2.27 31.93 2.27l-18.38-210.94z",
  fill: "#5f5d7e"
});

var _ref19 = /*#__PURE__*/createElement("path", {
  d: "M616.46 574.81s6.37 68.49 11.15 75.66 10.35 38.23 10.35 38.23l10.35 63.71s4 36.64 6.37 40.62 31.93 2.27 31.93 2.27l-18.38-210.94z",
  opacity: 0.05
});

var _ref20 = /*#__PURE__*/createElement("path", {
  d: "M603.72 542.14l2.08 6.61 11.25 35.71.22.68h.06c1.51.34 33.39 7.67 40.27 9.92a9.73 9.73 0 011.09.41c3.19 1.59 7.17 58.93 7.17 58.93s2.39 54.16 4 58.14 8 86 11.95 83.62 32.65 0 32.65 0c3.19-3.19 0-46.19 0-46.19l-5.66-78.83s3.19-43.8 0-51.77-3.19-61.32-3.19-61.32l-65.19-10.19-6.3-1z",
  fill: "#5f5d7e"
});

var _ref21 = /*#__PURE__*/createElement("path", {
  d: "M605.8 548.76l11.25 35.71.27.7c1.51.34 33.39 7.67 40.27 9.92h.69l-17.81-47.22-.51-1.36-5.79.37z",
  opacity: 0.02
});

var _ref22 = /*#__PURE__*/createElement("path", {
  d: "M680.18 382.87s-29.47 31.86-47.79 5.57l-17.52 11.95 3.19 18.32-10.36 138.57s27.08-.8 46.19 5.57a29.64 29.64 0 0031.06-7.17l-3.15-121.84 7.17-37.43z",
  opacity: 0.1
});

var _ref23 = /*#__PURE__*/createElement("path", {
  d: "M680.18 380.48s-29.47 31.86-47.79 5.57L614.87 398l3.19 18.32-10.36 138.57s27.08-.8 46.19 5.57a29.64 29.64 0 0031.06-7.17l-3.15-121.84 7.17-37.43z",
  fill: "#53526b"
});

var _ref24 = /*#__PURE__*/createElement("g", {
  "data-name": "TESLA"
}, /*#__PURE__*/createElement("g", {
  "data-name": "g8",
  fill: "#e82127"
}, /*#__PURE__*/createElement("path", {
  "data-name": "polyline10",
  d: "M621.35 522.36v5.02h-1.6v-3.34h-5.85v3.34h-1.61v-5.01l9.06-.01"
}), /*#__PURE__*/createElement("path", {
  "data-name": "path12",
  d: "M619.92 520.74h-6.18a2.28 2.28 0 01-1.68-1.66h9.53a2.29 2.29 0 01-1.68 1.66"
})), /*#__PURE__*/createElement("g", {
  "data-name": "g30"
}, /*#__PURE__*/createElement("path", {
  "data-name": "path32",
  d: "M675.8 519.14a2.31 2.31 0 01-1.67 1.65h-2.6l-.13.05v6.56h-1.6v-6.56l-.15-.05h-2.6a2.34 2.34 0 01-1.67-1.65h10.42",
  fill: "#e82127"
})));

var _ref25 = /*#__PURE__*/createElement("path", {
  d: "M618.85 545.34s0 20.71-4.78 29.47-32.65 4-32.65 4l5.57-29.47z",
  fill: "#d6dbe6"
});

var _ref26 = /*#__PURE__*/createElement("path", {
  d: "M584.45 593.14c4.2 4 21.61-4 20.41-8.76-.84-3.37-3.78-15.43-5.45-22.27l-1.16-4.81s-10.2-3.19-13.8 0c-1.31 1.16-2.23 5.73-2.66 11.25-.74 9.59.01 22.05 2.66 24.59zM622.8 394.81l27.87 21.5s41.41-2.39 31.06-22.3a74.24 74.24 0 01-8-28.14 58.84 58.84 0 010-10.89s-38.23-35-33.45 4.78a90.24 90.24 0 01.66 9.2c.57 29.86-18.14 25.85-18.14 25.85z",
  fill: "#fdc2cc"
});

var _ref27 = /*#__PURE__*/createElement("path", {
  d: "M640.36 359.77a90.24 90.24 0 01.66 9.2 26.1 26.1 0 0014.47 4.34c7.13 0 12.38-6.94 17.12-11.55-.53-6.61 1.19-6.77 1.19-6.77s-38.22-35.04-33.44 4.78z",
  opacity: 0.1
});

var _ref28 = /*#__PURE__*/createElement("circle", {
  cx: 655.49,
  cy: 345.44,
  r: 26.28,
  fill: "#fdc2cc"
});

var _ref29 = /*#__PURE__*/createElement("path", {
  d: "M674.2 370.52s4.38.4 13.14 12.34 27.87 13.54 27.87 13.54 7.17-3.19 15.13 32.65 10.35 59.73 6.37 63.71-19.91 9.57-27.91 9.57c0 0-2.39 50.17 1.59 58.93s-.8 14.34-.8 14.34l-35-2.39s-11.95-15.13-14.34-41.41-10.35-101.15-6.37-109.91 21.5-31.06 20.71-33.45-.39-17.92-.39-17.92z",
  opacity: 0.1
});

var _ref30 = /*#__PURE__*/createElement("path", {
  d: "M674.29 370.28s5.89-.16 14.65 11.79 27.86 13.54 27.86 13.54 7.17-3.19 15.13 32.65 10.35 59.73 6.37 63.71-19.91 9.56-27.87 9.56c0 0-2.39 50.17 1.59 58.93s-.8 14.34-.8 14.34l-35-2.39s-11.95-15.13-14.34-41.41-10.37-101.14-6.39-109.86 21.5-31.06 20.71-33.45-1.91-17.41-1.91-17.41z",
  fill: "#d6dbe6"
});

var _ref31 = /*#__PURE__*/createElement("path", {
  d: "M581.8 568.54c3.81-2.91 11-7.44 17.62-6.44l-1.16-4.81s-10.2-3.19-13.8 0c-1.33 1.16-2.24 5.72-2.66 11.25zM640.8 375.3s-20.31 13.14-22.7 18.72-11.15 9.56-11.15 9.56-16.72 8.76-16.72 39.82l-8.76 43.8 39.82 55.75s4.78-55.75 7.17-69.29 5.57-39 5.57-39 11.95-15.13 10.35-19.11-3.58-40.25-3.58-40.25z",
  opacity: 0.1
});

var _ref32 = /*#__PURE__*/createElement("path", {
  d: "M640.8 375.06s-21.18 11.79-23.56 17.36-11.15 9.56-11.15 9.56-16.72 8.76-16.72 39.82l-8.76 43.8-1.59 83.62s14.34-13.54 24.69-7.17 16.72-20.71 16.72-20.71 4.78-55.75 7.17-69.29 5.57-39 5.57-39 11.95-15.13 10.35-19.11-2.72-38.88-2.72-38.88z",
  fill: "#d6dbe6"
});

var _ref33 = /*#__PURE__*/createElement("path", {
  d: "M632.42 313.47a26 26 0 014.64-4.58c2.74-2.28 5.77-4.66 9.17-4.46a13.72 13.72 0 015.42 1.94q12.7 6.69 25.33 13.52c3.11 1.68 6.32 3.46 8.49 6.48s3.05 6.9 3.66 10.7a26.23 26.23 0 01.36 7.82 9.81 9.81 0 01-3.46 6.57c-2.27 1.65-5.38 1.66-7.28 3.82-1.1 1.25-1.58 3-2.36 4.52s-2.13 3-3.67 2.73-2.47-1.9-2.69-3.55a21.55 21.55 0 01.29-5c.3-3-.08-6.18-1.82-8.41-1.2-1.52-2.92-2.44-4.08-4-2.78-3.76-1.51-10-4.56-13.53a7.23 7.23 0 00-7-2c-2.47.52-4.73 1.86-7 3a52 52 0 01-9.59 3.7c-2.78.76-6 2.58-6.95-1.12-1.45-5.43-.1-13.74 3.1-18.15z",
  opacity: 0.1
});

var _ref34 = /*#__PURE__*/createElement("path", {
  d: "M633.22 312.68a26 26 0 014.64-4.58c2.74-2.28 5.77-4.66 9.17-4.46a13.72 13.72 0 015.42 1.94c8.46 4.46 15.49.24 25.33 13.52 2.1 2.84 6.32 3.46 8.49 6.48s3.05 6.9 3.66 10.7a26.23 26.23 0 01.36 7.82 9.81 9.81 0 01-3.46 6.57c-2.27 1.65-5.38 1.66-7.28 3.82-1.1 1.25-1.58 3-2.36 4.52s-2.13 3-3.67 2.73-2.47-1.9-2.69-3.55a21.55 21.55 0 01.29-5c.3-3-.08-6.18-1.82-8.41-1.2-1.52-2.92-2.44-4.08-4-2.78-3.76-1.51-10-4.56-13.53a7.23 7.23 0 00-7-2c-2.47.52-4.73 1.86-7 3a52 52 0 01-9.59 3.7c-2.78.76-6 2.58-6.95-1.12-1.46-5.43-.1-13.75 3.1-18.15z",
  fill: "#865a61"
});

var _ref35 = /*#__PURE__*/createElement("path", {
  d: "M705 434.23s10.62 27.08 2.65 38.23l-17.52-4s15.93 4.78 13.54-4.78 1.33-29.45 1.33-29.45zM710.8 501.14s-23.1 1.59-29.47-3.19a61 61 0 0028.75 11.95zM611.29 450.14s-11.95 36.64-11.15 42.21 2.39 66.9 2.39 66.9l2.39-.8-.8-66.9z",
  opacity: 0.1
});

var _ref36 = /*#__PURE__*/createElement("path", {
  d: "M756.81 518.78l-273-220a17.08 17.08 0 00-12.1-5h-11.6a148 148 0 10-25.63 25.63V331a17.08 17.08 0 005 12.1l273 220a17 17 0 0024.14 0l20.12-20.1a17.17 17.17 0 00.07-24.22zm-413.47-225a91.14 91.14 0 1191.14-91.14 91.09 91.09 0 01-91.14 91.16z",
  transform: "translate(-43.2 -23.86)",
  fill: "url(#PersonInput_svg__e)"
});

var _ref37 = /*#__PURE__*/createElement("path", {
  d: "M715.61 492.92l-273-220a17.08 17.08 0 00-12.1-5h-11.6a148 148 0 10-25.63 25.63v11.59a17.08 17.08 0 005 12.1l273 220a17 17 0 0024.14 0l20.12-20.1a17.17 17.17 0 00.07-24.22zm-413.47-225a91.14 91.14 0 1191.14-91.14 91.09 91.09 0 01-91.14 91.16z",
  fill: "#28629b"
});

var _ref38 = /*#__PURE__*/createElement("path", {
  d: "M695.31 472.86s-39.85-45.7-34.25-14.34c4 22.3 19.11 34.25 26.28 36.64s7.97-22.3 7.97-22.3z",
  fill: "#fdc2cc"
});

var _ref39 = /*#__PURE__*/createElement("path", {
  d: "M704.87 430.65s.8 29.47 4.78 33.45-2.39 8.76-2.39 8.76l-15.93-4s4 26.28-12.74 23.1c0 0 11.15 10.35 22.3 11.95s10.35-2.39 10.35-2.39l16.72-19.91z",
  fill: "#d6dbe6"
});

var _ref40 = /*#__PURE__*/createElement("path", {
  fill: "#d6dbe6",
  d: "M709.28 501.95l16.16-3.55-2.16-7.45-10-4-13 6 9 9z"
});

var _ref41 = /*#__PURE__*/createElement("path", {
  d: "M237.58 175.94a67.68 67.68 0 0013.58 40.78 66.14 66.14 0 004.4 5.27q.41.46.84.9a66.72 66.72 0 007.26 6.59l.18.13a66.47 66.47 0 0012.9 7.92 67 67 0 007.24 2.9l.91.29c.56.19 1.14.36 1.71.52l.23.07c.29.08.58.17.88.24a67.71 67.71 0 0017.83 2.37c1 0 2.05 0 3.07-.07a67.24 67.24 0 0015.77-2.58h.1c.95-.28 1.89-.57 2.82-.89h.1l.85-.3a65.93 65.93 0 009.4-4.16l.19-.1c.33-.18.66-.36 1-.55a67.83 67.83 0 0012.34-8.88l.33-.31a63.54 63.54 0 005.81-6l.21-.25c.17-.19.33-.38.49-.58.44-.52.86-1.06 1.28-1.6a68 68 0 10-121.72-41.71z",
  fill: "#c0bccf"
});

var _ref42 = /*#__PURE__*/createElement("path", {
  d: "M304.31 221.67s14.75-1.25 21.51-10.63c6.59-9.13 11.07-9.24 11.29-9.24.17-1.22.29-2.38.37-3.46v-.15a2 2 0 01-.93.41c-1.32.2-2.48-1.05-3.14-2.38a18.57 18.57 0 00-2-3.94c-1.63-1.88-4.3-1.89-6.24-3.32a8.58 8.58 0 01-3-5.72 15.74 15.74 0 01-.12-2.5 27.68 27.68 0 01.42-5.33c.52-3.31 1.29-6.7 3.14-9.31s5.47-3.17 7.27-5.64c8.43-11.56 14.44-7.89 21.69-11.77a11.62 11.62 0 014.64-1.69c2.91-.17 5.51 1.91 7.85 3.89a22.42 22.42 0 014 4c2.09 2.93 3.26 7.84 3.16 12.14a18.18 18.18 0 01-.46 4.75c-.58 2.3-2.15 2.15-3.87 1.63a20.78 20.78 0 01-7.06 26.08v1.05a1.83 1.83 0 000 .23 47.35 47.35 0 00.16 4.78c.17.09 16.34 9.26 18.17 13.61s8.61 7.5 8.61 7.5 7.45 4 11 16.56l-.21.25a64.14 64.14 0 01-5.81 6.12l-.33.32a67.87 67.87 0 01-12.34 9c-.32.19-.65.38-1 .56l-.19.1a65.38 65.38 0 01-9.4 4.23l-.85.31h-.1c-.93.33-1.87.62-2.82.9h-.1a66.22 66.22 0 01-15.77 2.62c-1 .05-2 .07-3.07.07a66.65 66.65 0 01-17.78-2.31c-.3-.07-.59-.16-.88-.24l-.23-.07c-.57-.16-1.15-.34-1.71-.53l-.91-.29a66.4 66.4 0 01-7.27-2.96 66.28 66.28 0 01-12.9-8.05l-.18-.13a67.13 67.13 0 01-7.26-6.7q-.43-.44-.84-.92c-.55-.6-1.09-1.21-1.61-1.83-1-1.15-1.9-2.32-2.79-3.53 5.35-20.53 9.89-18.47 9.89-18.47z",
  transform: "translate(-43.2 -23.86)",
  fill: "url(#PersonInput_svg__f)"
});

var _ref43 = /*#__PURE__*/createElement("path", {
  d: "M312.11 214.55l21.51-16.59s-14.41 3.09-14-19.94a1.77 1.77 0 010-.23c0-2.08.2-4.36.5-6.87 3.69-30.73-25.81-3.69-25.81-3.69a44 44 0 010 8.18v.22a57.14 57.14 0 01-6.14 21.71c-8.01 15.36 23.94 17.21 23.94 17.21z",
  fill: "#fdc2cc"
});

var _ref44 = /*#__PURE__*/createElement("path", {
  d: "M297.06 171.14c3.65 3.55 5.88 10 11.37 10a20.15 20.15 0 0011.17-3.35c0-2.08.2-4.36.5-6.87 3.69-30.73-25.81-3.69-25.81-3.69s3.16-1.09 2.77 3.91z",
  opacity: 0.1
});

var _ref45 = /*#__PURE__*/createElement("circle", {
  cx: 308.43,
  cy: 159.86,
  r: 20.28,
  fill: "#fdc2cc"
});

var _ref46 = /*#__PURE__*/createElement("path", {
  d: "M327.88 133.89a22.25 22.25 0 00-4-3.92c-2.34-1.95-4.94-4-7.85-3.82a11.75 11.75 0 00-4.64 1.66c-7.25 3.82-13.26.21-21.69 11.57-1.8 2.43-5.41 3-7.27 5.55s-2.61 5.9-3.14 9.16a22.46 22.46 0 00-.31 6.7 8.39 8.39 0 003 5.62c1.94 1.41 4.61 1.42 6.24 3.27a18.15 18.15 0 012 3.87c.66 1.3 1.82 2.53 3.14 2.34s2.11-1.62 2.3-3a18.44 18.44 0 00-.25-4.27c-.25-2.53.07-5.29 1.56-7.2 1-1.31 2.5-2.09 3.49-3.42 2.38-3.21 1.3-8.6 3.91-11.58a6.19 6.19 0 016-1.67 25.57 25.57 0 016 2.58 44.52 44.52 0 008.21 3.17c2.38.65 5.14 2.21 5.95-1 1.27-4.72.08-11.84-2.65-15.61z",
  opacity: 0.1
});

var _ref47 = /*#__PURE__*/createElement("path", {
  d: "M327.88 132.89a22.25 22.25 0 00-4-3.92c-2.34-1.95-4.94-4-7.85-3.82a11.75 11.75 0 00-4.64 1.66c-7.25 3.82-13.26.21-21.69 11.57-1.8 2.43-5.41 3-7.27 5.55s-2.61 5.9-3.14 9.16a22.46 22.46 0 00-.31 6.7 8.39 8.39 0 003 5.62c1.94 1.41 4.61 1.42 6.24 3.27a18.15 18.15 0 012 3.87c.66 1.3 1.82 2.53 3.14 2.34s2.11-1.62 2.3-3a18.44 18.44 0 00-.25-4.27c-.25-2.53.07-5.29 1.56-7.2 1-1.31 2.5-2.09 3.49-3.42 2.38-3.21 1.3-8.6 3.91-11.58a6.19 6.19 0 016-1.67 25.57 25.57 0 016 2.58 44.52 44.52 0 008.21 3.17c2.38.65 5.14 2.21 5.95-1 1.27-4.72.08-11.84-2.65-15.61z",
  fill: "#865a61"
});

var _ref48 = /*#__PURE__*/createElement("path", {
  d: "M288.15 225.22l-.4 15.35a67.71 67.71 0 0017.83 2.37c1 0 2.05 0 3.07-.07a67.24 67.24 0 0015.77-2.58h.1c.95-.28 1.89-.57 2.82-.89h.1l.85-.3a65.93 65.93 0 009.4-4.16l.19-.1c.33-.18.66-.36 1-.55l-1.55-20.69 2.47-14.19-13.52-9.21a23.81 23.81 0 01-2.54 3.08 17 17 0 01-4.62 3.42c-9.7 4.78-20.74-2.82-26.23-7.52l-1.25-1.11c-1.42-1.29-2.23-2.17-2.23-2.17l-6.76 10.44z",
  opacity: 0.1
});

var _ref49 = /*#__PURE__*/createElement("path", {
  d: "M288.15 226.22l-.4 15.35a67.71 67.71 0 0017.83 2.37c1 0 2.05 0 3.07-.07a67.24 67.24 0 0015.77-2.58h.1c.95-.28 1.89-.57 2.82-.89h.1l.85-.3a65.93 65.93 0 009.4-4.16l.19-.1c.33-.18.66-.36 1-.55l-1.55-20.69 2.47-14.19-13.52-9.21a23.81 23.81 0 01-2.54 3.08 17 17 0 01-4.62 3.42c-9.7 4.78-20.74-2.82-26.23-7.52l-1.25-1.11c-1.42-1.29-2.23-2.17-2.23-2.17l-6.76 10.44z",
  fill: "#53526b"
});

var _ref50 = /*#__PURE__*/createElement("path", {
  d: "M251.16 216.72a66.14 66.14 0 004.4 5.27q.41.46.84.9a66.72 66.72 0 007.26 6.59l.18.13a66.47 66.47 0 0012.9 7.92 67 67 0 007.24 2.9l.91.29c.56.19 1.14.36 1.71.52l.23.07c.29.08.58.17.88.24a67.71 67.71 0 0017.83 2.37c1 0 2.05 0 3.07-.07.78-12.76 1-23-.22-25.63a41.25 41.25 0 00-2.47-4.42c-4.94-7.94-14-19.88-13.51-21.39a15.66 15.66 0 00.41-2.25c.53-3.94 1.06-11.15 1.06-11.15-.22 0-4.7.11-11.29 9.09-6.76 9.22-21.51 10.45-21.51 10.45s-4.51-2-9.92 18.17zM325.63 227.45s.74 5.89 1.71 12.93h.1l.85-.3a65.93 65.93 0 009.4-4.16l.19-.1c.33-.18.66-.36 1-.55a67.83 67.83 0 0012.34-8.88l.33-.31a63.54 63.54 0 005.81-6l.21-.25c-3.57-12.39-11-16.29-11-16.29s-6.76-3.08-8.61-7.38-18.18-13.39-18.18-13.39v.07c0 .77-.26 7.82-.65 14.91-.25 4.61-.56 9.24-.92 12.18a14.23 14.23 0 01-.52 2.82c-1.27 3.03 7.94 14.7 7.94 14.7z",
  fill: "#555388"
});

function SvgPersonInput(props) {
  return /*#__PURE__*/createElement("svg", _extends$1({
    "data-name": "Layer 1",
    viewBox: "0 0 1113.61 844.14"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50);
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteral(["\n      query People($first: Int!, $filters: PeopleFiltersInput) {\n        viewer {\n          people(first: $first, filters: $filters) {\n            edges {\n              node {\n                id\n                firstName\n                middleName\n                lastName\n                bornAt\n                deceasedAt\n              }\n            }\n          }\n        }\n      }\n    "]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n    mutation addPerson($person: PersonInput) {\n      createPerson(person: $person) {\n        name\n      }\n    }\n  "]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var useCreate$1 = function useCreate() {
  var _useMutation = useMutation(gql(_templateObject$1())),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      mutate = _useMutation2[0],
      meta = _useMutation2[1];

  var create = function create(person) {
    return mutate({
      variables: {
        person: person
      }
    });
  };

  return [create, meta];
};
/**
 * React hook that manages fetching a list of people.
 *
 * @param {object} [options={}] optional query options
 */

var usePeople = function usePeople() {
  var _meta$data, _meta$data$viewer, _meta$data$viewer$peo, _meta$data$viewer$peo2;

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    fetchPolicy: "cache-and-network"
  };

  var _useLazyQuery = useLazyQuery(gql(_templateObject2$1()), options),
      _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
      query = _useLazyQuery2[0],
      meta = _useLazyQuery2[1];
  /**
   * Function that retrieves a list of people based on the given variables.
   *
   * @param {object} [form={}] - Search criteria
   * @param {object} [requestOptions={}] - Additional request options
   */


  var getPeople = function getPeople() {
    var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var requestOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return query(_objectSpread2({
      variables: _objectSpread2({
        first: 10
      }, form)
    }, requestOptions));
  }; // Clean data for easier consumption


  var data = {
    people: (meta === null || meta === void 0 ? void 0 : (_meta$data = meta.data) === null || _meta$data === void 0 ? void 0 : (_meta$data$viewer = _meta$data.viewer) === null || _meta$data$viewer === void 0 ? void 0 : (_meta$data$viewer$peo = _meta$data$viewer.people) === null || _meta$data$viewer$peo === void 0 ? void 0 : (_meta$data$viewer$peo2 = _meta$data$viewer$peo.edges) === null || _meta$data$viewer$peo2 === void 0 ? void 0 : _meta$data$viewer$peo2.map(function (_ref) {
      var node = _ref.node;
      return node;
    })) || []
  };
  return [getPeople, _objectSpread2(_objectSpread2({}, meta), {}, {
    data: data
  })];
};
/**
 * Custom form input for selecting one or more person instances. Connects automatically to a parent
 * `Form`.
 */


var PersonInput = function PersonInput(_ref2) {
  var name = _ref2.name,
      label = _ref2.label,
      _ref2$multiple = _ref2.multiple,
      multiple = _ref2$multiple === void 0 ? false : _ref2$multiple,
      defaultValue = _ref2.defaultValue,
      props = _objectWithoutProperties(_ref2, ["name", "label", "multiple", "defaultValue"]);

  var _React$useState = React.useState(""),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      search = _React$useState2[0],
      setSearch = _React$useState2[1];

  var _useDebounce = useDebounce(search, 300),
      _useDebounce2 = _slicedToArray(_useDebounce, 1),
      debouncedSearchTerm = _useDebounce2[0];

  var _React$useState3 = React.useState([]),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      people = _React$useState4[0],
      setPeople = _React$useState4[1];

  var _usePeople = usePeople({
    onCompleted: function onCompleted(response) {
      var _response$viewer, _response$viewer$peop, _response$viewer$peop2;

      setPeople(response === null || response === void 0 ? void 0 : (_response$viewer = response.viewer) === null || _response$viewer === void 0 ? void 0 : (_response$viewer$peop = _response$viewer.people) === null || _response$viewer$peop === void 0 ? void 0 : (_response$viewer$peop2 = _response$viewer$peop.edges) === null || _response$viewer$peop2 === void 0 ? void 0 : _response$viewer$peop2.map(function (edge) {
        return edge.node;
      }));
    }
  }),
      _usePeople2 = _slicedToArray(_usePeople, 2),
      getPeople = _usePeople2[0],
      _usePeople2$ = _usePeople2[1],
      called = _usePeople2$.called,
      loading = _usePeople2$.loading;

  var _useCreate = useCreate$1(),
      _useCreate2 = _slicedToArray(_useCreate, 2),
      create = _useCreate2[0],
      createMeta = _useCreate2[1];

  var createModal = useModal();

  var createPerson = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(form) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return create(form);

            case 3:
              createModal.close();
              Toasts.success("New person created");
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              Toasts.danger({
                title: "Invalid form field entry",
                error: _context.t0
              });

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function createPerson(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  React.useEffect(function () {
    if (debouncedSearchTerm) {
      getPeople({
        filters: {
          search: debouncedSearchTerm
        }
      });
    }
  }, [debouncedSearchTerm]);
  return /*#__PURE__*/React.createElement(AssociationInput, _extends({}, props, {
    name: name,
    defaultValue: defaultValue,
    label: label,
    options: people,
    multiple: multiple,
    placeholderComponent: SvgPersonInput,
    placeholderMessage: called && !loading ? "Try again. Unable to find anyone." : "Search for a person",
    onBlur: function onBlur() {
      setSearch("");
      setPeople([]);
    },
    renderSelectionItem: function renderSelectionItem(person) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
        className: "has-text-weight-semibold"
      }, [person.firstName, person.middleName, person.lastName].filter(Boolean).join(" ")), /*#__PURE__*/React.createElement("p", {
        className: "is-size-7"
      }, [person.bornAt ? new Date(person.bornAt).toLocaleDateString() : "Unknown", "–", person.deceasedAt && new Date(person.deceasedAt).toLocaleDateString()].filter(Boolean).join(" ")));
    },
    renderSelectedItem: function renderSelectedItem(person) {
      return /*#__PURE__*/React.createElement("div", null, [person.firstName, person.middleName, person.lastName].filter(Boolean).join(" "), /*#__PURE__*/React.createElement("p", {
        className: "is-block is-size-7 has-text-weight-normal"
      }, [person.bornAt ? new Date(person.bornAt).toLocaleDateString() : "Unknown", "–", person.deceasedAt && new Date(person.deceasedAt).toLocaleDateString()].filter(Boolean).join(" ")));
    }
  }), /*#__PURE__*/React.createElement(Level, null, /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement(Input, {
    value: search,
    onChange: function onChange(e) {
      return setSearch(e.target.value);
    },
    type: "search",
    autoComplete: "off",
    "aria-label": "Search by Name",
    placeholder: "search by name",
    name: "search",
    loading: loading
  })), /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement(Button, _extends({
    type: "button",
    color: "success",
    size: "small"
  }, createModal.triggerProps), /*#__PURE__*/React.createElement(Icon, {
    name: "plus"
  }), " ", /*#__PURE__*/React.createElement("span", null, "Add")), /*#__PURE__*/React.createElement(Modal, _extends({}, createModal.modalProps, {
    title: "New Person"
  }), /*#__PURE__*/React.createElement(Modal.Content, null, createModal.active && /*#__PURE__*/React.createElement(Form, {
    onSubmit: createPerson,
    error: createMeta.error,
    loading: createMeta.loading
  }, /*#__PURE__*/React.createElement(Form.Input, {
    name: "firstName",
    label: "First Name",
    type: "text",
    required: true
  }), /*#__PURE__*/React.createElement(Form.Input, {
    name: "lastName",
    label: "Last Name",
    type: "text",
    required: true
  }), /*#__PURE__*/React.createElement(Form.Input, {
    name: "bornAt",
    label: "Date of Birth",
    type: "date",
    required: true
  }), /*#__PURE__*/React.createElement(Form.Select, {
    name: "sex",
    label: "Sex",
    options: [{
      label: "-",
      value: "",
      selected: true
    }, {
      label: "Female",
      value: "female"
    }, {
      label: "Male",
      value: "male"
    }]
  }), /*#__PURE__*/React.createElement(Level, {
    mobile: true
  }, /*#__PURE__*/React.createElement(Level.Right, null, /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement(Form.SubmitButton, {
    color: "success"
  }, "Create Person"))))))))));
};
PersonInput.propTypes = {
  /** Display label for the input */
  label: PropTypes.string.isRequired,

  /** Form input name */
  name: PropTypes.string.isRequired,

  /** Default input value */
  defaultValue: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),

  /** Multiple people may be selected */
  multiple: PropTypes.bool
};

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

var _ref$1 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("linearGradient", {
  id: "FeeInput_svg__a",
  x1: 790.68,
  y1: 664.41,
  x2: 790.68,
  y2: 175.75,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})));

var _ref2$1 = /*#__PURE__*/createElement("path", {
  fill: "#85848b",
  d: "M0 670.92h1049.58v7.67H0z"
});

var _ref3$1 = /*#__PURE__*/createElement("path", {
  d: "M831.54 535.49c0 5.9-34.39 23.1-75.24 23.1s-72.68-17.2-72.68-23.1 33.11-4 74-4 73.92-1.91 73.92 4z",
  fill: "#504f60"
});

var _ref4$1 = /*#__PURE__*/createElement("path", {
  d: "M831.54 535.49c0 5.9-34.39 23.1-75.24 23.1s-72.68-17.2-72.68-23.1",
  opacity: 0.2
});

var _ref5$1 = /*#__PURE__*/createElement("path", {
  d: "M420.15 427.23c6.63.85 13.51 1.39 19.86-.67 1-.31 2.1-1 2-2a2.42 2.42 0 00-.45-1 61.78 61.78 0 01-6-11.43 1 1 0 00-.37-.52.94.94 0 00-.64 0c-2.93.77-5.46 2.66-8.37 3.47a11.9 11.9 0 01-4.56.34c-1.32-.15-3.12-1.24-4.32-1.1.68 4.37 2.34 8.45 2.85 12.91zM545.54 416.16c4.37-3 8.9-6.15 11.48-10.78a1.87 1.87 0 00.31-.93 1.92 1.92 0 00-.37-.9 37.16 37.16 0 00-9.33-10.07 27.21 27.21 0 00-5.2 4.8c-1.1 1.16-4.14 3-4.17 4.77 0 1 1.16 2.16 1.7 3 .73 1.08 1.42 2.18 2.08 3.3.38.55 3.85 6.59 3.5 6.81z",
  fill: "#28629b"
});

var _ref6$1 = /*#__PURE__*/createElement("path", {
  d: "M446.14 440.62a4.45 4.45 0 01-.8 2.9 3.93 3.93 0 01-1.68 1c-9.27 3.32-20-.82-29.25 2.45-1.9.67-3.7 1.64-5.61 2.28a30.52 30.52 0 01-7 1.24c-3.27.31-6.56.51-9.84.6a23.66 23.66 0 01-7.42-.65 8.91 8.91 0 01-5.69-4.51 4.33 4.33 0 01-.28-3.21 3.46 3.46 0 01.61-1 8.77 8.77 0 012.18-1.77l3.41-2.2a22.89 22.89 0 015.17-2.74c1.35-.44 2.78-.63 4.15-1 4.79-1.4 8.45-5.2 11.85-8.85l4.64-4.95a4.67 4.67 0 011.61-1.29 4.46 4.46 0 012-.19 26.74 26.74 0 0112.65 4.24 16.39 16.39 0 003.12 1.84c2.72 1.06 6.21.26 8.72-1.08 1.19-.64.93-1 1.43-2.14s1.72-1.87 2.78-.83a2.94 2.94 0 01.66 1.26c1 3.3.62 6.85.62 10.31a4.54 4.54 0 00.2 1.6 9.05 9.05 0 00.91 1.48 3.37 3.37 0 01.19.38 10.17 10.17 0 01.67 4.83z",
  fill: "#514e7f"
});

var _ref7$1 = /*#__PURE__*/createElement("path", {
  d: "M446.14 440.62a4.45 4.45 0 01-.8 2.9 3.93 3.93 0 01-1.68 1c-9.27 3.32-20-.82-29.25 2.45-1.9.67-3.7 1.64-5.61 2.28a30.52 30.52 0 01-7 1.24c-3.27.31-6.56.51-9.84.6a23.66 23.66 0 01-7.42-.65 8.91 8.91 0 01-5.69-4.51 4.33 4.33 0 01-.28-3.21 3.46 3.46 0 01.61-1c.54 1.13.93 2.63 1.27 3.17a6.49 6.49 0 004.34 3.13 10.78 10.78 0 004-.51c8.4-2.08 17.33-2.11 25.4-5.26 2.77-1.09 5.41-2.54 8.32-3.2s6-.48 9-.73c4.74-.38 9.33-1.81 14-2.56a10.17 10.17 0 01.63 4.86z",
  fill: "#464353"
});

var _ref8$1 = /*#__PURE__*/createElement("path", {
  d: "M566.77 415.55c-.44 3.52-2.67 6.55-5.12 9.12s-5.22 4.88-7.17 7.84c-2.4 3.67-3.48 8.22-6.6 11.32a18.1 18.1 0 01-4 2.85 27.91 27.91 0 01-5.15 2.37c-4.66 1.49-9.68 1.15-14.55.79a13.09 13.09 0 01-4.62-.89 13.92 13.92 0 01-1.92-1.18 9.17 9.17 0 01-3-3 3 3 0 01-.29-2.18 5.12 5.12 0 011.39-2.12 33 33 0 013.52-3.17 21.07 21.07 0 004.58-4 12.92 12.92 0 001.77-4 35.48 35.48 0 001.29-7.65 24.25 24.25 0 01.53-5.12c.74-2.64 2.7-5 2.48-7.73a1.93 1.93 0 01.1-1.17 1.63 1.63 0 01.92-.57 16.3 16.3 0 014.78-1.11 5.57 5.57 0 014.44 1.74c.68.82 1.13 2 2.13 2.32a3.38 3.38 0 001.52.06c2.46-.25 5.06-.56 7-2.15a8.73 8.73 0 002.9-6.37c0-.91-.41-1.86 1-2 1.06-.14 1.9 1 2.44 1.7 1.95 2.61 3.95 5.34 4.68 8.52a2.51 2.51 0 01.89-.17 3.87 3.87 0 013.19 1.63 6.35 6.35 0 01.87 4.32z",
  fill: "#514e7f"
});

var _ref9$1 = /*#__PURE__*/createElement("path", {
  d: "M566.77 415.55c-.44 3.52-2.67 6.55-5.12 9.12s-5.22 4.88-7.17 7.84c-2.4 3.67-3.48 8.22-6.6 11.32a18.1 18.1 0 01-4 2.85 27.91 27.91 0 01-5.15 2.37c-4.66 1.49-9.68 1.15-14.55.79a13.09 13.09 0 01-4.62-.89 13.92 13.92 0 01-1.92-1.18 9.17 9.17 0 01-3-3 7.31 7.31 0 013-.72c2.16.12 3.74 2.16 5.81 2.79 2.95.89 5.89-1.19 8.88-1.9 1.95-.46 4-.34 5.93-1a14.66 14.66 0 004.39-2.66 22.35 22.35 0 004.69-4.52 29.05 29.05 0 002.75-5.49 78.5 78.5 0 015.56-10.64 7.52 7.52 0 011.13-1.48c.47-.43 1-.73 1.53-1.11 2-1.51 2.83-4 3.53-6.44a11.27 11.27 0 01.79-2.15 3.87 3.87 0 013.19 1.63 6.35 6.35 0 01.95 4.47z",
  fill: "#464353"
});

var _ref10$1 = /*#__PURE__*/createElement("path", {
  d: "M357.08 103.77a21.21 21.21 0 016 7c1.4 2.74 9.47 24 9 27.09 2.63-2.65 13-3.08 15.66-5.73 1.11-1.11 7.1-6.65 8-7.94s7.58-4 8.31-5.36c2.73-4.89-19.36-23.42-16.53-28.25a1.26 1.26 0 00.23-.76 1.24 1.24 0 00-.37-.59c-1.81-1.85-4.21-3-6.39-4.37s-4.28-3.28-4.87-5.8a21 21 0 00-5.65 3.82q-6.08 5.21-11.95 10.63c-1.53 1.42-4.49 3.31-5.2 5.34-.84 2.18 2.3 3.73 3.76 4.92z",
  fill: "#a1616a"
});

var _ref11$1 = /*#__PURE__*/createElement("path", {
  d: "M392.84 95.9a65.08 65.08 0 00-9.46 7.74c-2.74 2.71-5.34 5.85-6 9.64-.28 1.49-.24 3-.47 4.51-1 6.55-6.66 11.35-9.16 17.48a30.31 30.31 0 00-1.59 5.85 69.15 69.15 0 00-1.15 11.48c-.06 3.73 3.6 6.3 4.94 9.78s1.7 7.06 2.38 10.63c1.28 6.74 3.63 13.24 6 19.7 4.93 13.62 20.91 51.27 25.84 64.9 15.11-3.79 55.33-12.5 68.71-20.49 4.46-2.66-30.95-32.67-26.18-34.74a1.78 1.78 0 001.34-2.51c-4.77-20.86-19.69-38-26.46-58.31-2.35-7.05-6.57-13.07-9.77-19.77-2.9-6.07-4.45-12.78-7.92-18.55a11.7 11.7 0 00-2.53-3.15 14.92 14.92 0 00-2.79-1.69c-1.98-.96-3.82-1.53-5.73-2.5z",
  fill: "#514e7f"
});

var _ref12$1 = /*#__PURE__*/createElement("circle", {
  cx: 357.88,
  cy: 77.75,
  r: 23.65,
  fill: "#a1616a"
});

var _ref13$1 = /*#__PURE__*/createElement("path", {
  d: "M381.94 88.86a7.93 7.93 0 018.89-1.28c1.6.83 3 2.51 2.64 4.27l11.73.18a23.55 23.55 0 015.56.51 8.08 8.08 0 014.64 2.91c.14.19.3.42.54.45a.86.86 0 00.54-.18 10.18 10.18 0 015.84-1c6.34.41 12.2 3.58 17.17 7.54a5.55 5.55 0 012 2.49c.41 1.33-.08 3 1 3.95 0 11 3.78 21.28 6.3 32 .45 1.91 2.28 3.6 3.55 5.1a20.57 20.57 0 013.79 5.66c2.14 5.56-.81 12.1 1.27 17.68.88 2.36 2.58 4.3 4 6.35a16.42 16.42 0 013.42 8.2c.09 1.34-.08 2.69 0 4a24.21 24.21 0 001 5.31q1.28 4.84 2.68 9.67c1.52 5.2 3.5 10.81 8.16 13.58-11.25 1.91-23.11 3.78-33.83-.13a17.54 17.54 0 01-4.22-2.11c-3.87-2.76-5.74-7.48-7.41-11.94-1.86-5-3.75-10.09-4.13-15.41a17.69 17.69 0 00-.71-5c-1.09-2.9-4-4.65-6.64-6.26a31.88 31.88 0 01-8-6.22 12.43 12.43 0 01-3.24-9.34c.2-1.65.85-3.24.91-4.9s-.68-3.56-2.27-4c-8.19-2.48-12.1-12.18-13.92-20.54a65.94 65.94 0 01-1.05-13.1l-.11-8.53a11.26 11.26 0 01-3.68-8.09 9.61 9.61 0 00-.05-2.68 7.39 7.39 0 00-1.88-2.85 25.44 25.44 0 01-4.49-6.29zM356.75 115.9c-.27 2.64.33 5.35-.26 7.94-.23 1-.63 2-.92 2.93a17.2 17.2 0 001.09 11.13 62 62 0 005.69 9.85 16 16 0 011.82 3.41 17.65 17.65 0 01.7 3.89 120.83 120.83 0 002.78 15.72c1.12 4.48 13.84 42.78 16.8 46.33a3.77 3.77 0 002.28 1.55 4.15 4.15 0 001.94-.4l6-2.3a3.92 3.92 0 001.39-.76 3.58 3.58 0 00.86-2.36c.43-4.88-12.32-43.45-13.94-48.06-4.9-13.92-11.42-27.34-14.61-41.75-.89-4-1.36-10.16-4.29-13.35-1.21-1.32-.8-.76-2.25-.07a16.42 16.42 0 00-2.12 1.11 6.94 6.94 0 00-2.96 5.19z",
  fill: "#464353"
});

var _ref14$1 = /*#__PURE__*/createElement("path", {
  d: "M374.96 142.31c1.61 8.51 3.27 17 4.92 25.51l23.48-6.15c.19-2.46-1.12-4.74-2-7-2.14-5.37-2.19-11.35-3.92-16.87-1.31-4.2-3.59-8.06-4.82-12.29-.71-2.46-1.07-5-1.77-7.49a54.4 54.4 0 00-2.76-7.15 44.76 44.76 0 00-5.12-9.49c-3 1.12-6.2 2.42-7.91 5.13a11.08 11.08 0 00-1.46 5c-.41 5.27 1.5 10.57.87 15.81a46.5 46.5 0 00.49 14.99z",
  fill: "#28629b"
});

var _ref15$1 = /*#__PURE__*/createElement("path", {
  d: "M403.75 255.51c1.32 5-.59 10.26-2.15 15.21a117.88 117.88 0 00-4.78 22.9 19.82 19.82 0 01-1.18 5.79c-.74 1.67-2 3.08-2.86 4.67-2.36 4.18-2.3 9.28-1.79 14.06.34 3.15.85 6.29 1.48 9.39.77 3.79 1.72 7.75.61 11.45 1.86-.41 3.12 2 3 3.89s-.73 4 .18 5.63c2.3.84 2.32 4 2.25 6.45a54.25 54.25 0 001.6 12.6q5.22 25.1 11.08 50.06c8.45 2.62 18.32 5.35 26.38 1.72 1.5-.67 3-1.74 3.34-3.36a5.86 5.86 0 00-.32-2.58l-3.82-13.9c-.93-3.36-1.86-6.83-1.37-10.28.37-2.57 1.49-5.34.23-7.61-.43-.78-1.11-1.39-1.61-2.13-2-2.93-.95-6.85-.79-10.4a8.24 8.24 0 00-.16-2.38 11.88 11.88 0 00-1.14-2.61 39.92 39.92 0 01-4.4-19.86 4.91 4.91 0 00-.35-2.59 8.38 8.38 0 01-.65-1.06 2.9 2.9 0 01.21-1.91 17.5 17.5 0 01-3.08-3 4.31 4.31 0 00.74-6.74 2.25 2.25 0 001.07-3.87c-.49-.34-1.14-.49-1.49-1-.54-.74-.1-1.77.34-2.56l2.33-4.21c1.74-3.13 2.13-7 4-10 2.68-4.37 4.43-9.24 6.16-14.06l6.73-18.57 4.53 3.93a14.32 14.32 0 013.72 4.24 18.3 18.3 0 011.21 5.08c1.66 10.08 8 18.82 10.35 28.75.52 2.21.87 4.53 2.14 6.42a14 14 0 011.22 1.84 9.76 9.76 0 01.51 3.05 14.23 14.23 0 006 10.2c2.23 1.53 5 2.58 6.21 5a9.32 9.32 0 001 2.13c1.08 1.3 3.41 1.45 3.87 3.08.26.91-.22 2 .29 2.8a2.65 2.65 0 001.11.83l6.51 3.25c7.28 3.64 11 12 16.37 18.09a39 39 0 014.9 6.48c2.32 4.15 3.39 9.36 7.31 12a11.06 11.06 0 012.84 2.11c1.23 1.62.78 3.89.89 5.93s1.67 4.47 3.61 3.85a14.23 14.23 0 000 7.55 38 38 0 0023.06-9.34c1.9-1.66 3.73-3.78 3.75-6.3a2.26 2.26 0 00-.28-1.25 3.57 3.57 0 00-1.47-1.11c-6.09-3.3-7.92-10.95-11-17.16-2.69-5.48-6.67-10.2-10-15.29-7.24-10.95-12.18-24.2-23.13-31.43-2.41-1.59-5.21-3-6.42-5.63-.67-1.47-.75-3.15-1.28-4.67s-1.8-3-3.42-3c.9-2.2.72-4.88.78-7.26a9.17 9.17 0 00-.36-3.13 15.23 15.23 0 00-1.61-3.1 29.74 29.74 0 01-4.12-16c.08-2.89.59-5.87-.28-8.63-.44-1.39-1.21-2.66-1.74-4a25 25 0 01-1.25-7.52l-.6-9.61a47.28 47.28 0 00-1.24-9.5c-2-7.46-4-38.71-10.85-42.23s-18.62 20.53-26.33 21a34.29 34.29 0 00-10 1.93c-5.13 1.92-9.43 5.5-13.62 9l-14.18 11.91c-3 2.47-5.48 4.83-8.79 6.57zM335.69 51.49c3.12-4.26 8.48-6.52 13.76-6.71s10.48 1.47 15.21 3.82a18.79 18.79 0 004.44 1.82c2.5.51 5.28-.17 7.54 1 3 1.59 3.58 5.64 3.32 9s-.89 7.09.9 10a23.12 23.12 0 011.73 2.61c.77 1.73.32 3.73-.14 5.56-1.17-1-1.83-2.51-2.87-3.67s-2.85-1.94-4.14-1.07-1.27 2.45-1.34 3.87-.43 3.12-1.77 3.58a2.87 2.87 0 01-3-1.17c-2.29-2.8-1.37-7.27-3.64-10.09-1.29-1.6-3.44-2.38-4.63-4.06-.94-1.32-1.18-3-2-4.42s-2.73-2.46-4-1.48a5.41 5.41 0 00-1.07 1.43 6.15 6.15 0 01-7.3 2.2 12.21 12.21 0 00-3.16-1.37 3.91 3.91 0 00-3.61 2 7.81 7.81 0 00-1 4.18c0 2 .36 4.13-.78 5.73a5.93 5.93 0 01-1.6 1.52c-1.67 1.07-4 1.79-5.54.57a4.16 4.16 0 01-1.24-3.88 31.37 31.37 0 011.18-4.1c.88-3.1-.27-6.59.69-9.51a30.36 30.36 0 014.06-7.36z",
  fill: "#464353"
});

var _ref16$1 = /*#__PURE__*/createElement("path", {
  d: "M348.36 122.04a3.64 3.64 0 00.22 2.17 3.45 3.45 0 001.18 1.13 24.26 24.26 0 0011.14 3.61 3.39 3.39 0 011.54.4c.94.62 1 2 .65 3.1a8.07 8.07 0 00-.71 3.3c.29 2.09 2.77 3 4.86 3.31 2.93.37 6.14.18 8.46-1.65a13.07 13.07 0 003.49-5.23c5.74-13.19 7.75-27.77 13.56-40.92a8.68 8.68 0 00.87-2.74 2.7 2.7 0 00-1.08-2.52c-1.08-.67-2.76-.29-3.49-1.34-.36-.53-.32-1.25-.64-1.81-.67-1.19-2.43-1-3.63-1.69-.94-.5-1.59-1.53-2.64-1.73a3.32 3.32 0 00-2.73 1.18c-3.41 3.18-5.2 7.69-7.1 11.95a140.09 140.09 0 01-10.16 18.84c.45-.7-2.16-6-3.18-6.23-1.79-.36-4.08 2.78-5.05 3.95a25.16 25.16 0 00-5.56 12.92z",
  fill: "#28629b"
});

var _ref17$1 = /*#__PURE__*/createElement("path", {
  d: "M384.69 82.09a4.79 4.79 0 00-3.71 1.86c-1.07 1.39-1.28 3.23-1.55 5a43.45 43.45 0 01-5.89 15.82M389.79 86.08a5.71 5.71 0 00-4.85 2.91 16.35 16.35 0 00-1.22 4.94 27.11 27.11 0 01-4.85 10.39",
  opacity: 0.1
});

var _ref18$1 = /*#__PURE__*/createElement("path", {
  d: "M627.45 281.58v-12.42a34.48 34.48 0 00-34.48-34.47H102.48A34.48 34.48 0 0068 269.16v22.9z",
  fill: "#33323d"
});

var _ref19$1 = /*#__PURE__*/createElement("path", {
  d: "M238.93 220.13s-1.4 86.86 14 115.44 22 152.91 22 152.91 161.44 16.7 273.94-20 351.88-51.71 351.88-51.71l-40.34-271.89s-199.29-12.78-312.66 41.29-308.82 33.96-308.82 33.96z",
  fill: "#8dd070"
});

var _ref20$1 = /*#__PURE__*/createElement("path", {
  d: "M238.93 220.13s-1.4 86.86 14 115.44 22 152.91 22 152.91 161.44 16.7 273.94-20 351.88-51.71 351.88-51.71l-40.34-271.89s-199.29-12.78-312.66 41.29-308.82 33.96-308.82 33.96z",
  opacity: 0.1
});

var _ref21$1 = /*#__PURE__*/createElement("path", {
  d: "M274.66 251.86s-5.05 71.67 7.62 94.57 13.26 125.13 13.26 125.13 145.29 6.74 248.64-28.44 320.53-58 320.53-58l-24.68-222.35s-179.7-1.85-284.58 47.67-280.79 41.42-280.79 41.42z",
  fill: "#8dd070"
});

var _ref22$1 = /*#__PURE__*/createElement("ellipse", {
  cx: 628.34,
  cy: 440.31,
  rx: 37.72,
  ry: 80.9,
  transform: "rotate(-7.1 -366.375 1062.128)",
  opacity: 0.1
});

var _ref23$1 = /*#__PURE__*/createElement("path", {
  d: "M751.15 12.43s-193.61 49-284.91 135.25-283.5 127.09-283.5 127.09 25.32 83.09 48.74 105.57 67.84 138.8 67.84 138.8S458.09 485.48 553.89 416s319.07-157.23 319.07-157.23z",
  opacity: 0.2
});

var _ref24$1 = /*#__PURE__*/createElement("path", {
  d: "M179.83 262.33s25.31 83.1 48.71 105.58 67.84 138.79 67.84 138.79 158.79-33.65 254.6-103.13 319.06-157.2 319.06-157.2L748.23 0s-193.6 49-284.9 135.25-283.5 127.08-283.5 127.08z",
  fill: "#8dd070"
});

var _ref25$1 = /*#__PURE__*/createElement("path", {
  d: "M179.83 262.33s25.31 83.1 48.71 105.58 67.84 138.79 67.84 138.79 158.79-33.65 254.6-103.13 319.06-157.2 319.06-157.2L748.23 0s-193.6 49-284.9 135.25-283.5 127.08-283.5 127.08z",
  opacity: 0.1
});

var _ref26$1 = /*#__PURE__*/createElement("path", {
  d: "M223.54 281.57s17.19 69.77 36.28 87.67 51 115 51 115 140.34-38.18 227.91-103.38 287.29-153.47 287.29-153.47L734.31 23.27S562.72 76.64 478.09 155.96 223.54 281.57 223.54 281.57z",
  fill: "#8dd070"
});

var _ref27$1 = /*#__PURE__*/createElement("ellipse", {
  cx: 585.81,
  cy: 384.01,
  rx: 37.72,
  ry: 80.9,
  transform: "rotate(-24.97 276.73 515.669)",
  opacity: 0.1
});

var _ref28$1 = /*#__PURE__*/createElement("path", {
  d: "M640.69 293.77v345a29.83 29.83 0 01-29.84 29.83h-513a29.83 29.83 0 01-29.82-29.83V258.99c14.7 5.46 14.7 5.46 29.82 5h513a29.84 29.84 0 0129.84 29.78z",
  opacity: 0.1
});

var _ref29$1 = /*#__PURE__*/createElement("path", {
  d: "M640.69 298.16v345a29.84 29.84 0 01-29.84 29.83h-513a29.83 29.83 0 01-29.82-29.83V263.37c14.7 5.45 14.7 5.45 29.82 5h513a29.84 29.84 0 0129.84 29.79z",
  fill: "#504f60"
});

var _ref30$1 = /*#__PURE__*/createElement("path", {
  d: "M639.23 425.71v110.33h-107a55.17 55.17 0 010-110.33z",
  opacity: 0.1
});

var _ref31$1 = /*#__PURE__*/createElement("path", {
  d: "M640.69 422.77v110.35h-107a55.17 55.17 0 010-110.33z",
  fill: "#33323d"
});

var _ref32$1 = /*#__PURE__*/createElement("circle", {
  cx: 538.82,
  cy: 480.88,
  r: 21.51,
  opacity: 0.1
});

var _ref33$1 = /*#__PURE__*/createElement("circle", {
  cx: 540.28,
  cy: 477.96,
  r: 21.51,
  fill: "#28629b"
});

var _ref34$1 = /*#__PURE__*/createElement("path", {
  d: "M826.42 421.82c.85 9.21-6.12 18.15-4.09 27.17.44 1.93 1.27 3.75 1.57 5.7.84 5.36-2.35 10.43-5.4 14.91l-26.2 38.44a23.87 23.87 0 01-3.74 4.62c-5 4.46-12.52 4-19.1 5.33a32.64 32.64 0 00-12.8 5.66.82.82 0 00-.12 1.12 11 11 0 009.52 4.47c.69.91 0 2.24-1 2.89-1.41 1-3.34 1.24-3.62 3.62a3.93 3.93 0 00.48 2.4 7.45 7.45 0 004.58 3.19c9.07 2.77 18.87-2.1 25.66-8.73s11.66-15 18.32-21.75c3.69-3.73 7.88-6.93 11.68-10.55 7.58-7.22 13.47-16 19.16-24.79 1.71-2.65 3.43-5.37 4.15-8.44s.38-6.17 1.19-9.14c1.06-3.9 3.91-7 6.28-10.27 4.65-6.4 7.75-14.23 7.14-22.11s-5.5-15.67-12.94-18.35a11.5 11.5 0 00-7.25-.44c-3.05.94-5.3 3.46-7.38 5.87l-5 5.75a13.48 13.48 0 00-2.9 4.4 4.61 4.61 0 001 4.89",
  fill: "#fbbebe"
});

var _ref35$1 = /*#__PURE__*/createElement("path", {
  d: "M826.42 421.82c.85 9.21-6.12 18.15-4.09 27.17.44 1.93 1.27 3.75 1.57 5.7.84 5.36-2.35 10.43-5.4 14.91l-26.2 38.44a23.87 23.87 0 01-3.74 4.62c-5 4.46-12.52 4-19.1 5.33a32.64 32.64 0 00-12.8 5.66.82.82 0 00-.12 1.12 11 11 0 009.52 4.47c.69.91 0 2.24-1 2.89-1.41 1-3.34 1.24-3.62 3.62a3.93 3.93 0 00.48 2.4 7.45 7.45 0 004.58 3.19c9.07 2.77 18.87-2.1 25.66-8.73s11.66-15 18.32-21.75c3.69-3.73 7.88-6.93 11.68-10.55 7.58-7.22 13.47-16 19.16-24.79 1.71-2.65 3.43-5.37 4.15-8.44s.38-6.17 1.19-9.14c1.06-3.9 3.91-7 6.28-10.27 4.65-6.4 7.75-14.23 7.14-22.11s-5.5-15.67-12.94-18.35a11.5 11.5 0 00-7.25-.44c-3.05.94-5.3 3.46-7.38 5.87l-5 5.75a13.48 13.48 0 00-2.9 4.4 4.61 4.61 0 001 4.89",
  opacity: 0.05
});

var _ref36$1 = /*#__PURE__*/createElement("path", {
  d: "M846.25 658.92c-5.72 3.49-12.85 3.7-19.5 2.89-1.07-.13-2.34-.21-3 .62-1 1.2.18 3 1.4 3.93a28.85 28.85 0 0013.39 5.51 88.17 88.17 0 0013.1.87c12 .21 24 .41 35.81-1.31a5.07 5.07 0 002-.58 3.66 3.66 0 001.48-2.25c.81-3.08-.75-6.38-3.11-8.52s-5.39-3.33-8.35-4.48l-10.4-4.05c-2.44-.95-6.35-3.47-9-3.27-4.98.36-9.69 8.22-13.82 10.64z",
  fill: "#3f3d56"
});

var _ref37$1 = /*#__PURE__*/createElement("path", {
  d: "M846.25 658.92c-5.72 3.49-12.85 3.7-19.5 2.89-1.07-.13-2.34-.21-3 .62-1 1.2.18 3 1.4 3.93a28.85 28.85 0 0013.39 5.51 88.17 88.17 0 0013.1.87c12 .21 24 .41 35.81-1.31a5.07 5.07 0 002-.58 3.66 3.66 0 001.48-2.25c.81-3.08-.75-6.38-3.11-8.52s-5.39-3.33-8.35-4.48l-10.4-4.05c-2.44-.95-6.35-3.47-9-3.27-4.98.36-9.69 8.22-13.82 10.64z",
  opacity: 0.05
});

var _ref38$1 = /*#__PURE__*/createElement("path", {
  d: "M853.54 520.86c-4.33 5.76-8.81 12.41-7.74 19.54.58 3.84 2.73 7.23 4.31 10.78 2.14 4.82 3.26 10 4.36 15.16 1.62 7.54 3.25 15.1 4.24 22.76 1.13 8.65-4.18 33.68-4.67 42.39-.12 2.1-.37 4.37-1.83 5.88-.57.6-1.33 1.08-1.59 1.86a3.18 3.18 0 00.35 2.2c2.44 5.5 7.43 9.6 13 11.94s19 6.38 25.07 6.59a5 5 0 002.36-.31 4.59 4.59 0 001.82-2.09c4.35-8.32.17-37.9.23-47.29.06-7.83 1.91-15.61 1.57-23.43-.28-6.28-2-12.42-2.57-18.68-1-10.26.88-20.57 2.77-30.71 1.44-7.78 2.89-15.56 4.74-23.24 1.13-4.69 2.44-9.42 5-13.49 2-3.23 4.81-5.93 7.14-9a40.62 40.62 0 008-29.74c-.14-1-15 3.77-16.31 4.34a50.81 50.81 0 00-14.54 9.35c-3.44 3.28-6.15 7.66-9.16 11.33q-6.39 7.79-12.62 15.69-7.11 9.03-13.93 18.17z",
  fill: "#464353"
});

var _ref39$1 = /*#__PURE__*/createElement("path", {
  d: "M853.54 520.51c-4.33 5.76-8.81 12.42-7.74 19.54.58 3.85 2.73 7.24 4.31 10.79 2.14 4.81 3.26 10 4.36 15.15 1.62 7.55 3.25 15.11 4.24 22.76 1.13 8.66-4.18 33.68-4.67 42.39-.12 2.1-.37 4.38-1.83 5.89-.57.59-1.33 1.07-1.59 1.85a3.17 3.17 0 00.35 2.2c2.44 5.51 7.43 9.6 13 12s19 4.49 25.07 4.69a5 5 0 002.36-.31 4.52 4.52 0 001.82-2.08c4.35-8.32.17-36 .23-45.4.06-7.84 1.91-15.61 1.57-23.44-.28-6.28-2-12.42-2.57-18.67-1-10.27.88-20.58 2.77-30.72 1.44-7.77 2.89-15.55 4.74-23.24 1.13-4.69 2.44-9.42 5-13.49 2-3.23 4.81-5.93 7.14-9a40.6 40.6 0 008-29.74c-.14-1-15 3.77-16.31 4.34a51.05 51.05 0 00-14.54 9.36c-3.44 3.27-6.15 7.65-9.16 11.32q-6.39 7.79-12.62 15.7-7.11 8.96-13.93 18.11z",
  opacity: 0.05
});

var _ref40$1 = /*#__PURE__*/createElement("circle", {
  cx: 805.36,
  cy: 369.73,
  r: 24.27,
  fill: "#fbbebe"
});

var _ref41$1 = /*#__PURE__*/createElement("path", {
  d: "M827.22 368.71a31.43 31.43 0 0020.15 14.06l-1.83 6.65c-3.16 11.42-6.71 23.5-15.53 31.42 1-3.87-.28-8-2.46-11.36s-5.24-6-8.24-8.61l-13.97-12.1a4.21 4.21 0 01-1-1.18 3.55 3.55 0 010-2.66c1.78-5.54 6.86-9 11-12.74a38.1 38.1 0 005.53-6.44c2.79-3.98 4.52.02 6.35 2.96z",
  fill: "#fbbebe"
});

var _ref42$1 = /*#__PURE__*/createElement("path", {
  d: "M773.39 345.33l-.55-4.56c3.83 1 7.47-2.26 9.92-5.63s4.72-7.34 8.45-8.75c4.53-1.7 9.33 1 13.66 3.28a43.19 43.19 0 0015.67 5.1 10.31 10.31 0 012.59.42c2.82 1 4.16 4.54 4.57 7.75s.3 6.62 1.69 9.48c1 2.17 2.86 3.78 4 5.92 3 5.74.1 13.59 3.23 19.22l-7.78-7.13c-.71-.65-1.71-1.33-2.5-.78-.62.44-.67 1.39-.92 2.15-.75 2.22-3.53 2.88-5.54 2s-3.48-2.79-5-4.53c-3.44-4.06-7.54-7.63-12.34-9.36a15.84 15.84 0 00-13 .86c-3.63 2.05-6.29 6.83-10.74 7-6.1.23-8.64-11.13-11.46-15.62a5.5 5.5 0 001.6-6.88c.41-.17 4.36-.64 4.45.06z",
  fill: "#464353"
});

var _ref43$1 = /*#__PURE__*/createElement("path", {
  d: "M473.2 203.44a47.21 47.21 0 00-5.39 5.66 11.33 11.33 0 00-2.48 7.27 3.72 3.72 0 00.7 2.13 1.8 1.8 0 002 .61 2.69 2.69 0 001-.88 48.27 48.27 0 013.36-3.64c.43-.43 1-.88 1.58-.72a1.69 1.69 0 01.68.45 4.6 4.6 0 011.41 2.2c.35 1.53-.54 3.06-1.55 4.26s-2.2 2.35-2.61 3.86a1.71 1.71 0 000 1.24 1.86 1.86 0 00.78.66 11.16 11.16 0 009.44.62c2-.81 3.78-2.2 5.84-2.92a13.5 13.5 0 002.58-1 5.36 5.36 0 002.29-3.43 14.14 14.14 0 00.15-4.21 48.41 48.41 0 00-3.44-15.83 2 2 0 00-.58-.84 1.85 1.85 0 00-1-.27c-2.56-.27-6.76-1.58-9.23-.63a6.52 6.52 0 00-2.18 1.94c-.46.51-3.35 2.8-3.35 3.47z",
  fill: "#a1616a"
});

var _ref44$1 = /*#__PURE__*/createElement("path", {
  d: "M472.39 201.18c0-2.44-3-8.33 1.77-8.72 0-2.61-3.69-4.23-3-7 .22-.92 1-1.67 1.09-2.61.3-2.67-4.52-4.12-3.72-6.68.3-1 1.36-1.58 1.59-2.57.54-2.31-3.59-3.34-3.67-5.71 0-.8.45-1.55.41-2.35 0-1-.87-1.76-1.35-2.63-1.25-2.23-.64-5.68-2.92-6.83 1.51.13 2-2.11 1.38-3.48s-1.89-2.56-1.9-4.08a6.16 6.16 0 000-1.66c-.42-1.46-2.81-1.58-3.21-3a12.78 12.78 0 01-.05-1.64c-.16-1.13-1.32-1.85-2.41-2.17a9.83 9.83 0 01-3.22-1.15c-.7-.53-1.51-1.41-2.26-1-.28.17-.42.49-.63.73-.9 1.05-2.62.59-3.75-.18-3.34-2.27-5-6.34-5.71-10.31s-.69-8.07-1.58-12a25.64 25.64 0 00-1.08-3.6c-.38-1-1.6-2.57-1.68-3.58-.18-2.3 4.58-.73 6.39-.5a28.46 28.46 0 015.19 1 55.49 55.49 0 015.31 2.33c7.22 3.19 15.94 3.58 21.74 8.94 1.91 1.76 3.52 4.07 6 4.87a27.15 27.15 0 013.36.87c2.75 1.29 3.18 4.94 4.68 7.58a14.86 14.86 0 011.23 2.2 8.48 8.48 0 01.4 2.8l.21 6.93c.34 11.61.68 23.25-.56 34.79-.4 3.81-1 7.73.13 11.39.3 1 .72 1.94 1 2.95a18 18 0 01.38 3.6l.16 4.49a1.4 1.4 0 01-.22 1 1.44 1.44 0 01-1.21.29c-6.25-.56-12.57-4.08-18.47-1.95",
  fill: "#464353"
});

var _ref45$1 = /*#__PURE__*/createElement("ellipse", {
  cx: 757.61,
  cy: 535.49,
  rx: 73.96,
  ry: 10.69,
  fill: "#504f60"
});

var _ref46$1 = /*#__PURE__*/createElement("path", {
  d: "M905.7 654.24c-1.3-5.57-2.11-10.46-2.11-10.46s.3-6.06-2.42-10.61V620.45a38.18 38.18 0 012.83-5.87c2-3.52 0-16.42 0-16.42s-7.47-18.19-5.66-29.73S883 517.19 883 517.19a50.59 50.59 0 011.61-11.34 8.65 8.65 0 00.22-2.38v-.29.09c-.26-7.61-6.28-21.87-6.28-21.87l.81-27.18s3.84-16-2.42-37.55c-2.19-7.51-3.59-13.52-4.48-18.16-.1-.52-.2-1-.28-1.51 12.89-2 22.74-3.6 22.74-3.6s-7.48-31.29-12.53-36.77-9.09-22.69-9.09-22.69-2.63-22.09 1.62-28.55 4.85-17.6 4.85-17.6 9.69-7 10.91-10.17 3.23-10.17 3.23-13.88-1.21-7-.81-9-2.83-9.39-1.21-12.91a9.47 9.47 0 00.64-3.39.44.44 0 000-.1 47.51 47.51 0 00-.85-9.18 26.05 26.05 0 00-9.6-5.13l-.21-.84-.55-2.2a10.67 10.67 0 00-.95-.56v-.8l-.09-3.18 1.52-7.14c3-12.42-13.59-14.27-13.59-14.27a8.75 8.75 0 00-4.7-4.12c-3.33-1.17-.55 18.68 1 20 1.17 1 4.79 7.18 6.54 10.24l.28.5a7 7 0 00-.76.8l.63 4.31.1.66a17.89 17.89 0 00-2.65 4.51s3 3.32 2.43 7 .93 8.35 1 8.6c-.18-.21-2.31-2.51-4.44-1.95s-8.08 2.35-8.08 2.35-4.44.78-4 1.76-3 5.28-3 5.28l-11.94-11.32c-.12-.34-.25-.68-.35-1a27.53 27.53 0 01-1-5 27.31 27.31 0 003.82-1.21 8.24 8.24 0 003.3-2.12c1.21-1.43 1.44-3.37 1.93-5.15.94-3.48 3-6.57 4.43-9.88a32.12 32.12 0 002.25-17.78 11.6 11.6 0 00-1.83-5.2c-1.95-2.68-5.49-3.77-8.06-5.91s-4.23-5.41-7.23-7c-2.71-1.45-6-1.28-9.06-.78a48.83 48.83 0 00-16.93 6.16c-1.74 1-3.66 2.23-5.66 1.86-1.72-.31-3-1.68-4.08-3a1 1 0 01.05-.16 1 1 0 01-.13-.16 21.09 21.09 0 00-1.86 8.94c0 .48 0 1 .06 1.43V198.61a2.28 2.28 0 01-.09.63 4.55 4.55 0 01-1.12 1.61 10.79 10.79 0 00-1 1.33c0-.16.1-.32.16-.49a7.11 7.11 0 00-1.24 3.77 3.85 3.85 0 00.9 2.7 13 13 0 001.95 1.56 22.75 22.75 0 00-.36 4 23.11 23.11 0 0011.26 19.71c.14.33.27.67.4 1 1.53 4 2.68 8.7 2.17 13 0 .31-.09.63-.14.94s-.3.33-.43.5-19.73.2-24.37-4-11.72 10.27-11.72 10.27-7.07 1.37-8.49 0-9.69-.19-9.69-.19a17.83 17.83 0 00-12.33-4.5 36.19 36.19 0 00-9-5l-.22-.08a10.08 10.08 0 00-4.45-.56s-9.7-8-12.53-12.32-16.3-20.27-16.36-20.34v-.77l-.15-2.32a8.31 8.31 0 01-1.21.1c-.07-.23-.17-.5-.27-.81a44.73 44.73 0 00-2.86-6.57s0-2.93.85-3.67-.35-11.49-.35-11.49-8.74-20.43-16.57-5.18c0 0-14.8 9.87-2.38 21.37 0 0 5 2.4 5.66 4.3.46 1.23 2.14 4.68 3.27 7l.51 1-.14.12.18 1.92.08.74c-2.34 1.33-3.93 2.65-3.54 3.64a21.87 21.87 0 011.41 5.28s17.18 21.52 19.4 30.71c0 0 46.07 27.38 61.22 29.33L766 300.5a108.94 108.94 0 00-.6 11.15c.2 2.93-1.82 16.23-1.82 16.23s-2.63 19.56-4.85 22.3-1.82 14.47-1.82 14.47a98.86 98.86 0 01-3 16.62c-2.22 7.43-.61 16.63-.61 16.63s-7.67 17.6 10.71 5.67c0 0 9-.56 19.42-.92v1c0 1.34 0 2.79-.07 4.31-.14 10.08-.2 24 .26 34.48.81 18.58 6.47 55.35 6.47 55.35v18.51a25.19 25.19 0 00-.54 5.28 34.36 34.36 0 005 18.49l1.42 12.32s3.32 8.12 3.38 13a6.82 6.82 0 01-.14 1.17 7.87 7.87 0 00-.16 1.89c-.19 5.6 3.18 19 3.18 19s.2 13.49 2.22 14.28c1.73.67-2.31 7.77-3.51 9.81a2.79 2.79 0 01-.07-.38l-.25.4a9.58 9.58 0 00-.63 3.42 4.9 4.9 0 002.24 4.74c3.84 2.35 5.9 4.3 2.64 5.08a33.94 33.94 0 00-3.56.75c0-.15-.12-.31-.17-.45a2.14 2.14 0 00-1.33 2.36A10 10 0 00801 632c3.23 7.24 5.47 10 5.47 10l1.55-.17a7.56 7.56 0 01-.9 1.67 6.44 6.44 0 01-2.28 2 7.06 7.06 0 01-2.77.95 7.8 7.8 0 00-5.72 2.78c-2 2.61-3.28 6.16.7 9.28l14.45 5s24.86 3.23 23.54-2.35-2.12-10.46-2.12-10.46a22.05 22.05 0 00-2-9.89 12.85 12.85 0 00-.88-1.46l.88-.09s1.82-12.33 4.24-14.67c.56-.54.69-1 .56-1.28.25-.67-.39-1.06-1.2-1.29l-.18.49a11.79 11.79 0 00-2.41-.27s-.81-6.45 1.82-8.8a2.49 2.49 0 00.51-1.92 10.32 10.32 0 00-.28-2.63 1.29 1.29 0 01-.09.16c-1.32-5.86-5.8-15.17-5.8-15.17s-.2-5.86 1.42-8.21-.21-31.88-.21-31.88.61-14.27-1.21-20.92 2.22-14.48 2.22-14.48v-.52l-.23-2.25a.58.58 0 000 .14c-.41-3.78-1.18-10.63-1.75-13.79-.81-4.5.21-26 .21-26l3.63-9.2 6.47 15.85 6.87 21.12s3.4 4.46 3.48 9v.66a11.54 11.54 0 00-.08 1.41 12.56 12.56 0 002.09 7.53s1.82 10 4.65 12.51 2.83 7.43 2.83 7.43 3.43 14.48 5 17c1.36 2.14 1.43 8 1.42 9.83v.52s.48 5.18.46 9.52v1.55a.43.43 0 000-.11 15.06 15.06 0 01-.42 3.52l-.06.2c0-.25 0-.49.07-.73a36.75 36.75 0 00-1 9c-.09 5.2.7 11.36 3.85 15 5.46 6.26 8.89 5.48 8.89 5.48s-2.62 7.82-5.86 9.39a1.52 1.52 0 00-.34.22c0-.16-.06-.31-.08-.46a3.81 3.81 0 00-1 2.92c-.23 3.44 1.94 9 4 11.59a6.53 6.53 0 002.73 1.6 4.33 4.33 0 01-.51.31 10.86 10.86 0 01-1.11.53 5.83 5.83 0 01-1.65.43 7.7 7.7 0 00-5.72 2.78c-2 2.6-3.28 6.15.7 9.27l14.45 5s24.7 3.17 23.4-2.4z",
  transform: "translate(-84.46 -118.23)",
  fill: "url(#FeeInput_svg__a)"
});

var _ref47$1 = /*#__PURE__*/createElement("path", {
  d: "M726.33 545.25l-14-5c-3.86-3.12-2.63-6.67-.68-9.28a7.48 7.48 0 015.54-2.78 6.64 6.64 0 002.67-.95 6.4 6.4 0 002.22-2 10.33 10.33 0 001.59-5.41s15.36-4.5 19.56 0a11.37 11.37 0 011.86 2.73 22.85 22.85 0 012 9.89s.78 4.88 2.05 10.46-22.81 2.34-22.81 2.34zM794.77 538.35l-14-5c-3.86-3.12-2.63-6.67-.68-9.27a7.39 7.39 0 015.53-2.78 5.19 5.19 0 001.6-.43 10.61 10.61 0 001.08-.53c3.91-2.15 3.81-7.43 3.81-7.43s15.35-4.5 19.56 0a11.08 11.08 0 011.47 2c2.63 4.55 2.34 10.62 2.34 10.62s.78 4.89 2 10.46-22.71 2.36-22.71 2.36z",
  fill: "#2d293d"
});

var _ref48$1 = /*#__PURE__*/createElement("path", {
  d: "M743.24 519.82a11.37 11.37 0 011.86 2.73l-23 2.67a10.33 10.33 0 001.59-5.41s15.35-4.49 19.55.01zM813.16 514.93v4.31c-3.58 5.89-20.89 4.6-25.92 1.65a10.61 10.61 0 001.08-.53c3.91-2.15 3.81-7.43 3.81-7.43s15.35-4.5 19.56 0a11.08 11.08 0 011.47 2z",
  opacity: 0.1
});

var _ref49$1 = /*#__PURE__*/createElement("path", {
  d: "M815.89 496.35a39.2 39.2 0 00-2.73 5.87v15.45c-3.92 6.45-24.25 4.3-27 .78s-5.62-12.68-2.53-14.27 5.67-9.39 5.67-9.39-3.33.78-8.61-5.48-3.71-20.14-2.73-23.46 0-14.47 0-14.47.2-7.83-1.36-10.37-4.89-17-4.89-17 0-4.89-2.74-7.43-4.5-12.52-4.5-12.52a12.83 12.83 0 01-1.95-8.41c.58-4.89-3.33-10.17-3.33-10.17l-6.65-21.13-6.26-15.84-3.52 9.19s-1 21.51-.19 26 2 16.43 2 16.43-3.91 7.82-2.15 14.47 1.12 20.94 1.12 20.94 1.76 29.52.19 31.87-1.37 8.22-1.37 8.22 8 17.2 5.48 19.55-1.76 8.8-1.76 8.8 5.47 0 3.13 2.35S745.1 521 745.1 521l-23.65 2.77s-2.16-2.73-5.29-10 .58-6.45 3.73-7.24 1.16-2.73-2.56-5.08-1.56-7.63-1.56-7.63 5.67-9.58 3.71-10.36-2.15-14.28-2.15-14.28-3.91-16-2.93-20.34-3.13-14.66-3.13-14.66l-1.37-12.32a33.9 33.9 0 01-4.3-23.28v-19s-5.48-36.76-6.26-55.34c-.5-11.9-.36-28.14-.2-38.27.1-5.68.2-9.45.2-9.45l84.48-8.8s-.08 3.9 1.53 12.55c.87 4.64 2.22 10.65 4.34 18.16 6.06 21.51 2.35 37.54 2.35 37.54l-.79 27.19s7.43 18.18 5.87 24.44a52.13 52.13 0 00-1.58 11.36s16.62 39.7 14.86 51.24 5.47 29.73 5.47 29.73 1.98 12.9.02 16.42z",
  fill: "#464353"
});

var _ref50$1 = /*#__PURE__*/createElement("path", {
  d: "M767.59 394.47l25.72-3.43s-14.57 14.87-25.72 3.43z",
  opacity: 0.05
});

var _ref51 = /*#__PURE__*/createElement("path", {
  d: "M789.59 365.91s.88 9.1-4.69 12.52c0 0 9.97-1.56 4.69-12.52zM788.01 336.97s-21.5 17.7-29.32 16.23 29.32-16.23 29.32-16.23zM735.71 402.77s-16.33 3.71-16.82 10.27 16.82-10.27 16.82-10.27z",
  opacity: 0.1
});

var _ref52 = /*#__PURE__*/createElement("path", {
  d: "M739.3 484.33s-23.07 4.3-16.52 7.23 17.31 5.28 17.31 5.28 7.45.39-.79-12.51z",
  opacity: 0.05
});

var _ref53 = /*#__PURE__*/createElement("g", {
  opacity: 0.05
}, /*#__PURE__*/createElement("path", {
  d: "M718.12 496.22a4.55 4.55 0 01-2.11-3.34l-.24.41s-2.15 5.28 1.57 7.62c.42.27.83.54 1.2.8.69-.13 1.43-.23 2.14-.41 3.15-.78 1.16-2.73-2.56-5.08zM747.84 494.65c.64-.58.62-2.08.23-4-1 1.51-1.29 3.87-1.31 5.66a4.88 4.88 0 011.08-1.66zM744.29 397.36a26.67 26.67 0 00-1.56 7.19 29 29 0 011.79-4.94zM797.13 387.1a9.18 9.18 0 00.21-2.14 57.08 57.08 0 00-.64 4c.13-.61.27-1.19.43-1.86zM743.74 466.89c.32-.48.5-2.1.58-4.35a14.77 14.77 0 00-1.13 5.49 5.25 5.25 0 01.55-1.14zM748.54 503.77a77.62 77.62 0 00-2.69 12l-23.65 2.73s-2.16-2.73-5.29-10a18.1 18.1 0 01-.67-1.72c-1.42.65-2 2.12-.12 6.41 3.13 7.24 5.3 10 5.3 10l23.65-2.74s1.76-12.32 4.1-14.67c1.2-1.13.46-1.72-.63-2.01zM717.34 468.65s.19 13.49 2.15 14.27c1-2.23 1.65-4.35.77-4.7-2-.78-2.15-14.28-2.15-14.28s-3.91-16-2.93-20.34-3.13-14.66-3.13-14.66l-1.37-12.32a33.9 33.9 0 01-4.3-23.28v-19s-5.48-36.76-6.26-55.34c-.5-11.9-.36-28.14-.2-38.27 0-1.83.06-3.45.09-4.82l-.67.07s-.11 3.76-.2 9.45c-.16 10.13-.31 26.37.2 38.26.78 18.58 6.25 55.35 6.25 55.35v19a33.92 33.92 0 004.31 23.27l1.36 12.32s4.11 10.36 3.13 14.67 2.95 20.35 2.95 20.35zM786.96 513.23a22.87 22.87 0 01-3.75-9.29c-2.41 2.18.36 10.64 3 14 2.73 3.52 23.07 5.67 27-.79v-3.72c-5.33 5.23-23.67 3.13-26.25-.2zM816.68 491.13a39.51 39.51 0 00-2.74 5.87v2.77c.45-1 1.08-2.34 2-3.92a12 12 0 00.86-4.85s-.09.09-.12.13zM788.16 494.22a38.66 38.66 0 001.93-4.65s-3.33.78-8.61-5.48c-3.84-4.55-4.06-13.15-3.51-18.77-1 3.33-2.55 17.21 2.73 23.47 3.45 4.09 6.06 5.17 7.46 5.43zM777.96 450.85a104.22 104.22 0 01.39 11.59 15.82 15.82 0 01.4-1.81c1-3.33 0-14.47 0-14.47s.2-7.83-1.37-10.37-4.84-17.02-4.84-17.02 0-4.89-2.74-7.43-4.5-12.52-4.5-12.52a12.87 12.87 0 01-2-8.41c.59-4.89-3.32-10.17-3.32-10.17l-6.65-21.12-6.26-15.84-3.53 9.2s0 1.16-.12 3l2.86-7.47 6.26 15.81 6.65 21.12s3.91 5.28 3.32 10.17a12.87 12.87 0 002 8.41s1.76 10 4.5 12.52 2.73 7.43 2.73 7.43 3.33 14.47 4.89 17 1.33 10.38 1.33 10.38z"
}));

var _ref54 = /*#__PURE__*/createElement("path", {
  d: "M794.38 91.05l-1.47 7.14.09 3.18.06 2.34-8.16.84-.91-1.69c-1.69-3.06-5.2-9.28-6.33-10.24-1.51-1.26-4.2-21.12-1-19.94a8.53 8.53 0 014.54 4.11s16.07 1.84 13.18 14.26z",
  fill: "#ffcdd3"
});

var _ref55 = /*#__PURE__*/createElement("path", {
  d: "M793.06 103.71l-8.16.84-.91-1.69a7.19 7.19 0 019-1.48z",
  opacity: 0.1
});

var _ref56 = /*#__PURE__*/createElement("path", {
  d: "M795.12 107.58l-10.76 2.49-.23-1.6-.61-4.31s4.26-5.68 10.42-1.42l.54 2.19z",
  fill: "#28629b"
});

var _ref57 = /*#__PURE__*/createElement("path", {
  d: "M620.82 91.83l-11.49 6.16-1-2.16c-1.09-2.29-2.72-5.74-3.17-7-.68-1.9-5.47-4.3-5.47-4.3-12-11.49 2.3-21.37 2.3-21.37 7.58-15.25 16 5.18 16 5.18s1.18 10.77.35 11.49-.83 3.67-.83 3.67a45.14 45.14 0 012.77 6.57c.35 1.09.54 1.76.54 1.76z",
  fill: "#ffcdd3"
});

var _ref58 = /*#__PURE__*/createElement("path", {
  d: "M620.82 91.83l-11.49 6.16-1-2.16c1.62-1.36 7.37-6 9.26-5.81a13.84 13.84 0 002.72.07c.32 1.07.51 1.74.51 1.74z",
  opacity: 0.1
});

var _ref59 = /*#__PURE__*/createElement("path", {
  d: "M621.99 95.3l-12.91 6.36-.26-2.77-.18-1.92s7.48-6.41 9.69-6.16a11.75 11.75 0 003.37 0l.15 2.32z",
  fill: "#28629b"
});

var _ref60 = /*#__PURE__*/createElement("path", {
  d: "M763.09 138.48s-56.28 6.35-45.76 2.93c7.32-2.39 10.23-7 10.84-12.2.5-4.33-.62-9-2.09-13a56.68 56.68 0 00-5-10.17s43-23.66 34.41-2.15a34.68 34.68 0 00-2.44 10.19 28.79 28.79 0 001.11 10.32 30.73 30.73 0 008.93 14.08z",
  fill: "#ffcdd3"
});

var _ref61 = /*#__PURE__*/createElement("path", {
  d: "M755.46 103.86a34.68 34.68 0 00-2.44 10.19c-4.05 3.41-8.49 3.18-14.2 3.18-4.38 0-9.24 1.06-12.74-1.05a56.68 56.68 0 00-5-10.17s42.99-23.66 34.38-2.15z",
  opacity: 0.1
});

var _ref62 = /*#__PURE__*/createElement("circle", {
  cx: 738.06,
  cy: 95.46,
  r: 23.27,
  fill: "#ffcdd3"
});

var _ref63 = /*#__PURE__*/createElement("path", {
  d: "M763.09 138.48s-56.28 6.35-45.76 2.93c7.32-2.39 10.23-7 10.84-12.2 2.8-3 8.43-5.23 12-6.39a16.84 16.84 0 0110.2-.17 14.5 14.5 0 013.71 1.72 30.73 30.73 0 009.01 14.11zM795.12 107.58l-10.76 2.49-.23-1.6a9.52 9.52 0 0110.35-3.54zM621.99 95.3l-12.91 6.36-.26-2.77a94.16 94.16 0 0113-5.77zM785.35 280.29c-21.81 3.48-52.81 7.92-57.73 6.42-4.09-1.24-17.13-1.11-28.48-.72.1-5.68.2-9.45.2-9.45l84.48-8.8s-.08 3.9 1.53 12.55z",
  opacity: 0.1
});

var _ref64 = /*#__PURE__*/createElement("path", {
  d: "M807.09 275.17s-71.77 12.32-79.47 10-47.25.19-47.25.19c-17.8 11.93-10.37-5.67-10.37-5.67s-1.56-9.19.59-16.62a101.54 101.54 0 002.95-16.64s-.39-11.74 1.76-14.48 4.7-22.29 4.7-22.29 1.95-13.3 1.76-16.23.58-11.15.58-11.15l2.55-13.69c-14.67-1.95-59.26-29.33-59.26-29.33-2.15-9.19-18.77-30.7-18.77-30.7a22.63 22.63 0 00-1.37-5.28c-1.17-3.13 16.43-9.39 16.43-9.39s13.1 16 15.84 20.34 12.12 12.32 12.12 12.32a9.43 9.43 0 014.3.56l.23.07a34.86 34.86 0 018.75 5 17 17 0 0111.93 4.5s8-1.18 9.39.19 8.21 0 8.21 0 6.84-14.47 11.34-10.27 23.59 4 23.59 4c2.54-3.38 8.73-5.8 12.6-7a16.91 16.91 0 0110.2-.17 12.94 12.94 0 014 2l11.61 11.34s3.32-4.31 2.93-5.28 3.91-1.76 3.91-1.76 5.67-1.76 7.82-2.35 4.12 1.74 4.3 1.95c-.07-.25-1.54-5-1-8.6s-2.35-7-2.35-7c6.84-16.82 22.29-2.74 22.29-2.74s1.76 9.19.2 12.71 1.56 10.95 1.17 12.91.79 5.28.79 9-2 10.75-3.13 13.88-10.56 10.17-10.56 10.17-.59 11.15-4.7 17.6-1.53 28.51-1.53 28.51 3.91 17.21 8.8 22.69 12.12 36.71 12.12 36.71z",
  fill: "#3f3d56"
});

var _ref65 = /*#__PURE__*/createElement("path", {
  d: "M702.47 146.49s-2.15-6.45-4.11-7a45.24 45.24 0 01-5.67-2.54l1.26-2.41s7.34 2 8.52 4.17 0 7.78 0 7.78zM663.16 132.22c-.39 2-17.8 3.71-17.8 3.71l8.8-8.82.22.08a34.86 34.86 0 018.78 5.03z",
  opacity: 0.1
});

var _ref66 = /*#__PURE__*/createElement("circle", {
  cx: 612.8,
  cy: 105.38,
  r: 1.56,
  fill: "#575988"
});

var _ref67 = /*#__PURE__*/createElement("circle", {
  cx: 614.8,
  cy: 108.51,
  r: 1.56,
  fill: "#575988"
});

var _ref68 = /*#__PURE__*/createElement("circle", {
  cx: 616.76,
  cy: 111.4,
  r: 1.56,
  fill: "#575988"
});

var _ref69 = /*#__PURE__*/createElement("circle", {
  cx: 618.81,
  cy: 114.52,
  r: 1.56,
  fill: "#575988"
});

var _ref70 = /*#__PURE__*/createElement("circle", {
  cx: 803.15,
  cy: 114.35,
  r: 1.27,
  fill: "#575988"
});

var _ref71 = /*#__PURE__*/createElement("circle", {
  cx: 803.35,
  cy: 117.24,
  r: 1.27,
  fill: "#575988"
});

var _ref72 = /*#__PURE__*/createElement("circle", {
  cx: 803.52,
  cy: 120.12,
  r: 1.27,
  fill: "#575988"
});

var _ref73 = /*#__PURE__*/createElement("path", {
  d: "M702.54 199.49c-.19-.23 43.9 55.44 78.12 23.27.03.01-54.04 7.34-78.12-23.27zM677.24 228.43s26.38.72 29.14 8.31v7.9a5.06 5.06 0 01-4.91 0c-2.66-1.44-18.61-9.54-24.23-5.64z",
  opacity: 0.1
});

var _ref74 = /*#__PURE__*/createElement("path", {
  d: "M677.73 228.43s25.23.69 27.87 7.93v7.52a4.84 4.84 0 01-4.7 0c-2.54-1.36-17.79-9.09-23.17-5.37z",
  fill: "#3f3d56"
});

var _ref75 = /*#__PURE__*/createElement("path", {
  d: "M691.64 171.15a84.88 84.88 0 0010.23 17.55 68.86 68.86 0 0016 15.47s-25.79-29.4-26.23-33.02zM683.01 140.5s4.4 19 15.74 25.45zM676.26 142.42c-.11-.35-3.91 15 14.62 23.53 0 0-7.87-2.67-14.62-23.53zM791.45 129.68c-.29 0 9.14 6 11.71 8.8 0 0-6.14-9.2-11.71-8.8z",
  opacity: 0.1
});

var _ref76 = /*#__PURE__*/createElement("path", {
  d: "M731.77 116.55a3.67 3.67 0 004 3.63c7.09.44 14.48.75 21-2a8 8 0 003.2-2.12c1.16-1.43 1.39-3.37 1.86-5.15.92-3.48 2.88-6.57 4.29-9.88a33.1 33.1 0 002.31-17.75 12 12 0 00-1.78-5.19c-1.88-2.69-5.31-3.78-7.8-5.92s-4.09-5.41-7-7c-2.62-1.46-5.83-1.28-8.78-.78a46.09 46.09 0 00-16.38 6.15c-1.69 1-3.54 2.23-5.48 1.86-1.7-.32-2.94-1.75-4-3.09a21.66 21.66 0 00-1.67 10.15 4.36 4.36 0 01-.05 1.53 4.6 4.6 0 01-1.09 1.61c-1.75 2-2.84 5.25-1.11 7.31.75.89 1.91 1.38 2.64 2.29 1.31 1.63.87 4 .84 6.08a3.13 3.13 0 00.52 2.06 3 3 0 002.87.69 7.81 7.81 0 013.06-.29 5.13 5.13 0 012.66 2c3.23 4.21 4.51 8.79 5.89 13.81z",
  fill: "#2d293d"
});

var _ref77 = /*#__PURE__*/createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/createElement("path", {
  d: "M760.8 114.29a8 8 0 01-3.2 2.12c-6.56 2.73-13.94 2.42-21 2a4.92 4.92 0 01-2.19-.49c-1.08-.63-1.49-1.95-1.82-3.15-1.38-5-2.65-9.59-5.93-13.76a5.14 5.14 0 00-2.66-2.05 8.2 8.2 0 00-3.06.29 3 3 0 01-2.87-.68 3.13 3.13 0 01-.52-2.06c0-2.1.47-4.45-.84-6.08-.73-.91-1.89-1.4-2.64-2.3a4.56 4.56 0 01-.45-4.66c-1.25 2-1.78 4.51-.33 6.23.75.89 1.91 1.38 2.64 2.29 1.31 1.64.87 4 .84 6.08a3.11 3.11 0 00.51 2.06 3 3 0 002.88.69 7.81 7.81 0 013.06-.29 5.13 5.13 0 012.66 2c3.27 4.17 4.55 8.75 5.93 13.77a5 5 0 001.73 3.17 4.85 4.85 0 002.2.48c7.09.44 14.48.76 21-2a7.92 7.92 0 003.2-2.12 6.11 6.11 0 001-1.88c.01.13-.06.24-.14.34zM715.54 80.38a3.42 3.42 0 00.71-1.18 4.36 4.36 0 000-1.53 21.69 21.69 0 011.09-8.42l-.13-.15a21.5 21.5 0 00-1.67 10.14 7.23 7.23 0 010 1.14z"
}));

var _ref78 = /*#__PURE__*/createElement("path", {
  d: "M727.62 130.65s29.07 3.86 31.68-.51M784.13 118.62s16.16 0 19.71 6.08",
  opacity: 0.1
});

var _ref79 = /*#__PURE__*/createElement("path", {
  d: "M874.54 658.77a25.63 25.63 0 01-17.45 6.52c-1.64 0-3.91.31-3.92 1.95a2.75 2.75 0 00.48 1.34 16.05 16.05 0 009 7.07c3.5 1.06 7.24.88 10.89.69l10.65-.55c2-.11 4-.21 6-.46s4.18-.66 6.27-1a82 82 0 0115.51-.72c1.38.05 3 0 3.82-1s.4-2.91.09-4.41c-.64-3.09 0-6.33-.59-9.43-1-5.44-5.71-9.61-10.87-11.58-4.8-1.82-13.3-3.91-17.84-.87-4.79 3.19-7.72 8.52-12.04 12.45z",
  fill: "#3f3d56"
});

var _ref80 = /*#__PURE__*/createElement("path", {
  d: "M885.12 476.51c.94 4.47 5.27 7.89 5.39 12.45.11 3.66-2.5 6.73-4.38 9.86a65.78 65.78 0 00-4.47 10.12 154.59 154.59 0 01-13.12 26.1c-2.5 4-5.3 8.27-4.73 12.92a19.36 19.36 0 002.27 6.18l7.5 14.9a43.15 43.15 0 013.83 9.41c.65 2.83.71 5.76 1.09 8.64 1.18 9.14 5.47 18.34 2.93 27.2-.22.76-1 1.68-1.61 1.15 2.48 4.63 4.47 9.29 4.28 14.54-.1 2.75-.94 5.62.07 8.18.43 1.07 1.18 2.07 1.17 3.22 0 .76-.35 1.47-.43 2.21-.21 2.11 1.73 3.87 3.74 4.54s4.2.62 6.23 1.23c3.9 1.17 6.69 4.53 10 6.86a21.29 21.29 0 0011.52 3.75 2.9 2.9 0 001.7-.34 2.75 2.75 0 00.94-2.06 11.44 11.44 0 00-4.12-9.94 4.5 4.5 0 01-1.53-1.6 3.86 3.86 0 01-.14-1.79 134.78 134.78 0 00-.44-24.6 37.36 37.36 0 01-.39-7.83c.21-2.18.87-4.34.63-6.51s-1.35-4.15-2-6.24c-1.16-3.72-.84-7.72-1-11.61-.2-6.76-1.75-13.4-3.29-20-.61-2.59-1.28-5.3-3.11-7.22-1.56-1.63-4.08-3.19-3.49-5.36a6.35 6.35 0 011.43-2.13 8.55 8.55 0 001.78-6.52 2.93 2.93 0 003.37-1.58c12.18-5.75 22-17.25 26.38-30a9.9 9.9 0 011.18-2.68c1.13-1.58 3.09-2.26 4.83-3.13 5.46-2.75 9.23-7.9 12.69-12.94 2-2.92 4-5.94 4.9-9.38a30.74 30.74 0 00.67-6.77l.31-11.75a6.35 6.35 0 00-.22-2.3 5.75 5.75 0 00-1.27-1.86 22.59 22.59 0 00-12.46-6.72c-3.2-.57-6.47-.46-9.71-.73-6.28-.52-12.48-2.47-18.76-2-9.87.73-18.66 7.57-23.31 16.31-1.63 3.08-3.35 5.76-6.85 5.82z",
  fill: "#464353"
});

var _ref81 = /*#__PURE__*/createElement("path", {
  d: "M830.32 400.11a13.13 13.13 0 01-.72 5.35c-.77 1.64-2.7 2.92-4.39 2.25.51-1.15-.84-2.46-2.1-2.32a3.93 3.93 0 00-2.77 2.38 8.85 8.85 0 00-.8 5.43c.4 2.3 1.73 4.51 1.38 6.82-.28 1.92-1.69 3.83-.94 5.61a9.09 9.09 0 001.81 2.17 6.12 6.12 0 01-.65 8.4l18.92.38c-.69 3.16.73 6.39 2.35 9.2a58 58 0 0043.24 28.23 3.76 3.76 0 00-.91 5.75c1.54 1.53 4.15 1.34 6.08.35s3.44-2.63 5.2-3.9a16 16 0 0110.69-2.88c2.37.23 4.67 1 7.05 1.12 7 .37 13-4.67 19.74-6.73 4.91-1.51 10.48-1.51 14.6-4.58 1.78-1.32 3.24-3.49 2.72-5.63a9.41 9.41 0 00-2-3.31c-2.37-3.07-3.77-6.76-5.47-10.25a61.31 61.31 0 00-13.67-18.32 122.31 122.31 0 00-13.56-10.28 23.12 23.12 0 00-3.66-2.21c-1.66-.73-3.5-1.08-5-2-2.22-1.4-3.5-3.87-5.21-5.86-3.75-4.38-9.51-6.39-14.13-9.83-3.1-2.31-5.84-5.35-9.54-6.46-1.8-.55-3.71-.59-5.51-1.13-4.09-1.24-7.07-4.87-11.08-6.34-3.17-1.16-6.67-.86-10-1.27a23.41 23.41 0 01-10.45-3.98 12.4 12.4 0 00-3.33-1.94c-5.07-1.54-5.48 7.9-6 11.17-.67 4.86-1.89 9.69-1.89 14.61z",
  fill: "#28629b"
});

var _ref82 = /*#__PURE__*/createElement("path", {
  d: "M835.26 431.77c.85 9.22-6.11 18.15-4.08 27.18.43 1.92 1.26 3.75 1.56 5.7.85 5.35-2.35 10.42-5.4 14.9L801.14 518a24.18 24.18 0 01-3.74 4.62c-5 4.45-12.52 4-19.1 5.32a33 33 0 00-12.8 5.66.83.83 0 00-.16 1.15 11 11 0 009.51 4.47c.69.9 0 2.24-.95 2.89-1.4 1-3.34 1.23-3.62 3.62a4 4 0 00.48 2.4 7.47 7.47 0 004.58 3.18c9.07 2.78 18.87-2.1 25.66-8.73s11.66-15 18.32-21.74c3.69-3.74 7.88-6.93 11.68-10.55 7.58-7.23 13.48-16 19.16-24.79 1.71-2.65 3.44-5.37 4.15-8.44s.38-6.18 1.19-9.15c1.06-3.89 3.91-7 6.28-10.26 4.65-6.4 7.76-14.23 7.14-22.12s-5.5-15.67-12.94-18.35a11.63 11.63 0 00-7.25-.44c-3.05.94-5.3 3.46-7.38 5.88l-5 5.74a13.39 13.39 0 00-2.81 4.41 4.61 4.61 0 001 4.9",
  fill: "#fbbebe"
});

var _ref83 = /*#__PURE__*/createElement("path", {
  d: "M848.54 393.95c-3.44.2-7.23.54-9.66 3a13.75 13.75 0 00-2.44 3.82c-2.36 4.81-4.66 9.84-4.83 15.2-.14 4.28 1.1 8.47 1.75 12.7.54 3.52-.83 7.11-1.09 10.67 4.27-1.31 9.91-3.09 13.78-5.3 2.64-1.51 5.19-3.23 8.07-4.19 4.11-1.37 11 1 14.91 2.9.21-2.74-1.85-7.52-1.63-10.27a11.47 11.47 0 01.61-3.4 20.62 20.62 0 012.07-3.29 13.46 13.46 0 00-1.21-15.77c-3.47-3.9-8.9-5.36-14.08-6a60.9 60.9 0 00-9.83-.34",
  fill: "#28629b"
});

function SvgFeeInput(props) {
  return /*#__PURE__*/createElement("svg", _extends$2({
    "data-name": "Layer 1",
    viewBox: "0 0 1049.58 678.59"
  }, props), _ref$1, _ref2$1, _ref3$1, _ref4$1, _ref5$1, _ref6$1, _ref7$1, _ref8$1, _ref9$1, _ref10$1, _ref11$1, _ref12$1, _ref13$1, _ref14$1, _ref15$1, _ref16$1, _ref17$1, _ref18$1, _ref19$1, _ref20$1, _ref21$1, _ref22$1, _ref23$1, _ref24$1, _ref25$1, _ref26$1, _ref27$1, _ref28$1, _ref29$1, _ref30$1, _ref31$1, _ref32$1, _ref33$1, _ref34$1, _ref35$1, _ref36$1, _ref37$1, _ref38$1, _ref39$1, _ref40$1, _ref41$1, _ref42$1, _ref43$1, _ref44$1, _ref45$1, _ref46$1, _ref47$1, _ref48$1, _ref49$1, _ref50$1, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83);
}

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n      query Fees {\n        viewer {\n          fees {\n            id\n            name\n            amount\n          }\n        }\n      }\n    "]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

var useOptions = function useOptions() {
  var _meta$data, _meta$data$viewer;

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    fetchPolicy: "cache-and-network"
  };

  var _useLazyQuery = useLazyQuery(gql(_templateObject$2()), options),
      _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
      query = _useLazyQuery2[0],
      meta = _useLazyQuery2[1];

  var getOptions = function getOptions() {
    var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var requestOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return query(_objectSpread2({
      variables: form
    }, requestOptions));
  }; // Cleaned data for easier consumption


  var data = {
    options: (meta === null || meta === void 0 ? void 0 : (_meta$data = meta.data) === null || _meta$data === void 0 ? void 0 : (_meta$data$viewer = _meta$data.viewer) === null || _meta$data$viewer === void 0 ? void 0 : _meta$data$viewer.charges) || []
  };
  return [getOptions, _objectSpread2(_objectSpread2({}, meta), {}, {
    data: data
  })];
};
/**
 * Custom input for selecting an instance of a Fee.
 */


var FeeInput = function FeeInput(_ref) {
  var name = _ref.name,
      label = _ref.label,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? false : _ref$multiple,
      defaultValue = _ref.defaultValue,
      props = _objectWithoutProperties(_ref, ["name", "label", "multiple", "defaultValue"]);

  var _useOptions = useOptions(),
      _useOptions2 = _slicedToArray(_useOptions, 2),
      getOptions = _useOptions2[0],
      data = _useOptions2[1].data;

  return /*#__PURE__*/React.createElement(AssociationInput, _extends({}, props, {
    name: name,
    label: label,
    multiple: multiple,
    options: data.options,
    onFocus: function onFocus() {
      getOptions();
    },
    defaultValue: defaultValue,
    renderSelectionItem: function renderSelectionItem(fee) {
      return /*#__PURE__*/React.createElement("p", {
        className: "has-text-weight-semibold"
      }, [fee.name, fee.amount ? new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      }).format(fee.amount) : null].filter(Boolean).join(" - "));
    },
    renderSelectedItem: function renderSelectedItem(fee) {
      return /*#__PURE__*/React.createElement("p", {
        className: "has-text-weight-semibold"
      }, [fee.name, fee.amount ? new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      }).format(fee.amount) : null].filter(Boolean).join(" - "));
    },
    placeholderComponent: SvgFeeInput,
    placeholderMessage: "No fees to select from"
  }));
};
FeeInput.propTypes = {
  /** Display label for the input */
  label: PropTypes.string.isRequired,

  /** Form input name */
  name: PropTypes.string.isRequired,

  /** Default input value */
  defaultValue: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),

  /** Multiple counsels may be selected */
  multiple: PropTypes.bool
};

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

var _ref$2 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("linearGradient", {
  id: "WarrantInput_svg__a",
  x1: 378.37,
  y1: 732.81,
  x2: 378.37,
  y2: 130.21,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/createElement("linearGradient", {
  id: "WarrantInput_svg__c",
  x1: 274.44,
  y1: 409.32,
  x2: 274.44,
  y2: 248.16,
  xlinkHref: "#WarrantInput_svg__a"
}), /*#__PURE__*/createElement("linearGradient", {
  id: "WarrantInput_svg__d",
  x1: 274.44,
  y1: 361.44,
  x2: 274.44,
  y2: 261.01,
  xlinkHref: "#WarrantInput_svg__a"
}), /*#__PURE__*/createElement("linearGradient", {
  id: "WarrantInput_svg__f",
  x1: 274.44,
  y1: 616.03,
  x2: 274.44,
  y2: 454.87,
  xlinkHref: "#WarrantInput_svg__a"
}), /*#__PURE__*/createElement("linearGradient", {
  id: "WarrantInput_svg__g",
  x1: 274.44,
  y1: 568.15,
  x2: 274.44,
  y2: 467.72,
  xlinkHref: "#WarrantInput_svg__a"
}), /*#__PURE__*/createElement("linearGradient", {
  id: "WarrantInput_svg__i",
  x1: 688.76,
  y1: 765.86,
  x2: 688.76,
  y2: 163.26,
  gradientTransform: "rotate(90 665.375 476.845)",
  xlinkHref: "#WarrantInput_svg__a"
}), /*#__PURE__*/createElement("linearGradient", {
  id: "WarrantInput_svg__j",
  x1: 688.18,
  y1: 568.49,
  x2: 688.18,
  y2: 409.67,
  gradientTransform: "rotate(90 662.7 498.69)",
  xlinkHref: "#WarrantInput_svg__a"
}), /*#__PURE__*/createElement("linearGradient", {
  id: "WarrantInput_svg__k",
  x1: 810.6,
  y1: 767.54,
  x2: 810.6,
  y2: 362.71,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/createElement("stop", {
  offset: 0,
  stopColor: "#b3b3b3",
  stopOpacity: 0.25
}), /*#__PURE__*/createElement("stop", {
  offset: 0.54,
  stopColor: "#b3b3b3",
  stopOpacity: 0.1
}), /*#__PURE__*/createElement("stop", {
  offset: 1,
  stopColor: "#b3b3b3",
  stopOpacity: 0.05
})), /*#__PURE__*/createElement("linearGradient", {
  id: "WarrantInput_svg__b",
  x1: 685.49,
  y1: 507.08,
  x2: 685.49,
  y2: 487.6,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/createElement("stop", {
  offset: 0,
  stopOpacity: 0.12
}), /*#__PURE__*/createElement("stop", {
  offset: 0.55,
  stopOpacity: 0.09
}), /*#__PURE__*/createElement("stop", {
  offset: 1,
  stopOpacity: 0.02
})), /*#__PURE__*/createElement("linearGradient", {
  id: "WarrantInput_svg__l",
  x1: 774.99,
  y1: 484.73,
  x2: 774.99,
  y2: 425.15,
  xlinkHref: "#WarrantInput_svg__b"
}), /*#__PURE__*/createElement("clipPath", {
  id: "WarrantInput_svg__e",
  transform: "translate(-179 -60.54)"
}, /*#__PURE__*/createElement("path", {
  "data-name": "<Rectangle>",
  fill: "#fff",
  d: "M381.54 322.72h143.79v96.93H381.54z"
})), /*#__PURE__*/createElement("clipPath", {
  id: "WarrantInput_svg__h",
  transform: "translate(-179 -60.54)"
}, /*#__PURE__*/createElement("path", {
  "data-name": "<Rectangle>",
  fill: "#fff",
  d: "M381.54 529.42h143.79v96.93H381.54z"
})));

var _ref2$2 = /*#__PURE__*/createElement("path", {
  fill: "url(#WarrantInput_svg__a)",
  d: "M154.15 130.21h448.44v602.6H154.15z",
  opacity: 0.5
});

var _ref3$2 = /*#__PURE__*/createElement("path", {
  fill: "#f2f2f2",
  d: "M159.99 138.39h434.43v581.58H159.99z"
});

var _ref4$2 = /*#__PURE__*/createElement("path", {
  fill: "#e0e0e0",
  d: "M193.86 162.91h149.48v4.67H193.86z"
});

var _ref5$2 = /*#__PURE__*/createElement("path", {
  fill: "#28629b",
  opacity: 0.7,
  d: "M193.86 183.93h149.48v4.67H193.86z"
});

var _ref6$2 = /*#__PURE__*/createElement("path", {
  fill: "#e0e0e0",
  d: "M365.53 162.91h149.48v4.67H365.53zM388.88 296.05h149.48v4.67H388.88zM392.39 308.89h149.48v4.67H392.39zM399.4 321.74h149.48v4.67H399.4zM388.88 502.75h149.48v4.67H388.88zM392.39 515.6h149.48v4.67H392.39zM399.4 528.44h149.48v4.67H399.4z"
});

var _ref7$2 = /*#__PURE__*/createElement("path", {
  fill: "url(#WarrantInput_svg__c)",
  d: "M195.03 248.16h158.82v161.16H195.03z",
  opacity: 0.5
});

var _ref8$2 = /*#__PURE__*/createElement("path", {
  fill: "#f5f5f5",
  d: "M196.03 251.67h156.32v154.15H196.03z"
});

var _ref9$2 = /*#__PURE__*/createElement("path", {
  fill: "url(#WarrantInput_svg__d)",
  d: "M201.54 261.01h145.8v100.43h-145.8z",
  opacity: 0.5
});

var _ref10$2 = /*#__PURE__*/createElement("path", {
  "data-name": "<Rectangle>",
  fill: "#fff",
  d: "M202.54 262.18h143.79v96.93H202.54z"
});

var _ref11$2 = /*#__PURE__*/createElement("g", {
  clipPath: "url(#WarrantInput_svg__e)",
  fill: "#28629b"
}, /*#__PURE__*/createElement("path", {
  opacity: 0.4,
  d: "M190.35 355.61l36.21-56.06 15.18 24.52 32.7-33.86 28.03 33.86 24.52-50.21 63.06 100.43-204.37-7.01 4.67-11.67z"
}), /*#__PURE__*/createElement("circle", {
  cx: 218.38,
  cy: 276.19,
  r: 10.51,
  opacity: 0.4
}));

var _ref12$2 = /*#__PURE__*/createElement("path", {
  fill: "url(#WarrantInput_svg__f)",
  d: "M195.03 454.87h158.82v161.16H195.03z",
  opacity: 0.5
});

var _ref13$2 = /*#__PURE__*/createElement("path", {
  fill: "#f5f5f5",
  d: "M196.03 458.37h156.32v154.15H196.03z"
});

var _ref14$2 = /*#__PURE__*/createElement("path", {
  fill: "url(#WarrantInput_svg__g)",
  d: "M201.54 467.72h145.8v100.43h-145.8z",
  opacity: 0.5
});

var _ref15$2 = /*#__PURE__*/createElement("path", {
  "data-name": "<Rectangle>",
  fill: "#fff",
  d: "M202.54 468.88h143.79v96.93H202.54z"
});

var _ref16$2 = /*#__PURE__*/createElement("g", {
  clipPath: "url(#WarrantInput_svg__h)",
  fill: "#bdbdbd"
}, /*#__PURE__*/createElement("path", {
  opacity: 0.4,
  d: "M190.35 562.31l36.21-56.06 15.18 24.53 32.7-33.87 28.03 33.87 24.52-50.22 63.06 100.43-204.37-7 4.67-11.68z"
}), /*#__PURE__*/createElement("circle", {
  cx: 218.38,
  cy: 482.9,
  r: 10.51,
  opacity: 0.4
}));

var _ref17$2 = /*#__PURE__*/createElement("path", {
  transform: "rotate(-78.76 551.253 578.999)",
  fill: "url(#WarrantInput_svg__i)",
  d: "M376.36 276.01h602.6v448.44h-602.6z",
  opacity: 0.5
});

var _ref18$2 = /*#__PURE__*/createElement("path", {
  fill: "#fff",
  d: "M228.214 680.02l113.361-570.425 426.097 84.679-113.36 570.425z"
});

var _ref19$2 = /*#__PURE__*/createElement("path", {
  fill: "#e0e0e0",
  d: "M367.32 142.077l302.395 60.096-.91 4.58-302.396-60.095zM281.276 575.058l302.396 60.095-.91 4.58-302.397-60.095zM276.03 601.393L509.7 647.83l-.91 4.58-233.67-46.437z"
});

var _ref20$2 = /*#__PURE__*/createElement("path", {
  fill: "#28629b",
  opacity: 0.7,
  d: "M270.797 627.746l87.048 17.3-.91 4.58-87.048-17.3zM362.075 168.427l151.193 30.047-.91 4.58-151.194-30.046z"
});

var _ref21$2 = /*#__PURE__*/createElement("path", {
  fill: "#e0e0e0",
  d: "M356.851 194.77l272.609 54.175-.91 4.58-272.61-54.175z"
});

var _ref22$2 = /*#__PURE__*/createElement("path", {
  fill: "#3ad29f",
  opacity: 0.7,
  d: "M351.61 221.12l66.431 13.201-.91 4.58-66.43-13.201z"
});

var _ref23$2 = /*#__PURE__*/createElement("path", {
  fill: "#e0e0e0",
  d: "M346.38 247.464l302.397 60.096-.91 4.58-302.397-60.095z"
});

var _ref24$2 = /*#__PURE__*/createElement("path", {
  transform: "rotate(-78.76 545.898 602.937)",
  fill: "url(#WarrantInput_svg__j)",
  d: "M592.89 385.78h158.82v276.77H592.89z",
  opacity: 0.5
});

var _ref25$2 = /*#__PURE__*/createElement("path", {
  fill: "#fff",
  d: "M374.561 360.23l268.029 53.266-30.275 152.34-268.029-53.265z"
});

var _ref26$2 = /*#__PURE__*/createElement("path", {
  fill: "#e0e0e0",
  d: "M341.145 273.818l302.396 60.095-.91 4.58-302.397-60.095z"
});

var _ref27$2 = /*#__PURE__*/createElement("path", {
  fill: "#28629b",
  d: "M398.533 386.426l33.22 6.601-22.08 111.108-33.22-6.602z"
});

var _ref28$2 = /*#__PURE__*/createElement("path", {
  fill: "#3ad29f",
  d: "M450.809 434.918l33.22 6.602-14.796 74.454-33.22-6.602z"
});

var _ref29$2 = /*#__PURE__*/createElement("path", {
  fill: "#f55f44",
  d: "M503.55 481.12l33.22 6.602-7.966 40.086-33.22-6.601z"
});

var _ref30$2 = /*#__PURE__*/createElement("path", {
  fill: "#fdd835",
  d: "M571.308 451.72l33.22 6.603-16.162 81.33-33.22-6.603z"
});

var _ref31$2 = /*#__PURE__*/createElement("path", {
  d: "M880.45 410.55a155.89 155.89 0 00-223.11-1.68c-59 59.48-60 156.33-2.29 217.07A155.89 155.89 0 00854.95 648l112.69 117.21a7.59 7.59 0 0010.73.21l28.08-27a7.59 7.59 0 00.21-10.73L894 610.49a155.9 155.9 0 00-13.55-199.94zM845.35 599a111.5 111.5 0 113.1-157.66 111.5 111.5 0 01-3.1 157.66z",
  transform: "translate(-179 -60.54)",
  fill: "url(#WarrantInput_svg__k)"
});

var _ref32$2 = /*#__PURE__*/createElement("path", {
  d: "M685.49 487.6c-12.54 0-12.56 19.49 0 19.49s12.56-19.49 0-19.49z",
  transform: "translate(-179 -60.54)",
  fill: "url(#WarrantInput_svg__b)"
});

var _ref33$2 = /*#__PURE__*/createElement("path", {
  d: "M772.9 425.17c-33.75-.76-64.46 16.17-80.79 41.73-5.33 8.34 9.8 15.71 15.1 7.41 13.52-21.16 39.21-34.6 67-33.9 29.12.73 55.62 17.39 69.65 40.51 5.32 8.77 19.27.8 14-7.92-17.06-28-50.1-47-84.96-47.83z",
  transform: "translate(-179 -60.54)",
  fill: "url(#WarrantInput_svg__l)"
});

var _ref34$2 = /*#__PURE__*/createElement("path", {
  d: "M713.68 344.09a155.89 155.89 0 00-223.11-1.68c-59 59.48-60 156.33-2.29 217.07a155.89 155.89 0 00199.9 22.05l112.68 117.22a7.59 7.59 0 0010.73.21l28.08-27a7.59 7.59 0 00.21-10.73L727.19 544.02a155.9 155.9 0 00-13.51-199.93zm-35.1 188.37a111.5 111.5 0 113.1-157.66 111.5 111.5 0 01-3.1 157.66z",
  fill: "#28629b"
});

var _ref35$2 = /*#__PURE__*/createElement("path", {
  d: "M518.72 421.13c-12.54 0-12.56 19.49 0 19.49s12.56-19.49 0-19.49zM606.13 358.71c-33.75-.76-64.46 16.17-80.79 41.73-5.33 8.34 9.8 15.71 15.1 7.41 13.52-21.16 39.21-34.6 67-33.9 29.12.73 55.62 17.39 69.65 40.51 5.32 8.77 19.27.8 14-7.92-17.09-28.08-50.09-47.08-84.96-47.83z",
  fill: "#28629b"
});

var _ref36$2 = /*#__PURE__*/createElement("path", {
  fill: "#47e6b1",
  d: "M121.45 663.91h3.5v19.85h-3.5z"
});

var _ref37$2 = /*#__PURE__*/createElement("path", {
  fill: "#47e6b1",
  d: "M133.13 672.08v3.5h-19.85v-3.5z"
});

var _ref38$2 = /*#__PURE__*/createElement("path", {
  d: "M571.87 7.95a4.29 4.29 0 01-2.39-5.19 2.06 2.06 0 00.09-.48A2.15 2.15 0 00565.7.85a2.06 2.06 0 00-.24.42 4.29 4.29 0 01-5.19 2.39 2.06 2.06 0 00-.48-.09 2.15 2.15 0 00-1.41 3.89 2.06 2.06 0 00.42.24 4.29 4.29 0 012.39 5.19 2.06 2.06 0 00-.09.48 2.15 2.15 0 003.9 1.41 2.06 2.06 0 00.24-.42 4.29 4.29 0 015.19-2.39 2.06 2.06 0 00.48.09 2.15 2.15 0 001.43-3.87 2.06 2.06 0 00-.47-.24z",
  fill: "#4d8af0"
});

var _ref39$2 = /*#__PURE__*/createElement("path", {
  d: "M137.44 155.1a4.29 4.29 0 01-2.39-5.19 2.06 2.06 0 00.09-.48 2.15 2.15 0 00-3.87-1.43 2.06 2.06 0 00-.24.42 4.29 4.29 0 01-5.19 2.39 2.06 2.06 0 00-.48-.09 2.15 2.15 0 00-1.43 3.87 2.06 2.06 0 00.42.24 4.29 4.29 0 012.39 5.19 2.06 2.06 0 00-.09.48 2.15 2.15 0 003.87 1.43 2.06 2.06 0 00.24-.42 4.29 4.29 0 015.19-2.39 2.06 2.06 0 00.48.09 2.15 2.15 0 001.43-3.87 2.06 2.06 0 00-.42-.24zM755.22 762.36a4.29 4.29 0 01-2.39-5.19 2.06 2.06 0 00.09-.48 2.15 2.15 0 00-3.87-1.43 2.06 2.06 0 00-.24.42 4.29 4.29 0 01-5.19 2.39 2.06 2.06 0 00-.48-.09 2.15 2.15 0 00-1.43 3.87 2.06 2.06 0 00.42.24 4.29 4.29 0 012.39 5.19 2.06 2.06 0 00-.09.48 2.15 2.15 0 003.87 1.43 2.06 2.06 0 00.24-.42 4.29 4.29 0 015.19-2.39 2.06 2.06 0 00.48.09 2.15 2.15 0 001.43-3.87 2.06 2.06 0 00-.42-.24z",
  fill: "#fdd835"
});

var _ref40$2 = /*#__PURE__*/createElement("circle", {
  cx: 321.15,
  cy: 75.33,
  r: 7.01,
  fill: "#f55f44"
});

var _ref41$2 = /*#__PURE__*/createElement("circle", {
  cx: 823.31,
  cy: 162.91,
  r: 7.01,
  fill: "#f55f44"
});

var _ref42$2 = /*#__PURE__*/createElement("circle", {
  cx: 783.61,
  cy: 371.95,
  r: 7.01,
  fill: "#4d8af0"
});

var _ref43$2 = /*#__PURE__*/createElement("circle", {
  cx: 7.01,
  cy: 28.61,
  r: 7.01,
  fill: "#47e6b1",
  opacity: 0.5
});

function SvgWarrantInput(props) {
  return /*#__PURE__*/createElement("svg", _extends$3({
    "data-name": "Layer 1",
    viewBox: "0 0 842 778.92"
  }, props), _ref$2, _ref2$2, _ref3$2, _ref4$2, _ref5$2, _ref6$2, _ref7$2, _ref8$2, _ref9$2, _ref10$2, _ref11$2, _ref12$2, _ref13$2, _ref14$2, _ref15$2, _ref16$2, _ref17$2, _ref18$2, _ref19$2, _ref20$2, _ref21$2, _ref22$2, _ref23$2, _ref24$2, _ref25$2, _ref26$2, _ref27$2, _ref28$2, _ref29$2, _ref30$2, _ref31$2, _ref32$2, _ref33$2, _ref34$2, _ref35$2, _ref36$2, _ref37$2, _ref38$2, _ref39$2, _ref40$2, _ref41$2, _ref42$2, _ref43$2);
}

function _templateObject2$2() {
  var data = _taggedTemplateLiteral(["\n      query Warrants {\n        viewer {\n          warrants {\n            id\n            name\n          }\n        }\n      }\n    "]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = _taggedTemplateLiteral(["\n    mutation($warrant: NewWarrantInput!) {\n      warrant: addWarrant(warrant: $warrant) {\n        name\n        id\n      }\n    }\n  "]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var useCreate$2 = function useCreate() {
  var _useMutation = useMutation(gql(_templateObject$3())),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      mutate = _useMutation2[0],
      meta = _useMutation2[1];

  var create = function create(warrant) {
    return mutate({
      variables: {
        warrant: warrant
      }
    });
  };

  return [create, meta];
};

var useOptions$1 = function useOptions() {
  var _meta$data, _meta$data$viewer;

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    fetchPolicy: "cache-and-network"
  };

  var _useLazyQuery = useLazyQuery(gql(_templateObject2$2()), options),
      _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
      query = _useLazyQuery2[0],
      meta = _useLazyQuery2[1];

  var getOptions = function getOptions() {
    var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var requestOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return query(_objectSpread2({
      variables: form
    }, requestOptions));
  }; // Cleaned data for easier consumption


  var data = {
    options: (meta === null || meta === void 0 ? void 0 : (_meta$data = meta.data) === null || _meta$data === void 0 ? void 0 : (_meta$data$viewer = _meta$data.viewer) === null || _meta$data$viewer === void 0 ? void 0 : _meta$data$viewer.warrants) || []
  };
  return [getOptions, _objectSpread2(_objectSpread2({}, meta), {}, {
    data: data
  })];
};
/**
 * Custom input for selecting an instance of a Warrant.
 */


var WarrantInput = function WarrantInput(_ref) {
  var name = _ref.name,
      label = _ref.label,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? false : _ref$multiple,
      defaultValue = _ref.defaultValue,
      props = _objectWithoutProperties(_ref, ["name", "label", "multiple", "defaultValue"]);

  var _useOptions = useOptions$1(),
      _useOptions2 = _slicedToArray(_useOptions, 2),
      getOptions = _useOptions2[0],
      _useOptions2$ = _useOptions2[1],
      data = _useOptions2$.data,
      refetch = _useOptions2$.refetch;

  var _useCreate = useCreate$2(),
      _useCreate2 = _slicedToArray(_useCreate, 2),
      create = _useCreate2[0],
      createMeta = _useCreate2[1];

  var createModal = useModal();

  var createWarrant = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(form) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return create(form);

            case 3:
              createModal.close();
              refetch();
              Toasts.success("New warrant created");
              _context.next = 10;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));

    return function createWarrant(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(AssociationInput, _extends({}, props, {
    name: name,
    label: label,
    multiple: multiple,
    options: data.options,
    onFocus: function onFocus() {
      getOptions();
    },
    defaultValue: defaultValue,
    renderSelectionItem: function renderSelectionItem(warrant) {
      return /*#__PURE__*/React.createElement("p", {
        className: "has-text-weight-semibold"
      }, warrant.name);
    },
    renderSelectedItem: function renderSelectedItem(warrant) {
      return warrant.name;
    },
    placeholderComponent: SvgWarrantInput,
    placeholderMessage: "No warrants to select from"
  }), /*#__PURE__*/React.createElement(Level, null, /*#__PURE__*/React.createElement(Level.Left, null, /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement("span", {
    className: "is-size-5"
  }, "Warrants"))), /*#__PURE__*/React.createElement(Level.Right, null, /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement(Button, _extends({
    type: "button",
    color: "success",
    size: "small"
  }, createModal.triggerProps), /*#__PURE__*/React.createElement(Icon, {
    name: "plus"
  }), " ", /*#__PURE__*/React.createElement("span", null, "Add")), /*#__PURE__*/React.createElement(Modal, _extends({}, createModal.modalProps, {
    title: "New Warrant"
  }), /*#__PURE__*/React.createElement(Modal.Content, null, createModal.active && /*#__PURE__*/React.createElement(Form, {
    onSubmit: createWarrant,
    error: createMeta.error,
    loading: createMeta.loading
  }, /*#__PURE__*/React.createElement(Form.Input, {
    name: "name",
    label: "Name",
    type: "text",
    required: true
  }), /*#__PURE__*/React.createElement(Level, {
    mobile: true
  }, /*#__PURE__*/React.createElement(Level.Right, null, /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement(Form.SubmitButton, {
    color: "success"
  }, "Create Warrant")))))))))));
};
WarrantInput.propTypes = {
  /** Display label for the input */
  label: PropTypes.string.isRequired,

  /** Form input name */
  name: PropTypes.string.isRequired,

  /** Default input value */
  defaultValue: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),

  /** Multiple counsels may be selected */
  multiple: PropTypes.bool
};

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

var _ref$3 = /*#__PURE__*/createElement("path", {
  d: "M461.23 29.16C417.16 12.4 370.59-1.6 323.05.16c-69.9 2.58-137 41.91-169.86 99.66-27.88 48.93-31.32 106.28-43.33 160.58-14.78 66.89-43.14 130.48-73.42 192.65C20.18 486.45 3.02 520.57.35 557.18c-3.7 50.83 22.27 101.48 63 135.29s94.82 51.65 149.11 55.54c28.89 2.07 59.08.15 84.74-12.43 27.15-13.31 46.94-37.36 74.2-50.48 25.26-12.16 54.81-13.86 83.17-12.28a394.64 394.64 0 01108.58 21.6c39.64 13.92 76.5 34.09 116 48.21s83.74 22 124.16 10.22c38-11.07 68-37.95 95.05-65.17a1155.18 1155.18 0 00121.22-143.39c24.41-34.21 47.13-70.3 57.92-110.17 20.64-76.23-7.76-162.23-70.75-214.29-52.19-43.13-122.23-61.85-190.79-73.21-62.52-10.36-134.81-11-192.36-38-54.88-25.78-104.82-57.56-162.37-79.46z",
  fill: "#28629b",
  opacity: 0.1
});

var _ref2$3 = /*#__PURE__*/createElement("path", {
  fill: "#aaabb0",
  d: "M632.58 619v36.33h10.33l-2-39-8.33 2.67zM477.41 611.67V648h10.34l-2-39-8.34 2.67z"
});

var _ref3$3 = /*#__PURE__*/createElement("rect", {
  x: 644.58,
  y: 551.67,
  width: 13.33,
  height: 64.67,
  rx: 6.67,
  ry: 6.67,
  fill: "#aaabb0"
});

var _ref4$3 = /*#__PURE__*/createElement("rect", {
  x: 473.58,
  y: 537.33,
  width: 13.33,
  height: 79,
  rx: 6.67,
  ry: 6.67,
  fill: "#aaabb0"
});

var _ref5$3 = /*#__PURE__*/createElement("path", {
  d: "M674.92 164.67s13.33-5.67 15.33 0 3 54.67 3 54.67h-12.67zM528.92 164.67s-13.34-5.67-15.34 0-3 54.67-3 54.67h12.67zM530.91 116l-2 40.67h9V115l-7 1z",
  fill: "#aaabb0"
});

var _ref6$3 = /*#__PURE__*/createElement("path", {
  d: "M523.25 219.34l2.67-58.67s-1-13 30.66-9 124.34 12 124.34 12v55.67zM649.92 528.34l-5 89.66s-73.34 40.67-162.34 2l8-94.33z",
  fill: "#33323d"
});

var _ref7$3 = /*#__PURE__*/createElement("path", {
  fill: "#444053",
  d: "M580.25 175.33l1.66 58h103.34l-6-76.66-99 18.66z"
});

var _ref8$3 = /*#__PURE__*/createElement("path", {
  fill: "#4c4981",
  d: "M493.41 490h97.34v123.33h-97.34z"
});

var _ref9$3 = /*#__PURE__*/createElement("path", {
  d: "M554.92 540.34s14-11 16.33-7.67-8.32 17.67-12.66 16-3.67-8.33-3.67-8.33z",
  fill: "#ffb9b9"
});

var _ref10$3 = /*#__PURE__*/createElement("path", {
  fill: "#504f60",
  d: "M304.51 216h638.97v320H304.51z"
});

var _ref11$3 = /*#__PURE__*/createElement("path", {
  d: "M523.58 113.67s-5-46.67 0-52.33S612.58 2 690.25 65c0 0 7.33.34 6 17a200 200 0 00.16 31.67s-167.16 12-172.83 0z",
  fill: "#33323d"
});

var _ref12$3 = /*#__PURE__*/createElement("path", {
  d: "M523.58 113.67s-5-46.67 0-52.33S612.58 2 690.25 65c0 0 7.33.34 6 17a200 200 0 00.16 31.67s-167.16 12-172.83 0z",
  opacity: 0.1
});

var _ref13$3 = /*#__PURE__*/createElement("path", {
  d: "M523.58 119.67s-5-46.67 0-52.33S612.58 8 690.25 71c0 0 7.33.34 6 17a200 200 0 00.16 31.67s-167.16 12-172.83 0z",
  fill: "#33323d"
});

var _ref14$3 = /*#__PURE__*/createElement("path", {
  d: "M699.25 98.34s5.33 20 3.67 23.33-1.36 12.67-1.36 12.67.36 6-2.31 6.66-5 1-2.84 3 0 5 0 5-1.17 4.67 0 7.67-6.84 4.25-6.16 8 2.92 14.33 0 14.67 1 13.33-1.63 13.33-4.5 23.33-4.5 23.33-18.5-15.66-30.83-11.33c0 0 1-13 5-17.67s2.79-16.66 2.79-16.66l19.84-59.67z",
  fill: "#4c4981"
});

var _ref15$3 = /*#__PURE__*/createElement("path", {
  d: "M600.25 374.12c-4.33 4.79-9-20.79-9-20.79s-12.33 17-20.33 5.67c-5.54-7.85-1.17-30.09 2-43 1.42-5.74 2.62-9.64 2.62-9.64l18-3s.06 3.92.46 8.68c.54 6.43 1.71 14.41 4.2 16.32 4.39 3.31 6.39 40.93 2.05 45.76z",
  fill: "#ae6e79"
});

var _ref16$3 = /*#__PURE__*/createElement("path", {
  d: "M590.92 74.67s-31.34-.33-39 16.33-8 22.34-11 25 32.66 16.67 32.66 16.67l1.67 57.33s7-7.09 18.33-3.88 25.67 0 25.67 0-.67-1.21 8.67 0 39-14.45 39-14.45.49-25.08-.17-30.42 21.16-44.58 21.16-44.58 17-16.33-.66-22c0 0-6.25-9.42-22.33-9.33s-74 9.33-74 9.33z",
  opacity: 0.1
});

var _ref17$3 = /*#__PURE__*/createElement("path", {
  d: "M590.92 73.67s-31.34-.33-39 16.33-8 22.34-11 25 32.66 16.67 32.66 16.67l1.67 57.33s7-7.09 18.33-3.88 25.67 0 25.67 0-.67-1.21 8.67 0 39-14.45 39-14.45 11.66-19 11-24.33 23.33-45.67 23.33-45.67 3.67-21.33-14-27c0 0-6.25-9.42-22.33-9.33s-74 9.33-74 9.33z",
  fill: "#4c4981"
});

var _ref18$3 = /*#__PURE__*/createElement("path", {
  d: "M594.08 312.01c-6.87-2.14-17.65 2.58-21.08 4 1.42-5.74 2.62-9.64 2.62-9.64l18-3s.03 3.92.46 8.64z",
  opacity: 0.1
});

var _ref19$3 = /*#__PURE__*/createElement("path", {
  d: "M550.58 115h-9.66s-2 20.34 0 26.34 3 5.13 2.33 9.57 4.67 11.24 4.67 11.24.66 16.76 4 23-3.67 34.22-3.67 34.22a40.26 40.26 0 008.33 13c5.67 5.66 8.67 26.66 7 34.66s4.67 11 4.67 11 2.67 37.34 3.67 37.34 20.33-10 26.33-1.34l-4.67-34.33.34-66.33s-6.34-8.34-3-15.67-2.67-24.67-2.67-24.67l-8.67-38.66z",
  fill: "#4c4981"
});

var _ref20$3 = /*#__PURE__*/createElement("path", {
  d: "M490.58 642s-14-3-14.33 0-16.67 33.67 3.67 42.67 74.66 28.33 163 3.33c0 0 5.66 2 4.33-10.33s-1.33-26-1.33-26-13.34-3.67-23.34-2.33-97 19-132-7.34z",
  fill: "#33323d"
});

var _ref21$3 = /*#__PURE__*/createElement("path", {
  d: "M490.58 642s-14-3-14.33 0-16.67 33.67 3.67 42.67 74.66 28.33 163 3.33c0 0 5.66 2 4.33-10.33s-1.33-26-1.33-26-13.34-3.67-23.34-2.33-97 19-132-7.34z",
  opacity: 0.1
});

var _ref22$3 = /*#__PURE__*/createElement("path", {
  d: "M490.58 638s-14-3-14.33 0-16.67 33.67 3.67 42.67 74.66 28.33 163 3.33c0 0 5.66 2 4.33-10.33s-1.33-26-1.33-26-13.34-3.67-23.34-2.33-97 19-132-7.34z",
  fill: "#33323d"
});

var _ref23$3 = /*#__PURE__*/createElement("path", {
  d: "M572.22 126.98c-.86 4.89-2.81 9.59-3.11 14.54s1.61 10.58 6.18 12.52a20.83 20.83 0 013.69 1.5c1.76 1.19 2.48 3.43 2.85 5.53a30.2 30.2 0 01.35 8.22c-.25 2.76-.84 5.73.52 8.14 2.39 4.27 8.62 3.64 13.36 2.44l-1.63 12.63c-.13 1-.21 2.13.52 2.81a3.15 3.15 0 002.4.52c4.12-.26 8.36-.83 11.89-3s6.16-6.21 5.49-10.28c-.78-4.72-5.66-8.47-5-13.21.51-3.67 4.1-6 6.46-8.82 4.27-5.16 4.5-13 1.15-18.84s-9.82-9.46-16.48-10.12c-3.69-.37-7.53.08-11-1.2a8.34 8.34 0 01-5.1-5.38",
  fill: "#444053"
});

var _ref24$3 = /*#__PURE__*/createElement("path", {
  d: "M455.92 571.67l3.49-7.6s18.84-17.55 23.17-18.78 22-6.59 24.67-6.59 51.34-2.67 51.34-2.67l5.66 13.34-61.08 13.41-20.59 15z",
  fill: "#767d9f"
});

var _ref25$3 = /*#__PURE__*/createElement("path", {
  d: "M602.67 367l-3.19 24.55-1.23 9.45-14.33 2s-1.55-3.32-3.74-8.42c-6.65-15.48-19.17-47.4-11.91-52.91 9.65-7.34 12 17 12 17l11-5.34z",
  fill: "#ffb9b9"
});

var _ref26$3 = /*#__PURE__*/createElement("path", {
  fill: "#fff",
  d: "M527.91 412.67h72.37V522h-72.37z"
});

var _ref27$3 = /*#__PURE__*/createElement("path", {
  opacity: 0.1,
  d: "M527.91 412.67h72.37V522h-72.37z"
});

var _ref28$3 = /*#__PURE__*/createElement("path", {
  fill: "#fff",
  d: "M561.215 408.005l71.592 10.585-15.99 108.154-71.592-10.585z"
});

var _ref29$3 = /*#__PURE__*/createElement("path", {
  fill: "#28629b",
  d: "M567.954 418.32l36.85 5.448-8.23 55.665-36.85-5.448zM555.774 489.826l44.644 6.6-1.787 12.089-44.644-6.6z"
});

var _ref30$3 = /*#__PURE__*/createElement("circle", {
  cx: 619.25,
  cy: 95,
  r: 41.83,
  opacity: 0.1
});

var _ref31$3 = /*#__PURE__*/createElement("circle", {
  cx: 619.25,
  cy: 94,
  r: 41.83,
  fill: "#ae6e79"
});

var _ref32$3 = /*#__PURE__*/createElement("path", {
  d: "M584.76 125a4.76 4.76 0 01.29-3.23c1.59-3.31 6.12-3.6 9.79-3.43 8.63.4 18.1.45 24.85-5 2.8-2.24 5.93-7.87 10-6.8 3.62.95 5.13 5.86 8.9 6.95 2.73.79 5.56-.47 8.34-1 4-.79 8.1-.13 12.16-.1s8.47-.74 11.24-3.71c3.74-4 3.13-10.25 2.8-15.73a84.69 84.69 0 011.43-21.14c1.36-6.92 3.45-14.66-.37-20.59-3.64-5.65-11.18-7.2-16.33-11.53-4.82-4-7.37-10.41-12.46-14.12-6.41-4.67-15.12-4-23-3.19l-17.1 1.82c-4.41.47-9 1-12.63 3.63-6.55 4.74-7.45 14.59-13.65 19.78-2.76 2.3-6.29 3.44-9.44 5.16s-6.19 4.44-6.55 8c-.3 3 1.32 5.77 2.11 8.66 1.87 6.9-1.05 14-2.92 20.95s-2.23 15.39 3.2 20c1.1.94 2.38 1.66 3.45 2.64 3.67 3.35 4.17 9 3.32 13.88",
  fill: "#444053"
});

var _ref33$3 = /*#__PURE__*/createElement("ellipse", {
  cx: 622.66,
  cy: 143.75,
  rx: 1,
  ry: 2.5,
  fill: "#444053"
});

var _ref34$3 = /*#__PURE__*/createElement("ellipse", {
  cx: 622.66,
  cy: 154.17,
  rx: 1,
  ry: 2.5,
  fill: "#444053"
});

var _ref35$3 = /*#__PURE__*/createElement("path", {
  d: "M600.48 374.05c1.07-1.23 1.78-4.39 2.19-8.56l-11.92-14.86s5.05 28.81 9.73 23.42z",
  fill: "#ae6e79"
});

var _ref36$3 = /*#__PURE__*/createElement("path", {
  d: "M613.92 619.67s-19.56 30.24-80.67 27c-57.57-3-85.67-31.33-84.33-41.33S445.25 571 457.58 564c7.15-4.05 16.56-1.65 23.2 1.09a13.1 13.1 0 0013.77-2.47c6.07-5.47 17.39-11.63 35.26-6.78a12.7 12.7 0 007-.13c7.44-2.27 25.15-6.21 38 2.54a13 13 0 0013.92.53l.18-.11c6-3.67 34 31 34 31s1.34 26.67-8.99 30z",
  opacity: 0.1
});

var _ref37$3 = /*#__PURE__*/createElement("path", {
  d: "M613.92 620.67s-19.56 30.24-80.67 27c-57.57-3-85.67-31.33-84.33-41.33S445.25 572 457.58 565c7.15-4.05 16.56-1.65 23.2 1.09a13.1 13.1 0 0013.77-2.47c6.07-5.47 17.39-11.63 35.26-6.78a12.7 12.7 0 007-.13c7.44-2.27 25.15-6.21 38 2.54a13 13 0 0013.92.53l.18-.11c6-3.67 34 31 34 31s1.34 26.67-8.99 30z",
  fill: "#767d9f"
});

var _ref38$3 = /*#__PURE__*/createElement("circle", {
  cx: 533.25,
  cy: 592.67,
  r: 39.84,
  opacity: 0.1
});

var _ref39$3 = /*#__PURE__*/createElement("circle", {
  cx: 533.25,
  cy: 593.67,
  r: 39.84,
  fill: "#ffb9b9"
});

var _ref40$3 = /*#__PURE__*/createElement("path", {
  d: "M521.83 559.23c-4.18 1.13-8.3 3.29-10.34 6.84-1.23 2.14-1.66 4.71-3.44 6.49-2.52 2.53-6.77 2.58-10.18 4s-5.66 6.42-2.32 8c-3.48.18-6.06 3.39-6.49 6.58s.78 6.37 1.95 9.41c3.82 9.84 7.93 20.11 16.35 27.11 13.72 11.42 34.4 10.89 52.83 9.68a8.64 8.64 0 004.33-1c2-1.32 2.25-3.85 2.58-6.07 1.39-9.48 6.53-18.09 9.89-27.14s4.74-19.68-.92-27.69c-8.33-11.88-40.22-20.01-54.24-16.21z",
  fill: "#b96b6b"
});

var _ref41$3 = /*#__PURE__*/createElement("path", {
  d: "M599.48 391.55l-1.23 9.45-14.33 2s-1.55-3.32-3.74-8.42l19.07-3.58z",
  opacity: 0.1
});

var _ref42$3 = /*#__PURE__*/createElement("path", {
  d: "M614.58 600.34l8.34-9.67-1.67-53.33a86.51 86.51 0 001.67-11.67c.33-5.67-4.17-18.33-4.17-18.33a39.71 39.71 0 012.83-7.34c2-4-2.82-13-2.82-13s-7.18-23.33-4.18-35-.73-18.33-.73-18.33-2.93-13-2.6-18.33-6.67-10.34-6.67-10.34l-5.33-13-21.33 4v45s1.33 43 0 51.34 2.66 16.33 2.66 16.33-2.33 12.33-.33 17 6 16 6 16a26 26 0 00.67 12.16c2 5.84 0 9.17 0 9.17z",
  fill: "#767d9f"
});

var _ref43$3 = /*#__PURE__*/createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/createElement("path", {
  d: "M674.59 68.52a84.66 84.66 0 00-1.51 17.77 85.07 85.07 0 011.55-14.76c.88-4.44 2-9.22 1.76-13.65a83 83 0 01-1.8 10.64zM568.9 109.8c-1.07-1-2.35-1.7-3.45-2.65-2.92-2.49-4.15-6.1-4.39-10-.29 5 .73 9.84 4.39 13 1.1.95 2.38 1.67 3.45 2.65a12.22 12.22 0 013.62 8.35c.29-4.2-.56-8.57-3.62-11.35zM565.71 72.46a18.85 18.85 0 00-.54-6.29c-.58-2.14-1.62-4.23-2-6.38 0 .23-.08.47-.11.72-.29 3 1.33 5.77 2.11 8.66a17 17 0 01.54 3.29zM670.36 105.39c-2.77 3-7.18 3.74-11.24 3.71s-8.17-.69-12.16.11c-2.78.56-5.61 1.81-8.34 1-3.77-1.09-5.28-6-8.89-6.95-4.11-1.08-7.24 4.55-10 6.79-6.75 5.4-16.22 5.35-24.85 5-3.67-.17-8.2.12-9.78 3.44a4.64 4.64 0 00-.29 3.23l-12.22 1.92a23.71 23.71 0 01-.33 3l12.55-2a4.64 4.64 0 01.29-3.23c1.58-3.32 6.11-3.61 9.78-3.44 8.63.4 18.1.45 24.85-5 2.8-2.24 5.93-7.87 10-6.79 3.61.94 5.12 5.86 8.89 6.95 2.73.78 5.56-.47 8.34-1 4-.8 8.1-.14 12.16-.11s8.47-.74 11.24-3.71 3.17-7.4 3-11.72c-.12 3.35-.81 6.45-3 8.8z"
}));

var _ref44$2 = /*#__PURE__*/createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/createElement("path", {
  d: "M577.79 153.42a20.23 20.23 0 00-3.69-1.5 9.55 9.55 0 01-4.83-4.94c.75 3.45 2.65 6.59 5.83 7.94a20.23 20.23 0 013.69 1.5 5.54 5.54 0 011.77 2.07c-.4-1.96-1.13-3.96-2.77-5.07zM594.87 177.75c-4.61 1.17-10.63 1.78-13.16-2.13a6.87 6.87 0 00.8 2.69c2.16 3.85 7.44 3.72 11.93 2.77zM613.55 180.49c.64 4.06-2 8.11-5.5 10.24s-7.77 2.72-11.89 3a4.08 4.08 0 01-1.94-.22 2.38 2.38 0 002.94 3.22c4.12-.26 8.36-.83 11.89-3s6.17-6.21 5.49-10.28a11.34 11.34 0 00-.99-2.96zM617.99 144.29a16.46 16.46 0 01-3 14.15c-2.36 2.86-5.95 5.15-6.46 8.82a8.33 8.33 0 001 4.87 6.5 6.5 0 010-1.87c.51-3.67 4.1-6 6.46-8.82 3.88-4.69 4.42-11.6 2-17.15z"
}));

var _ref45$2 = /*#__PURE__*/createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/createElement("path", {
  d: "M497.88 578.1c3.4-1.41 7.65-1.46 10.18-4 1.78-1.78 2.21-4.35 3.44-6.48 2-3.56 6.15-5.71 10.33-6.84 14-3.8 45.92 4.32 54.24 16.09a21.85 21.85 0 013.82 12.08 22.58 22.58 0 00-3.81-14.07c-8.32-11.77-40.21-19.89-54.24-16.09-4.18 1.13-8.3 3.28-10.33 6.84-1.23 2.13-1.66 4.7-3.44 6.48-2.53 2.53-6.78 2.58-10.18 4-2.59 1.07-4.51 4.23-3.81 6.35a6.88 6.88 0 013.8-4.36zM489.08 592.63c.42-3.2 3-6.4 6.49-6.58a2.66 2.66 0 01-1.53-1.71 7.77 7.77 0 00-5 6.29 10.57 10.57 0 000 2.45c.04-.15.04-.3.04-.45z"
}));

var _ref46$2 = /*#__PURE__*/createElement("path", {
  fill: "#fff",
  d: "M609.91 230.24h91v118.67h-91z"
});

var _ref47$2 = /*#__PURE__*/createElement("path", {
  opacity: 0.1,
  d: "M609.91 230.24h91v118.67h-91z"
});

var _ref48$2 = /*#__PURE__*/createElement("path", {
  fill: "#fff",
  d: "M645.996 252.629l89.682-15.427 20.118 116.953-89.683 15.426z"
});

var _ref49$2 = /*#__PURE__*/createElement("path", {
  fill: "#28629b",
  d: "M667.731 332.355l21.071-3.624 4.726 27.476-21.07 3.624zM696.888 327.334l21.071-3.624 4.726 27.476-21.07 3.625zM664.67 296.143l73.893-12.689 4.74 27.602-73.894 12.688zM658.51 263.201l73.894-12.689 1.057 6.158-73.893 12.689zM660.934 274.529l73.893-12.69 1.058 6.159-73.894 12.688z"
});

var _ref50$2 = /*#__PURE__*/createElement("path", {
  d: "M661.08 198s-41.83 42-20.83 52.67 34.67-35.5 34.67-35.5l3.32-10.5z",
  fill: "#ae6e79"
});

var _ref51$1 = /*#__PURE__*/createElement("path", {
  d: "M657.42 194.29l-5.17 11.42s25.5 3.58 30.83 11.29l-3.16-20.15-3.75-8.6z",
  opacity: 0.1
});

var _ref52$1 = /*#__PURE__*/createElement("path", {
  d: "M658.42 193.29l-5.17 11.42s25.5 3.58 30.83 11.29l-3.16-20.15-3.75-8.6z",
  fill: "#4c4981"
});

var _ref53$1 = /*#__PURE__*/createElement("path", {
  fill: "#464a5f",
  d: "M812.78 403.26l-.55.38.76.34.82-.07.1-.57-1.13-.08z"
});

var _ref54$1 = /*#__PURE__*/createElement("path", {
  opacity: 0.1,
  d: "M812.78 403.26l-.55.38.76.34.82-.07.1-.57-1.13-.08z"
});

var _ref55$1 = /*#__PURE__*/createElement("path", {
  fill: "#9c9ca1",
  d: "M812.78 403.26l-.56.36-.44-.54.27-.44.25-.08.48.7z"
});

var _ref56$1 = /*#__PURE__*/createElement("path", {
  opacity: 0.1,
  d: "M812.78 403.26l-.56.36-.44-.54.27-.44.25-.08.48.7z"
});

var _ref57$1 = /*#__PURE__*/createElement("path", {
  d: "M911.21 334.15l-40.94-59.13a4.87 4.87 0 00-6.78-1.25l-91.26 62.64a4.89 4.89 0 00-1.27 6.79l40.83 59.88z",
  fill: "#9c9ca1"
});

var _ref58$1 = /*#__PURE__*/createElement("path", {
  d: "M911.21 334.15l-40.94-59.13a4.87 4.87 0 00-6.78-1.25l-91.26 62.64a4.89 4.89 0 00-1.27 6.79l40.83 59.88z",
  opacity: 0.1
});

var _ref59$1 = /*#__PURE__*/createElement("path", {
  d: "M912.21 334.29l-40.94-59.13a4.88 4.88 0 00-6.79-1.25l-91.25 62.68a4.9 4.9 0 00-1.28 6.79l40.83 59.91z",
  fill: "#9c9ca1"
});

var _ref60$1 = /*#__PURE__*/createElement("path", {
  d: "M946.43 345.98l-34-10.92-99.44 68.93 34.54 11.3a5.23 5.23 0 004.63-.7l94.55-66.76a1 1 0 00-.28-1.85z",
  fill: "#464a5f"
});

var _ref61$1 = /*#__PURE__*/createElement("path", {
  d: "M946.43 345.98l-34-10.92-99.44 68.93 34.54 11.3a5.23 5.23 0 004.63-.7l94.55-66.76a1 1 0 00-.28-1.85z",
  opacity: 0.1
});

var _ref62$1 = /*#__PURE__*/createElement("path", {
  d: "M946.22 345.29l-34-10.93-99.44 68.93 34.54 11.28a5.19 5.19 0 004.63-.69l94.55-66.76a1 1 0 00-.28-1.83z",
  fill: "#464a5f"
});

var _ref63$1 = /*#__PURE__*/createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/createElement("path", {
  d: "M896.15 331.65l-2.51-3.6a1 1 0 00-1.36-.25l-3.73 2.49a1 1 0 00-.27 1.35l2.31 3.55a1 1 0 001.35.29l3.93-2.47a1 1 0 00.28-1.36zM889.45 336.29l-2.52-3.59a1 1 0 00-1.36-.25l-3.72 2.51a1 1 0 00-.28 1.35l2.31 3.55a1 1 0 001.35.3l3.94-2.47a1 1 0 00.28-1.4zM882.41 341.16l-2.52-3.59a1 1 0 00-1.36-.25l-3.73 2.51a1 1 0 00-.27 1.36l2.31 3.55a1 1 0 001.35.29l3.93-2.47a1 1 0 00.29-1.4zM875.28 346.1l-2.52-3.6a1 1 0 00-1.35-.25l-3.73 2.52a1 1 0 00-.27 1.35l2.31 3.55a1 1 0 001.34.3l3.94-2.48a1 1 0 00.28-1.39zM868.16 351.03l-2.52-3.59a1 1 0 00-1.36-.25l-3.72 2.51a1 1 0 00-.28 1.35l2.31 3.55a1 1 0 001.35.3l3.94-2.48a1 1 0 00.28-1.39zM861.35 356.41l-3.13-4.46a.45.45 0 00-.63-.12l-4.58 3.09a.45.45 0 00-.13.63l2.87 4.41a.46.46 0 00.63.14l4.84-3a.46.46 0 00.13-.69zM854.23 361.34l-3.15-4.46a.46.46 0 00-.64-.12l-4.58 3.09a.46.46 0 00-.12.63l2.87 4.41a.44.44 0 00.63.14l4.83-3a.45.45 0 00.16-.69zM847.92 365.71l-3.13-4.42a.46.46 0 00-.63-.11l-4.58 3.08a.47.47 0 00-.13.64l2.87 4.41a.47.47 0 00.63.14l4.84-3a.46.46 0 00.13-.74zM840.86 370.59l-3.13-4.46a.46.46 0 00-.63-.11l-4.58 3.08a.46.46 0 00-.13.64l2.87 4.41a.47.47 0 00.63.14l4.84-3a.47.47 0 00.13-.7zM834.02 375.29l-3.13-4.46a.45.45 0 00-.63-.12l-4.58 3.09a.45.45 0 00-.13.63l2.87 4.41a.46.46 0 00.63.14l4.84-3a.46.46 0 00.13-.69zM827.18 380.07l-3.1-4.47a.46.46 0 00-.63-.11l-4.58 3.08a.46.46 0 00-.13.64l2.87 4.41a.47.47 0 00.63.14l4.84-3a.46.46 0 00.1-.69zM820.34 384.8l-3.13-4.46a.45.45 0 00-.63-.12l-4.58 3.07a.45.45 0 00-.13.63l2.87 4.41a.46.46 0 00.63.14l4.84-3a.46.46 0 00.13-.67zM891.65 325.14l-2.52-3.6a1 1 0 00-1.36-.25l-3.69 2.52a1 1 0 00-.28 1.35l2.31 3.55a1 1 0 001.35.29l3.94-2.47a1 1 0 00.25-1.39zM881.8 310.91l-2.52-3.62a1 1 0 00-1.35-.25l-3.73 2.51a1 1 0 00-.28 1.35l2.31 3.55a1 1 0 001.35.3l3.94-2.47a1 1 0 00.28-1.37zM884.94 329.78l-2.52-3.59a1 1 0 00-1.35-.25l-3.73 2.51a1 1 0 00-.27 1.35l2.3 3.55a1 1 0 001.35.3l3.94-2.47a1 1 0 00.28-1.4zM877.9 334.65l-2.52-3.59a1 1 0 00-1.36-.25l-3.72 2.48a1 1 0 00-.28 1.36l2.31 3.55a1 1 0 001.35.29l3.94-2.47a1 1 0 00.28-1.37zM870.77 339.59l-2.51-3.6a1 1 0 00-1.36-.25l-3.73 2.55a1 1 0 00-.27 1.35l2.31 3.55a1 1 0 001.35.29l3.93-2.47a1 1 0 00.28-1.42zM875.25 315.78l-2.52-3.59a1 1 0 00-1.35-.25l-3.73 2.51a1 1 0 00-.28 1.35l2.31 3.55a1 1 0 001.35.3l3.94-2.47a1 1 0 00.28-1.4zM868.21 320.66l-2.52-3.6a1 1 0 00-1.36-.25l-3.72 2.48a1 1 0 00-.28 1.35l2.31 3.55a1 1 0 001.35.29l3.94-2.47a1 1 0 00.28-1.35zM861.08 325.59l-2.52-3.59a1 1 0 00-1.35-.26l-3.73 2.55a1 1 0 00-.27 1.35l2.31 3.55a1 1 0 001.35.3l3.93-2.48a1 1 0 00.28-1.42zM863.65 344.52l-2.52-3.59a1 1 0 00-1.35-.26l-3.7 2.52a1 1 0 00-.27 1.35l2.27 3.55a1 1 0 001.34.3l3.94-2.48a1 1 0 00.29-1.39zM856.53 349.45l-2.52-3.59a1 1 0 00-1.36-.25l-3.72 2.51a1 1 0 00-.28 1.35l2.31 3.55a1 1 0 001.35.3l3.94-2.47a1 1 0 00.28-1.4zM849.72 354.83l-3.13-4.46a.45.45 0 00-.63-.12l-4.58 3.09a.45.45 0 00-.13.63l2.87 4.41a.45.45 0 00.63.14l4.84-3a.46.46 0 00.13-.69zM843.41 359.2l-3.13-4.47a.46.46 0 00-.63-.11l-4.57 3.08a.47.47 0 00-.13.64l2.87 4.41a.47.47 0 00.63.14l4.84-3a.44.44 0 00.12-.69zM836.35 364.08l-3.13-4.46a.46.46 0 00-.63-.11l-4.58 3.08a.45.45 0 00-.13.63l2.87 4.42a.47.47 0 00.63.14l4.84-3a.47.47 0 00.13-.7zM829.51 368.82l-3.13-4.46a.45.45 0 00-.63-.12l-4.58 3.05a.45.45 0 00-.13.63l2.87 4.41a.46.46 0 00.63.14l4.84-3a.46.46 0 00.13-.65zM873.21 327.88l-2.52-3.59a1 1 0 00-1.35-.25l-3.73 2.52a1 1 0 00-.27 1.35l2.31 3.55a1 1 0 001.34.29l3.94-2.47a1 1 0 00.28-1.4zM866.08 332.82l-2.52-3.6a1 1 0 00-1.36-.25l-3.72 2.52a1 1 0 00-.28 1.35l2.31 3.55a1 1 0 001.35.3l3.94-2.48a1 1 0 00.28-1.39zM858.97 337.75l-2.52-3.59a1 1 0 00-1.36-.25l-3.73 2.51a1 1 0 00-.27 1.35l2.31 3.55a1 1 0 001.35.3l3.93-2.48a1 1 0 00.29-1.39zM851.84 342.68l-2.52-3.59a1 1 0 00-1.35-.25l-3.73 2.51a1 1 0 00-.27 1.35l2.31 3.59a1 1 0 001.34.3l3.94-2.47a1 1 0 00.28-1.44zM845.08 348.06l-3.13-4.46a.45.45 0 00-.63-.12l-4.58 3.09a.46.46 0 00-.13.63l2.87 4.42a.45.45 0 00.63.13l4.84-3a.46.46 0 00.13-.69zM838.73 352.43l-3.13-4.47a.47.47 0 00-.64-.11l-4.57 3.08a.47.47 0 00-.13.64l2.87 4.41a.46.46 0 00.63.14l4.84-3a.46.46 0 00.13-.69zM831.67 357.29l-3.13-4.47a.47.47 0 00-.64-.11l-4.58 3.08a.48.48 0 00-.13.64l2.88 4.41a.46.46 0 00.63.14l4.83-3a.45.45 0 00.14-.69zM824.83 362.05l-3.13-4.46a.46.46 0 00-.64-.12l-4.58 3.09a.46.46 0 00-.12.63l2.87 4.41a.44.44 0 00.63.14l4.83-3a.45.45 0 00.14-.69zM822.67 373.55l-3.13-4.46a.46.46 0 00-.63-.11l-4.58 3.08a.45.45 0 00-.13.63l2.87 4.42a.47.47 0 00.63.14l4.84-3a.47.47 0 00.13-.7zM815.83 378.29l-3.13-4.46a.45.45 0 00-.63-.12l-4.58 3.09a.45.45 0 00-.13.63l2.87 4.41a.46.46 0 00.63.14l4.84-3a.46.46 0 00.13-.69zM826.57 349.95l-3-4.2a.62.62 0 00-.85-.15l-4.32 2.91a.61.61 0 00-.17.85l2.7 4.15a.6.6 0 00.84.19l4.57-2.87a.62.62 0 00.23-.88zM819.73 354.69l-2.95-4.2a.61.61 0 00-.85-.16l-4.32 2.96a.6.6 0 00-.17.84l2.7 4.16a.62.62 0 00.84.19l4.57-2.87a.62.62 0 00.18-.92zM812.89 359.43l-2.95-4.21a.62.62 0 00-.85-.15l-4.32 2.91a.61.61 0 00-.17.85l2.7 4.15a.6.6 0 00.84.19l4.57-2.87a.61.61 0 00.18-.87zM806.14 364.29l-3.13-4.47a.46.46 0 00-.63-.11l-4.58 3.08a.47.47 0 00-.13.64l2.87 4.41a.47.47 0 00.63.14l4.84-3a.44.44 0 00.13-.69zM887.08 318.14l-2.71-3.85a1 1 0 00-1.36-.24l-10.58 7.41a1 1 0 00-.26 1.34l2.55 3.94a1 1 0 001.39.27l10.74-7.51a1 1 0 00.23-1.36zM817.97 366.64l-3.32-4.69a.45.45 0 00-.64-.11l-11.42 8a.45.45 0 00-.12.62l3.12 4.83a.46.46 0 00.65.13l11.61-8.13a.47.47 0 00.12-.65zM854.3 330.77l-3.06-4.48a.46.46 0 00-.63-.12l-25.36 17.12a.46.46 0 00-.13.63l3.13 4.8a.46.46 0 00.65.13l25.28-17.44a.46.46 0 00.12-.64z"
}));

var _ref64$1 = /*#__PURE__*/createElement("path", {
  d: "M896.82 331.77l-2.52-3.6a1 1 0 00-1.36-.25l-3.72 2.52a1 1 0 00-.28 1.35l2.31 3.55a1 1 0 001.35.3l3.94-2.48a1 1 0 00.28-1.39zM890.08 336.41l-2.52-3.59a1 1 0 00-1.35-.25l-3.73 2.51a1 1 0 00-.28 1.35l2.31 3.55a1 1 0 001.35.3l3.94-2.47a1 1 0 00.28-1.4zM883.08 341.29l-2.52-3.59a1 1 0 00-1.36-.25l-3.72 2.52a1 1 0 00-.28 1.35l2.31 3.55a1 1 0 001.35.29l3.94-2.47a1 1 0 00.28-1.4zM875.94 346.22l-2.52-3.6a1 1 0 00-1.35-.25l-3.73 2.52a1 1 0 00-.26 1.4l2.31 3.55a1 1 0 001.35.3l3.93-2.48a1 1 0 00.27-1.44zM868.82 351.15l-2.52-3.59a1 1 0 00-1.35-.25l-3.73 2.51a1 1 0 00-.27 1.35l2.3 3.55a1 1 0 001.35.3l3.94-2.48a1 1 0 00.28-1.39zM862.01 356.53l-3.13-4.46a.45.45 0 00-.63-.12l-4.58 3.09a.45.45 0 00-.13.63l2.87 4.41a.46.46 0 00.63.14l4.84-3a.46.46 0 00.13-.69zM854.89 361.46l-3.13-4.46a.46.46 0 00-.64-.12l-4.57 3.09a.45.45 0 00-.13.63l2.87 4.42a.45.45 0 00.63.13l4.84-3a.47.47 0 00.13-.69zM848.58 365.83l-3.13-4.47a.46.46 0 00-.63-.11l-4.58 3.04a.47.47 0 00-.13.64l2.87 4.41a.47.47 0 00.63.14l4.84-3a.46.46 0 00.13-.65zM841.52 370.72l-3.13-4.43a.46.46 0 00-.63-.11l-4.58 3.08a.46.46 0 00-.13.64l2.87 4.41a.47.47 0 00.63.14l4.84-3a.46.46 0 00.13-.73zM834.68 375.45l-3.13-4.46a.45.45 0 00-.63-.12l-4.58 3.09a.45.45 0 00-.13.63l2.87 4.41a.45.45 0 00.63.14l4.84-3a.46.46 0 00.13-.69zM827.84 380.19l-3.13-4.47a.46.46 0 00-.63-.11l-4.58 3.08a.47.47 0 00-.13.64l2.87 4.41a.47.47 0 00.63.14l4.84-3a.46.46 0 00.13-.69zM821 384.92l-3.13-4.46a.45.45 0 00-.63-.12l-4.58 3.09a.45.45 0 00-.13.63l2.87 4.41a.45.45 0 00.63.14l4.84-3a.46.46 0 00.13-.69zM892.31 325.29l-2.52-3.6a1 1 0 00-1.35-.25l-3.73 2.52a1 1 0 00-.27 1.35l2.3 3.55a1 1 0 001.35.3l3.94-2.48a1 1 0 00.28-1.39zM882.46 311.03l-2.52-3.59a1 1 0 00-1.35-.25l-3.73 2.51a1 1 0 00-.27 1.35l2.31 3.55a1 1 0 001.34.3l3.94-2.47a1 1 0 00.28-1.4zM885.6 329.9l-2.52-3.61a1 1 0 00-1.35-.25l-3.73 2.51a1 1 0 00-.27 1.35l2.31 3.55a1 1 0 001.34.3l3.94-2.47a1 1 0 00.28-1.38zM878.56 334.77l-2.48-3.59a1 1 0 00-1.35-.25l-3.73 2.51a1 1 0 00-.27 1.36l2.3 3.55a1 1 0 001.35.29l3.94-2.47a1 1 0 00.24-1.4zM871.44 339.71l-2.52-3.6a1 1 0 00-1.36-.25l-3.72 2.52a1 1 0 00-.28 1.35l2.31 3.55a1 1 0 001.35.3l3.94-2.48a1 1 0 00.28-1.39zM875.91 315.9l-2.52-3.61a1 1 0 00-1.35-.25l-3.73 2.51a1 1 0 00-.27 1.35l2.31 3.55a1 1 0 001.34.3l3.94-2.47a1 1 0 00.28-1.38zM868.87 320.78l-2.52-3.6a1 1 0 00-1.35-.25l-3.73 2.52a1 1 0 00-.28 1.35l2.31 3.55a1 1 0 001.35.3l3.94-2.48a1 1 0 00.28-1.39zM861.75 325.71l-2.52-3.59a1 1 0 00-1.36-.25l-3.72 2.51a1 1 0 00-.28 1.35l2.31 3.56a1 1 0 001.35.3l3.93-2.48a1 1 0 00.29-1.4zM864.31 344.64l-2.52-3.59a1 1 0 00-1.35-.25l-3.73 2.49a1 1 0 00-.27 1.35l2.31 3.55a1 1 0 001.34.3l3.94-2.48a1 1 0 00.28-1.37zM857.19 349.57l-2.52-3.59a1 1 0 00-1.35-.25l-3.73 2.56a1 1 0 00-.28 1.35l2.31 3.55a1 1 0 001.35.3l3.94-2.47a1 1 0 00.28-1.45zM850.38 354.95l-3.13-4.46a.45.45 0 00-.63-.12l-4.54 3.09a.45.45 0 00-.13.63l2.87 4.41a.45.45 0 00.63.14l4.84-3a.47.47 0 00.09-.69zM844.08 359.29l-3.13-4.47a.47.47 0 00-.64-.11l-4.58 3.08a.48.48 0 00-.13.64l2.88 4.41a.46.46 0 00.63.14l4.83-3a.45.45 0 00.14-.69zM837.01 364.21l-3.13-4.47a.46.46 0 00-.63-.11l-4.58 3.08a.47.47 0 00-.13.64l2.87 4.41a.47.47 0 00.63.14l4.84-3a.44.44 0 00.13-.69zM830.18 368.94l-3.1-4.46a.45.45 0 00-.63-.12l-4.58 3.09a.46.46 0 00-.13.63l2.87 4.41a.46.46 0 00.63.14l4.84-3a.45.45 0 00.1-.69zM873.87 328.01l-2.51-3.6a1 1 0 00-1.36-.25l-3.73 2.52a1 1 0 00-.27 1.35l2.31 3.55a1 1 0 001.35.29l3.93-2.47a1 1 0 00.28-1.39zM866.75 332.94l-2.52-3.59a1 1 0 00-1.35-.26l-3.73 2.52a1 1 0 00-.27 1.35l2.31 3.55a1 1 0 001.34.3l3.94-2.48a1 1 0 00.28-1.39zM859.63 337.87l-2.55-3.58a1 1 0 00-1.36-.25l-3.64 2.5a1 1 0 00-.28 1.35l2.31 3.55a1 1 0 001.35.3l3.94-2.47a1 1 0 00.23-1.4zM852.5 342.8l-2.52-3.59a1 1 0 00-1.35-.25l-3.73 2.51a1 1 0 00-.27 1.35l2.31 3.55a1 1 0 001.34.3l3.94-2.47a1 1 0 00.28-1.4zM845.7 348.18l-3.13-4.46a.46.46 0 00-.64-.12l-4.58 3.09a.46.46 0 00-.13.63l2.87 4.42a.46.46 0 00.64.13l4.83-3a.46.46 0 00.14-.69zM839.39 352.55l-3.13-4.46a.45.45 0 00-.63-.12l-4.55 3.08a.47.47 0 00-.13.64l2.87 4.41a.47.47 0 00.63.14l4.84-3a.46.46 0 00.1-.69zM832.33 357.44l-3.13-4.47a.47.47 0 00-.64-.11l-4.57 3.08a.47.47 0 00-.13.64l2.87 4.41a.46.46 0 00.63.14l4.84-3a.46.46 0 00.13-.69zM825.49 362.17l-3.13-4.46a.46.46 0 00-.64-.12l-4.57 3.09a.45.45 0 00-.13.63l2.87 4.42a.45.45 0 00.63.13l4.84-3a.47.47 0 00.13-.69zM823.34 373.68l-3.13-4.47a.47.47 0 00-.64-.11l-4.58 3.08a.47.47 0 00-.13.64l2.87 4.41a.47.47 0 00.63.14l4.84-3a.45.45 0 00.14-.69zM816.5 378.41l-3.13-4.46a.46.46 0 00-.64-.12l-4.58 3.09a.46.46 0 00-.13.63l2.87 4.41a.46.46 0 00.64.14l4.83-3a.45.45 0 00.14-.69zM827.23 350.08l-2.95-4.21a.62.62 0 00-.85-.15l-4.35 2.91a.62.62 0 00-.17.85l2.7 4.16a.62.62 0 00.85.18l4.56-2.87a.61.61 0 00.21-.87zM820.39 354.81l-2.95-4.2a.61.61 0 00-.85-.16l-4.32 2.92a.61.61 0 00-.17.84l2.7 4.16a.63.63 0 00.85.19l4.57-2.87a.63.63 0 00.17-.88zM813.55 359.55l-3-4.21a.61.61 0 00-.84-.15l-4.33 2.91a.62.62 0 00-.17.85l2.7 4.16a.62.62 0 00.85.18l4.57-2.87a.61.61 0 00.22-.87zM806.81 364.42l-3.13-4.47a.47.47 0 00-.64-.11l-4.58 3.08a.47.47 0 00-.12.64l2.87 4.41a.46.46 0 00.63.14l4.84-3a.46.46 0 00.13-.69zM887.75 318.29l-2.67-3.86a1 1 0 00-1.36-.24l-10.64 7.41a1 1 0 00-.26 1.34l2.56 3.94a1 1 0 001.39.27l10.73-7.51a1 1 0 00.25-1.35zM818.63 366.76l-3.32-4.69a.45.45 0 00-.64-.11l-11.42 8a.46.46 0 00-.12.63l3.13 4.82a.46.46 0 00.65.13l11.61-8.13a.47.47 0 00.11-.65zM854.96 330.89l-3-4.45a.47.47 0 00-.64-.13l-25.35 17.1a.45.45 0 00-.13.63l3.12 4.8a.46.46 0 00.65.13l25.28-17.44a.46.46 0 00.07-.64z",
  fill: "#464a5f"
});

var _ref65$1 = /*#__PURE__*/createElement("path", {
  d: "M855.08 315.61l-13.48-19.59a2.5 2.5 0 00-3.46-.66l-37.13 24.93a2.51 2.51 0 00-.67 3.49l13.74 20.15a2.5 2.5 0 003.49.66l36.87-25.51a2.49 2.49 0 00.64-3.47z",
  opacity: 0.1
});

var _ref66$1 = /*#__PURE__*/createElement("path", {
  d: "M855.7 315.73l-13.48-19.59a2.51 2.51 0 00-3.46-.66l-37.08 24.95a2.5 2.5 0 00-.68 3.49l13.7 20.13a2.5 2.5 0 003.49.66l36.89-25.51a2.49 2.49 0 00.62-3.47z",
  fill: "#939498"
});

var _ref67$1 = /*#__PURE__*/createElement("path", {
  d: "M939.29 347.39l-28.6-9.54-91.73 63.72 28.39 9.25a5.2 5.2 0 004.59-.68l87.61-60.92a1 1 0 00-.26-1.83z",
  fill: "#28629b"
});

function SvgHearingInput(props) {
  return /*#__PURE__*/createElement("svg", _extends$4({
    "data-name": "Layer 1",
    viewBox: "0 0 1084.15 758.57"
  }, props), _ref$3, _ref2$3, _ref3$3, _ref4$3, _ref5$3, _ref6$3, _ref7$3, _ref8$3, _ref9$3, _ref10$3, _ref11$3, _ref12$3, _ref13$3, _ref14$3, _ref15$3, _ref16$3, _ref17$3, _ref18$3, _ref19$3, _ref20$3, _ref21$3, _ref22$3, _ref23$3, _ref24$3, _ref25$3, _ref26$3, _ref27$3, _ref28$3, _ref29$3, _ref30$3, _ref31$3, _ref32$3, _ref33$3, _ref34$3, _ref35$3, _ref36$3, _ref37$3, _ref38$3, _ref39$3, _ref40$3, _ref41$3, _ref42$3, _ref43$3, _ref44$2, _ref45$2, _ref46$2, _ref47$2, _ref48$2, _ref49$2, _ref50$2, _ref51$1, _ref52$1, _ref53$1, _ref54$1, _ref55$1, _ref56$1, _ref57$1, _ref58$1, _ref59$1, _ref60$1, _ref61$1, _ref62$1, _ref63$1, _ref64$1, _ref65$1, _ref66$1, _ref67$1);
}

function _templateObject2$3() {
  var data = _taggedTemplateLiteral(["\n      query Hearings {\n        viewer {\n          hearings {\n            id\n            name\n          }\n        }\n      }\n    "]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$4() {
  var data = _taggedTemplateLiteral(["\n    mutation($hearing: NewHearingInput) {\n      hearing: addHearing(hearing: $hearing) {\n        name\n        id\n      }\n    }\n  "]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}
var useCreate$3 = function useCreate() {
  var _useMutation = useMutation(gql(_templateObject$4())),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      mutate = _useMutation2[0],
      meta = _useMutation2[1];

  var create = function create(hearing) {
    return mutate({
      variables: {
        hearing: hearing
      }
    });
  };

  return [create, meta];
};

var useOptions$2 = function useOptions() {
  var _meta$data, _meta$data$viewer;

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    fetchPolicy: "cache-and-network"
  };

  var _useLazyQuery = useLazyQuery(gql(_templateObject2$3()), options),
      _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
      query = _useLazyQuery2[0],
      meta = _useLazyQuery2[1];

  var getOptions = function getOptions() {
    var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var requestOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return query(_objectSpread2({
      variables: form
    }, requestOptions));
  }; // Cleaned data for easier consumption


  var data = {
    options: (meta === null || meta === void 0 ? void 0 : (_meta$data = meta.data) === null || _meta$data === void 0 ? void 0 : (_meta$data$viewer = _meta$data.viewer) === null || _meta$data$viewer === void 0 ? void 0 : _meta$data$viewer.hearings) || []
  };
  return [getOptions, _objectSpread2(_objectSpread2({}, meta), {}, {
    data: data
  })];
};
/**
 * Custom input for selecting an instance of a Hearing.
 */


var HearingInput = function HearingInput(_ref) {
  var name = _ref.name,
      label = _ref.label,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? false : _ref$multiple,
      defaultValue = _ref.defaultValue,
      props = _objectWithoutProperties(_ref, ["name", "label", "multiple", "defaultValue"]);

  var _useOptions = useOptions$2(),
      _useOptions2 = _slicedToArray(_useOptions, 2),
      getOptions = _useOptions2[0],
      _useOptions2$ = _useOptions2[1],
      data = _useOptions2$.data,
      refetch = _useOptions2$.refetch;

  var _useCreate = useCreate$3(),
      _useCreate2 = _slicedToArray(_useCreate, 2),
      create = _useCreate2[0],
      createMeta = _useCreate2[1];

  var createModal = useModal();

  var createHearing = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(form) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return create(form);

            case 3:
              createModal.close();
              refetch();
              Toasts.success("New hearing created");
              _context.next = 10;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));

    return function createHearing(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(AssociationInput, _extends({}, props, {
    name: name,
    label: label,
    multiple: multiple,
    options: data.options,
    defaultValue: defaultValue,
    onFocus: function onFocus() {
      getOptions();
    },
    renderSelectionItem: function renderSelectionItem(hearing) {
      return /*#__PURE__*/React.createElement("p", {
        className: "has-text-weight-semibold"
      }, hearing.name);
    },
    renderSelectedItem: function renderSelectedItem(hearing) {
      return /*#__PURE__*/React.createElement("p", {
        className: "has-text-weight-semibold"
      }, hearing.name);
    },
    placeholderComponent: SvgHearingInput,
    placeholderMessage: "No hearings to select from"
  }), /*#__PURE__*/React.createElement(Level, null, /*#__PURE__*/React.createElement(Level.Left, null, /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement("span", {
    className: "is-size-5"
  }, "Hearings"))), /*#__PURE__*/React.createElement(Level.Right, null, /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement(Button, _extends({
    type: "button",
    color: "success",
    size: "small"
  }, createModal.triggerProps), /*#__PURE__*/React.createElement(Icon, {
    name: "plus"
  }), " ", /*#__PURE__*/React.createElement("span", null, "Add")), /*#__PURE__*/React.createElement(Modal, _extends({}, createModal.modalProps, {
    title: "New Hearing"
  }), /*#__PURE__*/React.createElement(Modal.Content, null, createModal.active && /*#__PURE__*/React.createElement(Form, {
    onSubmit: createHearing,
    error: createMeta.error,
    loading: createMeta.loading
  }, /*#__PURE__*/React.createElement(Form.Input, {
    name: "judge",
    label: "Judge",
    type: "judge",
    required: true
  }), /*#__PURE__*/React.createElement(Columns, null, /*#__PURE__*/React.createElement(Columns.Column, null, /*#__PURE__*/React.createElement(Form.Input, {
    name: "startedAt",
    label: "Starting Date & Time",
    type: "datetime-local"
  })), /*#__PURE__*/React.createElement(Columns.Column, null, /*#__PURE__*/React.createElement(Form.Input, {
    name: "endsAt",
    label: "Starting Date & Time",
    type: "datetime-local"
  }))), /*#__PURE__*/React.createElement(Level, {
    mobile: true
  }, /*#__PURE__*/React.createElement(Level.Right, null, /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement(Form.SubmitButton, {
    color: "success"
  }, "Create Hearing")))))))))));
};
HearingInput.propTypes = {
  /** Display label for the input */
  label: PropTypes.string.isRequired,

  /** Form input name */
  name: PropTypes.string.isRequired,

  /** Default input value */
  defaultValue: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),

  /** Multiple counsels may be selected */
  multiple: PropTypes.bool
};

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

var _ref$4 = /*#__PURE__*/createElement("path", {
  d: "M989.47 463.77c-3.55-31.86-13.88-62-27.35-88.93-30.4-60.85-76.47-106.25-126.27-138.77-.48-.32-1-.62-1.45-.93a55.72 55.72 0 0011.49-22.48c15.32-62.77-88-141.89-230.7-176.7-114.52-27.9-219.62-18.82-264.6 18.3-104.92-6.6-214.38 57.96-287.12 157.4-26 35.59-48 77.63-57.65 125.16-11.74 57.56-4.72 119.51 11.75 175.06 12.69 42.78 31.23 82.86 54.54 117.19q2.49 3.66 5.05 7.24 4.41 6.17 9 12c19.2 24.45 41.06 45.21 65.1 60.92a208.26 208.26 0 0043.69 21.8c41 14.68 85 15.29 125.52 0a175.76 175.76 0 0019.84-8.91q5.34-2.79 10.56-6c6.71-4.12 13.3-8.72 19.84-13.5 9.07-6.64 18-13.64 27.11-20.18l.78-.57c10.7-7.68 21.53-14.71 32.82-19.77a90.34 90.34 0 0123.66-7.17 83.47 83.47 0 0136.13 2.81c2.22.64 4.44 1.37 6.64 2.17a142.32 142.32 0 0120.72 9.61c28.84 16 56.44 41.51 84.76 61.51 4 2.86 8.11 5.61 12.19 8.2 36.13 22.93 75.87 34.11 115.19 44.95 44.58 12.3 91.76 24.24 134.89 5.09 25-11.09 46.65-32.12 64-58.24a258.6 258.6 0 0019.94-36.19q4.23-9.33 7.91-19c14.26-37.5 22.55-78.7 28.27-120 4.24-30.4 7.12-61.53 3.75-92.07z",
  fill: "#28629b",
  opacity: 0.1
});

var _ref2$4 = /*#__PURE__*/createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/createElement("path", {
  d: "M311.38 533.18c.31.89.63 1.75 1 2.59q9.89-7.75 19.16-16a18.55 18.55 0 008.7-8c1.78-1.68 3.55-3.4 5.3-5.11a26.05 26.05 0 00-2.43-2.39c-5.92-5.19-13.24-7.37-19.93-5.16s-11.26 8.32-12.93 16a34.44 34.44 0 001.13 18.07z",
  fill: "#3f3d56"
}), /*#__PURE__*/createElement("path", {
  d: "M300.4 499.96a34.46 34.46 0 009.83 15.15c5.92 5.17 13.23 7.36 19.93 5.14.46-.16.9-.33 1.36-.51a18.55 18.55 0 008.7-8 25.86 25.86 0 002.87-7.5 35.86 35.86 0 00-11-33.22c-5.93-5.19-13.24-7.37-19.93-5.16s-11.26 8.32-12.93 16a34.44 34.44 0 001.17 18.1z",
  fill: "#3f3d56"
}), /*#__PURE__*/createElement("ellipse", {
  cx: 414.71,
  cy: 510.2,
  rx: 21.87,
  ry: 28.63,
  transform: "rotate(-18.29 206.225 809.805)",
  fill: "#3f3d56"
}), /*#__PURE__*/createElement("ellipse", {
  cx: 403.73,
  cy: 476.99,
  rx: 21.87,
  ry: 28.63,
  transform: "rotate(-18.29 195.226 776.584)",
  fill: "#3f3d56"
}), /*#__PURE__*/createElement("ellipse", {
  cx: 392.75,
  cy: 443.77,
  rx: 21.87,
  ry: 28.63,
  transform: "rotate(-18.29 184.259 743.368)",
  fill: "#3f3d56"
}), /*#__PURE__*/createElement("path", {
  d: "M290.79 140.41a106.12 106.12 0 004-13.94l-57.52 9.08 59.15-19.07a105 105 0 00-24.16-79.43l-65.58 67.24 55.26-77.8a104.75 104.75 0 10-127.47 165.6 104.64 104.64 0 00-5.35 21.89l83 13.38-83.89-.38a104.8 104.8 0 0046.91 88.09 104.74 104.74 0 10156.33-51.69 104.74 104.74 0 00-40.65-123z",
  fill: "#28629b"
}), /*#__PURE__*/createElement("path", {
  d: "M133.47 260.66a104.32 104.32 0 0041.61 54.45 104.74 104.74 0 10156.39-51.73c7.71-21.33-201.66-13.93-198-2.72z",
  opacity: 0.1
}));

var _ref3$4 = /*#__PURE__*/createElement("path", {
  d: "M388.09 250.2c-2.49-5.08-3.42-10.81-4.32-16.43-5.28-33.18-10.22-69 4.12-99.07 2.26-4.73 5-9.33 9-12.56 4.28-3.45 9.59-5.09 14.55-7.33 14.4-6.48 26-18.11 38.66-27.76s27.94-17.7 43.45-15.24c8 1.27 15.4 5.27 23.16 7.78 21.92 7.1 47.22 2.47 66.91 14.78 7.11 4.45 12.91 10.8 18.61 17.08l25.43 28c6.89 7.58 13.91 15.35 18.08 24.85s5.05 21.21-.26 30.07c-2.67 4.47-6.89 8.34-7.35 13.59-.5 5.7 3.64 10.6 5.15 16.1 4 14.53-10.67 27-24.05 32.74-40.43 17.3-84.91 15.31-127.71 14.6-31.87-.55-85.05 16.18-103.43-21.2z",
  fill: "#3f3d56"
});

var _ref4$4 = /*#__PURE__*/createElement("path", {
  d: "M459.99 322.11c-2.81 6.71-8.85 11.45-14.82 15.62s-12.34 8.14-19.53 8.48c12.67 16.29 30 28.27 46.94 40 7.89 5.45 15.89 10.89 24.89 13.97 8.26 2.82 17.05 3.52 25.69 4.7 11 1.51 21.95 3.84 33 3.38 19.69-.82 38.52-10.75 51.58-25.51s20.54-34 22.56-53.63c-7-.11-13.46-4-19.11-8.24-6.91-5.17-13.39-11.15-17.85-18.54-4.83-8-7-17.28-9.2-26.37-23.31-.7-46.62-1.39-69.94-.94-8.49.16-17 .49-25.28 2.6-7.89 2-24.37 7.16-29.18 14.27-2.77 4.1 0 8.32 1 12.74 1.28 5.81 1.6 11.88-.75 17.47z",
  fill: "#be6f72"
});

var _ref5$4 = /*#__PURE__*/createElement("path", {
  d: "M459.99 322.11c-2.81 6.71-8.85 11.45-14.82 15.62s-12.34 8.14-19.53 8.48c12.67 16.29 30 28.27 46.94 40 7.89 5.45 15.89 10.89 24.89 13.97 8.26 2.82 17.05 3.52 25.69 4.7 11 1.51 21.95 3.84 33 3.38 19.69-.82 38.52-10.75 51.58-25.51s20.54-34 22.56-53.63c-7-.11-13.46-4-19.11-8.24-6.91-5.17-13.39-11.15-17.85-18.54-4.83-8-7-17.28-9.2-26.37-23.31-.7-46.62-1.39-69.94-.94-8.49.16-17 .49-25.28 2.6-7.89 2-24.37 7.16-29.18 14.27-2.77 4.1 0 8.32 1 12.74 1.28 5.81 1.6 11.88-.75 17.47z",
  opacity: 0.1
});

var _ref6$4 = /*#__PURE__*/createElement("path", {
  d: "M486.36 349.74c6.67 8.29 13.54 16.75 22.68 22.19 2.79 1.65 5.91 3 9.15 2.89 4.8-.2 8.77-3.62 12.29-6.9a675.29 675.29 0 0050-51.78c4.93-5.69 10-11.62 16.75-14.93a1016.62 1016.62 0 014.76 165.78 6 6 0 01-.7 3c-1.05 1.59-3.25 1.82-5.16 1.89-56.45 2.12-115.16 3.82-166.86-19 3.59-10.65 3-22.17 3.35-33.41.57-18.43 3.77-36.68 8.19-54.55 2.17-8.77 4.64-17.46 7.26-26.1 2.18-7.24 3.84-20 8.71-25.47 11.2 10 20.17 24.69 29.58 36.39z",
  fill: "#e3e8f4"
});

var _ref7$4 = /*#__PURE__*/createElement("path", {
  fill: "#3f3d56",
  d: "M511.99 376.54h7l18 30-19 47-23-46 17-31z"
});

var _ref8$4 = /*#__PURE__*/createElement("path", {
  d: "M511.36 423.94a84 84 0 01-13.18-31.54c-.7-3.62-1.17-7.31-2.45-10.77-1.9-5.13-5.48-9.43-8.71-13.86a122.9 122.9 0 01-22.45-55.72c-1.24-9.14-2.07-19.61-9.45-25.14-4.64-3.47-10.82-4-16.62-3.9a93.62 93.62 0 00-60.54 24.23 100 100 0 01-8.75 7.72 56.15 56.15 0 01-10 5.44c-8.86 4-18.12 7.32-27.77 8.33a30.44 30.44 0 00-7.32 1.21c-2.88 1-5.25 3.11-7.68 5a70.86 70.86 0 01-26.19 12.64 527.27 527.27 0 00-31 96.71c-1.81 8.25-3.43 16.56-5.9 24.64-3.41 11.2-8.43 21.88-11.78 33.1-13.32 44.65.67 93.29-8.3 139l481.06.66c-7.56-11.73-4.84-26.63-5.49-40.57-.61-12.84-3.87-25.39-6.13-38.05-3.78-21.17-4.75-42.75-5.14-64.25-.16-9.08-.17-18.46 3.34-26.83 6.59-15.71 23.69-24 39.88-29.33 7.74-2.54 15.88-4.86 22-10.29 6.27-5.61 9.53-13.85 11.53-22-10.91-21.5-25.09-42-43-58.13-6.73-6-13.92-11.63-19.6-18.65-3.46-4.29-6.33-9.07-10.15-13-9.56-9.93-24-13.67-37.76-14.22-4.25-.17-8.56-.09-12.68-1.15-11.82-3-19.35-14.55-30-20.53a35.3 35.3 0 00-24.37-3.74c-6 1.25-12.14 4.81-13.49 10.73-.75 3.33.17 6.77.52 10.16 1.08 10.43-3.25 20.65-8.49 29.73-18.83 32.41-49.62 57.7-63.94 92.37z",
  fill: "#28629b"
});

var _ref9$4 = /*#__PURE__*/createElement("path", {
  d: "M616.47 224.04a101 101 0 11-46.87-85.29 101 101 0 0146.87 85.29z",
  fill: "#be6f72"
});

var _ref10$4 = /*#__PURE__*/createElement("path", {
  d: "M957.47 675.82v-46.78H72.13q2.49 3.66 5.05 7.24a31.43 31.43 0 005.23 8.39 30.37 30.37 0 003.8 3.65c19.2 24.45 41.06 45.21 65.1 60.92a208.26 208.26 0 0043.69 21.8h734.64z",
  fill: "#3f3d56"
});

var _ref11$4 = /*#__PURE__*/createElement("path", {
  d: "M534.38 575.54c-13.57-1.08-27.68-4.46-40.46.22a58.64 58.64 0 00-12.31 6.72 221 221 0 00-37.9 32.18c-3.29 3.49-6.51 7.17-8.53 11.53-2.85 6.15-3.1 13.16-5 19.67-1.09 3.73-2.75 7.51-2.09 11.34s5.08 7.26 8.39 5.22a7.34 7.34 0 007.51 8.46 24.78 24.78 0 0014-4.93 4.74 4.74 0 005 4.23c8.67-.57 16.93-5 24.35-9.84 8.71-5.64 17.36-12.06 27.56-14a44.69 44.69 0 00-16.15 12.49c-1.67 2.05-3.23 4.45-1.39 7.62a8.89 8.89 0 004.78 3.77c11.42 4 23.83-2.62 31.45-11.8 3.07-3.71 5.78-8 10-10.25 6.79-3.65 15.16-1.09 22.8-2.15 8.48-1.16 15.61-6.69 23.4-10.26 10.37-4.74 21.93-6 33-8.82a6 6 0 003.48-1.8 6.21 6.21 0 00.85-3.84 286 286 0 00-3.09-40.92 14.25 14.25 0 00-1.95-6.18c-2.18-3.1-6.32-4-10.05-4.62-6-1-12.73-3.24-18.77-3.22-5.8 0-11.39 3.28-16.92 4.89a117.35 117.35 0 01-41.96 4.29z",
  fill: "#be6f72"
});

var _ref12$4 = /*#__PURE__*/createElement("path", {
  d: "M597.64 557.51a71 71 0 00-40.26 18c12.47-3.15 25.89-6.26 37.91-1.7a31.62 31.62 0 011.66 58.44c2.43 2.73 6 4.07 9.55 5.1 25.65 7.48 53.11 3 79.34-2.1 4.8-.93 10-2.16 12.93-6.11 2.61-3.57 2.53-8.38 2.3-12.81-.67-12.79-1.78-26-7.58-37.39-7.86-15.46-21.51-21.22-37.95-19.43-19.34 2.06-38.54-3.96-57.9-2z",
  fill: "#e3e8f4"
});

var _ref13$4 = /*#__PURE__*/createElement("path", {
  d: "M760.84 393.66c8.29 7.89 14.27 17.85 19.76 27.89a462.25 462.25 0 0142.42 107.74c.94 3.69 1.87 7.48 4.07 10.59 3.2 4.51 8.63 7 12.12 11.26 4.19 5.18 5 12.48 3.62 19s-4.67 12.47-8 18.24c-9.11 15.78-19.86 32.07-36.59 39.28-7 3-14.65 4.24-22.22 5.23a436.14 436.14 0 01-85.78 2.77c5-5.8 5.48-14.36 3.71-21.81s-5.46-14.28-8-21.49c-2-5.63-3.41-11.63-6.92-16.47a33.57 33.57 0 00-9.4-8.27 68.07 68.07 0 00-27.16-9.96c7.17-5.6 16.46-7.46 25.2-10s17.88-6.44 22.46-14.3c2.75-4.71 3.51-10.3 3.88-15.74a133.44 133.44 0 00-5.64-48.48c-3.22-10.43-7.78-21.33-5-31.87 1.42-5.32 4.61-10 7.74-14.48 6.1-8.8 12.42-17.81 21.32-23.75 7.68-5.13 16.81-7.54 25.95-8.18 6.85-.45 17.26-2.11 22.46 2.8z",
  fill: "#28629b"
});

var _ref14$4 = /*#__PURE__*/createElement("path", {
  d: "M400.99 700.16c-.08 10.44-28.47 22-61.32 22s-60.27-11.53-60.71-22c-1.53-36.31 27.85-15.87 60.71-15.87s61.62-25.93 61.32 15.87z",
  fill: "#3f3d56"
});

var _ref15$4 = /*#__PURE__*/createElement("path", {
  d: "M400.99 700.16c-.08 10.44-28.47 22-61.32 22s-60.27-11.53-60.71-22c-1.53-36.31 27.85-15.87 60.71-15.87s61.62-25.93 61.32 15.87z",
  opacity: 0.2
});

var _ref16$4 = /*#__PURE__*/createElement("path", {
  d: "M399.16 684.29c0 10.45-26.64 22-59.49 22s-59.49-11.52-59.49-22 26.63-15.86 59.49-15.86 59.49 5.42 59.49 15.86z",
  fill: "#3f3d56"
});

var _ref17$4 = /*#__PURE__*/createElement("path", {
  d: "M399.16 684.29c0 10.45-26.64 22-59.49 22s-59.49-11.52-59.49-22 26.63-15.86 59.49-15.86 59.49 5.42 59.49 15.86z",
  fill: "#fff",
  opacity: 0.1
});

var _ref18$4 = /*#__PURE__*/createElement("path", {
  d: "M387.56 680.17c-.06 8.15-22.2 17.13-47.83 17.13s-47-9-47.36-17.13c-1.19-28.32 21.73-12.38 47.36-12.38s48.07-20.22 47.83 12.38z",
  fill: "#3f3d56"
});

var _ref19$4 = /*#__PURE__*/createElement("path", {
  d: "M387.56 680.17c-.06 8.15-22.2 17.13-47.83 17.13s-47-9-47.36-17.13c-1.19-28.32 21.73-12.38 47.36-12.38s48.07-20.22 47.83 12.38z",
  opacity: 0.2
});

var _ref20$4 = /*#__PURE__*/createElement("path", {
  d: "M386.13 665.78c0 9.11-20.77 19.15-46.4 19.15s-46.41-10-46.41-19.15 20.78-13.82 46.41-13.82 46.4 4.7 46.4 13.82z",
  fill: "#3f3d56"
});

var _ref21$4 = /*#__PURE__*/createElement("path", {
  d: "M386.13 665.78c0 9.11-20.77 19.15-46.4 19.15s-46.41-10-46.41-19.15 20.78-13.82 46.41-13.82 46.4 4.7 46.4 13.82z",
  fill: "#fff",
  opacity: 0.1
});

var _ref22$4 = /*#__PURE__*/createElement("path", {
  d: "M228.52 726.18s8.78-9.68 10.29-20.56-42.9-27.59-42.9-27.59-15.4 9-15.92 17.43c0 0 29.48 31.68 48.53 30.72z",
  fill: "#3f3d56"
});

var _ref23$4 = /*#__PURE__*/createElement("path", {
  d: "M228.52 726.18s8.78-9.68 10.29-20.56-42.9-27.59-42.9-27.59-15.4 9-15.92 17.43c0 0 29.48 31.68 48.53 30.72z",
  opacity: 0.2
});

var _ref24$4 = /*#__PURE__*/createElement("ellipse", {
  cx: 307.98,
  cy: 762.13,
  rx: 9.66,
  ry: 28.78,
  transform: "rotate(-59.03 211.268 829.3)",
  fill: "#3f3d56"
});

var _ref25$4 = /*#__PURE__*/createElement("ellipse", {
  cx: 307.98,
  cy: 762.13,
  rx: 9.66,
  ry: 28.78,
  transform: "rotate(-59.03 211.268 829.3)",
  fill: "#fff",
  opacity: 0.1
});

var _ref26$4 = /*#__PURE__*/createElement("path", {
  fill: "#3f3d56",
  d: "M239.43 702.29l25.26-42.11L239 638.36l-20.03-3.75-6.25 11.27-17.58 32.62 44.29 23.79z"
});

var _ref27$4 = /*#__PURE__*/createElement("path", {
  fill: "#fff",
  opacity: 0.1,
  d: "M239.43 702.29l25.26-42.11L239 638.36l-20.03-3.75-6.25 11.27-17.58 32.62 44.29 23.79z"
});

var _ref28$4 = /*#__PURE__*/createElement("path", {
  d: "M265.03 664.33s17.06-18.13 12.68-27.93-27.51-29.44-42.24-26.45-17.09 24.71-17.09 24.71z",
  fill: "#3f3d56"
});

var _ref29$4 = /*#__PURE__*/createElement("path", {
  d: "M265.03 664.33s17.06-18.13 12.68-27.93-27.51-29.44-42.24-26.45-17.09 24.71-17.09 24.71z",
  opacity: 0.2
});

var _ref30$4 = /*#__PURE__*/createElement("path", {
  d: "M70.98 584.66l130.67 79.48s12.42-1.61 11.07-18.24L83.3 565.56a13.39 13.39 0 00-8.83-1.9c-3.54.48-7.73 1.77-9.09 5.14a11.39 11.39 0 00-.72 2.67 13.19 13.19 0 006.32 13.19z",
  fill: "#3f3d56"
});

var _ref31$4 = /*#__PURE__*/createElement("path", {
  d: "M70.98 584.66l130.67 79.48s12.42-1.61 11.07-18.24L83.3 565.56a13.39 13.39 0 00-8.83-1.9c-3.54.48-7.73 1.77-9.09 5.14a11.39 11.39 0 00-.72 2.67 13.19 13.19 0 006.32 13.19z",
  opacity: 0.2
});

var _ref32$4 = /*#__PURE__*/createElement("path", {
  d: "M239.41 708.22a3.21 3.21 0 002.93-2.42c.64-2.25-.53-4.41-1.76-6.21a33.36 33.36 0 00-8.1-8.28c-5.32-3.85-10.48-8.19-16.5-11a50.41 50.41 0 00-10.88-3.43 37 37 0 00-8.56-.94 2.52 2.52 0 00-1.55 4.45 12.71 12.71 0 004.38 1.84c7.79 2.29 15 6.26 21.75 10.77a68.29 68.29 0 0110.17 8c2.08 2.06 4.74 7.3 8.12 7.22z",
  fill: "#3f3d56"
});

var _ref33$4 = /*#__PURE__*/createElement("path", {
  d: "M239.41 708.22a3.21 3.21 0 002.93-2.42c.64-2.25-.53-4.41-1.76-6.21a33.36 33.36 0 00-8.1-8.28c-5.32-3.85-10.48-8.19-16.5-11a50.41 50.41 0 00-10.88-3.43 37 37 0 00-8.56-.94 2.52 2.52 0 00-1.55 4.45 12.71 12.71 0 004.38 1.84c7.79 2.29 15 6.26 21.75 10.77a68.29 68.29 0 0110.17 8c2.08 2.06 4.74 7.3 8.12 7.22z",
  opacity: 0.2
});

var _ref34$4 = /*#__PURE__*/createElement("path", {
  d: "M260.27 667.55s12.82.31 2.21-12.58-29.59-25.68-43.1-22.79c0 0-5.6 4.64-.76 5.44 4.59.76 26 5 35.84 16.93a25.55 25.55 0 003.59 3.54c2.31 1.88 5.42 5.44 2.22 9.46z",
  fill: "#3f3d56"
});

var _ref35$4 = /*#__PURE__*/createElement("path", {
  d: "M260.27 667.55s12.82.31 2.21-12.58-29.59-25.68-43.1-22.79c0 0-5.6 4.64-.76 5.44 4.59.76 26 5 35.84 16.93a25.55 25.55 0 003.59 3.54c2.31 1.88 5.42 5.44 2.22 9.46z",
  opacity: 0.2
});

var _ref36$4 = /*#__PURE__*/createElement("ellipse", {
  cx: 361.03,
  cy: 674.65,
  rx: 9.66,
  ry: 28.78,
  transform: "rotate(-59.03 264.324 741.822)",
  fill: "#3f3d56"
});

var _ref37$4 = /*#__PURE__*/createElement("ellipse", {
  cx: 361.03,
  cy: 674.65,
  rx: 9.66,
  ry: 28.78,
  transform: "rotate(-59.03 264.324 741.822)",
  fill: "#fff",
  opacity: 0.1
});

var _ref38$4 = /*#__PURE__*/createElement("path", {
  d: "M196.54 635.84a14.3 14.3 0 01-7.14 11.34c-6.71 3.58-16.13.39-19.29-6.53-1.64-3.6-1.67-7.64-2-11.61a38.09 38.09 0 00-.52-3.86c-1-5.15-5.26-10.62-10.41-9.6-4.25.83-6.49 5.6-7 9.9a32.53 32.53 0 00-.2 3.56c0 1.24.05 2.48.12 3.72.14 2.54.36 5.09.35 7.63 0 5-1.08 10.31-4.69 13.74-4.38 4.17-11.1 4.36-17.16 4.29-14.79-.15-31.25-1-42.38-10.1a30.37 30.37 0 01-3.8-3.65 31.43 31.43 0 01-5.23-8.39 38.8 38.8 0 01-2.27-7.24c-1.66-7.75-1.29-16.2.07-24.06.88-5.14 2.58-10.77 6.34-14.05a11.41 11.41 0 013-1.89c1.8-.76 3.84-1 5.41-2.19s2.59-3.35 4.25-4.65c3.33-2.61 8.39-1.49 12.29-2.37h.17l.21-.06c4.21-1 8.1-3.3 12.07-5 1.71-.73 3.42-1.43 5.14-2.05a29.56 29.56 0 0113.5-2c15 1.71 33 10.81 43.27 21.73a25.27 25.27 0 015.78 8.86 32.82 32.82 0 011.38 8.59c.27 4.11.49 8.21 2.53 11.72 1.24 2.12 3.06 3.85 4.35 6a11.36 11.36 0 01.78 1.51 13.73 13.73 0 011.08 6.71z",
  fill: "#be6f72"
});

var _ref39$4 = /*#__PURE__*/createElement("path", {
  d: "M163.55 586.48c6.11 3.16 12.12 6.73 16.92 11.65s8.34 11.37 8.62 18.25a86.25 86.25 0 0010.73-16.51c2.32-4.65 4.23-10.15 2.17-14.93a16.64 16.64 0 00-4.07-5.3c-9-8.52-21.1-13.23-33.34-15.16-13.23-2.09-39.66-6.65-41.69 12.61 14.82-.7 27.42 2.57 40.66 9.39z",
  fill: "#e3e8f4"
});

var _ref40$4 = /*#__PURE__*/createElement("path", {
  d: "M327.47 340.22c-9.79 4.23-21.25 1.24-31.6 3.8-7.64 1.89-14.21 6.68-20.41 11.53-12.36 9.66-24.54 20.46-31.15 34.69-2.16 4.66-3.7 9.61-6.29 14-4.19 7.16-10.88 12.49-17.85 17-17.81 11.48-38.49 18.66-54.34 32.72-6.78 6-12.49 13.12-17.8 20.45-6.24 8.6-12.21 18.2-12.33 28.82 0 4.16.82 8.38 0 12.47-1.76 9.15-11 14.83-15.17 23.17-4 7.95-3.05 17.77-7.5 25.45-2.92 5-8.21 10-6.54 15.52 12.26-9.21 27-13 42-10 7.51 1.49 14.52 4.84 21.24 8.51 7.79 4.26 15.47 9.1 21.1 16s9 16.08 7 24.73c8.11-4 12.91-12.54 16.24-20.94s5.87-17.37 11.4-24.48c2.85-3.67 6.39-6.72 9.76-9.91 18.71-17.73 32.2-40.13 45.44-62.24q20.48-34.18 40.94-68.4c3.78-6.33 7.58-12.7 10.31-19.54 9.17-23 3.23-49.86-4.45-73.35z",
  fill: "#28629b"
});

var _ref41$4 = /*#__PURE__*/createElement("ellipse", {
  cx: 898.7,
  cy: 634.73,
  rx: 57.01,
  ry: 10.96,
  fill: "#28629b"
});

var _ref42$4 = /*#__PURE__*/createElement("ellipse", {
  cx: 897.74,
  cy: 630.08,
  rx: 6.64,
  ry: 8.69,
  fill: "#3f3d56"
});

var _ref43$4 = /*#__PURE__*/createElement("ellipse", {
  cx: 897.74,
  cy: 619.45,
  rx: 6.64,
  ry: 8.69,
  fill: "#3f3d56"
});

var _ref44$3 = /*#__PURE__*/createElement("ellipse", {
  cx: 897.74,
  cy: 608.83,
  rx: 6.64,
  ry: 8.69,
  fill: "#3f3d56"
});

var _ref45$3 = /*#__PURE__*/createElement("ellipse", {
  cx: 897.74,
  cy: 598.21,
  rx: 6.64,
  ry: 8.69,
  fill: "#3f3d56"
});

var _ref46$3 = /*#__PURE__*/createElement("ellipse", {
  cx: 897.74,
  cy: 587.59,
  rx: 6.64,
  ry: 8.69,
  fill: "#3f3d56"
});

var _ref47$3 = /*#__PURE__*/createElement("ellipse", {
  cx: 897.74,
  cy: 576.97,
  rx: 6.64,
  ry: 8.69,
  fill: "#3f3d56"
});

var _ref48$3 = /*#__PURE__*/createElement("ellipse", {
  cx: 897.74,
  cy: 566.35,
  rx: 6.64,
  ry: 8.69,
  fill: "#3f3d56"
});

var _ref49$3 = /*#__PURE__*/createElement("path", {
  d: "M922.6 493.66a32.2 32.2 0 002.47-3.63l-17.44-2.87 18.86.14a31.86 31.86 0 00.61-25.19l-25.31 13.13 23.34-17.16a31.8 31.8 0 10-52.52 35.58 32.4 32.4 0 00-3.62 5.8l22.64 11.77-24.16-8.11a31.82 31.82 0 005.12 29.86 31.8 31.8 0 1050 0 31.82 31.82 0 000-39.32z",
  fill: "#28629b"
});

var _ref50$3 = /*#__PURE__*/createElement("path", {
  d: "M865.81 513.32a31.67 31.67 0 006.8 19.66 31.8 31.8 0 1050 0c4.25-5.41-56.8-23.23-56.8-19.66z",
  opacity: 0.1
});

var _ref51$2 = /*#__PURE__*/createElement("path", {
  d: "M465.47 179.94c7 2.7 13.83 6.58 21.34 7.09 9.53.64 18.53-4.22 28-5.56 17.35-2.45 33.82 7 50.12 13.42s37.3 9.08 49.25-3.73c10.15-10.89 8.75-29 .59-41.4s-21.49-20.42-34.67-27.33c-14.54-7.62-29.7-14.55-45.89-17.24-34.36-5.69-69.27 8.52-97.78 28.53-9.46 6.64-18.81 14.39-23.33 25-2.56 6-3.36 13.68-1.13 19.93 3.66 10.28 6.06 9.06 13.65 6.38 14.5-5.1 23.07-11.51 39.85-5.09z",
  fill: "#3f3d56"
});

function SvgSentenceInput(props) {
  return /*#__PURE__*/createElement("svg", _extends$5({
    "data-name": "Layer 1",
    viewBox: "0 0 990.93 799.33"
  }, props), _ref$4, _ref2$4, _ref3$4, _ref4$4, _ref5$4, _ref6$4, _ref7$4, _ref8$4, _ref9$4, _ref10$4, _ref11$4, _ref12$4, _ref13$4, _ref14$4, _ref15$4, _ref16$4, _ref17$4, _ref18$4, _ref19$4, _ref20$4, _ref21$4, _ref22$4, _ref23$4, _ref24$4, _ref25$4, _ref26$4, _ref27$4, _ref28$4, _ref29$4, _ref30$4, _ref31$4, _ref32$4, _ref33$4, _ref34$4, _ref35$4, _ref36$4, _ref37$4, _ref38$4, _ref39$4, _ref40$4, _ref41$4, _ref42$4, _ref43$4, _ref44$3, _ref45$3, _ref46$3, _ref47$3, _ref48$3, _ref49$3, _ref50$3, _ref51$2);
}

function _templateObject2$4() {
  var data = _taggedTemplateLiteral(["\n      query Sentences {\n        viewer {\n          sentences {\n            id\n            name\n          }\n        }\n      }\n    "]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$5() {
  var data = _taggedTemplateLiteral(["\n    mutation($sentence: NewSentenceInput) {\n      sentence: addSentence(sentence: $sentence) {\n        name\n        id\n      }\n    }\n  "]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}
var useCreate$4 = function useCreate() {
  var _useMutation = useMutation(gql(_templateObject$5())),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      mutate = _useMutation2[0],
      meta = _useMutation2[1];

  var create = function create(sentence) {
    return mutate({
      variables: {
        sentence: sentence
      }
    });
  };

  return [create, meta];
};

var useOptions$3 = function useOptions() {
  var _meta$data, _meta$data$viewer;

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    fetchPolicy: "cache-and-network"
  };

  var _useLazyQuery = useLazyQuery(gql(_templateObject2$4()), options),
      _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
      query = _useLazyQuery2[0],
      meta = _useLazyQuery2[1];

  var getOptions = function getOptions() {
    var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var requestOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return query(_objectSpread2({
      variables: form
    }, requestOptions));
  }; // Cleaned data for easier consumption


  var data = {
    options: (meta === null || meta === void 0 ? void 0 : (_meta$data = meta.data) === null || _meta$data === void 0 ? void 0 : (_meta$data$viewer = _meta$data.viewer) === null || _meta$data$viewer === void 0 ? void 0 : _meta$data$viewer.sentences) || []
  };
  return [getOptions, _objectSpread2(_objectSpread2({}, meta), {}, {
    data: data
  })];
};
/**
 * Custom input for selecting an instance of a Sentence.
 */


var SentenceInput = function SentenceInput(_ref) {
  var name = _ref.name,
      label = _ref.label,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? false : _ref$multiple,
      defaultValue = _ref.defaultValue,
      props = _objectWithoutProperties(_ref, ["name", "label", "multiple", "defaultValue"]);

  var _useOptions = useOptions$3(),
      _useOptions2 = _slicedToArray(_useOptions, 2),
      getOptions = _useOptions2[0],
      _useOptions2$ = _useOptions2[1],
      data = _useOptions2$.data,
      refetch = _useOptions2$.refetch;

  var _useCreate = useCreate$4(),
      _useCreate2 = _slicedToArray(_useCreate, 2),
      create = _useCreate2[0],
      createMeta = _useCreate2[1];

  var createModal = useModal();

  var createInstance = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(form) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return create(form);

            case 3:
              createModal.close();
              refetch();
              Toasts.success("New sentence created");
              _context.next = 10;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));

    return function createInstance(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(AssociationInput, _extends({}, props, {
    name: name,
    label: label,
    multiple: multiple,
    options: data.options,
    defaultValue: defaultValue,
    onFocus: function onFocus() {
      getOptions();
    },
    renderSelectionItem: function renderSelectionItem(sentence) {
      return /*#__PURE__*/React.createElement("p", {
        className: "has-text-weight-semibold"
      }, sentence.name);
    },
    renderSelectedItem: function renderSelectedItem(sentence) {
      return /*#__PURE__*/React.createElement("p", {
        className: "has-text-weight-semibold"
      }, sentence.name);
    },
    placeholderComponent: SvgSentenceInput,
    placeholderMessage: "No sentences to select from"
  }), /*#__PURE__*/React.createElement(Level, null, /*#__PURE__*/React.createElement(Level.Left, null, /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement("span", {
    className: "is-size-5"
  }, "Sentences"))), /*#__PURE__*/React.createElement(Level.Right, null, /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement(Button, _extends({
    type: "button",
    color: "success",
    size: "small"
  }, createModal.triggerProps), /*#__PURE__*/React.createElement(Icon, {
    name: "plus"
  }), " ", /*#__PURE__*/React.createElement("span", null, "Add")), /*#__PURE__*/React.createElement(Modal, _extends({}, createModal.modalProps, {
    title: "New Sentence"
  }), /*#__PURE__*/React.createElement(Modal.Content, null, createModal.active && /*#__PURE__*/React.createElement(Form, {
    onSubmit: createInstance,
    error: createMeta.error,
    loading: createMeta.loading
  }, /*#__PURE__*/React.createElement(Form.Input, {
    name: "name",
    label: "Name",
    type: "text",
    required: true
  }), /*#__PURE__*/React.createElement(Level, {
    mobile: true
  }, /*#__PURE__*/React.createElement(Level.Right, null, /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement(Form.SubmitButton, {
    color: "success"
  }, "Create Sentence")))))))))));
};
SentenceInput.propTypes = {
  /** Display label for the input */
  label: PropTypes.string.isRequired,

  /** Form input name */
  name: PropTypes.string.isRequired,

  /** Default input value */
  defaultValue: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),

  /** Multiple counsels may be selected */
  multiple: PropTypes.bool
};

function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

var _ref$5 = /*#__PURE__*/createElement("path", {
  d: "M612.046 424.273L502.71 367.902a7.007 7.007 0 01-3.014-9.43l6.764-13.118a7.008 7.008 0 019.43-3.014l109.336 56.372a7.007 7.007 0 013.014 9.429l-6.763 13.118a6.952 6.952 0 01-4.092 3.457 7.034 7.034 0 01-2.143.337 6.956 6.956 0 01-3.195-.78z",
  fill: "#28629b"
});

var _ref2$5 = /*#__PURE__*/createElement("path", {
  d: "M578.712 371.54a6.966 6.966 0 015.394.14l35.831 19.813a17.47 17.47 0 017.253 22.951l-.448-.218.449.219a17.484 17.484 0 01-21.477 8.842l-38.859-13.582a7 7 0 01-3.573-9.237l11.554-25.231a7.037 7.037 0 01.743-1.294 6.958 6.958 0 013.133-2.403z",
  fill: "#2f2e41"
});

var _ref3$5 = /*#__PURE__*/createElement("circle", {
  cx: 661.155,
  cy: 311.968,
  r: 53.519,
  fill: "#28629b"
});

var _ref4$5 = /*#__PURE__*/createElement("path", {
  d: "M654.588 644.814V521.8a7.008 7.008 0 017-7h14.759a7.008 7.008 0 017 7v123.014a7.008 7.008 0 01-7 7h-14.76a7.008 7.008 0 01-7-7zM622.588 644.814V521.8a7.008 7.008 0 017-7h14.759a7.008 7.008 0 017 7v123.014a7.008 7.008 0 01-7 7h-14.76a7.008 7.008 0 01-7-7z",
  fill: "#28629b"
});

var _ref5$5 = /*#__PURE__*/createElement("path", {
  d: "M662.28 331.804l.055-2c-3.72-.104-7.001-.337-9.466-2.138a6.148 6.148 0 01-2.381-4.528 3.514 3.514 0 011.153-2.895c1.636-1.382 4.269-.934 6.188-.054l1.654.758-3.173-23.19-1.981.271 2.699 19.727c-2.608-.767-5.024-.437-6.678.961a5.471 5.471 0 00-1.86 4.492 8.133 8.133 0 003.2 6.073c3.166 2.315 7.282 2.43 10.59 2.523zM633.758 299.73h10.771v2h-10.771zM667.758 299.73h10.771v2h-10.771z",
  fill: "#2f2e41"
});

var _ref6$5 = /*#__PURE__*/createElement("path", {
  d: "M712.37 542.155l-18.511-121.613a7.007 7.007 0 015.867-7.973l14.59-2.221a7.008 7.008 0 017.974 5.867l18.51 121.613a7.008 7.008 0 01-5.866 7.973l-14.591 2.221a6.994 6.994 0 01-7.974-5.867z",
  fill: "#28629b"
});

var _ref7$5 = /*#__PURE__*/createElement("path", {
  d: "M698.064 464.098a6.966 6.966 0 01-3.056-4.448l-5.019-40.635a17.47 17.47 0 0114.311-19.354l.087.492-.087-.492a17.484 17.484 0 0119.773 12.184l11.84 39.425a7 7 0 01-5.375 8.318l-27.205 5.474a7.037 7.037 0 01-1.484.16 6.958 6.958 0 01-3.785-1.124z",
  fill: "#2f2e41"
});

var _ref8$5 = /*#__PURE__*/createElement("path", {
  d: "M699.5 552H556.477a8.5 8.5 0 01-7.594-12.319l69.15-137.512A47.516 47.516 0 01708 423.516V543.5a8.51 8.51 0 01-8.5 8.5zM663.051 267.813c-10.956 2.447-20.197 9.587-31.212 11.808-5.02 1.011-10.548.97-15.159-1.501a15.8 15.8 0 01-7.334-8.56 23.62 23.62 0 013.767-22.34c6.184-7.57 16.043-11.058 25.502-12.041 18.93-1.968 38.375 4.27 53.783 15.137 15.909 11.22 28.113 28.067 32.207 47.241 2.189 10.25 1.973 21.153-1.764 31.023a39.528 39.528 0 01-19.768 21.544 38.796 38.796 0 01-6.766 2.52 1.501 1.501 0 00.797 2.893 42.73 42.73 0 0024.768-18.24c5.86-9.374 7.827-20.851 6.924-31.759-1.746-21.099-13.349-40.492-29.569-53.768-15.582-12.754-35.74-20.514-56.007-19.898-10.164.31-20.715 2.89-28.62 9.588a26.919 26.919 0 00-9.34 23.787 21.57 21.57 0 004.735 11.294 19.518 19.518 0 0012.528 6.47c11.984 1.56 22.376-5.233 32.966-9.6a51.263 51.263 0 018.36-2.705c1.883-.42 1.086-3.313-.798-2.893z",
  fill: "#2f2e41"
});

var _ref9$5 = /*#__PURE__*/createElement("path", {
  d: "M693.152 246.612c-4.302-16.108 6.927-32.872 22.184-37.902a43.585 43.585 0 0126.84.3 52.942 52.942 0 0122.119 14.44c13.374 14.228 19.299 33.432 22.07 52.366 2.863 19.549 1.248 40.96 11.251 58.725 4.147 7.365 10.303 13.814 18.257 16.986 7.42 2.958 16.31 2.972 23.419-.873a22.458 22.458 0 004.705-3.437c1.408-1.328-.717-3.447-2.12-2.122-5.954 5.617-14.826 6.677-22.477 4.473-8.346-2.405-14.769-8.818-19.002-16.204-4.895-8.54-6.933-18.303-8.045-27.989-1.213-10.573-1.68-21.204-3.301-31.735-2.923-18.993-9.238-38.058-22.636-52.311a56.363 56.363 0 00-22.275-14.821 47.224 47.224 0 00-27.278-1.377 37.203 37.203 0 00-20.506 13.79 34.68 34.68 0 00-7.073 22.535 30.616 30.616 0 00.976 5.953 1.501 1.501 0 002.892-.798z",
  fill: "#2f2e41"
});

var _ref10$5 = /*#__PURE__*/createElement("path", {
  d: "M104.26 383H17a17.02 17.02 0 01-17-17V17A17.02 17.02 0 0117 0h236.68L297 38.678V109h-2V39.574L252.918 2H17A15.017 15.017 0 002 17v349a15.017 15.017 0 0015 15h87.26z",
  fill: "#ccc"
});

var _ref11$5 = /*#__PURE__*/createElement("path", {
  d: "M296 40h-27a17.02 17.02 0 01-17-17V1a1 1 0 112 0v22a15.017 15.017 0 0015 15h27a1 1 0 010 2z",
  fill: "#ccc"
});

var _ref12$5 = /*#__PURE__*/createElement("path", {
  d: "M262.54 90.5h-228a8 8 0 000 16h228a8 8 0 000-16zM147.54 56.5h-113a8 8 0 000 16h113a8 8 0 000-16zM34.54 157.5a8 8 0 000 16H106v-16zM34.54 123.5a8 8 0 100 16H106v-16zM106.5 327H42.46a16.519 16.519 0 01-16.5-16.5v-84a16.519 16.519 0 0116.5-16.5h64.04z",
  fill: "#e6e6e6"
});

var _ref13$5 = /*#__PURE__*/createElement("path", {
  d: "M209.76 490.5H122.5a17.02 17.02 0 01-17-17v-349a17.02 17.02 0 0117-17h236.68l43.32 38.678V212.5h-2v-65.426L358.418 109.5H122.5a15.017 15.017 0 00-15 15v349a15.017 15.017 0 0015 15h87.26z",
  fill: "#ccc"
});

var _ref14$5 = /*#__PURE__*/createElement("path", {
  d: "M401.5 147.5h-27a17.02 17.02 0 01-17-17v-22a1 1 0 112 0v22a15.017 15.017 0 0015 15h27a1 1 0 010 2z",
  fill: "#ccc"
});

var _ref15$5 = /*#__PURE__*/createElement("path", {
  d: "M368.04 198h-228a8 8 0 000 16h228a8 8 0 000-16zM253.04 164h-113a8 8 0 000 16h113a8 8 0 000-16z",
  fill: "#e6e6e6"
});

var _ref16$5 = /*#__PURE__*/createElement("path", {
  d: "M368.04 198h-228a8 8 0 000 16h228a8 8 0 000-16zM253.04 164h-113a8 8 0 000 16h113a8 8 0 000-16zM140.04 265a8 8 0 000 16h71.46v-16zM140.04 231a8 8 0 000 16h71.46v-16z",
  fill: "#e6e6e6"
});

var _ref17$5 = /*#__PURE__*/createElement("path", {
  d: "M140.04 265a8 8 0 000 16h71.46v-16zM140.04 231a8 8 0 000 16h71.46v-16zM212 434.5h-64.04a16.519 16.519 0 01-16.5-16.5v-84a16.519 16.519 0 0116.5-16.5H212z",
  fill: "#e6e6e6"
});

var _ref18$5 = /*#__PURE__*/createElement("path", {
  d: "M217.64 216a16.994 16.994 0 00-8.14 14.5v2.5h2v-2.5a15.027 15.027 0 0111.15-14.5zm245.54-2.5H226.5a17.02 17.02 0 00-17 17v349a17.024 17.024 0 0017 17h263a17.024 17.024 0 0017-17V252.18zm41.32 366a15.018 15.018 0 01-15 15h-263a15.018 15.018 0 01-15-15v-349a15.027 15.027 0 0111.15-14.5 14.833 14.833 0 013.85-.5h235.92l42.08 37.57zM217.64 216a16.994 16.994 0 00-8.14 14.5v2.5h2v-2.5a15.027 15.027 0 0111.15-14.5z",
  fill: "#3f3d56"
});

var _ref19$5 = /*#__PURE__*/createElement("path", {
  d: "M505.5 253.5h-27a17.02 17.02 0 01-17-17v-22a1 1 0 012 0v22a15.017 15.017 0 0015 15h27a1 1 0 010 2z",
  fill: "#3f3d56"
});

var _ref20$5 = /*#__PURE__*/createElement("path", {
  d: "M472.041 320h-228a8 8 0 110-16h228a8 8 0 010 16zM357.041 286h-113a8 8 0 110-16h113a8 8 0 010 16zM472.041 387h-228a8 8 0 110-16h228a8 8 0 010 16zM357.041 353h-113a8 8 0 110-16h113a8 8 0 010 16z",
  fill: "#ccc"
});

var _ref21$5 = /*#__PURE__*/createElement("path", {
  d: "M463.959 540.5h-212a16.519 16.519 0 01-16.5-16.5v-84a16.519 16.519 0 0116.5-16.5h212a16.519 16.519 0 0116.5 16.5v84a16.519 16.519 0 01-16.5 16.5z",
  fill: "#28629b"
});

function SvgChargeInput(props) {
  return /*#__PURE__*/createElement("svg", _extends$6({
    "data-name": "Layer 1",
    viewBox: "0 0 844.46 651.814"
  }, props), _ref$5, _ref2$5, _ref3$5, _ref4$5, _ref5$5, _ref6$5, _ref7$5, _ref8$5, _ref9$5, _ref10$5, _ref11$5, _ref12$5, _ref13$5, _ref14$5, _ref15$5, _ref16$5, _ref17$5, _ref18$5, _ref19$5, _ref20$5, _ref21$5);
}

function _templateObject2$5() {
  var data = _taggedTemplateLiteral(["\n      query Charges {\n        viewer {\n          charges {\n            id\n            name\n          }\n        }\n      }\n    "]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$6() {
  var data = _taggedTemplateLiteral(["\n    mutation($charge: NewChargeInput) {\n      charge: addCharge(charge: $charge) {\n        name\n        id\n      }\n    }\n  "]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}
var useCreate$5 = function useCreate() {
  var _useMutation = useMutation(gql(_templateObject$6())),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      mutate = _useMutation2[0],
      meta = _useMutation2[1];

  var create = function create(charge) {
    return mutate({
      variables: {
        charge: charge
      }
    });
  };

  return [create, meta];
};

var useOptions$4 = function useOptions() {
  var _meta$data, _meta$data$viewer;

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    fetchPolicy: "cache-and-network"
  };

  var _useLazyQuery = useLazyQuery(gql(_templateObject2$5()), options),
      _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
      query = _useLazyQuery2[0],
      meta = _useLazyQuery2[1];

  var getOptions = function getOptions() {
    var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var requestOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return query(_objectSpread2({
      variables: form
    }, requestOptions));
  }; // Cleaned data for easier consumption


  var data = {
    options: (meta === null || meta === void 0 ? void 0 : (_meta$data = meta.data) === null || _meta$data === void 0 ? void 0 : (_meta$data$viewer = _meta$data.viewer) === null || _meta$data$viewer === void 0 ? void 0 : _meta$data$viewer.charges) || []
  };
  return [getOptions, _objectSpread2(_objectSpread2({}, meta), {}, {
    data: data
  })];
};
/**
 * Custom input for selecting an instance of a criminal Charge.
 */


var ChargeInput = function ChargeInput(_ref) {
  var name = _ref.name,
      label = _ref.label,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? false : _ref$multiple,
      defaultValue = _ref.defaultValue,
      props = _objectWithoutProperties(_ref, ["name", "label", "multiple", "defaultValue"]);

  var _useOptions = useOptions$4(),
      _useOptions2 = _slicedToArray(_useOptions, 2),
      getOptions = _useOptions2[0],
      _useOptions2$ = _useOptions2[1],
      data = _useOptions2$.data,
      refetch = _useOptions2$.refetch;

  var _useCreate = useCreate$5(),
      _useCreate2 = _slicedToArray(_useCreate, 2),
      create = _useCreate2[0],
      createMeta = _useCreate2[1];

  var createModal = useModal();

  var createCharge = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(form) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return create(form);

            case 3:
              createModal.close();
              refetch();
              Toasts.success("New charge created");
              _context.next = 10;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));

    return function createCharge(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(AssociationInput, _extends({}, props, {
    name: name,
    label: label,
    multiple: multiple,
    options: data.options,
    onFocus: function onFocus() {
      getOptions();
    },
    defaultValue: defaultValue,
    renderSelectionItem: function renderSelectionItem(charge) {
      return /*#__PURE__*/React.createElement("p", {
        className: "has-text-weight-semibold"
      }, charge.name);
    },
    renderSelectedItem: function renderSelectedItem(charge) {
      return /*#__PURE__*/React.createElement("p", {
        className: "has-text-weight-semibold"
      }, charge.name);
    },
    placeholderComponent: SvgChargeInput,
    placeholderMessage: "No charges to select from"
  }), /*#__PURE__*/React.createElement(Level, null, /*#__PURE__*/React.createElement(Level.Left, null, /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement("span", {
    className: "is-size-5"
  }, "Charges"))), /*#__PURE__*/React.createElement(Level.Right, null, /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement(Button, _extends({
    type: "button",
    color: "success",
    size: "small"
  }, createModal.triggerProps), /*#__PURE__*/React.createElement(Icon, {
    name: "plus"
  }), " ", /*#__PURE__*/React.createElement("span", null, "Add")), /*#__PURE__*/React.createElement(Modal, _extends({}, createModal.modalProps, {
    title: "New Charge"
  }), /*#__PURE__*/React.createElement(Modal.Content, null, createModal.active && /*#__PURE__*/React.createElement(Form, {
    onSubmit: createCharge,
    error: createMeta.error,
    loading: createMeta.loading
  }, /*#__PURE__*/React.createElement(Form.Input, {
    name: "name",
    label: "Name",
    type: "text",
    required: true
  }), /*#__PURE__*/React.createElement(Level, {
    mobile: true
  }, /*#__PURE__*/React.createElement(Level.Right, null, /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement(Form.SubmitButton, {
    color: "success"
  }, "Create Charge")))))))))));
};
ChargeInput.propTypes = {
  /** Display label for the input */
  label: PropTypes.string.isRequired,

  /** Form input name */
  name: PropTypes.string.isRequired,

  /** Default input value */
  defaultValue: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),

  /** Multiple options may be selected */
  multiple: PropTypes.bool
};

function _templateObject2$6() {
  var data = _taggedTemplateLiteral(["\n    query Person($person: ID!) {\n      viewer {\n        person(id: $person) {\n          ...basicInfo\n\n          mother {\n            ...basicInfo\n            mother {\n              ...basicInfo\n            }\n            father {\n              ...basicInfo\n            }\n          }\n\n          father {\n            ...basicInfo\n            mother {\n              ...basicInfo\n            }\n            father {\n              ...basicInfo\n            }\n          }\n\n          firstCousins {\n            ...basicInfo\n          }\n\n          siblings: fullSiblings {\n            ...basicInfo\n          }\n\n          paternalSiblings: fatherOnlySiblings {\n            ...basicInfo\n          }\n\n          maternalSiblings: motherOnlySiblings {\n            ...basicInfo\n          }\n\n          children {\n            ...basicInfo\n\n            children {\n              ...basicInfo\n            }\n          }\n        }\n      }\n    }\n    ", "\n  "]);

  _templateObject2$6 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$7() {
  var data = _taggedTemplateLiteral(["\n  fragment basicInfo on Person {\n    id\n    firstName\n    middleName\n    lastName\n    sex\n  }\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}

var personDetailsFragment = gql(_templateObject$7());
/**
 * Takes a Person object containing various relationships with other
 * people and then flattens the relationship into an array suitable to
 * the FamilyInput.
 *
 * @param {object} person - Instance of a person and their relationship to other people.
 * @returns {array<object>} Array of related individuals with extra `relation` attribute.
 */

var flattenRelatives = function flattenRelatives(person) {
  return [// parents
  _objectSpread2(_objectSpread2({}, person === null || person === void 0 ? void 0 : person.father), {}, {
    relation: "Father"
  }), _objectSpread2(_objectSpread2({}, person === null || person === void 0 ? void 0 : person.mother), {}, {
    relation: "Mother"
  })].concat(_toConsumableArray(((person === null || person === void 0 ? void 0 : person.siblings) || []).map(function (sibling) {
    return _objectSpread2(_objectSpread2({}, sibling), {}, {
      relation: sibling.sex === "male" ? "Brother" : "Sister"
    });
  })), _toConsumableArray(((person === null || person === void 0 ? void 0 : person.maternalSiblings) || []).map(function (sibling) {
    return _objectSpread2(_objectSpread2({}, sibling), {}, {
      relation: sibling.sex === "male" ? "Maternal Half Brother" : "Maternal Half Sister"
    });
  })), _toConsumableArray(((person === null || person === void 0 ? void 0 : person.paternalSiblings) || []).map(function (sibling) {
    return _objectSpread2(_objectSpread2({}, sibling), {}, {
      relation: sibling.sex === "male" ? "Paternal Half Brother" : "Paternal Half Sister"
    });
  })), _toConsumableArray(((person === null || person === void 0 ? void 0 : person.children) || []).map(function (child) {
    return _objectSpread2(_objectSpread2({}, child), {}, {
      relation: child.sex === "male" ? "Son" : "Daughter"
    });
  })), _toConsumableArray(((person === null || person === void 0 ? void 0 : person.children) || []).reduce(function (grandchildren, child) {
    return [].concat(_toConsumableArray(grandchildren), _toConsumableArray(child.children || []));
  }, []).map(function (child) {
    return _objectSpread2(_objectSpread2({}, child), {}, {
      relation: child.sex === "male" ? "Grandson" : "Granddaughter"
    });
  })), _toConsumableArray(((person === null || person === void 0 ? void 0 : person.firstCousins) || []).map(function (cousin) {
    return _objectSpread2(_objectSpread2({}, cousin), {}, {
      relation: "First Cousin"
    });
  }))) // We don't want any relatives that don't have enough info for us to use them
  .filter(function (relative) {
    return Boolean(relative.id);
  });
};
/**
 * Hook that manages all the data needs for the FamilyInput
 *
 * @param {object|string} relatedTo - Name of form input to watch, or instance of a Person
 * @returns {[function, object]} Tuple of function to fetch relatives and an object containing request meta data.
 */


var useRelatives = function useRelatives(relatedTo) {
  var _person2;

  // In case `relatedTo` is the name of another input in the form, we'll watch the
  // form for any changes for an input with that name.
  var relatedInputValue = useWatch({
    name: String(relatedTo)
  });

  var _useLazyQuery = useLazyQuery(gql(_templateObject2$6(), personDetailsFragment)),
      _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
      query = _useLazyQuery2[0],
      meta = _useLazyQuery2[1]; // Parse the person based on either the watched input field, or the relatedTo


  var person = Array.isArray(relatedInputValue) ? relatedInputValue[0] : relatedInputValue;

  if (!person && typeof relatedTo !== "string") {
    person = relatedTo;
  }

  if (person && person.__typename !== "Person") {
    throw new Error('FamilyInput: relatedTo must be either an instance of a `Person` or the `name` prop of a `<Form.Input type="person" />`');
  }

  var getRelatives = function getRelatives() {
    var _person;

    return query({
      variables: {
        person: (_person = person) === null || _person === void 0 ? void 0 : _person.id
      }
    });
  }; // We need to augment the metadata to include a "disabled" value. The input
  // can't work if we don't know enough about a person to display relatives.


  meta.disabled = !((_person2 = person) === null || _person2 === void 0 ? void 0 : _person2.id);
  return [getRelatives, meta];
};
/**
 * How a relative's info is displayed in the FamilyInput.
 */


var RelativeDisplay = function RelativeDisplay(_ref) {
  var firstName = _ref.firstName,
      middleName = _ref.middleName,
      lastName = _ref.lastName,
      relation = _ref.relation;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "is-size-6"
  }, [firstName, middleName, lastName].filter(Boolean).join(" ")), !!relation && /*#__PURE__*/React.createElement("p", {
    className: "has-text-grey-dark is-size-7 has-text-weight-normal"
  }, relation));
};

RelativeDisplay.propTypes = {
  firstName: PropTypes.string,
  middleName: PropTypes.string,
  lastName: PropTypes.string,
  relation: PropTypes.string
};
/**
 * Custom input for selecting an instance of a person related to another person.
 */

var FamilyInput = function FamilyInput(_ref2) {
  var _meta$data, _meta$data$viewer;

  var name = _ref2.name,
      label = _ref2.label,
      _ref2$multiple = _ref2.multiple,
      multiple = _ref2$multiple === void 0 ? false : _ref2$multiple,
      defaultValue = _ref2.defaultValue,
      relatedTo = _ref2.relatedTo,
      disabledProp = _ref2.disabled,
      props = _objectWithoutProperties(_ref2, ["name", "label", "multiple", "defaultValue", "relatedTo", "disabled"]);

  var _useRelatives = useRelatives(relatedTo),
      _useRelatives2 = _slicedToArray(_useRelatives, 2),
      getRelatives = _useRelatives2[0],
      meta = _useRelatives2[1];

  var person = meta === null || meta === void 0 ? void 0 : (_meta$data = meta.data) === null || _meta$data === void 0 ? void 0 : (_meta$data$viewer = _meta$data.viewer) === null || _meta$data$viewer === void 0 ? void 0 : _meta$data$viewer.person;
  return /*#__PURE__*/React.createElement(AssociationInput, _extends({}, props, {
    name: name,
    label: label,
    multiple: multiple,
    options: flattenRelatives(person),
    defaultValue: defaultValue,
    disabled: disabledProp || meta.disabled,
    onFocus: function onFocus() {
      getRelatives();
    },
    renderSelectionItem: function renderSelectionItem(relative) {
      return /*#__PURE__*/React.createElement(RelativeDisplay, {
        firstName: relative.firstName,
        middleName: relative.middleName,
        lastName: relative.lastName,
        relation: relative.relation
      });
    },
    renderSelectedItem: function renderSelectedItem(relative) {
      return /*#__PURE__*/React.createElement(RelativeDisplay, {
        firstName: relative.firstName,
        middleName: relative.middleName,
        lastName: relative.lastName,
        relation: relative.relation
      });
    },
    placeholderMessage: meta.loading ? "Looking for family members..." : "No known family members"
  }), /*#__PURE__*/React.createElement(Heading, {
    className: "mb-0"
  }, "Relatives of"), /*#__PURE__*/React.createElement("p", {
    className: "is-size-5"
  }, [person === null || person === void 0 ? void 0 : person.firstName, person === null || person === void 0 ? void 0 : person.middleName, person === null || person === void 0 ? void 0 : person.lastName].filter(Boolean).join(" ")));
};
FamilyInput.propTypes = {
  /** Display label for the input */
  label: PropTypes.string.isRequired,

  /** Form input name */
  name: PropTypes.string.isRequired,

  /** Either the name of a Person input; or an instance of a Person. Options displayed are related to this person. */
  relatedTo: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    id: PropTypes.string,
    __typename: PropTypes.oneOf(["Person"])
  })]).isRequired,

  /** Default input value */
  defaultValue: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),

  /** Prevents the user from updating the input's value */
  disabled: PropTypes.bool,

  /** Multiple counsels may be selected */
  multiple: PropTypes.bool
};

function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

var _ref$6 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("linearGradient", {
  id: "BankInput_svg__a",
  x1: 585.48,
  y1: 733,
  x2: 585.48,
  y2: 673.63,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/createElement("linearGradient", {
  id: "BankInput_svg__b",
  x1: 93.98,
  x2: 93.98,
  y2: 673.63,
  xlinkHref: "#BankInput_svg__a"
}), /*#__PURE__*/createElement("linearGradient", {
  id: "BankInput_svg__c",
  x1: 339.15,
  y1: 681.8,
  x2: 339.15,
  y2: 0,
  xlinkHref: "#BankInput_svg__a"
}), /*#__PURE__*/createElement("linearGradient", {
  id: "BankInput_svg__d",
  x1: 339.15,
  y1: 569.14,
  x2: 339.15,
  y2: 111.49,
  xlinkHref: "#BankInput_svg__a"
}), /*#__PURE__*/createElement("linearGradient", {
  id: "BankInput_svg__e",
  x1: 806.95,
  y1: 427.79,
  x2: 806.95,
  y2: 354.24,
  gradientTransform: "translate(-.46 -24.57)",
  xlinkHref: "#BankInput_svg__a"
}), /*#__PURE__*/createElement("linearGradient", {
  id: "BankInput_svg__f",
  x1: 780.89,
  y1: 503.2,
  x2: 780.89,
  y2: 429.65,
  gradientTransform: "rotate(90 788.23 481.69)",
  xlinkHref: "#BankInput_svg__a"
}), /*#__PURE__*/createElement("linearGradient", {
  id: "BankInput_svg__g",
  x1: 565.48,
  y1: 376.26,
  x2: 565.48,
  y2: 302.71,
  xlinkHref: "#BankInput_svg__a"
}), /*#__PURE__*/createElement("linearGradient", {
  id: "BankInput_svg__h",
  x1: 339.15,
  y1: 423.21,
  x2: 339.15,
  y2: 255.09,
  xlinkHref: "#BankInput_svg__a"
}), /*#__PURE__*/createElement("linearGradient", {
  id: "BankInput_svg__i",
  x1: 290.11,
  y1: 525.36,
  x2: 290.11,
  y2: 499.67,
  xlinkHref: "#BankInput_svg__a"
}), /*#__PURE__*/createElement("linearGradient", {
  id: "BankInput_svg__j",
  x1: 322.8,
  y1: 525.36,
  x2: 322.8,
  y2: 499.67,
  xlinkHref: "#BankInput_svg__a"
}), /*#__PURE__*/createElement("linearGradient", {
  id: "BankInput_svg__k",
  x1: 355.49,
  y1: 525.36,
  x2: 355.49,
  y2: 499.67,
  xlinkHref: "#BankInput_svg__a"
}), /*#__PURE__*/createElement("linearGradient", {
  id: "BankInput_svg__l",
  x1: 388.18,
  y1: 525.36,
  x2: 388.18,
  y2: 499.67,
  xlinkHref: "#BankInput_svg__a"
}), /*#__PURE__*/createElement("linearGradient", {
  id: "BankInput_svg__m",
  x1: 339.15,
  y1: 389.93,
  x2: 339.15,
  y2: 288.36,
  xlinkHref: "#BankInput_svg__a"
}), /*#__PURE__*/createElement("linearGradient", {
  id: "BankInput_svg__n",
  x1: 377.6,
  y1: 380.54,
  x2: 377.6,
  y2: 283.64,
  xlinkHref: "#BankInput_svg__a"
}), /*#__PURE__*/createElement("linearGradient", {
  id: "BankInput_svg__o",
  x1: 377.6,
  y1: 563.83,
  x2: 377.6,
  y2: 466.93,
  xlinkHref: "#BankInput_svg__a"
}));

var _ref2$6 = /*#__PURE__*/createElement("path", {
  fill: "url(#BankInput_svg__a)",
  d: "M560.38 673.63h50.2V733h-50.2z"
});

var _ref3$6 = /*#__PURE__*/createElement("path", {
  fill: "#f5f5f5",
  d: "M609.42 730.83h-47.87v-57.21h47.87z"
});

var _ref4$6 = /*#__PURE__*/createElement("path", {
  fill: "url(#BankInput_svg__b)",
  d: "M68.88 673.63h50.2V733h-50.2z"
});

var _ref5$6 = /*#__PURE__*/createElement("path", {
  fill: "#f5f5f5",
  d: "M70.05 673.63h47.87v57.21H70.05z"
});

var _ref6$6 = /*#__PURE__*/createElement("rect", {
  width: 678.3,
  height: 681.8,
  rx: 14.86,
  ry: 14.86,
  fill: "url(#BankInput_svg__c)"
});

var _ref7$6 = /*#__PURE__*/createElement("rect", {
  x: 4.67,
  y: 3.5,
  width: 670.12,
  height: 670.12,
  rx: 14.86,
  ry: 14.86,
  fill: "#fafafa"
});

var _ref8$6 = /*#__PURE__*/createElement("path", {
  fill: "url(#BankInput_svg__d)",
  d: "M112.66 111.49h452.98v457.65H112.66z"
});

var _ref9$6 = /*#__PURE__*/createElement("path", {
  transform: "rotate(-14.86 353.904 1324.53)",
  fill: "url(#BankInput_svg__e)",
  d: "M731.19 329.67h150.6v73.55h-150.6z"
});

var _ref10$6 = /*#__PURE__*/createElement("path", {
  fill: "#fff",
  d: "M464.853 267.018l143.312-38.025 18.265 68.838-143.312 38.025z"
});

var _ref11$6 = /*#__PURE__*/createElement("path", {
  fill: "#69f0ae",
  d: "M470.158 268.021l133.916-35.532 17.068 64.324-133.917 35.532z"
});

var _ref12$6 = /*#__PURE__*/createElement("ellipse", {
  cx: 805.77,
  cy: 366.03,
  rx: 25.68,
  ry: 14.01,
  transform: "rotate(-14.86 353.216 1324.127)",
  fill: "#fff"
});

var _ref13$6 = /*#__PURE__*/createElement("path", {
  transform: "rotate(-71.04 614.22 615.064)",
  fill: "url(#BankInput_svg__f)",
  d: "M766.71 399.05h73.55v150.6h-73.55z"
});

var _ref14$6 = /*#__PURE__*/createElement("path", {
  fill: "#fff",
  d: "M484.09 332.578l140.225 48.174-23.14 67.356-140.225-48.174z"
});

var _ref15$6 = /*#__PURE__*/createElement("path", {
  fill: "#69f0ae",
  d: "M487.935 336.373l131.033 45.016-21.623 62.94-131.033-45.016z"
});

var _ref16$6 = /*#__PURE__*/createElement("ellipse", {
  cx: 803.13,
  cy: 473.61,
  rx: 14.01,
  ry: 25.68,
  transform: "rotate(-71.04 613.86 614.322)",
  fill: "#fff"
});

var _ref17$6 = /*#__PURE__*/createElement("path", {
  fill: "url(#BankInput_svg__g)",
  d: "M490.18 302.71h150.6v73.55h-150.6z"
});

var _ref18$6 = /*#__PURE__*/createElement("path", {
  fill: "#fff",
  d: "M491.35 303.88h148.27v71.22H491.35z"
});

var _ref19$6 = /*#__PURE__*/createElement("path", {
  fill: "#69f0ae",
  d: "M496.21 306.21h138.55v66.55H496.21z"
});

var _ref20$6 = /*#__PURE__*/createElement("ellipse", {
  cx: 564.9,
  cy: 338.9,
  rx: 25.68,
  ry: 14.01,
  fill: "#fff"
});

var _ref21$6 = /*#__PURE__*/createElement("path", {
  fill: "#fff",
  d: "M116.16 116.16h445.97v445.97H116.16z"
});

var _ref22$5 = /*#__PURE__*/createElement("circle", {
  cx: 339.15,
  cy: 339.15,
  r: 84.06,
  fill: "url(#BankInput_svg__h)"
});

var _ref23$5 = /*#__PURE__*/createElement("circle", {
  cx: 339.15,
  cy: 339.15,
  r: 80.56,
  fill: "#fafafa"
});

var _ref24$5 = /*#__PURE__*/createElement("path", {
  fill: "url(#BankInput_svg__i)",
  d: "M277.86 499.67h24.52v25.68h-24.52z"
});

var _ref25$5 = /*#__PURE__*/createElement("path", {
  fill: "url(#BankInput_svg__j)",
  d: "M310.55 499.67h24.52v25.68h-24.52z"
});

var _ref26$5 = /*#__PURE__*/createElement("path", {
  fill: "url(#BankInput_svg__k)",
  d: "M343.23 499.67h24.52v25.68h-24.52z"
});

var _ref27$5 = /*#__PURE__*/createElement("path", {
  fill: "url(#BankInput_svg__l)",
  d: "M375.92 499.67h24.52v25.68h-24.52z"
});

var _ref28$5 = /*#__PURE__*/createElement("path", {
  fill: "#28629b",
  d: "M278.44 500.84h23.35v23.35h-23.35z"
});

var _ref29$5 = /*#__PURE__*/createElement("path", {
  fill: "#28629b",
  opacity: 0.7,
  d: "M311.13 500.84h23.35v23.35h-23.35z"
});

var _ref30$5 = /*#__PURE__*/createElement("path", {
  fill: "#28629b",
  opacity: 0.5,
  d: "M343.82 500.84h23.35v23.35h-23.35z"
});

var _ref31$5 = /*#__PURE__*/createElement("path", {
  fill: "#28629b",
  opacity: 0.3,
  d: "M376.51 500.84h23.35v23.35h-23.35z"
});

var _ref32$5 = /*#__PURE__*/createElement("path", {
  fill: "#28629b",
  d: "M372.871 287.937l3.826 2.678L367.325 304l-3.826-2.678zM390.363 372.866l-2.679 3.826-13.385-9.373 2.68-3.825zM305.424 390.358l-3.825-2.678 9.372-13.385 3.825 2.678zM287.941 305.429l2.679-3.825 13.385 9.372-2.679 3.825z"
});

var _ref33$5 = /*#__PURE__*/createElement("path", {
  opacity: 0.2,
  d: "M372.829 287.799l3.825 2.679-9.372 13.385-3.825-2.68zM390.325 372.732l-2.679 3.825-13.385-9.372 2.679-3.825zM305.392 390.218l-3.825-2.679 9.372-13.385 3.826 2.679zM287.904 305.291l2.678-3.825 13.385 9.372-2.678 3.826z"
});

var _ref34$5 = /*#__PURE__*/createElement("circle", {
  cx: 339.15,
  cy: 339.15,
  r: 50.78,
  fill: "url(#BankInput_svg__m)"
});

var _ref35$5 = /*#__PURE__*/createElement("circle", {
  cx: 339.15,
  cy: 339.15,
  r: 47.87,
  fill: "#28629b"
});

var _ref36$5 = /*#__PURE__*/createElement("path", {
  d: "M300.04 345.57A47.86 47.86 0 01371.71 304a47.86 47.86 0 10-57 76 47.71 47.71 0 01-14.67-34.43z",
  fill: "#fff",
  opacity: 0.2
});

var _ref37$5 = /*#__PURE__*/createElement("path", {
  d: "M396.28 380.54h-37.36v-93.28a3.63 3.63 0 013.63-3.62h30.11a3.63 3.63 0 013.63 3.63z",
  transform: "translate(-260.85 -84)",
  fill: "url(#BankInput_svg__n)"
});

var _ref38$5 = /*#__PURE__*/createElement("path", {
  d: "M392.47 563.83h-29.74a3.81 3.81 0 01-3.81-3.81v-93.09h37.36V560a3.81 3.81 0 01-3.81 3.83z",
  transform: "translate(-260.85 -84)",
  fill: "url(#BankInput_svg__o)"
});

var _ref39$5 = /*#__PURE__*/createElement("path", {
  d: "M102.4 200.8h28.69a3.17 3.17 0 013.17 3.17v90.23h-35V204a3.17 3.17 0 013.14-3.2zM99.23 384.1h35v92.33a1.06 1.06 0 01-1.06 1.06H100.3a1.06 1.06 0 01-1.06-1.06V384.1h-.01z",
  fill: "#fafafa"
});

function SvgBankInput(props) {
  return /*#__PURE__*/createElement("svg", _extends$7({
    "data-name": "Layer 1",
    viewBox: "0 0 678.3 733"
  }, props), _ref$6, _ref2$6, _ref3$6, _ref4$6, _ref5$6, _ref6$6, _ref7$6, _ref8$6, _ref9$6, _ref10$6, _ref11$6, _ref12$6, _ref13$6, _ref14$6, _ref15$6, _ref16$6, _ref17$6, _ref18$6, _ref19$6, _ref20$6, _ref21$6, _ref22$5, _ref23$5, _ref24$5, _ref25$5, _ref26$5, _ref27$5, _ref28$5, _ref29$5, _ref30$5, _ref31$5, _ref32$5, _ref33$5, _ref34$5, _ref35$5, _ref36$5, _ref37$5, _ref38$5, _ref39$5);
}

function _templateObject2$7() {
  var data = _taggedTemplateLiteral(["\n      query Banks {\n        viewer {\n          banks {\n            id\n            name\n          }\n        }\n      }\n    "]);

  _templateObject2$7 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$8() {
  var data = _taggedTemplateLiteral(["\n    mutation($bank: NewBankInput!) {\n      bank: addBank(bank: $bank) {\n        name\n        id\n      }\n    }\n  "]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}
var useCreate$6 = function useCreate() {
  var _useMutation = useMutation(gql(_templateObject$8())),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      mutate = _useMutation2[0],
      meta = _useMutation2[1];

  var create = function create(bank) {
    return mutate({
      variables: {
        bank: bank
      }
    });
  };

  return [create, meta];
};

var useBanks = function useBanks() {
  var _meta$data, _meta$data$viewer;

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _useLazyQuery = useLazyQuery(gql(_templateObject2$7()), options),
      _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
      query = _useLazyQuery2[0],
      meta = _useLazyQuery2[1];

  var getBanks = function getBanks() {
    var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var requestOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return query(_objectSpread2({
      variables: form
    }, requestOptions));
  }; // Cleaned data for easier consumption


  var data = {
    banks: (meta === null || meta === void 0 ? void 0 : (_meta$data = meta.data) === null || _meta$data === void 0 ? void 0 : (_meta$data$viewer = _meta$data.viewer) === null || _meta$data$viewer === void 0 ? void 0 : _meta$data$viewer.banks) || []
  };
  return [getBanks, _objectSpread2(_objectSpread2({}, meta), {}, {
    data: data
  })];
};
/**
 * Custom form input for allowing users to select one or more banks. Connects automatically
 * to a parent `Form` component.
 */


var BankInput = function BankInput(_ref) {
  var name = _ref.name,
      label = _ref.label,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? false : _ref$multiple,
      defaultValue = _ref.defaultValue,
      props = _objectWithoutProperties(_ref, ["name", "label", "multiple", "defaultValue"]);

  var _useBanks = useBanks(),
      _useBanks2 = _slicedToArray(_useBanks, 2),
      getOptions = _useBanks2[0],
      _useBanks2$ = _useBanks2[1],
      data = _useBanks2$.data,
      refetch = _useBanks2$.refetch;

  var _useCreate = useCreate$6(),
      _useCreate2 = _slicedToArray(_useCreate, 2),
      create = _useCreate2[0],
      createMeta = _useCreate2[1];

  var createModal = useModal();

  var createBank = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(form) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return create(form);

            case 3:
              createModal.close();
              refetch();
              Toasts.success("New bank created");
              _context.next = 10;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));

    return function createBank(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(AssociationInput, _extends({}, props, {
    name: name,
    label: label,
    multiple: multiple,
    options: data.banks,
    defaultValue: defaultValue,
    placeholderComponent: SvgBankInput,
    placeholderMessage: "No banks to select from",
    onFocus: function onFocus() {
      getOptions();
    },
    renderSelectionItem: function renderSelectionItem(bank) {
      return /*#__PURE__*/React.createElement("p", {
        className: "has-text-weight-semibold"
      }, bank.name);
    },
    renderSelectedItem: function renderSelectedItem(bank) {
      return bank.name;
    }
  }), /*#__PURE__*/React.createElement(Level, null, /*#__PURE__*/React.createElement(Level.Left, null, /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement("span", {
    className: "is-size-5"
  }, "Banks"))), /*#__PURE__*/React.createElement(Level.Right, null, /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement(Button, _extends({
    type: "button",
    color: "success",
    size: "small"
  }, createModal.triggerProps), /*#__PURE__*/React.createElement(Icon, {
    name: "plus"
  }), " ", /*#__PURE__*/React.createElement("span", null, "Add")), /*#__PURE__*/React.createElement(Modal, _extends({}, createModal.modalProps, {
    title: "New Bank"
  }), /*#__PURE__*/React.createElement(Modal.Content, null, createModal.active && /*#__PURE__*/React.createElement(Form, {
    onSubmit: createBank,
    error: createMeta.error,
    loading: createMeta.loading
  }, /*#__PURE__*/React.createElement(Form.Input, {
    name: "name",
    label: "Name",
    type: "text",
    required: true
  }), /*#__PURE__*/React.createElement(Form.Input, {
    name: "phoneNumber",
    label: "Phone Number",
    type: "phone"
  }), /*#__PURE__*/React.createElement(Form.Input, {
    name: "street1",
    label: "Address 1",
    type: "text"
  }), /*#__PURE__*/React.createElement(Form.Input, {
    name: "street2",
    label: "Address 2",
    type: "text"
  }), /*#__PURE__*/React.createElement(Columns, null, /*#__PURE__*/React.createElement(Columns.Column, null, /*#__PURE__*/React.createElement(Form.Input, {
    name: "city",
    label: "City",
    type: "text"
  })), /*#__PURE__*/React.createElement(Columns.Column, null, /*#__PURE__*/React.createElement(Form.Input, {
    name: "state",
    label: "State",
    type: "text"
  })), /*#__PURE__*/React.createElement(Columns.Column, null, /*#__PURE__*/React.createElement(Form.Input, {
    name: "postalCode",
    label: "Zip Code",
    type: "text"
  }))), /*#__PURE__*/React.createElement(Level, {
    mobile: true
  }, /*#__PURE__*/React.createElement(Level.Right, null, /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement(Form.SubmitButton, {
    color: "success"
  }, "Create Bank")))))))))));
};
BankInput.propTypes = {
  /** Display label for the input */
  label: PropTypes.string.isRequired,

  /** Form input name */
  name: PropTypes.string.isRequired,

  /** Default input value */
  defaultValue: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),

  /** Multiple counsels may be selected */
  multiple: PropTypes.bool
};

function _templateObject$9() {
  var data = _taggedTemplateLiteral(["\n      query {\n        viewer {\n          role(name: \"judge\") {\n            judges: users {\n              value: id\n              label: email\n            }\n          }\n        }\n      }\n    "]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}

var useJudges = function useJudges() {
  var _query$data, _query$data$viewer, _query$data$viewer$ro;

  var query = useQuery(gql(_templateObject$9()));
  var options = [{
    label: "Unassigned",
    value: ""
  }].concat((query === null || query === void 0 ? void 0 : (_query$data = query.data) === null || _query$data === void 0 ? void 0 : (_query$data$viewer = _query$data.viewer) === null || _query$data$viewer === void 0 ? void 0 : (_query$data$viewer$ro = _query$data$viewer.role) === null || _query$data$viewer$ro === void 0 ? void 0 : _query$data$viewer$ro.judges) || []);
  return [options, query];
};
/**
 * Custom form input for allowing users to select one or more judges. Connects automatically
 * to a parent `Form` component.
 */


var JudgeInput = function JudgeInput(_ref) {
  var loadingProp = _ref.loading,
      disabledProp = _ref.disabled,
      props = _objectWithoutProperties(_ref, ["loading", "disabled"]);

  var _useJudges = useJudges(),
      _useJudges2 = _slicedToArray(_useJudges, 2),
      options = _useJudges2[0],
      meta = _useJudges2[1];

  var _useFormContext = useFormContext(),
      register = _useFormContext.register,
      loading = _useFormContext.loading,
      disabled = _useFormContext.disabled;

  return /*#__PURE__*/React.createElement(Select, _extends({}, props, {
    ref: !meta.loading ? register : null,
    options: options,
    loading: loading || loadingProp || meta.loading,
    disabled: loading || loadingProp || disabled || disabledProp || meta.loading
  }));
};
JudgeInput.propTypes = {
  /** Display label for the input */
  label: PropTypes.string.isRequired,

  /** Form input name */
  name: PropTypes.string.isRequired,

  /** Default input value */
  defaultValue: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),

  /** Multiple may be selected */
  multiple: PropTypes.bool,

  /** Input is loading */
  loading: PropTypes.bool,

  /** Input is disabled */
  disabled: PropTypes.bool
};

function _extends$8() { _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

var _ref$7 = /*#__PURE__*/createElement("path", {
  d: "M654.48 197.74H526.13v-27.76a6.64 6.64 0 00-6.64-6.64H481.8v-29.57a4.18 4.18 0 00-4.18-4.18h-48.55a4.18 4.18 0 00-4.18 4.18v29.58h-44.31a6.64 6.64 0 00-6.64 6.64v27.76H251.55a1.35 1.35 0 00-1.34 1.35v368.51a1.35 1.35 0 001.34 1.35h81.34a1.35 1.35 0 001.35-1.35v-49.58a1.36 1.36 0 011.35-1.35h34.36a1.36 1.36 0 011.35 1.35v49.58a1.35 1.35 0 001.34 1.35h160.73a1.36 1.36 0 001.35-1.35v-49.58a1.35 1.35 0 011.34-1.35h34.36a1.35 1.35 0 011.35 1.35v49.58a1.36 1.36 0 001.35 1.35h81.34a1.36 1.36 0 001.35-1.35V199.09a1.36 1.36 0 00-1.33-1.35zm-334.8 301.72a1.34 1.34 0 01-1.34 1.34H268.1a1.34 1.34 0 01-1.35-1.34v-17.11a1.35 1.35 0 011.35-1.35h50.27a1.35 1.35 0 011.34 1.35zm0-44.34a1.34 1.34 0 01-1.34 1.35H268.1a1.34 1.34 0 01-1.35-1.35v-17.15a1.34 1.34 0 011.35-1.35h50.27a1.34 1.34 0 011.34 1.35zm0-44.33a1.35 1.35 0 01-1.34 1.35H268.1a1.35 1.35 0 01-1.35-1.35v-17.16a1.35 1.35 0 011.35-1.35h50.27a1.35 1.35 0 011.34 1.35zm0-44.34a1.34 1.34 0 01-1.34 1.35H268.1a1.34 1.34 0 01-1.35-1.35v-17.1a1.34 1.34 0 011.35-1.35h50.27a1.34 1.34 0 011.34 1.35zm0-44.33a1.35 1.35 0 01-1.34 1.35H268.1a1.35 1.35 0 01-1.35-1.35v-17.16a1.34 1.34 0 011.35-1.34h50.27a1.34 1.34 0 011.34 1.34zm0-44.33a1.34 1.34 0 01-1.34 1.34H268.1a1.34 1.34 0 01-1.35-1.34v-17.16a1.35 1.35 0 011.35-1.35h50.27a1.35 1.35 0 011.34 1.35zm0-44.34a1.34 1.34 0 01-1.34 1.35H268.1a1.34 1.34 0 01-1.35-1.35v-17.1a1.34 1.34 0 011.35-1.35h50.27a1.34 1.34 0 011.34 1.35zm119.11 266a1.34 1.34 0 01-1.35 1.34H387.2a1.35 1.35 0 01-1.35-1.34v-17.1a1.36 1.36 0 011.35-1.35h50.24a1.35 1.35 0 011.35 1.35zm0-44.34a1.34 1.34 0 01-1.35 1.35H387.2a1.35 1.35 0 01-1.35-1.35v-17.14a1.35 1.35 0 011.35-1.35h50.24a1.34 1.34 0 011.35 1.35zm0-44.33a1.35 1.35 0 01-1.35 1.35H387.2a1.36 1.36 0 01-1.35-1.35v-17.15a1.36 1.36 0 011.35-1.35h50.24a1.35 1.35 0 011.35 1.35zm0-44.34a1.34 1.34 0 01-1.35 1.35H387.2a1.35 1.35 0 01-1.35-1.35v-17.09a1.35 1.35 0 011.35-1.35h50.24a1.34 1.34 0 011.35 1.35zm0-44.33a1.35 1.35 0 01-1.35 1.35H387.2a1.36 1.36 0 01-1.35-1.35v-17.15a1.35 1.35 0 011.35-1.34h50.24a1.34 1.34 0 011.35 1.34zm0-44.33a1.34 1.34 0 01-1.35 1.34H387.2a1.35 1.35 0 01-1.35-1.34v-17.15a1.36 1.36 0 011.35-1.35h50.24a1.35 1.35 0 011.35 1.35zm0-44.34a1.34 1.34 0 01-1.35 1.35H387.2a1.35 1.35 0 01-1.35-1.35v-17.09a1.35 1.35 0 011.35-1.35h50.24a1.34 1.34 0 011.35 1.35zm81.39 266a1.34 1.34 0 01-1.35 1.34h-50.24a1.35 1.35 0 01-1.35-1.34v-17.09a1.36 1.36 0 011.35-1.35h50.24a1.35 1.35 0 011.35 1.35zm0-44.34a1.34 1.34 0 01-1.35 1.35h-50.24a1.35 1.35 0 01-1.35-1.35v-17.13a1.35 1.35 0 011.35-1.35h50.24a1.34 1.34 0 011.35 1.35zm0-44.33a1.35 1.35 0 01-1.35 1.35h-50.24a1.36 1.36 0 01-1.35-1.35v-17.14a1.36 1.36 0 011.35-1.35h50.24a1.35 1.35 0 011.35 1.35zm0-44.34a1.34 1.34 0 01-1.35 1.35h-50.24a1.35 1.35 0 01-1.35-1.35v-17.08a1.35 1.35 0 011.35-1.35h50.24a1.34 1.34 0 011.35 1.35zm0-44.33a1.35 1.35 0 01-1.35 1.35h-50.24a1.36 1.36 0 01-1.35-1.35v-17.14a1.35 1.35 0 011.35-1.34h50.24a1.34 1.34 0 011.35 1.34zm0-44.33a1.34 1.34 0 01-1.35 1.34h-50.24a1.35 1.35 0 01-1.35-1.34v-17.14a1.36 1.36 0 011.35-1.35h50.24a1.35 1.35 0 011.35 1.35zm0-44.34a1.34 1.34 0 01-1.35 1.35h-50.24a1.35 1.35 0 01-1.35-1.35v-17.08a1.35 1.35 0 011.35-1.35h50.24a1.34 1.34 0 011.35 1.35zm119.11 266a1.35 1.35 0 01-1.35 1.34H587.7a1.34 1.34 0 01-1.35-1.34v-17.08a1.35 1.35 0 011.35-1.35h50.24a1.36 1.36 0 011.35 1.35zm0-44.34a1.35 1.35 0 01-1.35 1.35H587.7a1.34 1.34 0 01-1.35-1.35v-17.12a1.34 1.34 0 011.35-1.35h50.24a1.35 1.35 0 011.35 1.35zm0-44.33a1.36 1.36 0 01-1.35 1.35H587.7a1.35 1.35 0 01-1.35-1.35v-17.13a1.35 1.35 0 011.35-1.35h50.24a1.36 1.36 0 011.35 1.35zm0-44.34a1.35 1.35 0 01-1.35 1.35H587.7a1.34 1.34 0 01-1.33-1.32v-17.1a1.34 1.34 0 011.35-1.35h50.24a1.35 1.35 0 011.35 1.35zm0-44.33a1.36 1.36 0 01-1.35 1.35H587.7a1.35 1.35 0 01-1.35-1.35v-17.13a1.34 1.34 0 011.35-1.34h50.24a1.35 1.35 0 011.35 1.34zm0-44.33a1.35 1.35 0 01-1.35 1.34H587.7a1.34 1.34 0 01-1.35-1.34v-17.13a1.35 1.35 0 011.35-1.35h50.24a1.36 1.36 0 011.35 1.35zm0-44.34a1.35 1.35 0 01-1.35 1.35H587.7a1.34 1.34 0 01-1.33-1.32v-17.1a1.34 1.34 0 011.35-1.35h50.24a1.35 1.35 0 011.35 1.35zM267.15 44.24l-15.52 9.84 9.42-17.14a15.35 15.35 0 00-9.38-3.35h-.25a18.09 18.09 0 01-3.22-.24l-5.26 3.33 2.25-4.1a18.66 18.66 0 01-9.2-7l-9.41 6 5.94-10.81c-5.5-6.61-12.92-10.66-21.09-10.66-9.79 0-18.51 5.82-24.14 14.89a18 18 0 01-16 8.6h-.52c-10.81 0-19.57 12.26-19.57 27.37s8.8 27.38 19.61 27.38a14.72 14.72 0 006.81-1.71 28.21 28.21 0 0123.69-.46 24.66 24.66 0 0020.14 0 28.23 28.23 0 0123.47.46 14.72 14.72 0 006.75 1.71c10.81 0 19.57-12.26 19.57-27.38a34.7 34.7 0 00-4.09-16.73z",
  fill: "#f2f2f2"
});

var _ref2$7 = /*#__PURE__*/createElement("path", {
  d: "M237.9 84.29a28.89 28.89 0 00-16.77 1.82 24.69 24.69 0 01-20.13 0 28.28 28.28 0 00-23.69.46 14.61 14.61 0 01-6.82 1.71c-9.6 0-17.59-9.67-19.25-22.43a18.43 18.43 0 004.8-5.18c5.63-9.07 14.35-14.89 24.14-14.89s18.4 5.75 24 14.73a18.48 18.48 0 0015.95 8.76h.25c7.68-.05 14.3 6.08 17.52 15.02z",
  opacity: 0.03
});

var _ref3$7 = /*#__PURE__*/createElement("path", {
  d: "M814.13 17.03l-7.76 4.91 4.7-8.55a7.67 7.67 0 00-4.68-1.67h-.12a8.6 8.6 0 01-1.61-.12l-2.62 1.67 1.12-2a9.4 9.4 0 01-4.59-3.48l-4.69 3 3-5.39A13.71 13.71 0 00786.37 0c-4.88 0-9.23 2.91-12 7.43a9 9 0 01-8 4.29h-.26c-5.39 0-9.76 6.11-9.76 13.65s4.37 13.65 9.76 13.65a7.32 7.32 0 003.4-.85 14.08 14.08 0 0111.81-.23 12.33 12.33 0 0010.05 0 14.11 14.11 0 0111.71.23 7.29 7.29 0 003.36.83c5.39 0 9.76-6.11 9.76-13.65a17.38 17.38 0 00-2.07-8.32z",
  fill: "#f2f2f2"
});

var _ref4$7 = /*#__PURE__*/createElement("path", {
  d: "M799.54 37a14.52 14.52 0 00-8.37.91 12.28 12.28 0 01-5 1.06 12.41 12.41 0 01-5-1.08 14.1 14.1 0 00-11.82.23 7.29 7.29 0 01-3.4.85c-4.79 0-8.77-4.82-9.6-11.19a9.26 9.26 0 002.4-2.58c2.8-4.52 7.15-7.43 12-7.43s9.18 2.87 12 7.35a9.22 9.22 0 008 4.37h.13c3.75 0 7.05 3.06 8.66 7.51z",
  opacity: 0.03
});

var _ref5$7 = /*#__PURE__*/createElement("path", {
  d: "M619.82 106.96l-9.1 5.77 5.52-10a9 9 0 00-5.5-2h-.15a10.79 10.79 0 01-1.89-.14l-3.08 2 1.32-2.41a11 11 0 01-5.4-4.09l-5.52 3.5 3.49-6.34a16.15 16.15 0 00-12.37-6.26c-5.74 0-10.86 3.42-14.16 8.74a10.56 10.56 0 01-9.36 5h-.31c-6.34 0-11.47 7.19-11.47 16s5.13 16.05 11.47 16.05a8.56 8.56 0 004-1 16.56 16.56 0 0113.89-.27 14.52 14.52 0 0011.81 0 16.58 16.58 0 0113.77.27 8.68 8.68 0 004 1c6.34 0 11.48-7.18 11.48-16.05a20.4 20.4 0 00-2.44-9.77z",
  fill: "#f2f2f2"
});

var _ref6$7 = /*#__PURE__*/createElement("path", {
  d: "M602.67 130.45a17 17 0 00-9.84 1.07 14.52 14.52 0 01-11.81 0 16.56 16.56 0 00-13.89.27 8.59 8.59 0 01-4 1c-5.63 0-10.32-5.67-11.29-13.15a10.75 10.75 0 002.81-3c3.3-5.32 8.42-8.73 14.16-8.73s10.8 3.37 14.1 8.63a10.82 10.82 0 009.35 5.14h.11c4.52-.07 8.41 3.53 10.3 8.77z",
  opacity: 0.03
});

var _ref7$7 = /*#__PURE__*/createElement("path", {
  d: "M947.25 569.2c0 1.72 0 3.44-.11 5.14a121.57 121.57 0 01-2.38 19.69c-6.57 32.11-25.54 57.07-49.37 64.44a49.29 49.29 0 01-14.64 2.23c-36.73 0-66.5-41-66.5-91.5s29.77-91.5 66.5-91.5c34.45 0 62.79 36.06 66.16 82.25.23 3.04.34 6.13.34 9.25z",
  fill: "#36334a"
});

var _ref8$7 = /*#__PURE__*/createElement("path", {
  d: "M947.14 574.35a121.57 121.57 0 01-2.38 19.69c-6.57 32.11-25.54 57.07-49.37 64.44-18.45-8.49-32.14-40.31-32.14-78.27 0-44.46 18.8-80.5 42-80.5 19.47 0 35.85 25.42 40.6 59.91.66 4.73 1.09 9.67 1.29 14.73z",
  opacity: 0.1
});

var _ref9$7 = /*#__PURE__*/createElement("path", {
  d: "M613.25 366.7s180-37 275-3c0 0 14 7 0 19 0 0 13.24 14-9.88 19l-91.85 5.65-173.27-17.65z",
  fill: "#3f3d56"
});

var _ref10$7 = /*#__PURE__*/createElement("path", {
  d: "M644.75 371.35s154.11-31.68 235.45-2.57c0 0 12 6 0 16.27 0 0 11.33 12-8.46 16.27l-78.64 4.83-148.35-15.09z",
  opacity: 0.1
});

var _ref11$7 = /*#__PURE__*/createElement("path", {
  d: "M820.25 426.7l-12-24s5.26-24.28-37.5-31.42c-2.37-10.59-13.11-18.58-26-18.58-12.58 0-23.1 7.6-25.82 17.8-6.14.53-12.68 1.25-19.68 2.2l-9.78 52.44-1.22-2.44s6.21-28.68-49.76-32.87a20.82 20.82 0 004.76-13.13c0-12.71-11.87-23-26.5-23s-26.5 10.29-26.5 23a21 21 0 005.56 14.08q-7.85.75-16.56 1.92l-11 59 51 7 81-12-7.17-14.35 46.17 6.34z",
  fill: "#28629b"
});

var _ref12$7 = /*#__PURE__*/createElement("path", {
  d: "M820.25 426.7l-12-24s5.26-24.28-37.5-31.42c-2.37-10.59-13.11-18.58-26-18.58-12.58 0-23.1 7.6-25.82 17.8-6.14.53-12.68 1.25-19.68 2.2l-9.78 52.44-1.22-2.44s6.21-28.68-49.76-32.87a20.82 20.82 0 004.76-13.13c0-12.71-11.87-23-26.5-23s-26.5 10.29-26.5 23a21 21 0 005.56 14.08q-7.85.75-16.56 1.92l-11 59 51 7 81-12-7.17-14.35 46.17 6.34z",
  opacity: 0.2
});

var _ref13$7 = /*#__PURE__*/createElement("path", {
  d: "M648.23 373.58s-8-44.88 29-45.88 25 65 25 65 28 6 30 17-97 14-97 14z",
  fill: "#28629b"
});

var _ref14$7 = /*#__PURE__*/createElement("path", {
  d: "M583.25 610.7c0 53-39.4 96-88 96s-88-43-88-96 39.89-104.5 88.5-104.5 87.5 51.48 87.5 104.5z",
  fill: "#36334a"
});

var _ref15$7 = /*#__PURE__*/createElement("ellipse", {
  cx: 495.25,
  cy: 614.7,
  rx: 70,
  ry: 80.99,
  opacity: 0.1
});

var _ref16$7 = /*#__PURE__*/createElement("ellipse", {
  cx: 108.25,
  cy: 601.69,
  rx: 88,
  ry: 96,
  fill: "#36334a"
});

var _ref17$7 = /*#__PURE__*/createElement("path", {
  d: "M258.25 372.7s-41 2-39 24 35 6 35 6z",
  fill: "#36334a"
});

var _ref18$7 = /*#__PURE__*/createElement("path", {
  d: "M599.37 409.35l16.88-112.65s4-14-50-14c0 0-173-11-217 7 0 0-51 19-122 117 0 0 365.12 8.65 372.12 2.65z",
  fill: "#3f3d56"
});

var _ref19$7 = /*#__PURE__*/createElement("path", {
  d: "M593.25 291.7l-31 123-19.44-.47-92-2.24-205.19-5c-.57-9.72 96.6-110.29 96.6-110.29z",
  fill: "#36334a"
});

var _ref20$7 = /*#__PURE__*/createElement("path", {
  d: "M450.84 411.99l8.38-32.4s-8-44.89 29-45.89 25 65 25 65 25.5 5.47 29.56 15.53z",
  fill: "#28629b",
  opacity: 0.2
});

var _ref21$7 = /*#__PURE__*/createElement("path", {
  d: "M947.75 562.2c-6-58-43.5-70.5-43.5-70.5-36-2-60 135-60 135l-277 25s9.5-116.5-57.5-135.5-84.5 117.5-87.5 136.5-404-2-415-10-7-85-4-91 11-33 11-33c0-6.44 3.08-14.58 5.64-20.23 1.8-4 3.36-6.77 3.36-6.77 8.69-49.28 53.81-61.21 56.84-62h.16c12-12 123-20 123-20l42-8 341.47 6.71 14.53.29 173.6-8.35 117.4-5.65c27 0 41 68 41 68 25 60 14.5 99.5 14.5 99.5z",
  fill: "#3f3d56"
});

var _ref22$6 = /*#__PURE__*/createElement("ellipse", {
  cx: 455.39,
  cy: 570.05,
  rx: 51.48,
  ry: 32.23,
  transform: "rotate(-21.92 164.553 735.06)",
  opacity: 0.1
});

var _ref23$6 = /*#__PURE__*/createElement("ellipse", {
  cx: 453.39,
  cy: 566.05,
  rx: 51.48,
  ry: 32.23,
  transform: "rotate(-21.92 162.543 731.054)",
  fill: "#f2f2f2"
});

var _ref24$6 = /*#__PURE__*/createElement("path", {
  d: "M82.09 431.74c-.51 11-5.44 24.88-14.31 38.25-14.27 21.52-33.84 34.19-45.89 30.48 1.8-4 3.36-6.77 3.36-6.77 8.69-49.28 53.81-61.21 56.84-61.96z",
  opacity: 0.1
});

var _ref25$6 = /*#__PURE__*/createElement("path", {
  d: "M79.09 429.74c-.51 11-5.44 24.88-14.31 38.25-14.27 21.52-33.84 34.19-45.89 30.48 1.8-4 3.36-6.77 3.36-6.77 8.69-49.28 53.81-61.21 56.84-61.96z",
  fill: "#f2f2f2"
});

var _ref26$6 = /*#__PURE__*/createElement("path", {
  fill: "#36334a",
  d: "M219.25 459.69h-79l-4-11h96l-13 11zM71.25 540.69h130v38h-130z"
});

var _ref27$6 = /*#__PURE__*/createElement("circle", {
  cx: 341.25,
  cy: 597.69,
  r: 18,
  opacity: 0.1
});

var _ref28$6 = /*#__PURE__*/createElement("circle", {
  cx: 339.25,
  cy: 594.69,
  r: 18,
  fill: "#f2f2f2"
});

var _ref29$6 = /*#__PURE__*/createElement("ellipse", {
  cx: 14.25,
  cy: 583.69,
  rx: 9,
  ry: 19,
  opacity: 0.1
});

var _ref30$6 = /*#__PURE__*/createElement("ellipse", {
  cx: 11.25,
  cy: 582.69,
  rx: 9,
  ry: 19,
  fill: "#f2f2f2"
});

var _ref31$6 = /*#__PURE__*/createElement("path", {
  d: "M804.25 502.7c-11 34-12 87-12 87l-4 14-195 22s1-98 4-144c2.11-32.45-5.72-59.92-10.53-73.29l14.53.29 173.6-8.35c29 20.33 39.27 71.82 29.4 102.35z",
  fill: "#36334a"
});

var _ref32$6 = /*#__PURE__*/createElement("path", {
  d: "M759.79 441.4a4.91 4.91 0 00-4.52 5.69 3.51 3.51 0 002 2.61c3.23 1.61 24.73-2 32.88-3.44a5.53 5.53 0 004.62-4.93c.1-1.42-.42-2.63-2.5-2.63z",
  fill: "#f2f2f2"
});

var _ref33$6 = /*#__PURE__*/createElement("path", {
  d: "M586.25 404.7s5 22 29 15l8-31-16-9z",
  fill: "#36334a"
});

var _ref34$6 = /*#__PURE__*/createElement("path", {
  d: "M615.64 360.03c11-6.52 28.45-12.22 45.71 1.47a20.4 20.4 0 015.89 24.54c-5.65 12.23-19.06 25.5-50.37 9.61a20.2 20.2 0 01-7.62-6.74l-.16-.24a20.3 20.3 0 016.55-28.64z",
  fill: "#36334a"
});

var _ref35$6 = /*#__PURE__*/createElement("circle", {
  cx: 495.75,
  cy: 610.19,
  r: 20,
  fill: "#f2f2f2"
});

var _ref36$6 = /*#__PURE__*/createElement("ellipse", {
  cx: 908.75,
  cy: 574.19,
  rx: 11,
  ry: 20,
  fill: "#f2f2f2"
});

var _ref37$6 = /*#__PURE__*/createElement("rect", {
  x: 482.25,
  y: 548.69,
  width: 26,
  height: 35,
  rx: 12,
  fill: "#36334a"
});

var _ref38$6 = /*#__PURE__*/createElement("path", {
  d: "M908.75 510.19a7 7 0 017 7v16a12 12 0 01-12 12 7 7 0 01-7-7v-16a12 12 0 0112-12zM908.75 638.2a12 12 0 01-12-12v-11a12 12 0 0112-12c6.6 0 6 5.4 6 12v11c-.01 6.6.62 12-6 12zM878.75 556.19a12 12 0 0112 12v15a8 8 0 01-8 8 12 12 0 01-12-12v-15a8 8 0 018-8zM947.25 569.2c0 1.72 0 3.44-.11 5.14a121.57 121.57 0 01-2.38 19.69 12.21 12.21 0 01-2 .17 12 12 0 01-12-12v-11a12 12 0 0112-12 11.71 11.71 0 013.1.41c.36.1.72.21 1.06.34.22 3.04.33 6.13.33 9.25z",
  fill: "#36334a"
});

var _ref39$6 = /*#__PURE__*/createElement("rect", {
  x: 532.75,
  y: 591.19,
  width: 26,
  height: 35,
  rx: 12,
  fill: "#36334a"
});

var _ref40$5 = /*#__PURE__*/createElement("rect", {
  x: 434.75,
  y: 591.19,
  width: 26,
  height: 35,
  rx: 12,
  fill: "#36334a"
});

var _ref41$5 = /*#__PURE__*/createElement("rect", {
  x: 482.75,
  y: 643.19,
  width: 26,
  height: 35,
  rx: 12,
  fill: "#36334a"
});

var _ref42$5 = /*#__PURE__*/createElement("path", {
  d: "M845.01 206.01a16.42 16.42 0 01-1 5.59 16.6 16.6 0 01-31.09.44 16.33 16.33 0 01-1.14-6 16.6 16.6 0 0133.2 0z",
  fill: "#ff6584"
});

var _ref43$5 = /*#__PURE__*/createElement("path", {
  d: "M815.15 210.15a16.6 16.6 0 016.46-22.57 16.43 16.43 0 016-2 16.6 16.6 0 101.4 33.07 16.59 16.59 0 01-13.86-8.5zM807.66 229.13h44.47v69.37h-44.47z",
  fill: "#ff6584"
});

var _ref44$4 = /*#__PURE__*/createElement("path", {
  opacity: 0.1,
  d: "M808.66 227.13h44.47v69.37h-44.47z"
});

var _ref45$4 = /*#__PURE__*/createElement("path", {
  d: "M737.37 480.81s-4.74 13-16 14.82-17.76 4.72-17.76 4.72l26.68 17.19 14.23-1.78s1.77-18.38 7.7-22.53-14.85-12.42-14.85-12.42zM930.09 480.81s4.74 13 16 14.82 17.78 4.75 17.78 4.75l-26.68 17.19-14.23-1.78s-1.77-18.38-7.7-22.53 14.83-12.45 14.83-12.45z",
  fill: "#fbbebe"
});

var _ref46$4 = /*#__PURE__*/createElement("path", {
  d: "M800.25 365.79s-7.12 3.56-9.49 10.67c0 0-13 4.15-20.16 15.42 0 0-8.89 9.48-10.08 14.23s-14.82 33.24-14.82 33.24-13.63 44.46-20.75 49.21c0 0 22.53-4.75 26.68 17.78 0 0 5.34 0 11.27-20.75s20.15-46.24 20.15-46.24 4.75-17.79 8.9-20.75 10.67-16.6 16.6-13.05 45.06-.59 45.06-.59 23.12 10.67 23.71 17.79 4.75 7.7 5.34 13.63 22.53 52.77 22.53 52.77 4.15 13 5.33 16c0 0 13.05-31.42 30.24-13.64 0 0-.59-11.86-5.93-19s-28.46-62.85-28.46-62.85-2.37-8.3-4.74-10.67-20.75-21.34-27.26-21.34c0 0-3.56-8.9-7.71-10.08zM746.89 511.64a28.89 28.89 0 01-28.23-3.8 56.27 56.27 0 00-12.59-7.29c-6.28-2.54-13.81-4.43-16.1-.17-4.15 7.7 50.4 26.68 50.4 26.68s7.11-4.16 6.52-15.42zM920.6 511.64a28.89 28.89 0 0028.23-3.8 56.27 56.27 0 0112.59-7.29c6.28-2.54 13.81-4.43 16.1-.17 4.15 7.7-50.4 26.68-50.4 26.68s-7.11-4.16-6.52-15.42z",
  fill: "#696880"
});

var _ref47$4 = /*#__PURE__*/createElement("path", {
  d: "M819.63 268.27c-.23 2.06-.9 4.29-2.66 5.39-1.44.9-3.26.82-4.92 1.17a11.44 11.44 0 00-7.83 6.76 17.52 17.52 0 00-.74 10.55 38.85 38.85 0 001.51 5.07c1.75 4.92 3.85 9.79 7.09 13.89a59 59 0 009.3 8.76c2.11 1.72 4.29 3.48 6.89 4.29a21.36 21.36 0 005.41.71c2.25.11 4.64.18 6.59-.94 3-1.73 3.9-5.56 5.52-8.62 1.39-2.61 3.45-4.81 4.74-7.47a29.78 29.78 0 002-6.51l2.77-12.31c1-4.46 1.92-9.5-.6-13.33a2.1 2.1 0 00-.74-.77 2.75 2.75 0 00-1.51-.16 16.32 16.32 0 01-9.15-2.09 3.62 3.62 0 01-1.15-.9 4.53 4.53 0 01-.71-2.11 22.29 22.29 0 00-1.28-4.46 3 3 0 00-.87-1.33 3.11 3.11 0 00-1.4-.47 114.49 114.49 0 00-12.93-1.36c-1.43-.06-3.57-.63-4.54.62s-.63 4.12-.79 5.62z",
  fill: "#fbbebe"
});

var _ref48$4 = /*#__PURE__*/createElement("path", {
  d: "M819.63 268.27c-.23 2.06-.9 4.29-2.66 5.39-1.44.9-3.26.82-4.92 1.17a11.44 11.44 0 00-7.83 6.76 17.52 17.52 0 00-.74 10.55 38.85 38.85 0 001.51 5.07c1.75 4.92 3.85 9.79 7.09 13.89a59 59 0 009.3 8.76c2.11 1.72 4.29 3.48 6.89 4.29a21.36 21.36 0 005.41.71c2.25.11 4.64.18 6.59-.94 3-1.73 3.9-5.56 5.52-8.62 1.39-2.61 3.45-4.81 4.74-7.47a29.78 29.78 0 002-6.51l2.77-12.31c1-4.46 1.92-9.5-.6-13.33a2.1 2.1 0 00-.74-.77 2.75 2.75 0 00-1.51-.16 16.32 16.32 0 01-9.15-2.09 3.62 3.62 0 01-1.15-.9 4.53 4.53 0 01-.71-2.11 22.29 22.29 0 00-1.28-4.46 3 3 0 00-.87-1.33 3.11 3.11 0 00-1.4-.47 114.49 114.49 0 00-12.93-1.36c-1.43-.06-3.57-.63-4.54.62s-.63 4.12-.79 5.62z",
  opacity: 0.1
});

var _ref49$4 = /*#__PURE__*/createElement("path", {
  d: "M811.6 275.35a27.43 27.43 0 00-7.14-1.13c-5.72-.14-11.83 1.84-15.14 6.51a15.37 15.37 0 00-2.29 11.45 23.71 23.71 0 005.2 10.67 32.07 32.07 0 014 5.24c1.58 3 1.62 6.58 2 10 1 8.11 4.46 15.75 5.84 23.81s.18 17.42-6.19 22.56c-1.07.86-2.36 1.76-2.45 3.13-.15 2.19 2.7 3.13 4.89 3.33 6.55.63 13.27 1.24 19.63-.45 2.64-.7 5.17-1.79 7.85-2.29 6.81-1.27 13.65 1.33 20.45 2.59a91.81 91.81 0 0014.91 1.21 8 8 0 003.44-.45 2.75 2.75 0 001.74-2.74 4.64 4.64 0 00-1.18-2c-3.44-4.26-4.49-9.9-5.43-15.29l-3.1-18.15c-1.69-9.68-3.26-20.19 1.32-28.89 3.3-6.25 9.36-10.65 12.84-16.8a9.79 9.79 0 001.58-6.31c-.52-3.09-3.31-5.3-6.17-6.6a23.21 23.21 0 00-17.39-.63c.1 4.33-1 8.71-1.72 13l-1.21 7a89.13 89.13 0 01-2.7 12.2 13.22 13.22 0 01-2.17 4.42 11.43 11.43 0 01-3.83 2.79 22.76 22.76 0 01-10.15 2.31 13.32 13.32 0 01-4.48-.68c-2.38-.86-4.31-2.63-6.17-4.35a10.08 10.08 0 01-1.63-1.76 10.61 10.61 0 01-1.11-2.67 54.29 54.29 0 01-1.9-7.48c-.31-1.94-.4-3.91-.54-5.87-.44-5.68-.43-12.11-1.6-17.68z",
  fill: "#f2f2f2"
});

var _ref50$4 = /*#__PURE__*/createElement("path", {
  d: "M805.58 390.1s-2.37 31.42 12.45 36.76 1.78-26.09 1.78-26.09l-4.74-9.49zM855.98 390.1s2.37 31.42-12.45 36.76-1.78-26.09-1.78-26.09l4.74-9.49z",
  fill: "#fbbebe"
});

var _ref51$3 = /*#__PURE__*/createElement("path", {
  d: "M792.54 285.16l-4.74 7.71s4.15 26.68 4.74 31.42a61.84 61.84 0 002.37 10.06s.59 14.23.59 19.56 3 14.23 3 14.23a64.53 64.53 0 003 14.82c2.37 6.53 4.75 14.23 4.75 14.23s3-8.3 14.82 4.15a7.19 7.19 0 000-10.08s-3.56-16-3.56-24.3-6.52-48-6.52-48-4.22-45.07-18.45-33.8z",
  opacity: 0.1
});

var _ref52$2 = /*#__PURE__*/createElement("path", {
  d: "M791.37 284.57l-4.74 7.7s4.15 26.68 4.74 31.43a62.25 62.25 0 002.38 10.07s.62 14.23.62 19.58 3 14.23 3 14.23a64.82 64.82 0 003 14.82c2.37 6.52 4.74 14.23 4.74 14.23s3-8.3 14.82 4.15a7.18 7.18 0 000-10.08s-3.56-16-3.56-24.31-6.52-48-6.52-48-4.27-45.04-18.48-33.82z",
  fill: "#f2f2f2"
});

var _ref53$2 = /*#__PURE__*/createElement("path", {
  d: "M869.61 280.41l3 3.53s3.5 20.19-4.21 45.68l-2.37 23.13s-4.15 19.56-4.75 24.31-.59 5.33-1.77 7.11a2.28 2.28 0 000 3l-3.56 13.05s-5.34-6.52-16 1.78c0 0-3-4.75-.59-8.9s2.37-5.93 1.78-7.11 2.37-7.12 2.37-8.3 4.15-28.46 4.15-28.46 1.78-26.68 3.56-35.57c1.09-5.47 1.06-17.67.88-26.25-.19-8.93 10.62-13.78 17-7.49.17.13.34.31.51.49z",
  opacity: 0.1
});

var _ref54$2 = /*#__PURE__*/createElement("path", {
  d: "M871.37 279.23l3 3.53s3.49 20.18-4.21 45.68l-2.37 23.12s-4.15 19.57-4.75 24.31-.59 5.34-1.78 7.11a2.31 2.31 0 000 3l-3.55 13s-5.34-6.52-16 1.78c0 0-3-4.74-.59-8.89s2.37-5.93 1.77-7.12 2.38-7.11 2.38-8.3 4.15-28.46 4.15-28.46 1.78-26.68 3.55-35.57.6-35.57.6-35.57 9.52-6.5 17.8 2.38z",
  fill: "#f2f2f2"
});

var _ref55$2 = /*#__PURE__*/createElement("circle", {
  cx: 831.67,
  cy: 247.21,
  r: 23.72,
  fill: "#fbbebe"
});

var _ref56$2 = /*#__PURE__*/createElement("path", {
  d: "M844.04 211.6a16.6 16.6 0 01-31.09.44c9.25-3.72 18.72-.4 18.72-.4 4.7-1.67 8.82-1.51 12.37-.04z",
  opacity: 0.1
});

var _ref57$2 = /*#__PURE__*/createElement("path", {
  d: "M831.67 212.83s-45.65-16-34.39 61.66c0 0 10.08 6.52 17.79 2.37 0 0-5.34-54 15.41-51.58s17.2 50.39 17.2 50.39 11.86 3.56 15.41-3-1.18-70.52-31.42-59.84z",
  fill: "#ff6584"
});

var _ref58$2 = /*#__PURE__*/createElement("path", {
  d: "M830.48 221.72c-14.24-1.63-16.19 23.26-16 39.05.18-15.69 2.82-37 16-35.49 14.82 1.69 17.24 26.65 17.42 40.79.16-12.97-1.26-42.5-17.42-44.35zM797.28 270.93a161.19 161.19 0 01-1.77-20.58 152.23 152.23 0 001.77 24.1s10.08 6.52 17.79 2.37c0 0-.13-1.28-.27-3.43-7.67 3.96-17.52-2.46-17.52-2.46zM863.09 269.15c-3.31 6.07-13.82 3.41-15.25 3-.07 2.2-.16 3.51-.16 3.51s11.86 3.56 15.41-3c.74-1.35 1.12-5.14 1-10.21-.1 3.31-.45 5.69-1 6.7z",
  opacity: 0.1
});

var _ref59$2 = /*#__PURE__*/createElement("path", {
  d: "M984.66 652.89c2.74-5.07-.37-11.29-3.94-15.81s-7.93-9.23-7.84-15c.14-8.28 8.93-13.17 16-17.56a77.94 77.94 0 0014.33-11.52 21.21 21.21 0 004.4-5.89c1.45-3.24 1.41-6.93 1.32-10.48q-.45-17.73-1.75-35.43",
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 4
});

var _ref60$2 = /*#__PURE__*/createElement("path", {
  d: "M1020.48 540.56a12.9 12.9 0 00-6.45-10.59l-2.89 5.72.09-6.93a13.08 13.08 0 00-4.26-.51 12.92 12.92 0 1013.51 12.31zM997.44 628.01a12.92 12.92 0 01-24.39-5.3 12.75 12.75 0 01.84-5.25 12.93 12.93 0 0124.18.14l-8.07 6.57 8.87-2.06a12.79 12.79 0 01-1.43 5.9zM991.06 602.92a12.92 12.92 0 01-13.51-12.31 12.75 12.75 0 011.12-5.88 13 13 0 018.29-7.16l-.06 5.33 2.92-5.8a12.92 12.92 0 0113.5 12.31 12.67 12.67 0 01-.55 4.41 12.92 12.92 0 01-11.71 9.1zM1022.43 582.05a12.92 12.92 0 01-13.51-12.31 12.7 12.7 0 011.22-6.12 12.91 12.91 0 0118-5.75l-2.28 6.25 4.69-4.51a12.91 12.91 0 014.18 8.92 12.67 12.67 0 01-.33 3.56 12.92 12.92 0 01-11.97 9.96z",
  fill: "#28629b"
});

var _ref61$2 = /*#__PURE__*/createElement("path", {
  d: "M1018.75 544c-3 .33-5.89 1.25-8.88 1.44s-6.28-.53-8.17-2.86a40.27 40.27 0 01-2.39-4.2 9.28 9.28 0 00-3.25-3.07 12.77 12.77 0 00-1.39 6.45 12.92 12.92 0 0025.54 2.13c-.49.02-.98.06-1.46.11zM1022.43 582.05a12.92 12.92 0 01-13.51-12.31 12.7 12.7 0 011.22-6.12 9.6 9.6 0 012.6 2.6c.92 1.39 1.47 3 2.56 4.27 2 2.36 5.45 3.14 8.57 3s6.12-1 9.23-1.31c.43 0 .87-.07 1.3-.08a12.92 12.92 0 01-11.97 9.95zM991.06 602.92a12.92 12.92 0 01-13.51-12.31 12.75 12.75 0 011.12-5.88 10.65 10.65 0 012.7 2.62c1 1.42 1.63 3 2.8 4.36 2.18 2.43 5.85 3.28 9.15 3.21s6.28-.86 9.46-1.1a12.92 12.92 0 01-11.72 9.1zM997.44 628.01a12.92 12.92 0 01-24.39-5.3 12.75 12.75 0 01.84-5.25 13 13 0 012.83 2.53c1.23 1.5 2 3.2 3.46 4.59 2.64 2.6 6.91 3.67 10.7 3.77a57 57 0 006.56-.34z",
  opacity: 0.1
});

var _ref62$2 = /*#__PURE__*/createElement("path", {
  d: "M965.18 647.05s10.19-.31 13.27-2.5 15.68-4.8 16.45-1.29 15.32 17.46 3.81 17.55-26.75-1.79-29.82-3.66-3.71-10.1-3.71-10.1z",
  fill: "#656380"
});

var _ref63$2 = /*#__PURE__*/createElement("path", {
  d: "M998.91 659.59c-11.51.09-26.75-1.8-29.82-3.66-2.33-1.43-3.26-6.53-3.57-8.89h-.34s.64 8.23 3.71 10.1 18.31 3.75 29.82 3.66c3.32 0 4.47-1.21 4.41-3-.46 1.11-1.75 1.77-4.21 1.79z",
  opacity: 0.2
});

function SvgVehicleInput(props) {
  return /*#__PURE__*/createElement("svg", _extends$8({
    "data-name": "Layer 1",
    viewBox: "0 0 1034.75 706.69"
  }, props), _ref$7, _ref2$7, _ref3$7, _ref4$7, _ref5$7, _ref6$7, _ref7$7, _ref8$7, _ref9$7, _ref10$7, _ref11$7, _ref12$7, _ref13$7, _ref14$7, _ref15$7, _ref16$7, _ref17$7, _ref18$7, _ref19$7, _ref20$7, _ref21$7, _ref22$6, _ref23$6, _ref24$6, _ref25$6, _ref26$6, _ref27$6, _ref28$6, _ref29$6, _ref30$6, _ref31$6, _ref32$6, _ref33$6, _ref34$6, _ref35$6, _ref36$6, _ref37$6, _ref38$6, _ref39$6, _ref40$5, _ref41$5, _ref42$5, _ref43$5, _ref44$4, _ref45$4, _ref46$4, _ref47$4, _ref48$4, _ref49$4, _ref50$4, _ref51$3, _ref52$2, _ref53$2, _ref54$2, _ref55$2, _ref56$2, _ref57$2, _ref58$2, _ref59$2, _ref60$2, _ref61$2, _ref62$2, _ref63$2);
}

function _templateObject2$8() {
  var data = _taggedTemplateLiteral(["\n      query Vehicles {\n        viewer {\n          vehicles {\n            id\n            name\n          }\n        }\n      }\n    "]);

  _templateObject2$8 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$a() {
  var data = _taggedTemplateLiteral(["\n    mutation($vehicle: NewVehicleInput!) {\n      vehicle: addVehicle(vehicle: $vehicle) {\n        name\n        id\n      }\n    }\n  "]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}
var useCreate$7 = function useCreate() {
  var _useMutation = useMutation(gql(_templateObject$a())),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      mutate = _useMutation2[0],
      meta = _useMutation2[1];

  var create = function create(vehicle) {
    return mutate({
      variables: {
        vehicle: vehicle
      }
    });
  };

  return [create, meta];
};

var useVehicles = function useVehicles() {
  var _meta$data, _meta$data$viewer;

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _useLazyQuery = useLazyQuery(gql(_templateObject2$8()), options),
      _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
      query = _useLazyQuery2[0],
      meta = _useLazyQuery2[1];

  var getVehicles = function getVehicles() {
    var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var requestOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return query(_objectSpread2({
      variables: form
    }, requestOptions));
  }; // Cleaned data for easier consumption


  var data = {
    vehicles: (meta === null || meta === void 0 ? void 0 : (_meta$data = meta.data) === null || _meta$data === void 0 ? void 0 : (_meta$data$viewer = _meta$data.viewer) === null || _meta$data$viewer === void 0 ? void 0 : _meta$data$viewer.vehicles) || []
  };
  return [getVehicles, _objectSpread2(_objectSpread2({}, meta), {}, {
    data: data
  })];
};
/**
 * Custom form input for allowing users to select one or more vehicles. Connects automatically
 * to a parent `Form` component.
 */


var VehicleInput = function VehicleInput(_ref) {
  var name = _ref.name,
      label = _ref.label,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? false : _ref$multiple,
      defaultValue = _ref.defaultValue,
      props = _objectWithoutProperties(_ref, ["name", "label", "multiple", "defaultValue"]);

  var _useVehicles = useVehicles(),
      _useVehicles2 = _slicedToArray(_useVehicles, 2),
      getOptions = _useVehicles2[0],
      _useVehicles2$ = _useVehicles2[1],
      data = _useVehicles2$.data,
      refetch = _useVehicles2$.refetch;

  var _useCreate = useCreate$7(),
      _useCreate2 = _slicedToArray(_useCreate, 2),
      create = _useCreate2[0],
      createMeta = _useCreate2[1];

  var createModal = useModal();

  var createVehicle = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(form) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return create(form);

            case 3:
              createModal.close();
              refetch();
              Toasts.success("New vehicle created");
              _context.next = 10;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));

    return function createVehicle(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(AssociationInput, _extends({}, props, {
    name: name,
    label: label,
    multiple: multiple,
    options: data.vehicles,
    defaultValue: defaultValue,
    placeholderComponent: SvgVehicleInput,
    placeholderMessage: "No vehicles to select from",
    onFocus: function onFocus() {
      getOptions();
    },
    renderSelectionItem: function renderSelectionItem(vehicle) {
      return /*#__PURE__*/React.createElement("p", {
        className: "has-text-weight-semibold"
      }, vehicle.name);
    },
    renderSelectedItem: function renderSelectedItem(vehicle) {
      return vehicle.name;
    }
  }), /*#__PURE__*/React.createElement(Level, null, /*#__PURE__*/React.createElement(Level.Left, null, /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement("span", {
    className: "is-size-5"
  }, "Vehicles"))), /*#__PURE__*/React.createElement(Level.Right, null, /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement(Button, _extends({
    type: "button",
    color: "success",
    size: "small"
  }, createModal.triggerProps), /*#__PURE__*/React.createElement(Icon, {
    name: "plus"
  }), " ", /*#__PURE__*/React.createElement("span", null, "Add")), /*#__PURE__*/React.createElement(Modal, _extends({}, createModal.modalProps, {
    title: "New Vehicle"
  }), /*#__PURE__*/React.createElement(Modal.Content, null, createModal.active && /*#__PURE__*/React.createElement(Form, {
    onSubmit: createVehicle,
    error: createMeta.error,
    loading: createMeta.loading
  }, /*#__PURE__*/React.createElement(Columns, null, /*#__PURE__*/React.createElement(Columns.Column, null, /*#__PURE__*/React.createElement(Form.Input, {
    name: "make",
    label: "Vehicle Make",
    type: "text"
  })), /*#__PURE__*/React.createElement(Columns.Column, null, /*#__PURE__*/React.createElement(Form.Input, {
    name: "model",
    label: "Vehicle Model",
    type: "text"
  }))), /*#__PURE__*/React.createElement(Columns, null, /*#__PURE__*/React.createElement(Columns.Column, null, /*#__PURE__*/React.createElement(Form.Input, {
    name: "year",
    label: "Vehicle Year",
    type: "number",
    step: "1",
    min: "1900"
  })), /*#__PURE__*/React.createElement(Columns.Column, null, /*#__PURE__*/React.createElement(Form.Input, {
    name: "color",
    label: "Vehicle Color",
    type: "text"
  }))), /*#__PURE__*/React.createElement(Columns, null, /*#__PURE__*/React.createElement(Columns.Column, null, /*#__PURE__*/React.createElement(Form.Input, {
    name: "licenseNumber",
    label: "License Plate",
    type: "text"
  })), /*#__PURE__*/React.createElement(Columns.Column, null, /*#__PURE__*/React.createElement(Form.Input, {
    name: "licenseState",
    label: "License Plate State",
    type: "text"
  }))), /*#__PURE__*/React.createElement(Form.Input, {
    name: "vin",
    label: "VIN",
    type: "text"
  }), /*#__PURE__*/React.createElement(Level, {
    mobile: true
  }, /*#__PURE__*/React.createElement(Level.Right, null, /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement(Form.SubmitButton, {
    color: "success"
  }, "Create Vehicle")))))))))));
};
VehicleInput.propTypes = {
  /** Display label for the input */
  label: PropTypes.string.isRequired,

  /** Form input name */
  name: PropTypes.string.isRequired,

  /** Default input value */
  defaultValue: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),

  /** Multiple counsels may be selected */
  multiple: PropTypes.bool
};

function _templateObject$b() {
  var data = _taggedTemplateLiteral(["\n      query {\n        viewer {\n          officers {\n            id\n            badgeNumber\n            name\n            agency\n            badgeNumberSuffix\n          }\n        }\n      }\n    "]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}

var useOfficers = function useOfficers() {
  var _meta$data, _meta$data$viewer;

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _useLazyQuery = useLazyQuery(gql(_templateObject$b()), options),
      _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
      query = _useLazyQuery2[0],
      meta = _useLazyQuery2[1];

  var getOfficers = function getOfficers() {
    var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var requestOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return query(_objectSpread2({
      variables: form
    }, requestOptions));
  }; // Cleaned data for easier consumption


  var data = {
    officers: (meta === null || meta === void 0 ? void 0 : (_meta$data = meta.data) === null || _meta$data === void 0 ? void 0 : (_meta$data$viewer = _meta$data.viewer) === null || _meta$data$viewer === void 0 ? void 0 : _meta$data$viewer.officers) || []
  };
  return [getOfficers, _objectSpread2(_objectSpread2({}, meta), {}, {
    data: data
  })];
};
/**
 * Custom form input for allowing users to select one or more judges. Connects automatically
 * to a parent `Form` component.
 */


var OfficerInput = function OfficerInput(_ref) {
  var name = _ref.name,
      label = _ref.label,
      defaultValue = _ref.defaultValue,
      multiple = _ref.multiple,
      props = _objectWithoutProperties(_ref, ["name", "label", "defaultValue", "multiple"]);

  var _useOfficers = useOfficers(),
      _useOfficers2 = _slicedToArray(_useOfficers, 2),
      getOptions = _useOfficers2[0],
      data = _useOfficers2[1].data;

  return /*#__PURE__*/React.createElement(AssociationInput, _extends({}, props, {
    name: name,
    label: label,
    options: data.officers,
    defaultValue: defaultValue,
    multiple: multiple,
    placeholderComponent: SvgPersonInput,
    placeholderMessage: "No officers to select from",
    onFocus: function onFocus() {
      getOptions();
    },
    renderSelectionItem: function renderSelectionItem(officer) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
        className: "has-text-weight-semibold"
      }, officer.name), /*#__PURE__*/React.createElement("p", {
        className: "has-text-grey is-size-7"
      }, [officer.badgeNumber, officer.badgeNumberSuffix].join(" ")));
    },
    renderSelectedItem: function renderSelectedItem(officer) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
        className: "has-text-weight-semibold"
      }, officer.name), /*#__PURE__*/React.createElement("p", {
        className: "has-text-grey is-size-7"
      }, [officer.badgeNumber, officer.badgeNumberSuffix].join(" ")));
    }
  }));
};
OfficerInput.propTypes = {
  /** Display label for the input */
  label: PropTypes.string.isRequired,

  /** Form input name */
  name: PropTypes.string.isRequired,

  /** Default input value */
  defaultValue: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),

  /** If multiple entries allowed */
  multiple: PropTypes.bool
};

/**
 * A set of components that allow you to quickly/easily build a form. The `Form` component
 * manages the lifecycle of the form, just add an `onSubmit` handler and the `Form` will handle the
 * rest. When the form is submitted, the `onSubmit` event handler will be called with the form's
 * values.
 *
 * If `onSubmit` is async and takes time to resolve, then the form will automatically be disabled
 * and indicate to the user that it's being submitted. If you want to show the form as loading, or
 * want to disable it yourself, you may do so using the `loading` and `disabled` props.
 *
 * If the form relates to a graphQL query and an error is returned, you may pass the GraphQL error
 * instance to the form using the `error` prop and the form will display the error message for you.
 *
 * The `Form`'s magic only works if you use the nested `Form.*` inputs, regular `Input`/`Select`/etc
 * components will not be managed by the `Form`.
 *
 * See `react-elements/form` components for further documentation on each input type (just make sure
 * you use the `Form.*` version in order for it to be managed by the `Form`).
 *
 * ## Example
 *
 * ```javascript
 * const MyFormComponent = () => {
 *   const [performQuery, { error }] = useCustomQueryHook()
 *
 *   return (
 *     <Form error={error} onSubmit={performQuery}>
 *       <Form.Input type="text" name="firstName" />
 *       <Form.Select name="favoriteColor" options={['purple', { label: 'Green', value: 'gReEn' }]} />
 *       <Form.SubmitButton>Save Form</Form.SubmitButton>
 *     </Form>
 *   )
 * }
 * ```
 */

var Form = function Form(_ref) {
  var _errorProp$graphQLErr;

  var defaultValues = _ref.defaultValues,
      onSubmitProp = _ref.onSubmit,
      loadingProp = _ref.loading,
      disabledProp = _ref.disabled,
      errorProp = _ref.error,
      props = _objectWithoutProperties(_ref, ["defaultValues", "onSubmit", "loading", "disabled", "error"]);

  var methods = useForm({
    defaultValues: defaultValues
  });
  var errorMessage = (errorProp === null || errorProp === void 0 ? void 0 : errorProp.message) || !!errorProp && "Unable to connect to server.";
  var errors = errorProp === null || errorProp === void 0 ? void 0 : (_errorProp$graphQLErr = errorProp.graphQLErrors) === null || _errorProp$graphQLErr === void 0 ? void 0 : _errorProp$graphQLErr.errors;
  return /*#__PURE__*/React.createElement(FormProvider, _extends({}, methods, {
    loading: loadingProp,
    disabled: disabledProp,
    errors: errors
  }), !!errorMessage && /*#__PURE__*/React.createElement(Notification, {
    type: "danger",
    style: {
      position: "sticky",
      top: "1rem"
    }
  }, errorMessage), /*#__PURE__*/React.createElement("form", _extends({}, props, {
    onSubmit: function onSubmit(submitEvent) {
      if (typeof submitEvent.stopPropagation === "function") {
        submitEvent.stopPropagation();
      }

      return methods.handleSubmit(onSubmitProp)(submitEvent);
    }
  })));
};
Form.propTypes = {
  /** Default form values to use when the form is initialized */
  defaultValues: PropTypes.shape({}),

  /** Form submit handler. Receives an object containing the current form's values. */
  onSubmit: PropTypes.func.isRequired,

  /** Indicates the entire form is loading. All inputs are in a loading state. */
  loading: PropTypes.bool,

  /** Indicates the entire form is disabled. All inputs are disabled. */
  disabled: PropTypes.bool,

  /** GraphQL error instance. Displays an error message parsed from the GraphQL error. */
  error: PropTypes.shape({
    graphQLErrors: PropTypes.arrayOf(PropTypes.shape({
      message: PropTypes.string
    }))
  })
};
/**
 * Conditionally renders children based on if the invoked `condition` prop returns
 * true or not.
 */

var ConditionalFormContent = function ConditionalFormContent(_ref2) {
  var condition = _ref2.condition,
      children = _ref2.children;
  var form = useWatch({});

  if (condition === null || condition === void 0 ? void 0 : condition(form)) {
    return children;
  }

  return false;
};

var customInputTypes = {
  bank: BankInput,
  charge: ChargeInput,
  counsel: CounselInput,
  family: FamilyInput,
  fee: FeeInput,
  hearing: HearingInput,
  judge: JudgeInput,
  partyable: PersonInput,
  person: PersonInput,
  sentence: SentenceInput,
  vehicle: VehicleInput,
  warrant: WarrantInput,
  officer: OfficerInput
};
/**
 * Input that's automatically managed by the parent Form component.
 */

Form.Input = function (_ref3) {
  var disabledProp = _ref3.disabled,
      loadingProp = _ref3.loading,
      typeProp = _ref3.type,
      helpProp = _ref3.help,
      nameProp = _ref3.name,
      condition = _ref3.condition,
      props = _objectWithoutProperties(_ref3, ["disabled", "loading", "type", "help", "name", "condition"]);

  var _useFormContext = useFormContext(),
      register = _useFormContext.register,
      loading = _useFormContext.loading,
      errors = _useFormContext.errors,
      disabled = _useFormContext.disabled;

  var error = errors === null || errors === void 0 ? void 0 : errors[nameProp];
  var Component = customInputTypes[typeProp] || Input;

  if (typeof condition === "function") {
    return /*#__PURE__*/React.createElement(ConditionalFormContent, {
      condition: condition
    }, /*#__PURE__*/React.createElement(Component, _extends({}, props, {
      name: nameProp,
      type: typeProp,
      help: error || helpProp,
      color: error ? "danger" : null,
      helpProps: error ? {
        className: "has-text-danger-dark"
      } : null,
      disabled: loading || disabled || disabledProp,
      loading: loadingProp,
      ref: register
    })));
  }

  return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
    name: nameProp,
    type: typeProp,
    help: error || helpProp,
    color: error ? "danger" : null,
    helpProps: error ? {
      className: "has-text-danger-dark"
    } : null,
    disabled: loading || disabled || disabledProp,
    loading: loadingProp,
    ref: register
  }));
};

Form.Input.propTypes = {
  /** Display label for the input. Describes its purpose. */
  label: PropTypes.string.isRequired,

  /** Name of input field. The key associated with the input's value. */
  name: PropTypes.string.isRequired,

  /** Type of input */
  type: PropTypes.string.isRequired,

  /** Input is inaccessible */
  disabled: PropTypes.bool,

  /** Input is in a loading state */
  loading: PropTypes.bool,

  /** Resolver that decides whether the input should be rendered or not. Must return boolean. */
  condition: PropTypes.func,

  /** Help text to provide more context on the purpose of the input */
  help: PropTypes.string
};
/**
 * Textarea that's automatically managed by the parent Form component.
 */

Form.Textarea = function (_ref4) {
  var disabledProp = _ref4.disabled,
      loadingProp = _ref4.loading,
      nameProp = _ref4.name,
      helpProp = _ref4.help,
      condition = _ref4.condition,
      props = _objectWithoutProperties(_ref4, ["disabled", "loading", "name", "help", "condition"]);

  var _useFormContext2 = useFormContext(),
      register = _useFormContext2.register,
      loading = _useFormContext2.loading,
      disabled = _useFormContext2.disabled,
      errors = _useFormContext2.errors;

  var error = errors === null || errors === void 0 ? void 0 : errors[nameProp];

  if (typeof condition === "function") {
    return /*#__PURE__*/React.createElement(ConditionalFormContent, {
      condition: condition
    }, /*#__PURE__*/React.createElement(Textarea, _extends({}, props, {
      name: nameProp,
      color: error ? "danger" : null,
      help: error || helpProp,
      helpProps: error ? {
        className: "has-text-danger-dark"
      } : null,
      disabled: loading || disabled || disabledProp,
      loading: loadingProp,
      ref: register
    })));
  }

  return /*#__PURE__*/React.createElement(Textarea, _extends({}, props, {
    name: nameProp,
    color: error ? "danger" : null,
    help: error || helpProp,
    helpProps: error ? {
      className: "has-text-danger-dark"
    } : null,
    disabled: loading || disabled || disabledProp,
    loading: loadingProp,
    ref: register
  }));
};

Form.Textarea.propTypes = {
  /** Display label for the input. Describes its purpose. */
  label: PropTypes.string.isRequired,

  /** Name of input field. The key associated with the input's value. */
  name: PropTypes.string.isRequired,

  /** Input is inaccessible */
  disabled: PropTypes.bool,

  /** Input is in a loading state */
  loading: PropTypes.bool,

  /** Resolver that decides whether the input should be rendered or not. Must return boolean. */
  condition: PropTypes.func,

  /** Help text to provide more context on the purpose of the input */
  help: PropTypes.string
};
/**
 * Select that's automatically managed by the parent Form component.
 */

Form.Select = function (_ref5) {
  var disabledProp = _ref5.disabled,
      loadingProp = _ref5.loading,
      nameProp = _ref5.name,
      helpProp = _ref5.help,
      condition = _ref5.condition,
      props = _objectWithoutProperties(_ref5, ["disabled", "loading", "name", "help", "condition"]);

  var _useFormContext3 = useFormContext(),
      register = _useFormContext3.register,
      loading = _useFormContext3.loading,
      disabled = _useFormContext3.disabled,
      errors = _useFormContext3.errors;

  var error = errors === null || errors === void 0 ? void 0 : errors[nameProp];

  if (typeof condition === "function") {
    return /*#__PURE__*/React.createElement(ConditionalFormContent, {
      condition: condition
    }, /*#__PURE__*/React.createElement(Select, _extends({}, props, {
      name: nameProp,
      color: error ? "danger" : null,
      help: error || helpProp,
      helpProps: error ? {
        className: "has-text-danger-dark"
      } : null,
      disabled: loading || disabled || disabledProp,
      loading: loadingProp,
      ref: register
    })));
  }

  return /*#__PURE__*/React.createElement(Select, _extends({}, props, {
    name: nameProp,
    color: error ? "danger" : null,
    help: error || helpProp,
    helpProps: error ? {
      className: "has-text-danger-dark"
    } : null,
    disabled: loading || disabled || disabledProp,
    loading: loadingProp,
    ref: register
  }));
};

Form.Select.propTypes = {
  /** Display label for the input. Describes its purpose. */
  label: PropTypes.string.isRequired,

  /** Name of input field. The key associated with the input's value. */
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  })])).isRequired,

  /** Input is inaccessible */
  disabled: PropTypes.bool,

  /** Input is in a loading state */
  loading: PropTypes.bool,

  /** Resolver that decides whether the input should be rendered or not. Must return boolean. */
  condition: PropTypes.func,

  /** Help text to provide more context on the purpose of the input */
  help: PropTypes.string
};

Form.Checkbox = function (_ref6) {
  var disabledProp = _ref6.disabled,
      loadingProp = _ref6.loading,
      condition = _ref6.condition,
      props = _objectWithoutProperties(_ref6, ["disabled", "loading", "condition"]);

  var _useFormContext4 = useFormContext(),
      register = _useFormContext4.register,
      loading = _useFormContext4.loading,
      disabled = _useFormContext4.disabled;

  if (typeof condition === "function") {
    return /*#__PURE__*/React.createElement(ConditionalFormContent, {
      condition: condition
    }, /*#__PURE__*/React.createElement(Checkbox, _extends({}, props, {
      disabled: loading || disabled || disabledProp,
      loading: loadingProp,
      ref: register
    })));
  }

  return /*#__PURE__*/React.createElement(Checkbox, _extends({}, props, {
    disabled: loading || disabled || disabledProp,
    loading: loadingProp,
    ref: register
  }));
};

Form.Checkbox.propTypes = {
  /** Display label for the input. Describes its purpose. Component's children may also be used. */
  label: PropTypes.string,

  /** Name of input field. The key associated with the input's value. */
  name: PropTypes.string.isRequired,

  /** Form value for checkbox if and when the checkbox is checked. `false` if unchecked. */
  value: PropTypes.string,

  /** Input is inaccessible */
  disabled: PropTypes.bool,

  /** Input is in a loading state */
  loading: PropTypes.bool,

  /** Resolver that decides whether the input should be rendered or not. Must return boolean. */
  condition: PropTypes.func
};
/**
 * Submit button for a managed Form component. Should be used inside a Form component.
 */

Form.SubmitButton = function (_ref7) {
  var disabledProp = _ref7.disabled,
      loadingProp = _ref7.loading,
      props = _objectWithoutProperties(_ref7, ["disabled", "loading"]);

  var _useFormContext5 = useFormContext(),
      loading = _useFormContext5.loading,
      disabled = _useFormContext5.disabled;

  return /*#__PURE__*/React.createElement(Button, _extends({
    color: "primary"
  }, props, {
    type: "submit",
    disabled: disabled || disabledProp || loading || loadingProp,
    loading: loading || loadingProp
  }));
};

Form.SubmitButton.propTypes = {
  /** If the submit button should be disabled. */
  disabled: PropTypes.bool,

  /** If the submit button should indicate it's loading. */
  loading: PropTypes.bool
};

export { Form };
